!(function () {
  console.log("Upsell Kit...");
  let tools = "undefined" != typeof CKTools ? CKTools : {},
    settings = "undefined" != typeof CKSettings ? CKSettings : {},
    currentProduct =
      "undefined" != typeof CKCurrentProduct ? CKCurrentProduct : null,
    currentProductCollections =
      "undefined" != typeof CKCurrentProductCollections
        ? CKCurrentProductCollections
        : null,
    currentProductMetafields =
      "undefined" != typeof CKCurrentProductMetafields
        ? CKCurrentProductMetafields
        : {},
    currentProductCollectionsMetafields =
      "undefined" != typeof CKCurrentProductCollectionsMetafields
        ? CKCurrentProductCollectionsMetafields
        : {},
    currentPage = "undefined" != typeof CKCurrentPage ? CKCurrentPage : {},
    mixMatchBundlePageSettings =
      "undefined" != typeof CKMixMatchBundlePageSettings
        ? CKMixMatchBundlePageSettings
        : {},
    selectedVariant =
      "undefined" != typeof CKSelectedVariant ? CKSelectedVariant : null,
    variantsQuantities = "undefined" != typeof CKVQ ? CKVQ : null,
    cartItemsInCollection =
      "undefined" != typeof CKCartItemCollections
        ? CKCartItemCollections
        : null,
    EWCK = {
      gqlEndpoint: `${
        settings?.disableLocaleBasedRoute === "true"
          ? "/"
          : location.origin + (Shopify?.routes?.root || "/")
      }api/2025-10/graphql.json`,
      atcButton: null,
      qtyInput: null,
      volumeQty: null,
      volumeSelectedTier: null,
      activeOnProd: [],
      variantChangeTracker: null,
      screenSize: 1,
      atcViews: 1,
      stickyAtcScrnSize: null,
      stickyAtcResizeLis: null,
      countdownTimerRef: null,
      cart: null,
      cartChangeWatch: null,
      cartChangeWatchActive: !1,
      cartItemsElms: null,
      vdAtcLis: null,
      atcEffectInterval: {},
      favUrl: null,
      fccLis: null,
      fccInterval: null,
      pageTitle: null,
      itmLis: null,
      paoSelected: {},
      paoContainer: null,
      paoAtcLis: null,
      tccProductCheck: !1,
      tccCheckoutBtn: null,
      tccCheckoutLis: null,
      tccAtcBtn: null,
      tccAtcLis: null,
      tccCartDrawerCheckoutBtn: null,
      tccCartDrawerCheckoutLis: null,
      stickerProductCards: [],
      productsFilterObserver: null,
      pop: !1,
      bogoHCSI: {},
      labelsStickersSI: {},
      cuResizeLis: null,
      originalFetch: null,
      spEnabled: !1,
      spCheckoutBtn: null,
      spCheckoutLis: null,
      spCartDrawerCheckoutBtn: null,
      spCartDrawerCheckoutLis: null,
      checkoutBtns: [],
      checkoutBtnsLis: [],
      poSelectedPayment: null,
      customDate: new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "2-digit",
        year: "numeric",
      }),
      themeAtc: null,
      shopifyPaymentButton: null,
      poCFS: null,
      poThemeAtcLis: null,
      mmbInfo: {
        productFetchDetails: {},
        addedProducts: {},
        eligibleBundle: {},
      },
      toolsCompleted: [],
      async init(e) {
        if (
          settings?.featuredProduct &&
          location.pathname === Shopify.routes.root
        ) {
          if (e)
            selectedVariant = currentProduct.variants.find(
              (t) => t.id.toString() === e
            );
          else
            try {
              let t = await (
                await fetch(settings.featuredProduct + ".js")
              ).json();
              t &&
                ((currentProduct = t),
                (selectedVariant = t.variants.find((e) => e.available)));
              let i = document.querySelector(
                settings?.varinatInputSelector || "input.product-variant-id"
              );
              i &&
                i.addEventListener("change", (e) => {
                  let t = e.target.value;
                  t && EWCK.init(t);
                });
            } catch (a) {
              console.log("Error fetching featured product!"), console.log(a);
            }
        }
        if (
          (settings?.featuredMixMatchBundleId &&
            !location.pathname.includes("/products/") &&
            EWCK.handleMixMatchBundle(),
          Object.keys(currentProductMetafields).length)
        ) {
          for (let n in currentProductMetafields)
            if ("mix_match_bundle" === n) {
              let o = currentProductMetafields[n];
              for (let r in o) EWCK.handleMixMatchBundle(r);
            }
        }
        if (Object.keys(currentProductCollectionsMetafields).length) {
          for (let l of Object.values(currentProductCollectionsMetafields))
            for (let c in l)
              if ("mix_match_bundle" === c) {
                let s = l[c];
                for (let d in s) EWCK.handleMixMatchBundle(d);
              }
        }
        if (
          (currentPage?.id &&
            settings?.mixMatchBundlePageId?.includes(currentPage.id) &&
            EWCK.handleMixMatchBundle(),
          !currentPage?.id && tools?.mix_match_bundle?.length)
        )
          for (let p of tools.mix_match_bundle) EWCK.handleMixMatchBundle(p);
        if (!Object.keys(tools).length) return;
        for (let u in tools)
          switch ((EWCK.toolsCompleted.push(u), u)) {
            case "sticky_add_to_cart":
              if (currentProduct) {
                if (!Utils.checkVisibility(tools[u])) break;
                EWCK.handleStickyAddToCart(tools[u]);
              }
              break;
            case "scroll_to_top_button":
              EWCK.handleScrollToTop(tools[u]);
              break;
            case "content_protection":
              EWCK.handleContentProtection(tools[u]);
              break;
            case "payment_logos":
              if (!Utils.checkVisibility(tools[u])) break;
              EWCK.handlePaymentLogos(tools[u]);
              break;
            case "trust_badges":
              if (!Utils.checkVisibility(tools[u])) break;
              EWCK.handleTrustBadges(tools[u]);
              break;
            case "stock_scarcity":
              if (currentProduct) {
                if (tools[u]?.resourceType && !Utils.checkVisibility(tools[u]))
                  break;
                EWCK.handleStockScarcity(tools[u]);
              }
              break;
            case "countdown_timer":
              if (!Utils.checkVisibility(tools[u])) break;
              EWCK.handleCountdownTimer(tools[u]);
              break;
            case "size_chart_description":
              for (let m of tools[u]) {
                if (currentProduct) {
                  if (!Utils.checkVisibility(m) || "Inactive" === m.status)
                    continue;
                } else if (!settings?.enableSCDPage) continue;
                EWCK.handleSizeChartDescription(m);
              }
              break;
            case "announcement_bars":
              for (let y of tools[u])
                "Inactive" !== y.status && EWCK.handleAnnouncementBars(y);
              break;
            case "buy_x_get_y":
            case "volume_discounts":
              let f = tools[u];
              for (let g of f) {
                let h = {
                  resourceType: g.buyResourceType,
                  selectionIds:
                    "product" === g.buyResourceType
                      ? g.buySelectionProductIds.map((e) => e.id)
                      : g.buySelectionCollectionIds.map((e) =>
                          e.id.replace("gid://shopify/Collection/", "")
                        ),
                };
                "Active" === g.status &&
                  ("buy_x_get_y" === u
                    ? (g.showOnCartPage && Loaders.bogoCartLoader(g),
                      g.showOnHomeCollection && Loaders.bogoHCLoader(g))
                    : g.showOnCartPage && Loaders.vdCartLoader(g)),
                  currentProduct &&
                    currentProduct?.available !== !1 &&
                    Utils.checkVisibility(h) &&
                    "Inactive" !== g.status &&
                    ("buy_x_get_y" === u
                      ? EWCK.handleBOGO(g)
                      : EWCK.handleVolumeDiscounts(g));
              }
              break;
            case "order_rewards":
              EWCK.handleOrderRewards(tools[u]);
              break;
            case "age_verification":
              EWCK.handleAgeVerification(tools[u]);
              break;
            case "combo_products":
              let b = tools[u];
              for (let w of b) {
                if (
                  w?.resourceType === "all" ||
                  w?.resourceType === "product" ||
                  w?.resourceType === "collection"
                ) {
                  let k = {
                    resourceType: w.resourceType,
                    selectionIds: w?.selectionIds?.map((e) => e),
                  };
                  if (
                    !currentProduct ||
                    !Utils.checkVisibility(k) ||
                    "Inactive" === w.status
                  )
                    continue;
                } else {
                  let v = {
                    resourceType: "product",
                    selectionIds: w.selectedProducts.map((e) => e.id),
                  };
                  if (
                    !currentProduct ||
                    !Utils.checkVisibility(v) ||
                    "Inactive" === w.status
                  )
                    continue;
                }
                EWCK.handleComboProducts(w);
              }
              break;
            case "product_add_ons":
              Loaders.paoLoader(tools[u]),
                currentProduct && EWCK.handleAddons(tools[u]);
              break;
            case "animate_add_to_cart":
              if (!Utils.checkVisibility(tools[u])) break;
              EWCK.handleAnimateAddToCart(tools[u]);
              break;
            case "favicon_cart_count":
              EWCK.handleFaviconCartCount(tools[u]);
              break;
            case "inactive_tab_message":
              EWCK.handleInactiveTabMessage(tools[u]);
              break;
            case "sale_notifications":
              EWCK.handleSaleNotifications(tools[u]);
              break;
            case "hide_dynamic_checkout":
              EWCK.handleHideDynamicCheckout(tools[u]);
              break;
            case "terms_conditions_checkbox":
              EWCK.handleTermsConditions(tools[u]);
              break;
            case "labels_stickers":
              EWCK.handleLabelsStickers(tools[u]);
              break;
            case "pop_ups":
              EWCK.handlePopUps(tools[u]);
              break;
            case "cart_upsell":
              EWCK.handleCartUpsell(tools[u]);
              break;
            case "product_cross_sell":
              EWCK.handleProductCrossSell(tools[u]);
              break;
            case "shipping_protection":
              EWCK.handleShippingProtection(tools[u]);
              break;
            case "preorder":
              for (let $ of tools[u])
                if ($?.selectedProducts && currentProduct) {
                  let x = $.selectedProducts.find(
                    (e) => e.id === currentProduct.id.toString()
                  );
                  x && EWCK.handlePreorder($, x);
                }
          }
        let T = 0;
        if (settings?.toolsReCheck === "true") {
          let C = setInterval(() => {
            for (let e in tools)
              EWCK.toolsCompleted.includes(e) ||
                (clearInterval(C), EWCK.init());
            T >= 30 && clearInterval(C), T++;
          }, 1e3);
        }
      },
      async handleStickyAddToCart(e) {
        if (
          (document.querySelector(".ewck-s-atc-c")?.remove(),
          (e?.hideOnDesktop === !0 && window.innerWidth >= 770) ||
            (e?.hideOnMobile === !0 && window.innerWidth < 770))
        )
          return;
        e?.translations &&
          e.translations[Shopify.locale] &&
          (e.title = e.translations[Shopify.locale].title);
        let t = Utils.ce("div", { class: "ewck-s-atc-c" });
        Utils.addCustomCSS(t, e.css),
          Utils.addCustomCSS(t, settings?.css || "");
        let i = Utils.ce("div", {
            class: "ewck-s-atc-w",
            style: `width:100%;padding:${
              window.innerWidth < 500 ? "0" : "8"
            }px;${
              window.innerWidth < 500
                ? "max-width:" + window.innerWidth + "px"
                : ""
            };background:${e.backgroundColor};position:fixed;${
              "bottom" === e.position
                ? window.innerWidth < 500
                  ? "bottom:6px"
                  : "bottom:0"
                : window.innerWidth < 500
                ? "top:6px"
                : "top:0"
            };z-index:9`,
          }),
          a = Utils.ce("div", {
            class: "ewck-s-atc-i-w",
            style: `max-width:${e.maxWidth}px;display:flex;gap:20px;align-items:center;justify-content:space-between;position:relative;left:50%;top:50%;transform:translate(-50%, 0)`,
          }),
          n = Utils.ce("div", {
            class: "ewck-s-atc-i-b",
            style: "display:flex;align-items:center",
          }),
          o = Utils.ce("img", {
            class: "ewck-s-atc-i",
            alt: currentProduct.title,
            src:
              selectedVariant.featured_image?.src ||
              currentProduct.featured_image,
            style: `width:60px;height:60px;object-fit:cover;border-radius:${e.borderRadius}px`,
          }),
          r = Utils.ce("div", { class: "ewck-s-atc-p-t-b" }),
          l = Utils.ce("h3", {
            class: "ewck-s-atc-p-t",
            innerText:
              currentProduct.title.slice(
                0,
                +settings?.stickyAtcTitleTruncate || 40
              ) +
              (currentProduct.title.length >
              (+settings?.stickyAtcTitleTruncate || 40)
                ? "..."
                : ""),
            style: `font-size:17px;color:${e.textColor};font-weight:bold;white-space:nowrap;overflow:hidden;text-overflow:ellipsis`,
          }),
          c = Utils.ce("div", {
            class: "ewck-s-atc-e-t-w",
            style: "display:flex;align-items:center;gap:12px",
          }),
          s = Utils.ce("div", {
            class: "ewck-s-atc-v-s-b",
            style: `${
              1 === currentProduct.variants.length ? "display:none" : ""
            }`,
          }),
          d = Utils.ce("select", {
            class: "ewck-default-select ewck-s-atc-v-s",
            style: `font-size:15px;color:${e.textColor};padding:8px;width:100%;min-width:60px;border:1px solid #8a8a8a;border-radius:${e.borderRadius}px`,
            onchange(e) {
              let t = document.querySelector(
                  "[id*='shopify-section-template--'][id*='__main']"
                ),
                i =
                  settings?.mainSectionId !== "" &&
                  settings?.mainSectionId !== void 0
                    ? settings.mainSectionId
                    : document.querySelector("[name='section-id']")?.value;
              function a() {
                let a =
                    "" !== settings.productInfoSectionId &&
                    settings?.productInfoSectionId !== void 0
                      ? settings.productInfoSectionId.replace(
                          "mainSectionId",
                          i
                        )
                      : `#ProductInfo-${i}`,
                  n;
                n = t ? t.querySelector(a) : document.querySelector(a);
                let o = document.createElement("div");
                (o.innerHTML = this.responseText),
                  n && (n.innerHTML = o.querySelector(a).innerHTML);
                let r = new URL(location.href);
                r.searchParams.set("variant", e.target.value),
                  (selectedVariant = currentProduct.variants.find(
                    (t) => t.id.toString() === e.target.value
                  )),
                  window.history.pushState("", "", r.toString());
              }
              ("" === i || null == i) &&
                t &&
                (i = t.id.replace("shopify-section-", ""));
              let n = new XMLHttpRequest();
              n.addEventListener("load", a),
                n.open(
                  "GET",
                  `${location.pathname}?variant=${e.target.value}&section_id=${i}`,
                  !0
                ),
                n.send();
            },
          });
        currentProduct.variants.forEach((t) => {
          let i = Utils.ce("option", {
            value: t.id,
            innerText: t.public_title,
            style: `color:${e.textColor}`,
          });
          t.public_title === selectedVariant.public_title &&
            Utils.assignAtt(i, { selected: "selected" }),
            d.appendChild(i);
        });
        let p = Utils.ce("div", { class: "ewck-s-atc-q-s-b" }),
          u = Utils.ce("div", {
            class: "ewck-s-atc-q-s",
            style: `border-radius:${e.borderRadius}px`,
          }),
          m = Utils.ce("span", {
            innerText: EWCK.qtyInput?.value || "1",
            style: `width:100%;font-size:16px;color:${e.textColor}`,
          }),
          y = Utils.ce("span", {
            innerText: "-",
            style: "width:100%;cursor:pointer",
          }),
          f = Utils.ce("span", {
            innerText: "+",
            style: "width:100%;cursor:pointer",
          }),
          g = 1;
        (y.onclick = () => {
          !(g <= 1) &&
            (g--,
            (m.innerText = g),
            EWCK.qtyInput && (EWCK.qtyInput.value = g));
        }),
          (f.onclick = () => {
            g++, (m.innerText = g), EWCK.qtyInput && (EWCK.qtyInput.value = g);
          });
        let h = Utils.ce("div", {
            class: "ewck-s-atc-p-b",
            style: "display:flex;gap:12px;align-items:center;",
          }),
          b = Utils.ce("span", {
            class: "ewck-s-atc-p-b",
            style: `font-size:16px;font-weight:bold;color:${e.textColor}`,
            innerHTML: `${Utils.cf(
              selectedVariant.price,
              settings?.moneyFormat
            )}`,
          }),
          w = Utils.ce("div", { class: "ewck-s-atc-c-p-b" }),
          k = Utils.ce("span", {
            class: "ewck-s-atc-c-p",
            style:
              "font-size:16px;color:#000000bf;text-decoration:line-through;",
            innerHTML: `${Utils.cf(
              selectedVariant.compare_at_price,
              settings?.moneyFormat
            )}`,
          }),
          v = Utils.ce("div", { class: "ewck-s-atc-b-b" }),
          $ = Utils.ce("span", {
            id: "ewck-atc-text",
            innerText:
              !1 === selectedVariant.available
                ? e?.soldOutText || settings?.translateSoldOut || "Sold out"
                : e.title,
            style: `color:${e.buttonTextColor};white-space:nowrap;overflow:hidden`,
          }),
          x = Utils.ce("button", {
            class: "ewck-s-atc-b",
            type: "button",
            disabled: !1 === selectedVariant.available,
            style: `${
              "primary" === e.variant
                ? "border:none"
                : "border:1px solid lightgray"
            };position:relative;${
              "primary" === e.variant
                ? "background:" + e.buttonColor
                : "background:#fff"
            };border-radius:${e.borderRadius}px;padding-block:${
              window.innerWidth > 499 ? e.paddingY : +e.paddingY + 4
            }px;padding-inline:${e.paddingX}px;cursor:${
              !1 === selectedVariant.available ? "no-drop" : "pointer"
            };font-size:18px;font-weight:700`,
            async onclick() {
              (x.style.height = x.offsetHeight + "px"),
                (x.style.width = x.offsetWidth + "px"),
                ($.style.display = "none");
              let t = Utils.createSpinner(x);
              "redirect" === e.atcBehaviour ||
              settings?.overrideAtcBehaviour === "true"
                ? Utils.atc(
                    [{ id: selectedVariant.id, quantity: g }],
                    "sticky_add_to_cart",
                    "sticky_add_to_cart",
                    "Sticky Add To Cart"
                  )
                : "checkout" === e.atcBehaviour
                ? (await Utils.manualAtc([
                    { id: selectedVariant.id, quantity: g },
                  ])) &&
                  (location.href =
                    (window?.Shopify?.routes?.root || "/") + "cart/checkout")
                : EWCK.atcButton.click(),
                setTimeout(() => {
                  t.remove(), ($.style.display = "block");
                }, 2e3);
            },
          }),
          T = Utils.ce("div", {
            class: "ewck-s-atc-o-c-w",
            style: "display:flex;align-items:center;gap:40px",
          }),
          C = Utils.ce("div", {
            class: "ewck-s-atc-v-a-q-w",
            style: "display:flex;align-items:center;gap:40px",
          });
        n.appendChild(o),
          r.appendChild(l),
          !0 === e.variantSelectorEnabled && s.appendChild(d),
          u.append(y, m, f),
          !0 === e.quantitySelectorEnabled && p.appendChild(u),
          w.appendChild(k),
          selectedVariant.compare_at_price > selectedVariant.price
            ? h.append(w, b)
            : h.appendChild(b),
          x.appendChild($),
          v.appendChild(x),
          c.append(n, r),
          C.append(s, p),
          T.append(C, h, v),
          a.append(c, T),
          i.appendChild(a),
          t.append(i),
          document.body.appendChild(t);
        let S = window.innerWidth,
          _ = 1060,
          I = 880,
          P = 500;
        switch (
          (p.firstChild || ((_ -= 100), (I -= 100)),
          (1 === currentProduct.variants.length ||
            !1 === e.variantSelectorEnabled) &&
            ((_ -= 100), (I -= 100)),
          S <= _ && (n.style.display = "none"),
          S <= I &&
            ((c.style.display = "none"),
            (a.style.justifyContent = "center"),
            (T.style.width = "100%"),
            (T.style.justifyContent = "space-between"),
            (v.style.display = "flex"),
            (u.style.width = "80px")),
          S <= P &&
            ((i.style.background = "transparent"),
            (h.style.display = "none"),
            (C.style.display = "none"),
            (v.style.width = "100%"),
            (v.style.padding = "10px"),
            (x.style.width = "100%")),
          settings?.atcSelector !== "" && settings?.atcSelector !== void 0
            ? (EWCK.atcButton = document.querySelector(settings.atcSelector))
            : (EWCK.atcButton = Utils.findAtc()),
          (EWCK.qtyInput = document.querySelector(
            settings?.quantitySelector === "" ||
              settings?.quantitySelector === void 0
              ? "[name='quantity']"
              : settings?.quantitySelector
          )),
          EWCK.qtyInput &&
            EWCK.qtyInput.addEventListener("change", (e) => {
              (m.innerText = e.target.value), (g = e.target.value);
            }),
          null !== EWCK.stickyAtcResizeLis &&
            window.removeEventListener("resize", EWCK.stickyAtcResizeLis, !0),
          EWCK.stickyAtcScrnSize ||
            (EWCK.stickyAtcScrnSize =
              S > _ ? 4 : S <= _ && S > I ? 3 : S <= I && S > P ? 2 : 1),
          EWCK.stickyAtcScrnSize)
        ) {
          case 3:
            (l.style.fontSize = "15.5px"),
              (d.style.fontSize = "14.3px"),
              (d.style.padding = "7px"),
              (u.style.height = "36px"),
              (T.style.gap = "30px"),
              (C.style.gap = "30px"),
              (m.style.fontSize = "14px"),
              (b.style.fontSize = "14.4px"),
              (k.style.fontSize = "14.4px"),
              (x.style.fontSize = "16px");
            break;
          case 2:
            (d.style.fontSize = "13px"),
              (d.style.padding = "6px"),
              (u.style.height = "33px"),
              (T.style.gap = "20px"),
              (C.style.gap = "20px"),
              (m.style.fontSize = "13px"),
              (b.style.fontSize = "13.6px"),
              (k.style.fontSize = "13.6px"),
              (x.style.fontSize = "14.5px");
            break;
          case 1:
            x.style.fontSize = "13.5px";
        }
        let q;
        if (
          (window.addEventListener(
            "resize",
            (EWCK.stickyAtcResizeLis = () => {
              clearTimeout(q),
                (q = setTimeout(() => {
                  let e = window.innerWidth,
                    t =
                      e > _ ? 4 : e <= _ && e > I ? 3 : e <= I && e > P ? 2 : 1;
                  EWCK.stickyAtcScrnSize !== t &&
                    ((EWCK.stickyAtcScrnSize = t),
                    EWCK.init(),
                    clearTimeout(q));
                }, 200));
            }),
            !0
          ),
          "2" === e.condition)
        ) {
          function E() {
            Utils.checkVisible(EWCK.atcButton)
              ? (t.style.display = "none")
              : ((t.style.display = "block"),
                1 === EWCK.atcViews && (EWCK.atcViews = 2));
          }
          E(),
            window.addEventListener("scroll", () => {
              E();
            });
        } else 1 === EWCK.atcViews && (EWCK.atcViews = 2);
      },
      handleScrollToTop(e) {
        if (
          (document.querySelector(".ewck-stt-c")?.remove(),
          (!e.displayOnMobile && window.innerWidth <= 490) ||
            (!e.displayOnDesktop && window.innerWidth > 490))
        )
          return;
        let t = Utils.ce("div", { class: "ewck-stt-c", style: "display:none" });
        Utils.addCustomCSS(t, e.css),
          Utils.addCustomCSS(t, settings?.css || "");
        let i = Utils.ce("div", {
          class: "ewck-stt-w",
          style:
            "padding-right:12px;padding-bottom:12px;position:fixed;bottom:0;right:0;z-index:9;cursor:pointer",
          onclick() {
            window.scrollTo({ top: 0, behavior: "smooth" });
          },
        });
        if ("" !== e.customUrl) {
          let a = Utils.ce("img", {
            class: "ewck-stt-icon",
            src: e.customUrl ? e.customUrl : e.selectedUrl,
            style: `width:${e.size}px;height:${e.size}px`,
            alt: "scroll to top",
          });
          i.appendChild(a);
        } else {
          let n = new DOMParser().parseFromString(
              e.selectedSVG,
              "image/svg+xml"
            ).documentElement,
            o = Utils.ce("div", {
              style: `width:${e.size}px;height:${e.size}px`,
              class: "ewck-stt-icon",
            });
          o.appendChild(n), i.appendChild(o);
        }
        t.appendChild(i), document.body.appendChild(t), Loaders.sttLoader(t, i);
      },
      handleContentProtection(e) {
        e.disableRightClick &&
          document.addEventListener("contextmenu", (e) => e.preventDefault()),
          e.disableKeyboardShortcuts &&
            document.addEventListener("keydown", (e) => {
              (e.ctrlKey || e.metaKey) && e.preventDefault();
            }),
          e.disableTextSelection && (document.onselectstart = () => !1),
          e.disableContentDragging && (document.ondragstart = () => !1),
          e?.translations &&
            e.translations[Shopify.locale] &&
            (e.consoleMessage = e.translations[Shopify.locale].consoleMessage),
          e.consoleMessage &&
            console.log(
              `%c${e.consoleMessage}`,
              "color: #ff6608; font-family: sans-serif; font-size: 20px; font-weight: 700"
            );
      },
      handlePaymentLogos(e) {
        let t = document.getElementById("ewck-payment-logos-block"),
          i = "";
        if (
          !t &&
          (location.pathname.includes("/products/") ||
            settings?.singleProductPage === "true")
        ) {
          let a = settings?.paymentLogosTargetSelector || "";
          (i = settings?.paymentLogosInsert || (a ? "after" : "")),
            (t = a ? document.querySelector(a) : Utils.findTarget());
        }
        if (!t) return;
        e?.translations &&
          e.translations[Shopify.locale] &&
          (e.label = e.translations[Shopify.locale].label),
          document.querySelector(".ewck-pl-c")?.remove();
        let n = document.createElement("div");
        Utils.assignAtt(n, { class: "ewck-pl-c" }),
          Utils.addCustomCSS(n, e.css),
          Utils.addCustomCSS(n, settings?.css || "");
        let o = document.createElement("div");
        Utils.assignAtt(o, {
          class: "ewck-pb-w",
          style: `${e.marginY ? "margin-block:" + e.marginY + "px;" : ""}${
            e.marginX ? "margin-inline:" + e.marginX + "px;" : ""
          }display:flex;flex-direction:column;gap:4px;align-items:${
            "right" === e.align ? "end" : e.align
          }`,
        });
        let r = document.createElement("label");
        Utils.assignAtt(r, { class: "ewck-pb-l", innerText: e.label });
        let l = document.createElement("div");
        Utils.assignAtt(l, {
          class: "ewck-pb-l-w",
          style: `display:flex;gap:8px;flex-wrap:wrap;justify-content:${
            "right" === e.align ? "end" : e.align
          }`,
        }),
          e.selectedLogos.forEach((e) => {
            let t = document.createElement("div");
            Utils.assignAtt(t, { class: "ewck-pb-i-w" });
            let i = document.createElement("img");
            Utils.assignAtt(i, {
              class: "ewck-pb-image",
              alt: "",
              src: e.includes("cloudinary.com")
                ? `https://d2nt3atlyf8bm0.cloudfront.net/shopify/apps/upsell-kit/payment-logos/${e.slice(
                    e.lastIndexOf("/") + 1
                  )}`
                : e,
              width: 120,
              height: 80,
              style: "width:100%;height:100%;object-fit:contain",
            }),
              t.appendChild(i),
              l.appendChild(t);
          }),
          o.append(r, l),
          n.appendChild(o),
          "" === i ? t.appendChild(n) : Utils.insert(t, n, i);
      },
      handleTrustBadges(e) {
        let t = document.getElementById("ewck-trust-badges-block"),
          i = "";
        if (
          !t &&
          (location.pathname.includes("/products/") ||
            settings?.singleProductPage === "true")
        ) {
          let a = settings?.trustBadgesTargetSelector || "";
          (i = settings?.trustBadgesInsert || (a ? "after" : "")),
            (t = a ? document.querySelector(a) : Utils.findTarget());
        }
        if (!t) return;
        e?.translations &&
          e.translations[Shopify.locale] &&
          (e.label = e.translations[Shopify.locale].label),
          document.querySelector(".ewck-tb-c")?.remove();
        let n = document.createElement("div");
        Utils.assignAtt(n, { class: "ewck-tb-c" }),
          Utils.addCustomCSS(n, e.css),
          Utils.addCustomCSS(n, settings?.css || "");
        let o = document.createElement("div");
        Utils.assignAtt(o, {
          class: "ewck-tb-w",
          style: `${e.marginY ? "margin-block:" + e.marginY + "px;" : ""}${
            e.marginX ? "margin-inline:" + e.marginX + "px;" : ""
          }display:flex;flex-direction:column;gap:4px;align-items:${
            "right" === e.align ? "end" : e.align
          }`,
        });
        let r = document.createElement("label");
        Utils.assignAtt(r, { class: "ewck-tb-l", innerText: e.label });
        let l = document.createElement("div");
        Utils.assignAtt(l, {
          class: "ewck-tb-l-w",
          style: `display:flex;gap:8px;flex-wrap:wrap;justify-content:${
            "right" === e.align ? "end" : e.align
          }`,
        }),
          e.selectedBadges.forEach((e) => {
            let t = document.createElement("div");
            Utils.assignAtt(t, {
              class: "ewck-tb-i-w",
              style:
                "width:80px;height:80px;display:flex;align-items:center;border-radius:4px;",
            });
            let i = document.createElement("img");
            Utils.assignAtt(i, {
              class: "ewck-tb-image",
              alt: "",
              src: e.url.includes("cloudinary.com")
                ? `https://d2nt3atlyf8bm0.cloudfront.net/shopify/apps/upsell-kit/trust-badges/${e.url.slice(
                    e.url.lastIndexOf("/") + 1
                  )}`
                : e.url,
              width: 160,
              height: 160,
              style: "width:100%;height:auto;object-fit:contain",
            }),
              t.appendChild(i),
              l.appendChild(t);
          }),
          o.append(r, l),
          n.appendChild(o),
          "" === i ? t.appendChild(n) : Utils.insert(t, n, i);
      },
      handleStockScarcity(e) {
        let t = document.getElementById("ewck-stock-scarcity-block"),
          i = "";
        if (!t) {
          let a = settings?.stockScarcityTargetSelector || "";
          (i = settings?.stockScarcityInsert
            ? settings.stockScarcityInsert
            : "before"),
            (t = a ? document.querySelector(a) : Utils.findAtc());
        }
        if (
          !t ||
          (e?.translations &&
            e.translations[Shopify.locale] &&
            (e.label = e.translations[Shopify.locale].label),
          document.querySelector(".ewck-ss-c")?.remove(),
          variantsQuantities[selectedVariant.id] >= +e.quantity ||
            variantsQuantities[selectedVariant.id] <= 0)
        )
          return;
        let n = Utils.ce("div", { class: "ewck-ss-c" });
        Utils.addCustomCSS(n, e.css),
          Utils.addCustomCSS(n, settings?.css || "");
        let o = Utils.ce("div", {
            class: "ewck-ss-w",
            style: `${e.marginY ? "margin-block:" + e.marginY + "px;" : ""}${
              e.marginX ? "margin-inline:" + e.marginX + "px;" : ""
            }`,
          }),
          r = Utils.ce("div", {
            class: "ewck-ss-t",
            style: `color:${e.textColor};background-color:${e.textBackgroundColor};`,
            innerHTML:
              (e?.showBlinkingAnimation
                ? "<span class='ewck-ss-blinking'></span>"
                : "") +
              e.label.replace(
                "{{quantity}}",
                `<span><span style='color:${
                  e.specialTextColor
                };font-weight:bold'>${
                  variantsQuantities[selectedVariant.id]
                }</span></span>`
              ),
          }),
          l = Utils.ce("div", {
            class: "ewck-ss-p-w",
            style: `${
              e?.showProgressBar === !1 ? "display:none" : ""
            };width:100%;height:20px;background:${
              e.progressBackgroundColor
            };border-radius:4px`,
          }),
          c = Utils.ce("div", {
            class: "ewck-ss-p",
            style: `display:block;width:30px;height:100%;border-radius:4px;background-image:linear-gradient(to right, ${e.progressGradientStartColor}, ${e.progressGradientEndColor})`,
          });
        l.appendChild(c),
          o.append(r, l),
          n.appendChild(o),
          Utils.insert(t, n, i);
      },
      handleCountdownTimer(e) {
        let t = document.getElementById("ewck-countdown-timer-block"),
          i = "";
        if (
          !t &&
          (location.pathname.includes("/products/") ||
            settings?.singleProductPage === "true")
        ) {
          let a = settings?.countdownTimerTargetSelector || "";
          (i = settings?.countdownTimerInsert
            ? settings.countdownTimerInsert
            : "before"),
            (t = a ? document.querySelector(a) : Utils.findAtc());
        }
        if (
          !t ||
          (e?.translations &&
            e.translations[Shopify.locale] &&
            ((e.label = e.translations[Shopify.locale].label),
            (e.translateDay = e.translations[Shopify.locale].translateDay),
            (e.translateDays = e.translations[Shopify.locale].translateDays),
            (e.translateDaysMore =
              e.translations[Shopify.locale].translateDaysMore)),
          document.querySelector(".ewck-ct-c")?.remove(),
          "hide" === e.whenOutOfStock && currentProduct?.available === !1)
        )
          return;
        let n = document.createElement("div");
        Utils.assignAtt(n, { class: "ewck-ct-c" }),
          Utils.addCustomCSS(n, e.css),
          Utils.addCustomCSS(n, settings?.css || "");
        let o = document.createElement("div");
        Utils.assignAtt(o, {
          class: "ewck-ct-w",
          style: `${e.marginY ? "margin-block:" + e.marginY + "px;" : ""}${
            e.marginX ? "margin-inline:" + e.marginX + "px;" : ""
          };display:flex;justify-content:${
            "right" === e.align ? "end" : e.align
          }`,
        });
        let r = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        if ("fixed" === e.timerType) {
          let l = new Date(e.startDate).getTime(),
            c = new Date(e.endDate).getTime() - l,
            s = Date.now() - l;
          if (s < 0) return;
          let d = c - s,
            [p, u, m, y] = Utils.getDHMS(d);
          if (d > 0) {
            let [f, g, h, b] = Utils.getDHMS(d);
            (r.days = f), (r.hours = g), (r.minutes = h), (r.seconds = b);
          } else {
            if ("hide" === e.afterTimerExpire) return;
            remaining = s % c;
            let w = c - remaining;
            ([p, u, m, y] = Utils.getDHMS(w)),
              (r.days = p),
              (r.hours = u),
              (r.minutes = m),
              (r.seconds = y);
          }
        } else {
          let k = localStorage.getItem("ewck-ct-r-t-" + currentProduct.id);
          if (k) {
            k = JSON.parse(k);
            let v = Date.now() - k.createdAt,
              $ =
                864e5 * +k.days +
                36e5 * +k.hours +
                6e4 * +k.minutes +
                1e3 * +k.seconds,
              x = $ - v;
            if ((([days, hours, minutes, seconds] = Utils.getDHMS(v)), x > 0)) {
              let [T, C, S, _] = Utils.getDHMS(x);
              (r.days = T), (r.hours = C), (r.minutes = S), (r.seconds = _);
            }
            if (
              r.days <= 0 &&
              r.hours <= 0 &&
              r.minutes <= 0 &&
              r.seconds <= 0
            ) {
              if ("hide" === e.afterTimerExpire) return;
              remaining =
                v %
                ($ =
                  864e5 * +k.days +
                  36e5 * +k.hours +
                  6e4 * +k.minutes +
                  1e3 * +k.seconds);
              let I = $ - remaining;
              ([days, hours, minutes, seconds] = Utils.getDHMS(I)),
                (r.days = days),
                (r.hours = hours),
                (r.minutes = minutes),
                (r.seconds = seconds);
            }
          } else {
            let P = Utils.getRandomInt(e.minimumDays, e.maximumDays),
              q = Utils.getRandomInt(e.minimumHours, e.maximumHours),
              E = Utils.getRandomInt(e.minimumMinutes, e.maximumMinutes),
              L = Utils.getRandomInt(e.minimumSeconds, e.maximumSeconds);
            (r.days = P),
              (r.hours = q),
              (r.minutes = E),
              (r.seconds = L),
              localStorage.setItem(
                "ewck-ct-r-t-" + currentProduct.id,
                JSON.stringify({
                  days: P,
                  hours: q,
                  minutes: E,
                  seconds: L,
                  createdAt: Date.now(),
                })
              );
          }
        }
        if ("classic" === e.theme) {
          let B = document.createElement("div");
          Utils.assignAtt(B, {
            class: "ewck-ct-l-w-c",
            style: "display:flex;align-items:center;gap:5px;flex-wrap:wrap",
          });
          let F = document.createElement("span");
          Utils.assignAtt(F, {
            class: "ewck-ct-l-c",
            innerText: e.label,
            style: `font-size:${e.labelFontSize}px;color:${e.labelTextColor}`,
          });
          let A = document.createElement("span");
          Utils.assignAtt(A, {
            class: "ewck-ct-t-e",
            innerText: `${
              r.days > 0 && r.days < 2
                ? r.days +
                  " " +
                  (e?.translateDay || settings?.translateDay || "day") +
                  " "
                : ""
            }${
              r.days >= 2 && r.days <= 4
                ? r.days +
                  " " +
                  (e?.translateDays || settings?.translateDays || "days") +
                  " "
                : ""
            }${
              r.days >= 5
                ? r.days +
                  " " +
                  (e?.translateDaysMore ||
                    settings?.translateDaysMore ||
                    "days") +
                  " "
                : ""
            }${r.hours > 9 ? r.hours : "0" + r.hours}:${
              r.minutes > 9 ? r.minutes : "0" + r.minutes
            }:${r.seconds > 9 ? r.seconds : "0" + r.seconds}`,
            style: `font-size:${e.numberFontSize}px;color:${e.numberColor};font-weight:bold`,
          }),
            B.append(F, A),
            o.appendChild(B),
            n.appendChild(o);
        } else if ("modern" === e.theme) {
          let M = document.createElement("div");
          Utils.assignAtt(M, { class: "ewck-ct-l-w-m" });
          let D = document.createElement("span");
          Utils.assignAtt(D, {
            class: "ewck-ct-l-m",
            innerText: e.label,
            style: `font-size:${e.labelFontSize}px;color:${e.labelTextColor}`,
          });
          let H = document.createElement("div");
          Utils.assignAtt(H, {
            class: "ewck-ct-m-c-w",
            style:
              "display:flex;flex-wrap:nowrap;align-items:center;gap:6px;margin-top:2px;",
          }),
            ["days", "hours", "minutes", "seconds"].forEach((t, i) => {
              if (
                ("days" === t && r[t] <= 0) ||
                ("hours" === t && r[t] <= 0 && r.days <= 0)
              )
                return;
              let a = document.createElement("div"),
                n = document.createElement("div");
              Utils.assignAtt(n, {
                class: `ewck-ct-m-${t[0]}-w ewck-ct-m-c-sp`,
                style: `padding:${
                  e.numberFontSize / 3
                }px;border-radius:4px;text-align:center;background:${
                  e.backgroundColor
                };font-size:${e.numberFontSize}px;color:${
                  e.numberColor
                };font-weight:300;border:1px solid ${e.borderColor}`,
              });
              let o = document.createElement("span");
              if (
                (Utils.assignAtt(o, {
                  id: `ewck-ct-m-${t[0]}`,
                  innerText: r[t] > 9 ? r[t] : "0" + r[t],
                }),
                n.appendChild(o),
                a.appendChild(n),
                H.appendChild(a),
                i < 3)
              ) {
                let l = document.createElement("div");
                Utils.assignAtt(l, { class: "ewck-ct-m-s-e" });
                let c = document.createElement("span");
                Utils.assignAtt(c, {
                  innerText: ":",
                  style: `font-size:${e.numberFontSize}px`,
                }),
                  l.appendChild(c),
                  H.appendChild(l);
              }
            }),
            setTimeout(() => {
              document.querySelectorAll(".ewck-ct-m-c-sp").forEach((e) => {
                (e.style.width = e.offsetWidth + "px"), (e.style.padding = "0");
              });
            }, 10),
            M.append(D, H),
            o.appendChild(M),
            n.appendChild(o);
        }
        EWCK.countdownTimerRef && (EWCK.countdownTimerRef = null),
          (EWCK.countdownTimerRef = setInterval(() => {
            let t = r.seconds,
              i = r.minutes,
              a = r.hours,
              n = r.days;
            if (
              (a <= 0 && n > 0 && 0 === i && 0 === t && ((n -= 1), (a = 24)),
              i <= 0 && a > 0 && 0 === t && ((a -= 1), (i = 60)),
              t <= 0
                ? i > 0 && ((i -= 1), (t = 59))
                : t > 0 && (t = r.seconds - 1),
              (r.days = n),
              (r.hours = a),
              (r.minutes = i),
              (r.seconds = t),
              "classic" === e.theme)
            )
              document.querySelector(".ewck-ct-t-e").innerText = `${
                n > 0 ? n : ""
              }${
                n >= 5
                  ? " " +
                    (e?.translateDaysMore ||
                      settings?.translateDaysMore ||
                      "days") +
                    " "
                  : n > 1 && n <= 4
                  ? " " +
                    (e?.translateDays || settings?.translateDays || "days") +
                    " "
                  : 1 === n
                  ? " " +
                    (e?.translateDay || settings?.translateDay || "day") +
                    " "
                  : ""
              }${a > 9 ? a : "0" + a}:${i > 9 ? i : "0" + i}:${
                t > 9 ? t : "0" + t
              }`;
            else if ("modern" === e.theme) {
              let o = document.getElementById("ewck-ct-m-d");
              o && (o.innerText = n > 9 ? n : "0" + n);
              let l = document.getElementById("ewck-ct-m-h");
              l && (l.innerText = a > 9 ? a : "0" + a);
              let c = document.getElementById("ewck-ct-m-m");
              c && (c.innerText = i > 9 ? i : "0" + i);
              let s = document.getElementById("ewck-ct-m-s");
              s && (s.innerText = t > 9 ? t : "0" + t);
            }
          }, 1e3)),
          Utils.insert(t, n, i);
      },
      handleSizeChartDescription(e) {
        let t = document.getElementById("ewck-size-chart-description-block");
        settings?.enableSCDPage !== "true" ||
          currentProduct ||
          ((t = document.getElementById(
            `ewck-size-chart-description-block-${e.id}`
          )),
          (e.displayType = "section"));
        let i = "";
        if (
          !t &&
          (location.pathname.includes("/products/") ||
            settings?.singleProductPage === "true")
        ) {
          let a = settings?.scdTargetSelector || "";
          (i = settings?.scdInsert || (a ? "after" : "")),
            (t = a ? document.querySelector(a) : Utils.findTarget());
        }
        if (!t) return;
        if (e?.translations) {
          let n = e.translations[Shopify.locale];
          if (n && n.type === e.type) for (let o in n) e[o] = n[o];
        }
        document
          .querySelectorAll(`.ewck-scd-${e.id}`)
          .forEach((e) => e.remove());
        let r = document.createElement("div");
        Utils.assignAtt(r, { class: `ewck-scd-c ewck-scd-${e.id}` }),
          Utils.addCustomCSS(r, e.css),
          Utils.addCustomCSS(r, settings?.css || "");
        let l = document.createElement("div");
        if (
          (Utils.assignAtt(l, {
            class: "ewck-scd-w",
            style: `${e.marginY ? "margin-block:" + e.marginY + "px;" : ""}${
              e.marginX ? "margin-inline:" + e.marginX + "px;" : ""
            }display:flex;flex-direction:column;gap:4px;align-items:${
              "right" === e.align ? "end" : e.align
            }`,
          }),
          "popup" === e.displayType)
        ) {
          let c = document.createElement("div");
          Utils.assignAtt(c, { class: "ewck-scd-m-c" });
          let s = document.createElement("div");
          Utils.assignAtt(s, {
            class: "ewck-scd-m-b",
            onclick() {
              c.style.display = "none";
            },
          });
          let d = document.createElement("div");
          Utils.assignAtt(d, { class: "ewck-scd-m-w" });
          let p = document.createElement("div");
          Utils.assignAtt(p, { class: "ewck-scd-m-t-w" });
          let u = document.createElement("label");
          Utils.assignAtt(u, { class: "ewck-scd-m-t", innerText: e.title });
          let m = document.createElement("div");
          Utils.assignAtt(m, {
            class: "ewck-scd-m-c-b",
            innerHTML: "&#10005;",
            onclick() {
              c.style.display = "none";
            },
          });
          let y = document.createElement("div");
          Utils.assignAtt(y, { class: "ewck-scd-m-d" });
          let f = document.createElement("div");
          Utils.assignAtt(f, { class: "ewck-scd-m-c-w" });
          let g = document.createElement("div");
          Utils.assignAtt(g, {
            class: "sun-editor-editable",
            style: "width:100%",
          }),
            (g.innerHTML = e.richText),
            p.append(u, m),
            f.appendChild(g),
            d.append(p, y, f),
            c.append(s, d),
            document.body.appendChild(c);
          let h = document.createElement("div");
          Utils.assignAtt(h, {
            class: "ewck-scd-m-l-p",
            onclick() {
              c.style.display = "block";
            },
          });
          let b = document.createElement("span");
          Utils.assignAtt(b, {
            class: "ewck-scd-m-l-s",
            style: e?.iconColor === "Bright" ? "color:#fff" : "color:#000",
            innerText: e.title,
          });
          let w = document.createElement("div");
          Utils.assignAtt(w, { class: "ewck-scd-i-w" });
          let k = document.createElement("img"),
            v = e?.iconColor === "Bright" ? e.brightIcon : e.icon;
          Utils.assignAtt(k, {
            src: v.includes("cloudinary.com")
              ? `https://d2nt3atlyf8bm0.cloudfront.net/shopify/apps/upsell-kit/scd/${v.slice(
                  v.lastIndexOf("/") + 1
                )}`
              : v,
            alt: "measurement icon",
            class: "ewck-scd-t-i",
          }),
            w.appendChild(k),
            "" !== e.icon ? h.append(w, b) : h.appendChild(b),
            l.appendChild(h);
        } else {
          let $ = document.createElement("div");
          Utils.assignAtt($, { class: "ewck-scd-m-c-w" });
          let x = document.createElement("div");
          Utils.assignAtt(x, {
            class: "sun-editor-editable",
            style: "width:100%;padding:0",
          }),
            (x.innerHTML = e.richText),
            $.appendChild(x),
            l.appendChild($);
        }
        r.appendChild(l),
          "" === i ? t.appendChild(r) : Utils.insert(t, r, i),
          Utils.loadRTEStyle();
      },
      async handleAnimateAddToCart(e) {
        if (
          location.pathname.includes("/products/") ||
          settings?.singleProductPage === "true"
        ) {
          let t = [],
            i;
          settings?.animateAddToCartDelay &&
            (await new Promise((e) =>
              setTimeout(e, +settings.animateAddToCartDelay)
            )),
            (i =
              "" !== e.atcButtonSelector
                ? document.querySelector(e.atcButtonSelector)
                : Utils.findAtc()) && t.push(i),
            (tools?.combo_products ||
              tools?.buy_x_get_y ||
              tools?.sticky_add_to_cart ||
              tools?.volume_discounts) &&
              (await new Promise((e) => setTimeout(e, 2e3)));
          if (
            (document
              .querySelectorAll(
                ".ewck-s-atc-b,.ewck-bogo-atc-b,.ewck-bogo-cart-atc,.ewck-vd-atc-btn,.ewck-combo-atc-btn"
              )
              .forEach((e) => {
                t.push(e);
              }),
            t.length)
          ) {
            Object.values(EWCK.atcEffectInterval).forEach((e) => {
              clearInterval(e);
            });
            let a = `ewck-aatc-effect-${e.effect}`;
            function n(t, i, n) {
              function o() {
                n.classList.contains(a)
                  ? n.classList.remove(a)
                  : n.classList.add(a);
              }
              "hover" === i && o(),
                (EWCK.atcEffectInterval[t + "-" + i] = setInterval(() => {
                  o(),
                    setTimeout(() => {
                      o();
                    }, 1e3 * e.speed);
                }, 1e3 * +e.effectDelay));
            }
            for (let [o, r] of t.entries())
              (r.style.animationDuration = e.speed + "s"),
                Utils.addCustomCSS(r.parentElement, e.effectCode),
                ("hover" === e.triggerEffect || "both" === e.triggerEffect) &&
                  ((r.onmouseenter = () => {
                    "both" === e.triggerEffect &&
                      (clearInterval(EWCK.atcEffectInterval[o + "-normal"]),
                      r.classList.contains(a) && r.classList.remove(a)),
                      n(o, "hover", r);
                  }),
                  (r.onmouseleave = () => {
                    clearInterval(EWCK.atcEffectInterval[o + "-hover"]),
                      r.classList.contains(a) &&
                        setTimeout(() => {
                          r.classList.remove(a);
                        }, 1e3 * e.speed),
                      "both" === e.triggerEffect && n(o, "normal", r);
                  })),
                ("always" === e.triggerEffect || "both" === e.triggerEffect) &&
                  n(o, "normal", r);
          }
        }
      },
      async handleAnnouncementBars(e) {
        if (localStorage.getItem(`ewck-ab-c-main-${e.id}`)) return;
        if (e?.translations) {
          let t = e.translations[Shopify.locale];
          if (t && t.type === e.type) for (let i in t) e[i] = t[i];
        }
        let a = document.createElement("div");
        Utils.assignAtt(a, { class: `ewck-ab-c ewck-ab-c-main-${e.id}` }),
          Utils.addCustomCSS(a, e.css),
          Utils.addCustomCSS(a, settings?.css || "");
        let n = document.createElement("div");
        if (
          (Utils.assignAtt(n, {
            class: "ewck-ab-w",
            style: `${
              e.barPaddingY ? "padding-block:" + e.barPaddingY + "px;" : ""
            }${
              e.barPaddingX ? "padding-inline:" + e.barPaddingX + "px;" : ""
            }display:flex;justify-content:center;align-items:center;width:100%;${
              "Solid color" === e.backgroundType
                ? "background:" + e.backgroundColor + ";"
                : "Gradient" === e.backgroundType
                ? "background-image:linear-gradient(to right, " +
                  e.gradientStartColor +
                  " ," +
                  e.gradientEndColor +
                  ");"
                : "background-image:url(" +
                  e.imageUrl +
                  ");background-size:cover;background-position:center;"
            }`,
          }),
          e.closeButton)
        ) {
          let o = document.createElement("span");
          Utils.assignAtt(o, {
            class: "ewck-ab-c-b",
            innerHTML: "&#10005;",
            onclick() {
              localStorage.setItem(`ewck-ab-c-main-${e.id}`, "true"),
                a.remove();
            },
          }),
            n.appendChild(o);
        }
        switch (e.type) {
          case "Text":
            let r = document.createElement("span");
            Utils.assignAtt(r, {
              class: "ewck-ab-t",
              style: `color:${e.titleTextColor};text-align:center`,
              innerHTML: e.title,
            }),
              n.appendChild(r);
            break;
          case "Free shipping":
            let l = "" === e.shipping ? null : JSON.parse(e.shipping),
              c = window.Shopify.country,
              s,
              d;
            for (let p in l)
              "lastSynced" !== p &&
                l[p].countries.includes(c) &&
                l[p].condition.forEach((e) => {
                  "GREATER_THAN_OR_EQUAL_TO" === e.operator
                    ? (s = e.conditionCriteria.amount)
                    : "LESS_THAN_OR_EQUAL_TO" === e.operator &&
                      (d = e.conditionCriteria.amount);
                });
            if (!s && !d) return;
            let u = window?.Shopify?.routes?.root || "/",
              m = await (
                await fetch(
                  "/" === u
                    ? "/cart.js"
                    : u +
                        ("/" === u.charAt(u.length - 1)
                          ? "cart.js"
                          : "/cart.js")
                )
              ).json(),
              y = s - m.total_price / 100,
              f = "",
              g = "";
            y <= 0
              ? ((f = e.successText), (g = ""))
              : y < s
              ? ((f = e.ongoingText),
                (g = `<span style='color:${
                  e.specialColor
                };font-weight:bold'>${Utils.cf(
                  100 * y,
                  settings?.moneyFormat
                )}</span>`))
              : ((f = e.startingText),
                (g = `<span style='color:${
                  e.specialColor
                };font-weight:bold'>${Utils.cf(
                  100 * s,
                  settings?.moneyFormat
                )}</span>`));
            let h = document.createElement("span");
            if (
              (Utils.assignAtt(h, {
                class: "ewck-ab-f-s-t",
                style: `color:${e.titleTextColor};text-align:center`,
                innerHTML: f.replace("{{amount}}", g),
              }),
              m.total_price / 100 > d)
            )
              return;
            n.appendChild(h);
            break;
          case "Countdown timer":
            let b = document.createElement("div");
            Utils.assignAtt(b, {
              class: "ewck-ab-t-w",
              style: "display:flex;align-items:center;gap:10px",
            });
            let w = document.createElement("span");
            Utils.assignAtt(w, {
              class: "ewck-ab-t-t",
              style: `color:${e.titleTextColor};`,
              innerHTML: e.title.replace(
                "{{timer}}",
                `<span id='ewck-ab-t' style='color:${e.specialColor};font-weight:bold'>00:00:00</span>`
              ),
            });
            let k = { days: 0, hours: 0, minutes: 0, seconds: 0 },
              v = new Date(e.startDate).getTime(),
              $ = new Date(e.endDate).getTime() - v,
              x = Date.now() - v;
            if (x < 0) return;
            let T = $ - x,
              [C, S, _, I] = Utils.getDHMS(T);
            if (T > 0) {
              let [P, q, E, L] = Utils.getDHMS(T);
              (k.days = P), (k.hours = q), (k.minutes = E), (k.seconds = L);
            } else {
              if ("hide" === e.afterTimerExpire) return;
              (remaining = x % $),
                (T = $ - remaining),
                ([C, S, _, I] = Utils.getDHMS(T)),
                (k.days = C),
                (k.hours = S),
                (k.minutes = _),
                (k.seconds = I);
            }
            let B = setInterval(() => {
              if ((T -= 1e3) <= 0) {
                clearInterval(B);
                return;
              }
              let [t, i, a, n] = Utils.getDHMS(T);
              document.querySelector(".ewck-ab-t-t").innerHTML =
                e.title.replace(
                  "{{timer}}",
                  `<span id='ewck-ab-t' style='color:${
                    e.specialColor
                  };font-weight:bold'>${
                    t >= 5
                      ? t +
                        " " +
                        (e?.translateDaysMore ||
                          settings?.translateDaysMore ||
                          "days") +
                        " "
                      : t >= 2 && t <= 4
                      ? t +
                        " " +
                        (e?.translateDays ||
                          settings?.translateDays ||
                          "days") +
                        " "
                      : 1 === t
                      ? t +
                        " " +
                        (e?.translateDay || settings?.translateDay || "day") +
                        " "
                      : ""
                  }${i > 9 ? i : "0" + i}:${a > 9 ? a : "0" + a}:${
                    n > 9 ? n : "0" + n
                  }</span>`
                );
            }, 1e3);
            b.appendChild(w), n.appendChild(b);
            break;
          case "Email collect":
            let F = document.createElement("div");
            Utils.assignAtt(F, {
              class: "ewck-ab-e-c-w",
              style: `display:flex;${
                Utils.checkScreenSize() > 2
                  ? "gap:6px;"
                  : "flex-direction:column;"
              }align-items:center`,
            });
            let A = document.createElement("span");
            Utils.assignAtt(A, {
              class: "ewck-ab-e-c-t",
              style: `color:${e.titleTextColor};text-align:center`,
              innerHTML: e.title,
            });
            let M = document.createElement("div");
            Utils.assignAtt(M, {
              class: "ewck-e-c-i-b-w",
              style: "display:flex;gap:4px;flex-wrap:nowrap;align-items:center",
            });
            let D = document.createElement("input");
            Utils.assignAtt(D, {
              class: "ewck-ab-e-c-i",
              type: "text",
              onkeydown() {
                "2px solid red" === D.style.border &&
                  (D.style.border = "1px solid #b89f9f");
              },
            });
            let H = document.createElement("button");
            Utils.assignAtt(H, {
              class: "ewck-e-c-b",
              innerText: e.buttonText,
              style: `background:${e.buttonColor};color:${e.buttonTextColor};display:flex;flex-direction:column;align-items:center`,
              async onclick() {
                if (
                  D.value.match(
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                  )
                ) {
                  (H.style.width = H.offsetWidth + "px"),
                    (H.style.height = H.offsetHeight + "px"),
                    (H.style.position = "relative"),
                    (H.innerHTML = ""),
                    Utils.createSpinner(H);
                  if (!0 === (await Apis.createCustomer(D.value))) {
                    F.remove(), M.remove();
                    let t = document.createElement("span");
                    Utils.assignAtt(t, {
                      class: "ewck-ab-s-t",
                      style: `color:${e.titleTextColor}`,
                      innerHTML: e.couponText,
                    });
                    let i = document.createElement("span");
                    Utils.assignAtt(i, {
                      class: "ewck-ab-c-c",
                      style: `font-weight:bold;color:${e.specialColor}`,
                      innerText: e.discount,
                    }),
                      (n.style.flexWrap = "wrap");
                    let a = Utils.checkScreenSize();
                    (n.style.gap = a > 2 ? "6px" : 2 === a ? "4px" : ""),
                      n.append(t, i),
                      localStorage.setItem(`ewck-ab-c-main-${e.id}`, "true");
                  }
                } else
                  (D.style.border = "2px solid red"),
                    (D.style.margin = "-1px"),
                    D.classList.add("ewck-ab-e-e"),
                    setTimeout(() => {
                      D.classList.remove("ewck-ab-e-e");
                    }, 2e3);
              },
            }),
              M.append(D, H),
              F.append(A, M),
              n.appendChild(F);
        }
        a.appendChild(n),
          document.querySelector(`.ewck-ab-c-main-${e.id}`)?.remove(),
          "Bottom" === e.position
            ? ((a.style.position = "fixed"),
              (a.style.bottom = "0"),
              (a.style.left = "0"),
              (a.style.width = "100%"),
              document.body.appendChild(a))
            : "Top relative" === e.position
            ? ((a.style.position = "relative"),
              document.body.insertBefore(a, document.body.firstChild))
            : ((a.style.position = "sticky"),
              (a.style.top = "0"),
              (a.style.left = "0"),
              (a.style.zIndex = "9"),
              document.body.insertBefore(a, document.body.firstChild));
      },
      async handleBOGO(e) {
        let t = document.getElementById("ewck-bogo-block"),
          i = "";
        if (!t) {
          let a = settings?.bogoTargetSelector || "";
          (i = settings?.bogoInsert || (a ? "after" : "")),
            (t = a ? document.querySelector(a) : Utils.findTarget());
        }
        if (!t || !e.showOnProductPage) return;
        e?.translations &&
          e.translations[Shopify.locale] &&
          ((e.title = e.translations[Shopify.locale].title),
          (e.buyItemBadgeText =
            e.translations[Shopify.locale].buyItemBadgeText),
          (e.getItemBadgeText =
            e.translations[Shopify.locale].getItemBadgeText),
          (e.swapItemText = e.translations[Shopify.locale].swapItemText),
          (e.atcText = e.translations[Shopify.locale].atcText));
        let n = Utils.ce("div", { class: `ewck-bogo-c-main-${e.id}` });
        Utils.addCustomCSS(n, e.css),
          Utils.addCustomCSS(n, settings?.css || "");
        let o = Utils.ce("div", {
            class: "ewck-bogo-w",
            style: `margin-block:${e.marginY}px;background:${e.widgetBackgroundColor}`,
          }),
          r = Utils.ce("h2", {
            class: "ewck-bogo-t",
            style: `color:${e.widgetTitleColor}`,
            innerText: e.title,
          }),
          l = currentProduct,
          c = selectedVariant,
          s,
          d = (s = await Apis.getProduct(
            e.getSelectionProductIds[
              Math.floor(Math.random() * e.getSelectionProductIds.length)
            ].handle
          )).variants.find((e) => !0 === e.available),
          p = Utils.ce("div", { class: "ewck-bogo-p-w" }),
          u = Utils.ce("div", {
            class: "ewck-bogo-plus-w",
            innerHTML:
              '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 20 20" > <rect x="0" fill="none" width="20" height="20" /> <g fill="#4bae4e"> <path d="M15.8 4.2c3.2 3.21 3.2 8.39 0 11.6-3.21 3.2-8.39 3.2-11.6 0C1 12.59 1 7.41 4.2 4.2 7.41 1 12.59 1 15.8 4.2zm-4.3 11.3v-4h4v-3h-4v-4h-3v4h-4v3h4v4h3z" stroke="#4bae4e" strokeWidth="1px" /> </g> </svg>',
          });
        async function m() {
          let t = Utils.ce("div", { class: `ewck-bogo-b-p-w-${e.id}` }),
            i = Utils.ce("div", { class: "ewck-bogo-b-p" }),
            a = Utils.ce("div", {
              class: "ewck-bogo-b-b",
              style: `background:${e.badgeBackgroundColor};padding:4px;border-top-left-radius:4px;border-top-right-radius:4px;text-align:center`,
            }),
            n = Utils.ce("span", {
              style: `font-weight:bold;color:${e?.badgeTextColor}`,
              innerText: e.buyItemBadgeText.replace(
                "{{quantity}}",
                e.buyQuantity
              ),
            }),
            o = Utils.ce("div", { class: "ewck-bogo-b-p-i-w" }),
            r = Utils.ce("img", {
              class: "ewck-bogo-b-p-img",
              alt: "",
              src: c?.featured_image?.src || l?.featured_image || "",
            }),
            s = Utils.ce("div"),
            d = Utils.ce("div"),
            p = Utils.ce("span", {
              class: "ewck-bogo-b-p-t",
              innerText: l.title,
            });
          if (l.id !== currentProduct.id) {
            let y = Utils.ce("a", {
              href: `/products/${l.handle}`,
              target: "_blank",
              style: "text-decoration:none;color:inherit",
            });
            y.appendChild(p), d.appendChild(y);
            let f = Utils.ce("a", {
              href: `/products/${l.handle}`,
              target: "_blank",
            });
            f.appendChild(r), o.appendChild(f);
          } else d.appendChild(p), o.appendChild(r);
          let g = Utils.ce("div"),
            h = Utils.ce("span", {
              class: "ewck-bogo-b-p-p",
              innerHTML: Utils.cf(c.price, settings?.moneyFormat),
            }),
            b = Utils.ce("select", {
              class: "ewck-default-select",
              style: `max-width:140px;font-size:12px;padding:2px;${
                l.variants.length > 1 ? "display:block;" : "display:none;"
              }`,
              onchange(e) {
                let t = l.variants.find((t) => t.title === e.target.value);
                t &&
                  ((c = t),
                  (r.src = t?.featured_image?.src || l?.featured_image || ""),
                  (h.innerHTML = Utils.cf(t.price, settings?.moneyFormat)));
              },
            });
          l.variants.length > 1 &&
            l.variants.forEach((e) => {
              if (e.available) {
                let t = Utils.ce("option", {
                  value: e.title,
                  innerText: e.title,
                });
                b.appendChild(t);
              }
            });
          let w = Utils.ce("div", {
              style: l.variants.length <= 1 ? "margin-top:-6px" : "",
            }),
            k = Utils.ce("span", {
              class: "ewck-bogo-g-p-p",
              innerText: e.buyQuantity + "x",
            }),
            v = Utils.ce("div", { class: "ewck-bogo-swap-w" });
          if (e?.buySwap && e.buySelectionProductIds.length > 1) {
            let $ = Utils.ce("div", {
                class: "ewck-bogo-dropdown",
                style: "display:inline-block;",
              }),
              x = Utils.ce("button", {
                type: "button",
                class: "ewck-bogo-dropbtn ewck-bogo-buy-dropbtn",
                onclick() {
                  let e = document.getElementById("ewck-bogo-buy-dropdownMenu");
                  e.style.display =
                    "block" === e.style.display ? "none" : "block";
                },
                innerHTML: `${
                  e?.swapItemText || "Swap item"
                }<span style='font-size:13px;margin-left:5px'>▼</span>`,
              }),
              T = Utils.ce("div", {
                style: "z-index:2;",
                class:
                  "ewck-bogo-dropdown-content ewck-bogo-buy-dropdown-content",
                id: "ewck-bogo-buy-dropdownMenu",
              });
            try {
              let C = JSON.parse(JSON.stringify(e.buySelectionProductIds));
              async function S() {
                return (
                  await Promise.allSettled(
                    C.splice(0, 5).map((e) => Apis.getProduct(e.handle))
                  )
                ).map((e) => e.value);
              }
              async function _(e) {
                for (let t of e) {
                  if (!t?.id || t.id === l.id) continue;
                  let i = Utils.ce("div", {
                      class: "ewck-bogo-swap-content",
                      async onclick() {
                        T.style.display = "none";
                        let e = (l = await Apis.getProduct(
                          t.handle
                        )).variants.find((e) => !0 === e.available);
                        e && ((c = e), m());
                      },
                    }),
                    a = Utils.ce("div", { class: "ewck-bogo-swap-img" }),
                    n = Utils.ce("img", {
                      src: t?.featured_image,
                      alt: t.title,
                      style: "width:100%;height:100%;object-fit:cover;",
                    }),
                    o = Utils.ce("span", { innerText: t.title });
                  a.appendChild(n), i.append(a, o), T.appendChild(i);
                }
              }
              async function I() {
                let t = await S();
                await _(t);
                let i = !1;
                e.buySelectionProductIds.length + t.length > 6 &&
                  T.addEventListener(
                    "scroll",
                    async function e() {
                      Utils.onElementVisible(T.lastChild, async () => {
                        if (i) return;
                        (i = !0), (T.lastChild.style.position = "relative");
                        let t = Utils.createSpinner(T.lastChild);
                        setTimeout(() => {
                          t?.remove();
                        }, 800),
                          await _(await S(0, 5)),
                          T.scrollBy({ top: 40, behavior: "smooth" }),
                          (i = !1),
                          0 === C.length &&
                            T.removeEventListener("scroll", e, !0);
                      });
                    },
                    !0
                  ),
                  document.addEventListener("click", (e) => {
                    if (!e.target.className.includes("ewck-bogo-buy-dropbt"))
                      for (
                        var t = document.getElementsByClassName(
                            "ewck-bogo-buy-dropdown-content"
                          ),
                          i = 0;
                        i < t.length;
                        i++
                      ) {
                        var a = t[i];
                        "block" === a.style.display &&
                          (a.style.display = "none");
                      }
                  });
              }
              $.append(x, T), v.appendChild($), I();
            } catch (P) {
              console.log("error", P),
                console.log(
                  "Error on createBuyProd. Some products might not be available."
                );
            }
          }
          g.appendChild(h),
            s.append(d, g, b),
            settings?.showQuantityXBogoBuy === "true" &&
              (w.appendChild(k), s.appendChild(w)),
            a.appendChild(n),
            i.append(o, s),
            t.append(a, i, v),
            document.querySelector(`.ewck-bogo-b-p-w-${e.id}`)?.remove(),
            u.parentElement.insertBefore(t, u);
        }
        async function y() {
          let t = Utils.ce("div", {
              class: `ewck-bogo-g-p-w-${e.id}`,
              style:
                "border-bottom-left-radius:4px;border-bottom-right-radius:4px;position:relative;",
            }),
            i = Utils.ce("div", { class: "ewck-bogo-g-p" }),
            a = Utils.ce("div", {
              class: "ewck-bogo-g-b",
              style: `background:${e.badgeBackgroundColor};padding:4px;text-align:center;border-top-left-radius:4px;border-top-right-radius:4px`,
            }),
            n = Utils.ce("span", {
              style: `font-weight:bold;color:${e?.badgeTextColor}`,
              innerHTML: e.getItemBadgeText.replace(
                "{{discountValue}}",
                "Percentage" === e.discountType
                  ? e.discountValue + "%"
                  : "Amount off each" === e.discountType
                  ? Utils.cf(100 * e.discountValue, settings?.moneyFormat)
                  : "100%"
              ),
            }),
            o = Utils.ce("div", { class: "ewck-bogo-g-p-i-w" }),
            r = Utils.ce("a", {
              href: `/products/${s.handle}`,
              target: "_blank",
            }),
            l = Utils.ce("img", {
              class: "ewck-bogo-g-p-img",
              alt: "",
              src: s.variants[0].featured_image?.src || s?.featured_image || "",
            }),
            c = Utils.ce("div"),
            u = Utils.ce("div"),
            m = Utils.ce("a", {
              href: `/products/${s.handle}`,
              target: "_blank",
              style: "text-decoration:none;color:inherit",
            }),
            f = Utils.ce("span", {
              class: "ewck-bogo-g-p-t",
              innerText: s.title,
            }),
            g = Utils.ce("div"),
            h = Utils.ce("span", {
              class: "ewck-bogo-g-p-p",
              style: "margin-right:5px",
              innerHTML:
                "Free" === e.discountType
                  ? settings?.moneyFormat?.replace("{{amount}}", "0.00") ||
                    Shopify.money_format
                      .replace("{{amount}}", "0.00")
                      .replace("{{amount_no_decimals}}", "0.00")
                      .replace("{{amount_with_comma_separator}}", "0.00")
                      .replace(
                        "{{amount_no_decimals_with_comma_separator}}",
                        "0.00"
                      )
                  : Utils.cf(
                      +Utils.getBOGODisPrice(e, s.variants[0].price),
                      settings?.moneyFormat
                    ),
            }),
            b = Utils.ce("span", {
              class: "ewck-bogo-g-p-p",
              style: "text-decoration:line-through;opacity:0.8",
              innerHTML: Utils.cf(s.variants[0].price, settings?.moneyFormat),
            }),
            w = Utils.ce("select", {
              class: "ewck-default-select",
              style: `max-width:140px;font-size:12px;padding:2px;${
                s.variants.length > 1 ? "display:block;" : "display:none;"
              }`,
              onchange(t) {
                let i = s.variants.find((e) => e.title === t.target.value);
                i &&
                  ((d = i),
                  (l.src = i?.featured_image?.src || s?.featured_image || ""),
                  (b.innerHTML = Utils.cf(i.price, settings?.moneyFormat)),
                  (h.innerHTML =
                    "Free" === e.discountType
                      ? window.Shopify.currency.active + " 0.00"
                      : Utils.cf(
                          +Utils.getBOGODisPrice(e, i.price),
                          settings?.moneyFormat
                        )));
              },
            });
          s.variants.length > 1 &&
            s.variants.forEach((e) => {
              if (e.available) {
                let t = Utils.ce("option", {
                  value: e.title,
                  innerText: e.title,
                });
                w.appendChild(t);
              }
            });
          let k = Utils.ce("div", {
              style: s.variants.length <= 1 ? "margin-top:-6px" : "",
            }),
            v = Utils.ce("span", {
              class: "ewck-bogo-g-p-p",
              innerText: e.getQuantity + "x",
            }),
            $ = Utils.ce("div", { class: "ewck-bogo-swap-w" });
          if (e.getSwap && e.getSelectionProductIds.length > 1) {
            let x = Utils.ce("div", {
                class: "ewck-bogo-dropdown",
                style: "display:inline-block;",
              }),
              T = Utils.ce("button", {
                type: "button",
                class: "ewck-bogo-dropbtn ewck-bogo-get-dropbtn",
                onclick() {
                  let e = document.getElementById("ewck-bogo-dropdownMenu");
                  e.style.display =
                    "block" === e.style.display ? "none" : "block";
                },
                innerHTML: `${
                  e?.swapItemText || "Swap item"
                }<span style='font-size:13px;margin-left:5px'>▼</span>`,
              }),
              C = Utils.ce("div", {
                class:
                  "ewck-bogo-dropdown-content ewck-bogo-get-dropdown-content",
                id: "ewck-bogo-dropdownMenu",
              });
            try {
              let S = JSON.parse(JSON.stringify(e.getSelectionProductIds));
              async function _() {
                return (
                  await Promise.allSettled(
                    S.splice(0, 5).map((e) => Apis.getProduct(e.handle))
                  )
                ).map((e) => e.value);
              }
              async function I(e) {
                for (let t of e) {
                  if (!t?.id || t.id === s.id) continue;
                  let i = Utils.ce("div", {
                      class: "ewck-bogo-swap-content",
                      async onclick() {
                        let e = (s = await Apis.getProduct(
                          t.handle
                        )).variants.find((e) => !0 === e.available);
                        e && ((d = e), await y());
                      },
                    }),
                    a = Utils.ce("div", { class: "ewck-bogo-swap-img" }),
                    n = Utils.ce("img", {
                      src: t?.featured_image,
                      alt: t.title,
                      style: "width:100%;height:100%;object-fit:cover;",
                    }),
                    o = Utils.ce("span", { innerText: t.title });
                  a.appendChild(n), i.append(a, o), C.appendChild(i);
                }
              }
              async function P() {
                let t = await _();
                await I(t),
                  e.getSelectionProductIds.length + t.length > 6 &&
                    C.addEventListener("scroll", async () => {
                      let {
                        scrollTop: e,
                        scrollHeight: t,
                        clientHeight: i,
                      } = C;
                      if (e + i >= t) {
                        C.lastChild.style.position = "relative";
                        let a = Utils.createSpinner(C.lastChild);
                        setTimeout(() => {
                          a?.remove();
                        }, 800),
                          await I(await _(0, 5)),
                          C.scrollBy({ top: 40, behavior: "smooth" });
                      }
                    }),
                  document.addEventListener("click", (e) => {
                    if (!e.target.className.includes("ewck-bogo-get-dropbt"))
                      for (
                        var t = document.getElementsByClassName(
                            "ewck-bogo-get-dropdown-content"
                          ),
                          i = 0;
                        i < t.length;
                        i++
                      ) {
                        var a = t[i];
                        "block" === a.style.display &&
                          (a.style.display = "none");
                      }
                  });
              }
              x.append(T, C), $.appendChild(x), P();
            } catch (q) {
              console.log("error", q),
                console.log(
                  "Error on createGetProd. Some products might not be available."
                );
            }
          }
          k.appendChild(v),
            g.append(h, b),
            m.appendChild(f),
            u.appendChild(m),
            c.append(u, g, w, k),
            r.appendChild(l),
            o.appendChild(r),
            a.appendChild(n),
            i.append(o, c),
            t.append(a, i, $),
            document.querySelector(`.ewck-bogo-g-p-w-${e.id}`)?.remove(),
            p.appendChild(t);
        }
        let f = Utils.ce("div", { class: "ewck-bogo-atc-b-w" }),
          g = Utils.ce("button", {
            class: "ewck-bogo-atc-b",
            type: "button",
            style: `position:relative;background:${e.buttonColor};color:${e.buttonTextColor}`,
            async onclick() {
              (g.style.width = g.offsetWidth + "px"),
                (g.style.height = g.offsetHeight + "px"),
                (g.innerHTML = "");
              let t = Utils.createSpinner(g);
              (t.firstChild.style.border = "2px solid #ffffff"),
                (t.firstChild.style.borderTop = "2px solid #000000"),
                setTimeout(() => {
                  t?.remove(),
                    g.appendChild(Utils.ce("span", { innerText: e.atcText }));
                }, 2e3),
                await Utils.atc(
                  [
                    { id: c.id, quantity: e.buyQuantity },
                    { id: d.id, quantity: e.getQuantity },
                  ],
                  "buy_x_get_y",
                  e.id,
                  e.name
                );
            },
          }),
          h = Utils.ce("span", { innerText: e.atcText });
        g.appendChild(h),
          f.appendChild(g),
          p.append(u),
          await m(),
          await y(),
          o.append(r, p, f),
          n.appendChild(o),
          document
            .querySelectorAll(`.ewck-bogo-c-main-${e.id}`)
            .forEach((e) => e.remove()),
          "" === i ? t.appendChild(n) : Utils.insert(t, n, i);
      },
      handleBOGOCart(e, t, i) {
        let a = Utils.ce("div", { class: `ewck-bogo-cart-c-${e.id}-${t}` });
        Utils.addCustomCSS(a, e.css),
          Utils.addCustomCSS(a, settings?.css || "");
        let n = Utils.ce("div", { class: "ewck-bogo-cart-w" }),
          o = Utils.ce("span", {
            class: "ewck-bogo-cart-t",
            style: "font-size:12px",
            innerText: e.bogoCartText,
          }),
          r = Utils.ce("div", { class: "ewck-bogo-cart-prod-w" }),
          l = Utils.ce("div", { class: "ewck-bogo-cart-img-w" }),
          c = Utils.ce("a", {
            href: "/products/" + i.handle,
            target: "_blank",
          }),
          s = Utils.ce("img", {
            class: "ewck-bogo-cart-p-i",
            src: i.variants[0].featured_image?.src || i?.featured_image || "",
          }),
          d = Utils.ce("div", { class: "ewck-bogo-cart-info-w" }),
          p = Utils.ce("a", {
            href: "/products/" + i.handle,
            target: "_blank",
            style: "text-decoration:none;color:initial",
          }),
          u = Utils.ce("span", {
            class: `ewck-bogo-cart-item-title ewck-bogo-cart-t${t}`,
            innerText: i.title,
          }),
          m = i.variants.find((e) => !0 === e.available),
          y = Utils.ce("div", { class: "ewck-bogo-cart-price-w" }),
          f = +Utils.getBOGODisPrice(e, m.price),
          g = Utils.ce("span", {
            class: "ewck-bogo-cart-price-dis-" + t,
            style: "font-size:10px;margin-right:6px",
            innerHTML:
              "0.00" === f
                ? window.Shopify.currency.active + " " + f
                : Utils.cf(f, settings?.moneyFormat),
          }),
          h = Utils.ce("span", {
            class: "ewck-bogo-cart-price-ori-" + t,
            style: "font-size:10px;text-decoration:line-through;opacity:0.8;",
            innerHTML: Utils.cf(m.price, settings?.moneyFormat),
          }),
          b = Utils.ce("select", {
            class: "ewck-bogo-cart-v-s ewck-default-select",
            style: `display:${1 === i.variants.length ? "none" : "block"}`,
            onchange(t) {
              t.stopPropagation(),
                (m = i.variants.find((e) => e.title === t.target.value)),
                (s.src = m?.featured_image?.src || i?.featured_image || "");
              let a = +Utils.getBOGODisPrice(e, m.price);
              (g.innerHTML =
                "0.00" === a
                  ? window.Shopify.currency.active + " " + a
                  : Utils.cf(a, settings?.moneyFormat)),
                (h.innerHTML = Utils.cf(m.price, settings?.moneyFormat));
            },
          });
        i.variants.forEach((e) => {
          if (e.available) {
            let t = Utils.ce("option", { value: e.title, innerText: e.title });
            b.appendChild(t);
          }
        });
        let w = Utils.ce("button", {
          class: "ewck-bogo-cart-atc",
          type: "button",
          style: `position:relative;background:${e.buttonColor};color:${e.buttonTextColor};`,
          innerText: e.atcText,
          async onclick() {
            let t = Utils.createSpinner(w);
            (t.firstChild.style.border = "2px solid #ffffff"),
              (t.firstChild.style.borderTop = "2px solid #000000"),
              (t.firstChild.style.width = "10px"),
              (t.firstChild.style.height = "10px"),
              setTimeout(() => {
                t.remove();
              }, 2e3),
              await Utils.atc(
                [{ id: m.id, quantity: e.getQuantity }],
                "buy_x_get_y",
                e.id,
                e.name
              );
          },
        });
        return (
          y.append(g, h),
          p.appendChild(u),
          d.append(p, y, b, w),
          c.appendChild(s),
          l.appendChild(c),
          r.append(l, d),
          n.append(o, r),
          a.appendChild(n),
          document.querySelector(`.ewck-bogo-cart-c-${e.id}-${t}`)?.remove(),
          a
        );
      },
      handleVolumeDiscounts(data) {
        if (
          !data.showOnProductPage ||
          (settings?.excludeProductsVolumeDiscounts &&
            settings?.excludeProductsVolumeDiscounts.includes(
              currentProduct.id.toString()
            )) ||
          (data?.excludedProducts?.length &&
            data.excludedProducts.includes(currentProduct.id.toString()))
        )
          return;
        let parentElement = document.getElementById(
            "ewck-volume-discounts-block"
          ),
          insert = "";
        if (!parentElement) {
          let targetSelector = settings?.volumeDiscountsTargetSelector || "";
          (insert = settings?.volumeDiscountsInsert
            ? settings.volumeDiscountsInsert
            : "before"),
            (parentElement = targetSelector
              ? document.querySelector(targetSelector)
              : Utils.findAtc());
        }
        if (!parentElement) return;
        if (data?.translations) {
          let tcon = data.translations[Shopify.locale];
          if (tcon) {
            if (
              tcon.type === data?.template ||
              ("radio" === tcon.type && data?.template === void 0)
            )
              for (let key in tcon) data[key] = tcon[key];
            (data.title = data.translations[Shopify.locale].title),
              (data.cartText = data.translations[Shopify.locale].cartText),
              (data.atcText = data.translations[Shopify.locale].atcText);
          }
        }
        if (data.hideVariantPicker) {
          let picker = document.querySelector(
            settings?.variantPickerSelector !== "" &&
              settings?.variantPickerSelector !== void 0
              ? settings.variantPickerSelector
              : "variant-selects,variant-radios"
          );
          picker && (picker.style.display = "none");
        }
        if (data.hideQuantitySelector) {
          let quantity = document.querySelector(
            settings?.quantityWrapperSelector !== "" &&
              settings?.quantityWrapperSelector !== void 0
              ? settings.quantityWrapperSelector
              : ".product-form__quantity"
          );
          quantity && (quantity.style.display = "none");
        }
        let container = Utils.ce("div", { class: "ewck-vd-c" });
        Utils.addCustomCSS(container, data.css),
          Utils.addCustomCSS(container, settings?.css || "");
        let wrapper = Utils.ce("div", {
            class: "ewck-vd-w",
            style: `margin-block:${data.marginY}px;margin-inline:${data.marginX}px;`,
          }),
          widgetTitle = Utils.ce("h3", {
            class: "ewck-vd-wt",
            innerHTML: data.title,
            style: `color:${data?.titleTextColor}`,
          });
        if (data?.template === void 0 || data?.template === "radio") {
          let widgetBody = Utils.ce("div", { class: "ewck-vd-wb" });
          EWCK.qtyInput = document.querySelector(
            settings?.quantitySelector === "" ||
              settings?.quantitySelector === void 0
              ? "[name='quantity']"
              : settings?.quantitySelector
          );
          let selectedTier = {};
          data.discountTiers.forEach((tier, index) => {
            if (tier.default) {
              (selectedTier = {
                ...tier,
                selectedTierIndex: index,
                variants: [],
              }),
                (EWCK.volumeSelectedTier = selectedTier);
              for (let i = 1; i <= tier.quantity; i++)
                selectedTier.variants.push({ [selectedVariant.id]: 1 });
              EWCK.qtyInput && (EWCK.qtyInput.value = tier.quantity),
                (EWCK.volumeQty = tier.quantity);
            }
            let tierBody = Utils.ce("div", {
                class: `ewck-vd-tb ${
                  tier.default ? "ewck-vd-tb-selected" : ""
                }`,
                style: `display:${
                  data.showTier1 || 1 != +tier.quantity ? "block" : "none"
                };${
                  tier.default
                    ? `border:2px solid ${data.selectedTierBorderColor};margin:-1px;background-color:${data.selectedTierBackgroundColor}`
                    : "border:1px solid lightgray;margin:0px;background-color:transparent"
                };border-radius:4px;overflow:hidden;cursor:pointer;`,
                onclick() {
                  if (index === selectedTier.selectedTierIndex) return;
                  (selectedTier = {
                    ...tier,
                    selectedTierIndex: index,
                    variants: [],
                  }),
                    (EWCK.volumeSelectedTier = selectedTier),
                    EWCK.qtyInput && (EWCK.qtyInput.value = tier.quantity),
                    (EWCK.volumeQty = tier.quantity);
                  for (let i = 1; i <= tier.quantity; i++)
                    selectedTier.variants.push({ [selectedVariant.id]: 1 });
                  let prevSelTier = widgetBody.querySelector(
                    ".ewck-vd-tb-selected"
                  );
                  if (prevSelTier) {
                    prevSelTier.classList.remove("ewck-vd-tb-selected"),
                      (prevSelTier.style.background = "transparent"),
                      (prevSelTier.style.border = "1px solid lightgray"),
                      (prevSelTier.style.margin = "0px");
                    prevSelTier.querySelector(".ewck-vd-tb-tr").checked = !1;
                  }
                  tierBody.classList.add("ewck-vd-tb-selected"),
                    (tierBody.style.background =
                      data.selectedTierBackgroundColor),
                    (tierBody.style.border =
                      "2px solid" + data.selectedTierBorderColor),
                    (tierBody.style.margin = "-1px");
                  let curRadio;
                  if (
                    ((tierBody.querySelector(".ewck-vd-tb-tr").checked = !0),
                    currentProduct.variants.length > 1)
                  ) {
                    if (prevSelTier) {
                      let prevVrntsItems = prevSelTier.querySelector(
                        ".ewck-vd-tb-vw-selected"
                      );
                      prevVrntsItems.classList.remove("ewck-vd-tb-vw-selected"),
                        (prevVrntsItems.style.display = "none");
                    }
                    let curVrntsItems =
                      tierBody.querySelector(".ewck-vd-tb-vw");
                    curVrntsItems.classList.add("ewck-vd-tb-vw-selected"),
                      (curVrntsItems.style.display = "block");
                  }
                  settings?.volumeDiscountSelectedTierJS &&
                    eval(settings.volumeDiscountSelectedTierJS);
                },
              }),
              popularWrap = Utils.ce("div", {
                class: "ewck-vd-tb-pw",
                style: `background-color:${data.popularTextBackgroundColor}`,
              }),
              popular = Utils.ce("span", {
                class: "ewck-vd-tb-pt",
                style: `color:${data.popularTextColor}`,
                innerText: data.popularText,
              }),
              contentWrap = Utils.ce("div", { class: "ewck-vd-tb-cw" }),
              sqTierWrap = Utils.ce("div", { style: "width:100%" }),
              sqTierInfo = Utils.ce("div", { class: "ewck-vd-tb-sq-ti" }),
              radio = Utils.ce("input", {
                class: "ewck-vd-tb-tr",
                type: "radio",
                name: "ewck-vd-tb-r",
                checked: tier.default,
              }),
              title = Utils.ce("div", {
                class: "ewck-vd-tb-tt",
                style: "width: 100%",
                innerHTML:
                  1 === tier.quantity
                    ? data.tier1Title.replace(
                        "{{quantity}}",
                        `<span style='font-weight:bold'>${tier.quantity}</span>`
                      )
                    : data.tierTitle
                        .replace(
                          "{{quantity}}",
                          `<span style='font-weight:bold'>${tier.quantity}</span>`
                        )
                        .replace(
                          "{{discountValue}}",
                          `<span style='font-weight:bold'>${
                            "Percentage" === data.discountType
                              ? tier.discountValue + "%"
                              : Utils.cf(
                                  100 * tier.discountValue,
                                  settings?.moneyFormat
                                )
                          }</span>`
                        ),
              }),
              unitPrice = Utils.ce("span", {
                style: `font-weight:bold;white-space:nowrap;${
                  (settings?.volumeDiscountShowTotalPrice === "true" ||
                    data?.volumeDiscountShowTotalPrice === !0) &&
                  tier.quantity > 1
                    ? "text-decoration:line-through;color:red;"
                    : ""
                }`,
                innerHTML:
                  (settings?.volumeDiscountShowTotalPrice === "true" ||
                    data?.volumeDiscountShowTotalPrice === !0) &&
                  tier.quantity > 1
                    ? Utils.cf(
                        (
                          (selectedVariant.price * +tier.quantity) /
                          100
                        ).toFixed(settings?.toFixed || 2),
                        settings?.moneyFormat
                      )
                    : Utils.cf(
                        +Utils.getVDDisPrice(
                          selectedVariant.price,
                          data.discountType,
                          tier.discountValue
                        ),
                        settings?.moneyFormat
                      ),
              });
            sqTierWrap.appendChild(sqTierInfo);
            let saveBadge, totalPrice;
            if ((sqTierInfo.append(radio, title), tier.quantity > 1)) {
              let saveTotalWrap = Utils.ce("div", {
                class: "ewck-vd-tb-s-t-w",
              });
              (saveBadge = Utils.ce("span", {
                class: "ewck-vd-tb-sb",
                style: `background-color:${data.saveBadgeBackgroundColor};color:${data.saveBadgeTextColor};`,
                innerHTML: data.saveBadgeText.replace(
                  "{{saveAmount}}",
                  Utils.cf(
                    "Percentage" === data.discountType
                      ? +(
                          selectedVariant.price * +tier.quantity -
                          Utils.getVDDisPrice(
                            selectedVariant.price * +tier.quantity,
                            data.discountType,
                            tier.discountValue
                          )
                        ).toFixed(settings?.toFixed || 2)
                      : tier.quantity * tier.discountValue * 100,
                    settings?.moneyFormat
                  )
                ),
              })),
                (totalPrice = Utils.ce("span", {
                  style: `font-weight:bold;color:${data?.totalTextColor};white-space:nowrap;`,
                  innerHTML: data.totalPriceText.replace(
                    "{{totalAmount}}",
                    Utils.cf(
                      +Utils.getVDDisPrice(
                        (selectedVariant.price * +tier.quantity).toFixed(
                          settings?.toFixed || 2
                        ),
                        data.discountType,
                        "Percentage" === data.discountType
                          ? tier.discountValue
                          : tier.quantity * tier.discountValue
                      ),
                      settings?.moneyFormat
                    )
                  ),
                })),
                settings?.volumeDiscountReverseTotalPrice === "true"
                  ? (saveTotalWrap.append(saveBadge, unitPrice),
                    sqTierInfo.append(totalPrice))
                  : (saveTotalWrap.append(saveBadge, totalPrice),
                    sqTierInfo.append(unitPrice)),
                sqTierWrap.appendChild(saveTotalWrap);
            } else sqTierInfo.append(unitPrice);
            let vrnts = () => {
              let itemsWrap = Utils.ce("div", {
                class: `ewck-vd-tb-vw index-${index} ${
                  tier.default ? "ewck-vd-tb-vw-selected" : ""
                }`,
                style: `margin:4px 22px;${tier.default ? "" : "display:none"}`,
              });
              if (currentProduct.variants.length > 1) {
                let maxIteration =
                  "multiple" === data.variantPicker ? tier.quantity : 1;
                for (let i = 1; i <= maxIteration; i++) {
                  let selectWrap = Utils.ce("div", { class: "ewck-vd-tb-sw" });
                  if (
                    !(1 === tier.quantity || "single" === data.variantPicker)
                  ) {
                    let itemNumber = Utils.ce("span", {
                      class: "ewck-vd-tb-in",
                      style: "min-width:18px;white-space:nowrap;",
                      innerText: "#" + i,
                    });
                    selectWrap.append(itemNumber);
                  }
                  let vrntSelects = Utils.ce("select", {
                    class: "ewck-default-select",
                    style:
                      "width:100%;height:max-content;padding:4px;font-size:12px",
                    value: selectedVariant.id,
                    onchange(e) {
                      if (
                        ("multiple" === data.variantPicker
                          ? (selectedTier.variants[i - 1] = {
                              [e.target.value]: 1,
                            })
                          : (selectedTier.variants = selectedTier.variants.map(
                              (t) => ({ [e.target.value]: 1 })
                            )),
                        selectedTier.quantity > 1)
                      ) {
                        let tp = 0;
                        for (let item of selectedTier.variants)
                          for (let k in item)
                            currentProduct.variants.forEach((e) => {
                              e.id.toString() === k && (tp += e.price);
                            });
                        (saveBadge.innerHTML = data.saveBadgeText.replace(
                          "{{saveAmount}}",
                          Utils.cf(
                            "Percentage" === data.discountType
                              ? +(
                                  tp -
                                  Utils.getVDDisPrice(
                                    tp,
                                    data.discountType,
                                    tier.discountValue
                                  )
                                ).toFixed(settings?.toFixed || 2)
                              : tier.quantity * tier.discountValue * 100,
                            settings?.moneyFormat
                          )
                        )),
                          (totalPrice.innerHTML = data.totalPriceText.replace(
                            "{{totalAmount}}",
                            Utils.cf(
                              +Utils.getVDDisPrice(
                                tp.toFixed(settings?.toFixed || 2),
                                data.discountType,
                                "Percentage" === data.discountType
                                  ? tier.discountValue
                                  : tier.quantity * tier.discountValue
                              ),
                              settings?.moneyFormat
                            )
                          )),
                          (settings?.volumeDiscountShowTotalPrice === "true" ||
                            data?.volumeDiscountShowTotalPrice === !0) &&
                            tier.quantity > 1 &&
                            (unitPrice.innerHTML = Utils.cf(
                              (tp / 100).toFixed(settings?.toFixed || 2),
                              settings?.moneyFormat
                            ));
                      } else {
                        let selVar = currentProduct.variants.find(
                          (t) => t.id.toString() === e.target.value
                        );
                        unitPrice.innerHTML = Utils.cf(
                          +Utils.getVDDisPrice(
                            selVar.price,
                            data.discountType,
                            tier.discountValue
                          ),
                          settings?.moneyFormat
                        );
                      }
                      settings?.volumeDiscountSelectedTierJS &&
                        eval(settings.volumeDiscountSelectedTierJS);
                    },
                  });
                  currentProduct.variants.forEach((e) => {
                    if (e.available) {
                      let t = Utils.ce("option", {
                        title: "tier-" + index,
                        value: e.id,
                        innerText: e.title,
                        selected: selectedVariant.id === e.id,
                      });
                      vrntSelects.appendChild(t);
                    }
                  }),
                    selectWrap.appendChild(vrntSelects),
                    itemsWrap.appendChild(selectWrap);
                }
              }
              return itemsWrap;
            };
            sqTierWrap.appendChild(vrnts()),
              contentWrap.appendChild(sqTierWrap),
              tier.popular &&
                (popularWrap.appendChild(popular),
                tierBody.appendChild(popularWrap)),
              tierBody.appendChild(contentWrap),
              widgetBody.append(tierBody);
          });
          let helpText = Utils.ce("span", {
            class: "ewck-vd-ht",
            style: "color:#828282",
            innerText: data.helperText,
          });
          if (
            (wrapper.append(widgetTitle, widgetBody, helpText),
            data.showSeparateAtc)
          ) {
            let atcBtnWrap = Utils.ce("div", {
                class: "ewck-vd-atc-w",
                style: "width:100%",
              }),
              atcBtn = Utils.ce("button", {
                class: "ewck-vd-atc-btn",
                innerText: data.atcText,
                type: "button",
                onclick() {
                  let e = Utils.createSpinner(atcBtn);
                  setTimeout(() => {
                    e?.remove();
                  }, 1500);
                  let t = EWCK.volumeSelectedTier?.variants
                    ? Utils.getVDTierItems(EWCK.volumeSelectedTier)
                    : [{ id: selectedVariant.id, quantity: 1 }];
                  Utils.atc(t, "volume_discounts", data.id, data.name);
                },
              });
            atcBtnWrap.appendChild(atcBtn), wrapper.appendChild(atcBtnWrap);
          } else {
            let atcBtn;
            (atcBtn =
              settings?.atcSelector !== "" && settings?.atcSelector !== void 0
                ? document.querySelector(settings.atcSelector)
                : Utils.findAtc()) &&
              (null !== EWCK.vdAtcLis &&
                atcBtn.removeEventListener("click", EWCK.vdAtcLis, !0),
              atcBtn.addEventListener(
                "click",
                (EWCK.vdAtcLis = (e) => {
                  if (
                    (tools.terms_conditions_checkbox?.status === "Active" &&
                      tools.terms_conditions_checkbox?.enableOnProductPage ===
                        !0 &&
                      !1 === EWCK.tccProductCheck &&
                      document.querySelector(".ewck-tcc-product-page")) ||
                    EWCK.activeOnProd.includes("product_add_ons")
                  )
                    return;
                  if (settings?.optionsEnabled) {
                    atcBtn.removeEventListener("click", EWCK.vdAtcLis, !0),
                      atcBtn.click();
                    return;
                  }
                  e.stopPropagation(),
                    e.preventDefault(),
                    (atcBtn.style.position = "relative");
                  let t = Utils.createSpinner(atcBtn);
                  if (
                    (setTimeout(() => {
                      t?.remove();
                    }, 1500),
                    EWCK.volumeSelectedTier?.variants)
                  ) {
                    let i = Utils.getVDTierItems(EWCK.volumeSelectedTier);
                    Utils.atc(i, "volume_discounts", data.id, data.name);
                  } else
                    atcBtn.removeEventListener("click", EWCK.vdAtcLis, !0),
                      atcBtn.click();
                }),
                !0
              ));
          }
        } else {
          let widgetBody = Utils.ce("div", {
              class: "ewck-vd-wb-plain",
              style: "display:flex;flex-direction:column;gap:10px;",
            }),
            tbl = Utils.ce("table", { class: "ewck-bogo-discount-table" }),
            tblHead = Utils.ce("thead"),
            headTr = Utils.ce("tr"),
            headTh1 = Utils.ce("th", {
              innerText: data?.tableQtyText || "Quantity",
            }),
            headTh2 = Utils.ce("th", {
              innerText: data?.tableDisText || "Discount",
            }),
            tblBody = Utils.ce("tbody");
          for (let [index, tier] of data.discountTiers.entries()) {
            if (0 === index) continue;
            let bodyTr = Utils.ce("tr"),
              bodyTd1 = Utils.ce("td", {
                innerText: data?.tableQtyTextFormat
                  ? data.tableQtyTextFormat.replace(
                      "{{quantity}}",
                      tier.quantity
                    )
                  : `Buy ${tier.quantity}+`,
              }),
              bodyTd2 = Utils.ce("td", {
                innerHTML: data?.tableDisTextFormat
                  ? data.tableDisTextFormat.replace(
                      "{{discountValue}}",
                      `${
                        "Percentage" === data.discountType
                          ? tier.discountValue + "%"
                          : Utils.cf(
                              100 * tier.discountValue,
                              settings?.moneyFormat
                            )
                      }`
                    )
                  : `${
                      "Percentage" === data.discountType
                        ? tier.discountValue + "%"
                        : Utils.cf(
                            100 * tier.discountValue,
                            settings?.moneyFormat
                          )
                    }`,
              });
            bodyTr.append(bodyTd1, bodyTd2), tblBody.appendChild(bodyTr);
          }
          if (
            (headTr.append(headTh1, headTh2),
            tblHead.appendChild(headTr),
            tbl.append(tblHead, tblBody),
            widgetBody.appendChild(tbl),
            data?.helperText)
          ) {
            let helpText = Utils.ce("span", {
              class: "ewck-vd-ht",
              style: "color:#828282",
              innerText: data.helperText,
            });
            widgetBody.appendChild(helpText);
          }
          wrapper.append(widgetTitle, widgetBody);
        }
        container.appendChild(wrapper),
          document.querySelector(".ewck-vd-c")?.remove(),
          Utils.insert(parentElement, container, insert),
          data?.template !== "table" &&
            EWCK.activeOnProd.push("volume_discounts"),
          settings?.volumeDiscountSelectedTierJS &&
            eval(settings.volumeDiscountSelectedTierJS);
      },
      async handleOrderRewards(data, actionRequired = !1) {
        let cart;
        (cart =
          null === EWCK.cart ? window.CKCart : await Loaders.cartInitials(!0)),
          (EWCK.cart = cart);
        let parentElement = document.getElementById("ewck-order-rewards-block"),
          prev;
        if (
          (document.querySelectorAll(".ewck-or-c").forEach((e) => {
            e.remove();
          }),
          !cart.items.length && !data.showOnEmptyCart)
        )
          return;
        if (
          (parentElement ||
            (parentElement = document.querySelector(
              settings?.cartSelector !== "" && settings?.cartSelector !== void 0
                ? settings.cartSelector
                : "[id='cart'],cart-items form[action='/cart']"
            )),
          !parentElement && location.href.split("/").includes("cart"))
        ) {
          let h1 = document.querySelector("h1");
          h1 && (parentElement = h1.parentElement);
        }
        if (!parentElement) {
          if (
            (settings?.cartDrawerDelay &&
              (await new Promise((e) =>
                setTimeout(e, +settings.cartDrawerDelay)
              )),
            settings?.cartDrawerClickSelector && !1 === actionRequired)
          ) {
            let cartIcon = document.querySelector(
              settings.cartDrawerClickSelector
            );
            cartIcon &&
              cartIcon.addEventListener("click", () => {
                document.querySelector(".ewck-or-c") ||
                  EWCK.handleOrderRewards(data, !0);
              });
          }
          let defaultSelector = "cart-drawer-items,.cart__items",
            selector = settings?.cartDrawerSelector || defaultSelector;
          (parentElement = document.querySelector(selector)) ||
            (await new Promise((e) => setTimeout(e, 1e3)),
            (parentElement = document.querySelector(selector)));
        }
        if (data?.translations) {
          let tr = data.translations[Shopify.locale];
          if (
            tr &&
            (data.triggerType || (data.triggerType = "amount"),
            tr?.triggerType === data.triggerType)
          )
            for (let key in tr)
              key.includes("tier")
                ? tr[key].discountType === data[key].discountType &&
                  (data[key] = { ...data[key], ...tr[key] })
                : (data[key] = tr[key]);
        }
        let container = Utils.ce("div", {
          class: "ewck-or-c",
          style: "width:100%",
        });
        Utils.addCustomCSS(container, data.css),
          Utils.addCustomCSS(container, settings?.css || "");
        let wrapper = Utils.ce("div", {
            class: "ewck-or-w",
            style: `${
              data.marginY ? "margin-block:" + data.marginY + "px;" : ""
            }max-width:1200px;margin-left:auto;margin-right:auto`,
          }),
          cartTP =
            settings?.orderRewardsCalculate === "total_price"
              ? cart.total_price / 100
              : cart.original_total_price / 100,
          convertedT1MPrice = data.tier1.minimumTotal * +Shopify.currency.rate,
          convertedT2MPrice = data.tier2.minimumTotal * +Shopify.currency.rate,
          convertedT3MPrice = data.tier3.minimumTotal * +Shopify.currency.rate,
          cartTA = cart.item_count,
          freeProdsPrice = 0,
          freeProdsQuantity = 0,
          removeIds = [],
          zeroPriceProducts = [];
        for (let [index, lineItm] of cart.items.entries())
          if (lineItm.properties._ewckGift) {
            if (
              lineItm.discounts.length &&
              lineItm.discounts.some(
                (e) =>
                  (data.tier1.enabled &&
                    "Free gift" === data.tier1.discountType &&
                    data.tier1.discountTitle === e.title) ||
                  (data.tier2.enabled &&
                    "Free gift" === data.tier2.discountType &&
                    data.tier2.discountTitle === e.title) ||
                  (data.tier3.enabled &&
                    "Free gift" === data.tier3.discountType &&
                    data.tier3.discountTitle === e.title)
              )
            )
              (freeProdsPrice += lineItm.price * lineItm.quantity),
                (cartTP -=
                  settings?.orderRewardsCalculate === "total_price"
                    ? 0
                    : (lineItm.price * lineItm.quantity) / 100) <
                  data[lineItm.properties._ewckGift.split(" ").at(-1)]
                    .minimumTotal *
                    +Shopify.currency.rate &&
                  removeIds.push(lineItm.variant_id),
                (freeProdsQuantity += lineItm.quantity);
            else if (0 === lineItm.original_line_price) {
              if ((zeroPriceProducts.push(lineItm), lineItm.quantity > 1)) {
                let propValue = lineItm.properties._ewckGift;
                for (let tier of ["tier1", "tier2", "tier3"])
                  if (
                    data[tier].enabled &&
                    "Free gift" === data[tier].discountType &&
                    propValue.includes(data[tier].discountTitle)
                  ) {
                    let giftProd = data[tier].gifts.find(
                      (e) => e.variantId === lineItm.variant_id.toString()
                    );
                    if (lineItm.quantity > +giftProd.quantity) {
                      removeIds.push(lineItm.variant_id);
                      break;
                    }
                  }
              }
            } else
              lineItm.discounts.length || removeIds.push(lineItm.variant_id);
          }
        if (removeIds.length) {
          let success;
          (await Utils.removeCartItem(removeIds)) &&
            (settings?.afterGiftRemoveJS
              ? eval(settings.afterGiftRemoveJS)
              : location.reload());
        }
        for (let tier of ["tier1", "tier2", "tier3"])
          if (
            data[tier].enabled &&
            "Free gift" === data[tier].discountType &&
            cartTP < data[tier].minimumTotal * +Shopify.currency.rate
          ) {
            let found = cart.items.find(
              (e) =>
                !!e.discounts.find((e) => e.title === data[tier].discountTitle)
            );
            if (found) {
              let additionalGiftProduct;
              if (
                cart.items.find(
                  (e) =>
                    e.variant_id === found.variant_id &&
                    0 === e.discounts.length
                )
              ) {
                let cartItems = [],
                  discountCodes = [];
                cart.items.forEach((e) => {
                  e.discounts.find((e) => e.title === data[tier].discountTitle)
                    ? cartItems.push({ id: found.variant_id, quantity: 1 })
                    : (cartItems.push({
                        id: e.variant_id,
                        quantity: e.quantity,
                        properties: e.properties,
                      }),
                      (discountCodes = discountCodes.concat(
                        e.discounts.map((e) => e.title)
                      )));
                }),
                  Apis.applyMultipleDiscounts(cartItems, discountCodes);
              } else {
                let filter;
                if (
                  1 ===
                  cart.items.filter((e) => e.variant_id === found.variant_id)
                    .length
                ) {
                  let successRemove;
                  Utils.removeCartItem([found.variant_id]) &&
                    (settings?.afterGiftRemoveJS
                      ? eval(settings.afterGiftRemoveJS)
                      : location.reload());
                } else cartTP = +data[tier].minimumAmount;
              }
            }
          }
        data.tier1.enabled &&
          data.tier1.discountType &&
          (cartTA -= freeProdsQuantity);
        let eligibleTier = {};
        data?.triggerType === "quantity"
          ? cartTA < +data.tier1.minimumQuantity
            ? ((eligibleTier.tier = "tier1"),
              (eligibleTier.remaining = +data.tier1.minimumQuantity - cartTA),
              (eligibleTier.props = data.tier1))
            : data.tier2.enabled &&
              cartTA >= +data.tier1.minimumQuantity &&
              cartTA < +data.tier2.minimumQuantity
            ? ((eligibleTier.tier = "tier2"),
              (eligibleTier.remaining = +data.tier2.minimumQuantity - cartTA),
              (eligibleTier.props = data.tier2))
            : data.tier3.enabled &&
              cartTA >= +data.tier2.minimumQuantity &&
              cartTA < +data.tier3.minimumQuantity &&
              ((eligibleTier.tier = "tier3"),
              (eligibleTier.remaining = +data.tier3.minimumQuantity - cartTA),
              (eligibleTier.props = data.tier3))
          : (settings?.orderRewardsCalculate === "total_price" &&
              cart.cart_level_discount_applications.length &&
              cart.cart_level_discount_applications.forEach((e) => {
                cartTP += e.total_allocated_amount / 100;
              }),
            cartTP < convertedT1MPrice
              ? ((eligibleTier.tier = "tier1"),
                (eligibleTier.remaining = (convertedT1MPrice - cartTP).toFixed(
                  settings?.toFixed || 2
                )),
                (eligibleTier.props = data.tier1))
              : data.tier2.enabled &&
                cartTP >= convertedT1MPrice &&
                cartTP < convertedT2MPrice
              ? ((eligibleTier.tier = "tier2"),
                (eligibleTier.remaining = (convertedT2MPrice - cartTP).toFixed(
                  settings?.toFixed || 2
                )),
                (eligibleTier.props = data.tier2))
              : data.tier3.enabled &&
                cartTP >= convertedT2MPrice &&
                cartTP < convertedT3MPrice &&
                ((eligibleTier.tier = "tier3"),
                (eligibleTier.remaining = (convertedT3MPrice - cartTP).toFixed(
                  settings?.toFixed || 2
                )),
                (eligibleTier.props = data.tier3)));
        let progressTitle = "",
          progressPercent = 100;
        if (Object.keys(eligibleTier).length) {
          let text = "";
          switch (
            ((progressTitle = `<span style='color:${data.textColor}'>${(text =
              data?.triggerType === "quantity"
                ? "Free shipping" === eligibleTier.props.discountType
                  ? eligibleTier.props.shippingQuantityProgressText
                  : "Free gift" === eligibleTier.props.discountType
                  ? eligibleTier.props.giftQuantityProgressText
                  : eligibleTier.props.orderQuantityProgressText
                : "Free shipping" === eligibleTier.props.discountType
                ? eligibleTier.props.shippingProgressText
                : "Free gift" === eligibleTier.props.discountType
                ? eligibleTier.props.giftProgressText
                : eligibleTier.props.orderProgressText)
              .replace(
                "{{amount}}",
                `<span style='font-weight:bold;color:${
                  data.specialTextColor
                }'>${Utils.cf(
                  eligibleTier.remaining,
                  settings?.moneyFormat
                )}</span>`
              )
              .replace(
                "{{quantity}}",
                `<span style='font-weight:bold;color:${data.specialTextColor}'>${eligibleTier.remaining}</span>`
              )
              .replace(
                "{{discountValue}}",
                `<span style='font-weight:bold;color:${
                  data.specialTextColor
                }'>${
                  "Percentage" === eligibleTier.props.discountType
                    ? eligibleTier.props.discountValue + "%"
                    : Utils.cf(
                        100 * eligibleTier.props.discountValue,
                        settings?.moneyFormat
                      )
                }</span>`
              )}</span>`),
            eligibleTier.tier)
          ) {
            case "tier1":
              data.tier2.enabled && (progressPercent = 50),
                data.tier3.enabled && (progressPercent = 33.33),
                (progressPercent =
                  data?.triggerType === "quantity"
                    ? (cartTA / eligibleTier.props.minimumQuantity) *
                      progressPercent
                    : (progressPercent *
                        ((100 * cartTP) /
                          (eligibleTier.props.minimumTotal *
                            +Shopify.currency.rate))) /
                      100);
              break;
            case "tier2":
              if (
                ("Free gift" === data.tier1.discountType &&
                  Utils.addFreeGifts(cart, data.tier1, "tier1"),
                (progressPercent = 50),
                data.tier3.enabled && (progressPercent = 33.33),
                data?.triggerType === "quantity")
              ) {
                let remaining =
                  eligibleTier.props.minimumQuantity -
                  data.tier1.minimumQuantity;
                progressPercent =
                  (progressPercent *
                    (((cartTA - data.tier1.minimumQuantity) * 100) /
                      remaining)) /
                    100 +
                  progressPercent;
              } else
                progressPercent =
                  (progressPercent *
                    (((cartTP - convertedT1MPrice) * 100) /
                      (eligibleTier.props.minimumTotal *
                        +Shopify.currency.rate -
                        convertedT1MPrice))) /
                    100 +
                  progressPercent;
              break;
            case "tier3":
              if (
                ("Free gift" === data.tier1.discountType &&
                  Utils.addFreeGifts(cart, data.tier1, "tier1"),
                "Free gift" === data.tier2.discountType &&
                  Utils.addFreeGifts(cart, data.tier2, "tier2"),
                (progressPercent = 33.33),
                data?.triggerType === "quantity")
              ) {
                let remaining =
                  eligibleTier.props.minimumQuantity -
                  data.tier2.minimumQuantity;
                progressPercent =
                  (progressPercent *
                    (((cartTA - data.tier2.minimumQuantity) * 100) /
                      remaining)) /
                    100 +
                  2 * progressPercent;
              } else
                progressPercent =
                  (progressPercent *
                    (((cartTP - convertedT2MPrice) * 100) /
                      (eligibleTier.props.minimumTotal *
                        +Shopify.currency.rate -
                        convertedT2MPrice))) /
                    100 +
                  2 * progressPercent;
          }
        } else
          (progressTitle = data.successText),
            (progressPercent = 100),
            data.tier1.enabled &&
              "Free gift" === data.tier1.discountType &&
              Utils.addFreeGifts(cart, data.tier1, "tier1"),
            data.tier2.enabled &&
              "Free gift" === data.tier2.discountType &&
              Utils.addFreeGifts(cart, data.tier2, "tier2"),
            data.tier3.enabled &&
              "Free gift" === data.tier3.discountType &&
              Utils.addFreeGifts(cart, data.tier3, "tier3");
        Utils.createGiftClaim(
          cart,
          cartTP,
          cartTA,
          data,
          eligibleTier,
          progressPercent,
          zeroPriceProducts
        ),
          0 === progressPercent &&
            (progressTitle = `<span style='font-size:18px'>${data.emptyCartText}</span>`);
        let progressTitleWrap = Utils.ce("div", {
            class: "ewck-or-ptw",
            innerHTML: progressTitle,
          }),
          progressBarWrap = Utils.ce("div", {
            class: "ewck-or-pbw",
            style: `margin-right: ${
              data.tier2.enabled || !0 !== data.tier1.showIcon ? "0px" : "-20px"
            }`,
          }),
          progressBarBackground = Utils.ce("div", {
            class: "ewck-or-pbb",
            style: `background:${data.progressBackgroundColor};margin-top:${
              data.tier2.enabled || data.tier1.showIcon ? "12px" : "0px"
            };${
              (data.tier1.showIcon && !data.tier2.enabled) || data.tier2.enabled
                ? ""
                : "margin-right:0px;"
            }`,
          }),
          progressBarLevel = Utils.ce("div", {
            class: "ewck-or-pbl",
            style: `background:${data.progressLevelColor};width:${progressPercent}%;`,
          }),
          iconsWrap = Utils.ce("div", {
            class: `ewck-or-iw ewck-or-iw-${
              data.tier2.enabled && !data.tier3.enabled ? "tier2" : "tier3"
            }`,
            style: "display:grid;",
          });
        if (
          (["tier1", "tier2", "tier3"].forEach((e, t) => {
            if (
              (0 === t && (data.tier1.showIcon || data.tier2.enabled)) ||
              (1 === t && data.tier2.enabled) ||
              (2 === t && data.tier3.enabled)
            ) {
              0 === t
                ? (iconsWrap.style.gridTemplateColumns = "1fr")
                : 1 === t
                ? (iconsWrap.style.gridTemplateColumns = "1fr 1fr")
                : 2 === t &&
                  (iconsWrap.style.gridTemplateColumns = "1fr 1fr 1fr");
              let i = Utils.ce("div", {
                  style: "width:100%;display:flex;justify-content:end",
                }),
                a = Utils.ce("div", {
                  class: `ewck-or-icon-w ewck-or-icon-w-tier${t + 1}`,
                }),
                n = !1;
              (progressPercent >= 100 ||
                eligibleTier?.tier?.charAt(eligibleTier.tier.length - 1) >
                  t + 1) &&
                (n = !0);
              let o = n
                  ? data.progressLevelColor
                  : data.progressBackgroundColor,
                r = Utils.ce("div", {
                  class: `ewck-or-icon-bg ewck-or-icon-bg-tier${t + 1}`,
                  style: `border:2px solid ${o};background:${o}`,
                }),
                l = Utils.ce("div", {
                  class: `ewck-or-icon-svg-w ewck-or-icon-svg-w-tier${t + 1} ${
                    "Free gift" === data[e].discountType
                      ? "ewck-or-icon-svg-w-gift"
                      : "Free shipping" === data[e].discountType
                      ? "ewck-or-icon-svg-w-free-shipping"
                      : "Percentage" === data[e].discountType ||
                        "Fixed amount" === data[e].discountType
                      ? "ewck-or-icon-svg-w-amount-discount"
                      : ""
                  }`,
                  fill: data.progressLevelColor,
                  innerHTML:
                    "Free shipping" === data[e].discountType
                      ? settings?.customFreeShippingIcon
                        ? `<img alt='' src='${settings?.customFreeShippingIcon}' style='width:25px;height:25px;' />`
                        : data.shippingSvg.replace(
                            "<svg",
                            `<svg ${
                              n ? "id='ewck-or-free-shipping-eligible'" : ""
                            } fill='${n ? "#fff" : data.progressLevelColor}' `
                          )
                      : "Free gift" === data[e].discountType
                      ? settings?.customFreeGiftIcon
                        ? `<img alt='' src='${settings?.customFreeGiftIcon}' style='width:25px;height:25px;' />`
                        : data.giftIcon.replace(
                            "<svg",
                            `<svg ${
                              n ? "id='ewck-or-gift-eligible'" : ""
                            } fill='${n ? "#fff" : data.progressLevelColor}' `
                          )
                      : settings?.customFreeDiscountIcon
                      ? `<img alt='' src='${settings?.customFreeDiscountIcon}' style='width:25px;height:25px;' />`
                      : data.discountSvg.replace(
                          "<svg",
                          `<svg ${
                            n ? "id='ewck-or-discount-eligible'" : ""
                          } fill='${n ? "#fff" : data.progressLevelColor}' `
                        ),
                }),
                c = Utils.ce("span", {
                  class: `ewck-or-icon-t ewck-or-icon-t-tier${t + 1}`,
                  style: "font-size:12px",
                  innerHTML:
                    "Free shipping" === data[e].discountType
                      ? data[e].shippingTitle
                      : data[e].orderTitle,
                });
              r.appendChild(l),
                a.append(r, c),
                i.appendChild(a),
                iconsWrap.appendChild(i);
            }
          }),
          progressBarBackground.appendChild(progressBarLevel),
          progressBarWrap.append(progressBarBackground, iconsWrap),
          wrapper.append(progressTitleWrap, progressBarWrap),
          container.appendChild(wrapper),
          parentElement &&
            parentElement.parentElement.insertBefore(container, parentElement),
          settings?.duplicateOrderRewardsWidget)
        ) {
          if (0 === cart.items.length && data?.showOnEmptyCart === !1) return;
          let target = document.querySelector(
            settings.duplicateOrderRewardsWidget
          );
          target &&
            !target.parentElement.querySelector(".ewck-or-c") &&
            target.parentElement.insertBefore(container.cloneNode(!0), target);
        }
      },
      handleAgeVerification(e) {
        let t = localStorage.getItem(`ewck-av-conf-${e.expires}`);
        if (t) {
          let i = Date.now() - +t;
          if (864e5 * +e.expires - i > 0) return;
          localStorage.removeItem(`ewck-av-conf-${e.expires}`);
        }
        if ((document.querySelector(".ewck-av-c")?.remove(), e?.translations)) {
          let a = e.translations[Shopify.locale];
          if (a) {
            if (a.type === e.actionButton) for (let n in a) e[n] = a[n];
            e.content = a.content;
          }
        }
        let o = Utils.ce("div", { class: "ewck-av-c", style: "width:100%" });
        function r() {
          o.remove(),
            localStorage.setItem(`ewck-av-conf-${e.expires}`, Date.now());
        }
        Utils.addCustomCSS(o, e.css),
          Utils.addCustomCSS(o, settings?.css || "");
        let l = Utils.ce("div", { class: "ewck-av-ow" }),
          c = Utils.ce("div", { class: "ewck-av-w" }),
          s = Utils.ce("div", {
            class: "ewck-av-c-w sun-editor-editable",
            style: `border-radius:${e.borderRadius}px;padding-top:8px;padding-bottom:30px;background:${e.backgroundColor}`,
          }),
          d = Utils.ce("div", {
            class: "ewck-av-content",
            innerHTML: e.content,
          }),
          p = Utils.ce("div", {
            class: "ewck-av-b-w",
            style:
              "display:flex;justify-content:center;gap:6px;margin-top:20px",
          }),
          u = Utils.ce("button", {
            class: "ewck-av-single-btn",
            style: `${
              "Single" === e.actionButton ? "" : "display:none;"
            }border-radius:${e.borderRadius / 2 + "px"};background:${
              e.singBtnColor
            };color:${e.singTextColor}`,
            innerText: e.singleBtnText,
            onclick() {
              r();
            },
          }),
          m = Utils.ce("button", {
            class: "ewck-av-multiple-btn-1",
            style: `${
              "Multiple" === e.actionButton ? "" : "display:none;"
            }border-radius:${e.borderRadius / 2 + "px"};background:${
              e.multi1BtnColor
            };color:${e.multi1TextColor}`,
            innerText: e.multipleBtnText1,
            onclick() {
              r();
            },
          }),
          y = Utils.ce("button", {
            class: "ewck-av-multiple-btn-2",
            style: `${
              "Multiple" === e.actionButton ? "" : "display:none;"
            }border-radius:${e.borderRadius / 2 + "px"};background:${
              e.multi2BtnColor
            };color:${e.multi2TextColor}`,
            innerText: e.multipleBtnText2,
            onclick() {
              if ("Back" === e.discardAction) history.back();
              else if ("Message" === e.discardAction) {
                if (document.getElementById("ewck-av-discard-message")) return;
                let t = Utils.ce("div", {
                    id: "ewck-av-discard-message",
                    style: "text-align:center;margin-top:16px",
                  }),
                  i = Utils.ce("span", {
                    class: "ewck-av-d-m",
                    style: "color:red",
                    innerText: e.discardMessage,
                  });
                t.appendChild(i), s.appendChild(t);
              } else
                location.href = e.discardRedirectUrl.includes("http")
                  ? e.discardRedirectUrl
                  : "https://" + e.discardRedirectUrl;
            },
          });
        p.append(u, m, y),
          s.append(d, p),
          c.appendChild(s),
          o.append(c, l),
          document.body.appendChild(o),
          Utils.loadRTEStyle();
        let f = document.documentElement.scrollTop,
          g = document.documentElement.scrollLeft;
        window.onscroll = function () {
          document.querySelector(".ewck-av-c") && window.scrollTo(g, f);
        };
      },
      async handleComboProducts(e) {
        let t = document.getElementById("ewck-combo-products-block"),
          i = "";
        if (!t) {
          let a = settings?.comboProductsTargetSelector || "";
          (i = settings?.comboProductsInsert || (a ? "after" : "")),
            (t = a ? document.querySelector(a) : Utils.findTarget());
        }
        if (!t) return;
        e?.translations &&
          e.translations[Shopify.locale] &&
          ((e.title = e.translations[Shopify.locale].title),
          (e.saveBadgeText = e.translations[Shopify.locale].saveBadgeText),
          (e.totalPriceText = e.translations[Shopify.locale].totalPriceText),
          (e.atcText = e.translations[Shopify.locale].atcText));
        let n = Utils.ce("div", { class: "ewck-combo-c" });
        Utils.addCustomCSS(n, settings?.css || "");
        let o = Utils.ce("div", {
            class: "ewck-combo-w",
            style: `background:${e.widgetBackgroundColor};margin-block:${e.marginY}px`,
          }),
          r = Utils.ce("h3", {
            class: "ewck-combo-wt",
            style: `margin:0px;font-size:18px;font-weight:bold;color:${e.titleColor}`,
            innerHTML: e.title,
          }),
          l = Utils.ce("div", { class: "ewck-combo-wb" }),
          c = [...e.selectedProducts.map((e) => Apis.getProduct(e.handle))],
          s = 0,
          d = {},
          p = (await Promise.allSettled(c)).map((e) => {
            let t = e.value.variants.find((e) => !0 === e.available);
            return (
              t &&
                ((s = (+s + t.price / 100).toFixed(settings?.toFixed || 2)),
                (d[e.value.id] = t.id)),
              e.value
            );
          });
        if (Object.keys(d).length < p.length) return;
        p.sort(function (e, t) {
          return e.id == currentProduct.id
            ? -1
            : t.id == currentProduct.id
            ? 1
            : 0;
        });
        let u =
          "Percentage" === e.discountType
            ? e.discountPercentage
            : (100 * e.discountAmount) / s;
        function m(t) {
          let i = +t;
          if ("Percentage" === e.discountType)
            i -= (i * e.discountPercentage) / 100;
          else if ("Fixed amount" === e.discountType) {
            let a = (100 * e.discountAmount) / +s;
            i -= (i * a) / 100;
          }
          return i.toFixed(settings?.toFixed || 2);
        }
        for (let [y, f] of e.selectedProducts.entries()) {
          let g = p[y],
            h = g.variants.find((e) => !0 === e.available);
          if (!d) return;
          let b = Utils.ce("div", { class: "ewck-combo-pw" }),
            w = Utils.ce("div", { class: "ewck-combo-iw" }),
            k = Utils.ce("a", {
              href: "/products/" + g.handle,
              target: "_blank",
              style: "text-decoration:none;color:initial",
            }),
            v = Utils.ce("img", {
              class: "ewck-combo-img",
              alt: "",
              src: h.featured_image?.src || g?.featured_image || "",
            }),
            $ = Utils.ce("div", { class: "ewck-combo-cw" }),
            x = Utils.ce("a", {
              href: "/products/" + g.handle,
              target: "_blank",
              style: "text-decoration:none;color:initial",
            }),
            T = Utils.ce("div", {
              style: "font-size:15px;line-height:1.2;font-weight:bold",
              innerText: g.title,
            }),
            C = Utils.ce("div", {
              class: "ewck-combo-pr-w",
              style: "line-height:1.2",
            }),
            S = Utils.ce("span", {
              class: `ewck-combo-dis-pr-${y}`,
              style: "font-size:12px;margin-right:6px",
              innerHTML: Utils.cf(+m(h.price), settings?.moneyFormat),
            }),
            _ = Utils.ce("span", {
              class: `ewck-combo-ori-pr-${y}`,
              style:
                "font-size:12px;margin-right:6px;text-decoration:line-through;opacity:0.8",
              innerHTML: Utils.cf(h.price, settings?.moneyFormat),
            }),
            I = Utils.ce("select", {
              style: `margin-top:6px;max-width:140px;display:${
                1 === g.variants.length ? "none" : "block"
              }`,
              class: "ewck-default-select ewck-combo-vrnt-sel",
              onchange(t) {
                let i = g.variants.find(
                  (e) => e.id.toString() === t.target.value
                );
                if (i) {
                  d[g.id] = i.id;
                  let a = 0;
                  Object.keys(d).forEach((e) => {
                    let t = p
                      .find((t) => t.id === +e)
                      .variants.find((t) => t.id === d[e]);
                    t && (a += t.price / 100);
                  });
                  let n =
                      "Percentage" === e.discountType
                        ? e.discountPercentage
                        : (100 * e.discountAmount) / a,
                    o = document.querySelector(".ewck-combo-save-b");
                  o.innerHTML = e.saveBadgeText.replace(
                    "{{discountValue}}",
                    Utils.cf(((a * n) / 100) * 100, settings?.moneyFormat)
                  );
                  let r = document.querySelector(".ewck-combo-total-t");
                  (r.innerHTML = e.totalPriceText.replace(
                    "{{totalAmount}}",
                    Utils.cf((a - (a * n) / 100) * 100, settings?.moneyFormat)
                  )),
                    (v.src = i?.featured_image?.src || g?.featured_image || ""),
                    (S.innerHTML = Utils.cf(
                      +m(i.price),
                      settings?.moneyFormat
                    )),
                    (_.innerHTML = Utils.cf(i.price, settings?.moneyFormat));
                }
              },
            });
          g.variants.length > 1 &&
            g.variants.forEach((e) => {
              if (e.available) {
                let t = Utils.ce("option", { value: e.id, innerText: e.title });
                I.appendChild(t);
              }
            });
          let P = Utils.ce("div", {
            class: "ewck-combo-icon-pw",
            style: `display:${e.selectedProducts[y + 1] ? "block" : "none"}`,
            innerHTML: e.plusSvg,
          });
          C.appendChild(S),
            ("Fixed amount" !== e.discountType ||
              ("Fixed amount" === e.discountType &&
                "" !== e.discountAmount &&
                0 !== e.discountAmount &&
                "0" !== e.discountAmount)) &&
              C.append(_),
            x.appendChild(T),
            $.append(x, C, I),
            k.appendChild(v),
            w.appendChild(k),
            b.append(w, $),
            l.append(b, P);
        }
        let q = Utils.ce("div", {
            class: "ewck-combo-summ-w",
            style:
              "" === e.saveBadgeText.trim() && "" === e.totalPriceText.trim()
                ? "display:none"
                : "",
          }),
          E = Utils.ce("span", {
            class: "ewck-combo-save-b",
            style: `opacity:${
              "" === e.saveBadgeText.trim() ? "0" : 1
            };background:${
              e.saveBadgeBackgroundColor
            };white-space:nowrap;padding:3px 6px;font-size:12px;font-weight:bold;color:${
              e.saveBadgeTextColor
            }`,
            innerHTML: e.saveBadgeText.replace(
              "{{discountValue}}",
              Utils.cf(((s * u) / 100) * 100, settings?.moneyFormat)
            ),
          }),
          L = Utils.ce("span", {
            class: "ewck-combo-total-t",
            style: `opacity:${
              "" === e.totalPriceText.trim() ? "0" : "1"
            };font-sze:13px;font-weight:bold;`,
            innerHTML: e.totalPriceText.replace(
              "{{totalAmount}}",
              Utils.cf((s - (s * u) / 100) * 100, settings?.moneyFormat)
            ),
          }),
          B = Utils.ce("div", {
            style: "margin-top:4px;text-align:center",
            class: "ewck-combo-btn-wrap",
          }),
          F = Utils.ce("button", {
            class: "ewck-combo-atc-btn",
            style: `background:${e.buttonColor};color:${e.buttonTextColor}`,
            innerText: e.atcText,
            type: "button",
            onclick() {
              (F.style.width = F.offsetWidth + "px"),
                (F.style.height = F.offsetHeight + "px"),
                (F.innerHTML = "");
              let t = Utils.createSpinner(F);
              (t.firstChild.style.border = "2px solid #ffffff"),
                (t.firstChild.style.borderTop = "2px solid #000000");
              let i = [];
              for (let a in d) i.push({ id: d[a], quantity: 1 });
              Utils.atc(i, "combo_products", e.id, e.name),
                setTimeout(() => {
                  t?.remove(), (F.innerText = e.atcText);
                }, 2e3);
            },
          });
        B.appendChild(F),
          q.append(E, L),
          o.append(r, l, q, B),
          n.appendChild(o),
          document.querySelectorAll(".ewck-combo-c").forEach((e) => e.remove()),
          "" === i ? t.appendChild(n) : Utils.insert(t, n, i);
      },
      async handleFaviconCartCount(e) {
        let t = !0,
          i = await Loaders.cartInitials(!0);
        if (0 === i.item_count) return;
        function a(t, a) {
          let n = document.querySelector("link[rel~='icon']");
          n ||
            (((n = document.createElement("link")).rel = "icon"),
            document.head.appendChild(n));
          let o = 16,
            r = document.createElement("canvas"),
            l = r.getContext("2d");
          l.beginPath();
          (document.createElement("img").src = t?.src || ""),
            (r.width = o),
            (r.height = o),
            t && l.drawImage(t, 0, 0, o, o),
            a &&
              ((l.fillStyle = a),
              l.beginPath(),
              l.roundRect(4, 0, r.width - o / 4, r.height - o / 4, 20),
              l.fill(),
              (l.font = "10px 'helvetica', Assistant"),
              (l.fillStyle = e.textColor),
              (l.textAlign = "center"),
              (l.textBaseline = "middle"),
              l.fillText(i.item_count, 10, 6)),
            (n.href = r.toDataURL("image/png"));
        }
        function n(i) {
          clearInterval(EWCK.fccInterval),
            (EWCK.fccInterval = setInterval(function () {
              t ? (a(i, e.backgroundColor), (t = !1)) : (a(i), (t = !0));
            }, 1e3 * +e.frequency));
        }
        function o(t) {
          clearInterval(EWCK.fccInterval),
            a(t, e.backgroundColor),
            null !== EWCK.fccLis &&
              document.removeEventListener("visibilitychange", EWCK.fccLis, !0),
            document.addEventListener(
              "visibilitychange",
              (EWCK.fccLis = (i) => {
                "visible" === document.visibilityState
                  ? (clearInterval(EWCK.fccInterval), a(t, e.backgroundColor))
                  : "Pop & hide" === e.effect
                  ? n(t)
                  : a(t, e.backgroundColor);
              }),
              !0
            );
        }
        EWCK.fccInterval && clearInterval(EWCK.fccInterval);
        let r = document.querySelector("link[rel~='icon']");
        e.hideFav
          ? (EWCK.favUrl = "")
          : null === EWCK.favUrl && (EWCK.favUrl = r?.href || "");
        let l = new Image();
        (l.src = EWCK.favUrl),
          (l.crossOrigin = "anonymous"),
          "" === EWCK.favUrl || null === EWCK.favUrl
            ? o(l)
            : (l.onload = () => {
                o(l);
              });
      },
      handleInactiveTabMessage(e) {
        null === EWCK.pageTitle && (EWCK.pageTitle = document.title),
          null !== EWCK.itmLis &&
            document.removeEventListener("visibilitychange", EWCK.itmLis, !0),
          e?.translations &&
            e.translations[Shopify.locale] &&
            (e.message = e.translations[Shopify.locale].message),
          document.addEventListener(
            "visibilitychange",
            (EWCK.itmLis = (t) => {
              "visible" === document.visibilityState
                ? (document.title = EWCK.pageTitle)
                : (document.title = e.message);
            }),
            !0
          );
      },
      async handleSaleNotifications(data) {
        if (data.hideOnMobile && Utils.isMobile()) return;
        if (data.closeButton) {
          let closedTime = localStorage.getItem("ewck-sn-hide");
          if (closedTime && Date.now() - closedTime < 6e4 * data.hideTime)
            return;
        }
        let notifications = [],
          notiIndex = 0,
          prevNotis = localStorage.getItem("ewck-sn-active");
        if (prevNotis) {
          let parsedNotis = JSON.parse(prevNotis);
          Date.now() - parsedNotis.createdAt > 6e4
            ? (notifications = [])
            : parsedNotis.toolUpdatedAt === data.updatedAt &&
              ((notifications = parsedNotis.notifications),
              (notiIndex = parsedNotis.nextIndex));
        }
        if (
          (data?.translations &&
            data.translations[Shopify.locale] &&
            ((data.title = data.translations[Shopify.locale].title),
            (data.verifiedText =
              data.translations[Shopify.locale].verifiedText),
            (data.translateDay =
              data.translations[Shopify.locale].translateDay),
            (data.translateDays =
              data.translations[Shopify.locale].translateDays),
            (data.translateHour =
              data.translations[Shopify.locale].translateHour),
            (data.translateHours =
              data.translations[Shopify.locale].translateHours),
            (data.translateMinute =
              data.translations[Shopify.locale].translateMinute),
            (data.translateMinutes =
              data.translations[Shopify.locale].translateMinutes),
            (data.translateSecond =
              data.translations[Shopify.locale].translateSecond),
            (data.translateSeconds =
              data.translations[Shopify.locale].translateSeconds),
            (data.translateJustNow =
              data.translations[Shopify.locale].translateJustNow),
            (data.translateAgo =
              data.translations[Shopify.locale].translateAgo)),
          0 === notifications.length)
        ) {
          if ("manual" === data.importOrder) {
            let snPromises = [
                ...data.manualProducts.map((e) => Apis.getProduct(e.handle)),
              ],
              snAll = [];
            (await Promise.allSettled(snPromises)).forEach((e) => {
              "fulfilled" === e.status &&
                e.value?.title &&
                snAll.push({
                  title: e.value?.title,
                  productUrl: e.value?.url || "",
                  imageUrl: e.value?.featured_image || "",
                });
            }),
              (snAll = Utils.shuffle(snAll));
            let customers = {};
            function getRN() {
              let e =
                data.randomNames?.[
                  Math.floor(Math.random() * data.randomNames.length)
                ]?.trim() ||
                settings?.translateSomeone?.trim() ||
                "Someone";
              if (
                ((data.randomNames = data.randomNames.filter(
                  (t) => !t.includes(e)
                )),
                "" !== e)
              ) {
                if ("firstNameOnly" === data.displayNameAs) {
                  let t = e.trim().split(" ")[0];
                  return customers?.[t] || (customers[t] = ""), t;
                }
                if ("initial" === data.displayNameAs) {
                  let i = e
                    .trim()
                    .split(" ")
                    .map((e) => e.charAt(0) + ".")
                    .join("");
                  return customers?.[i] || (customers[i] = ""), i;
                }
                customers?.[e] || (customers[e] = "");
              }
              return e;
            }
            function getRL(e) {
              let t = Math.floor(Math.random() * data.randomLocations.length),
                i = Object.keys(customers);
              if (i.includes(e) && "" === customers[e]) {
                let a = data.randomLocations?.[t] || "";
                return (customers[e] = a?.trim()), a;
              }
              if (i.includes(e)) return customers[e];
              {
                let n = data.randomLocations?.[t] || "";
                return (customers[e] = n?.trim()), n;
              }
            }
            function getRT() {
              return (
                data.randomTimestamps?.[
                  Math.floor(Math.random() * data.randomTimestamps.length)
                ] || ""
              );
            }
            function getRP() {
              return snAll[Math.floor(Math.random() * snAll.length)];
            }
            snAll.forEach((e) => {
              let t = getRN();
              notifications.push({
                product: e,
                customerName: t,
                customerLocation: getRL(t),
                purchaseTimestamp: getRT(),
              });
            });
            Utils.shuffle(data.randomNames).forEach((e) => {
              let t = e;
              "firstNameOnly" === data.displayNameAs && (t = t.split(" ")[0]);
              Object.keys(customers).includes(t)
                ? notifications.push({
                    product: getRP(),
                    customerName: t,
                    customerLocation: customers[t],
                    purchaseTimestamp: getRT(),
                  })
                : notifications.push({
                    product: getRP(),
                    customerName: t,
                    customerLocation: getRL(t),
                    purchaseTimestamp: getRT(),
                  });
            }),
              localStorage.setItem(
                "ewck-sn-active",
                JSON.stringify({
                  createdAt: Date.now(),
                  nextIndex: 0,
                  notifications,
                  toolUpdatedAt: data.updatedAt,
                })
              );
          } else {
            let snPromises = [
                ...data.automaticOrders.map((e) => Apis.getProduct(e.handle)),
              ],
              snAll = [];
            (await Promise.allSettled(snPromises)).forEach((e) => {
              "fulfilled" === e.status &&
                e.value?.title &&
                snAll.push({
                  title: e.value.title,
                  productUrl: e.value?.url || "",
                  imageUrl: e.value?.featured_image || "",
                });
            }),
              settings?.randomizeSaleNotifications &&
                (snAll = Utils.shuffle(snAll)),
              snAll.forEach((item, index) => {
                let tempNoti = {
                  product: item,
                  purchaseTimestamp: Utils.df(
                    data,
                    data.automaticOrders[index].timestamp
                  ),
                };
                if (
                  (settings?.saleNotificationsLocation === "city"
                    ? (tempNoti.customerLocation =
                        data.automaticOrders[
                          index
                        ]?.customer?.addresses?.[0]?.city)
                    : settings?.saleNotificationsLocation === "country"
                    ? (tempNoti.customerLocation =
                        data.automaticOrders[
                          index
                        ]?.customer?.addresses?.[0]?.country)
                    : settings?.saleNotificationsLocation === "citycountry"
                    ? (tempNoti.customerLocation =
                        data.automaticOrders[index]?.customer?.addresses?.[0]
                          ?.city +
                        ", " +
                        data.automaticOrders[index]?.customer?.addresses?.[0]
                          ?.country)
                    : settings?.saleNotificationsLocation === "countrycity"
                    ? (tempNoti.customerLocation =
                        data.automaticOrders[index]?.customer?.addresses?.[0]
                          ?.country +
                        ", " +
                        data.automaticOrders[index]?.customer?.addresses?.[0]
                          ?.city)
                    : (tempNoti.customerLocation =
                        data.automaticOrders[index]?.customer?.addresses?.[0]
                          ?.country ||
                        data.automaticOrders[index]?.customer?.addresses?.[0]
                          ?.city ||
                        settings?.unknownLocation ||
                        "Unknown location"),
                  "firstNameOnly" === data.displayNameAs)
                )
                  tempNoti.customerName =
                    data.automaticOrders[index]?.customer?.firstName ||
                    settings?.translateSomeone ||
                    "Someone";
                else if ("initial" === data.displayNameAs) {
                  if (settings?.customerNameInitialFormat)
                    tempNoti.customerName = eval(
                      settings.customerNameInitialFormat
                    );
                  else {
                    let fInitial =
                      data.automaticOrders[index]?.customer?.firstName?.charAt(
                        0
                      ) || "";
                    "" !== fInitial && (fInitial += ".");
                    let lInitial =
                      data.automaticOrders[index]?.customer?.lastName?.charAt(
                        0
                      ) || "";
                    "" !== lInitial && (lInitial += ".");
                    let nam = fInitial + lInitial;
                    "" !== nam
                      ? (tempNoti.customerName = nam)
                      : (tempNoti.customerName =
                          settings?.translateSomeone || "Someone");
                  }
                } else
                  tempNoti.customerName =
                    (data.automaticOrders[index]?.customer?.firstName ||
                      settings?.translateSomeone ||
                      "Someone") +
                    (data.automaticOrders[index]?.customer?.firstName || "");
                notifications.push(tempNoti);
              }),
              localStorage.setItem(
                "ewck-sn-active",
                JSON.stringify({
                  createdAt: Date.now(),
                  nextIndex: 0,
                  notifications,
                  toolUpdatedAt: data.updatedAt,
                })
              );
          }
        }
        if (0 === notifications.length) return;
        document.querySelectorAll(".ewck-sn-c").forEach((e) => e.remove());
        let container = Utils.ce("div", { class: "ewck-sn-c" });
        Utils.addCustomCSS(container, settings?.css || "");
        let wrapper = Utils.ce("div", {
          class: "ewck-sn-w",
          style: `${
            "Left" === data.position && "Slide in" === data.effect
              ? "bottom:0;left:-500px;"
              : "Left" === data.position && "Bottom up" === data.effect
              ? "bottom:-150px;left:0;"
              : "Right" === data.position && "Slide in" === data.effect
              ? "bottom:0;right:-500px"
              : "bottom:-150;right:0;"
          };`,
        });
        settings?.saleNotificationTopDown &&
          ((wrapper.style.top = "-250px"),
          (wrapper.style.bottom = "unset"),
          "Left" === data.position
            ? (wrapper.style.left = "0")
            : (wrapper.style.right = "0"));
        let innerWrapper = Utils.ce("div", {
            class: "ewck-sn-iw",
            style: Utils.getSNContainerStyle(data),
          }),
          closeBtn = Utils.ce("div", {
            class: "ewck-sn-c-b",
            style: `top:${data.widgetBorderRadius / 5 + 5}px;right:${
              data.widgetBorderRadius / 5 + 5
            }px`,
            innerHTML: "&#10005;",
            onclick() {
              container.remove(),
                (notiIndex = -9),
                localStorage.setItem("ewck-sn-hide", Date.now());
            },
          }),
          notiBody = Utils.ce("div", { class: "ewck-sn-nb" }),
          imgWrap = Utils.ce("div", {
            class: "ewck-sn-img-w",
            style: `border-radius:${data.imageBorderRadius}px`,
          }),
          imgLink = Utils.ce("a", {
            href: location.origin + notifications[notiIndex].product.productUrl,
            target: data.openNewTab ? "_blank" : "_self",
          }),
          img = Utils.ce("img", {
            src: notifications[notiIndex].product.imageUrl,
            alt: "",
            style: "width:100%;height:100%;object-fit:contain",
          }),
          infoWrap = Utils.ce("div", { class: "ewck-sn-info-w" }),
          notiTitle = Utils.ce("span", {
            class: "ewck-sn-info-nt",
            innerText: data.title
              .replace("{{name}}", notifications[notiIndex].customerName)
              .replace(
                "{{location}}",
                notifications?.[notiIndex]?.customerLocation || ""
              ),
            style: `font-size:${data.titleTextFontSize}px;color:${data.titleTextColor}`,
          }),
          prodTitleLink = Utils.ce("a", {
            class: "ewck-sn-info-pt-a",
            href: location.origin + notifications[notiIndex].product.productUrl,
            target: data.openNewTab ? "_blank" : "_self",
          }),
          prodTitle = Utils.ce("span", {
            class: "ewck-sn-info-pt",
            innerText: notifications[notiIndex].product.title,
            style: `font-size:${data.productTextFontSize}px;color:${data.productTextColor};font-weight:bold`,
          }),
          extraInfo = Utils.ce("div", { class: "ewck-sn-info-ei" }),
          timestamp = Utils.ce("span", {
            class: "ewck-sn-info-ei-t",
            innerText: notifications[notiIndex].purchaseTimestamp,
            style: `font-size:${data.timestampFontSize}px;color:${data.timestampColor}`,
          }),
          badge = Utils.ce("div", {
            class: "ewck-sn-info-svg-w",
            innerHTML: data.badgeSVG,
          }),
          badgeText = Utils.ce("span", {
            innerText: data.verifiedText,
            style: `font-size:${data.timestampFontSize}px;color:${data.timestampColor};color:#298060`,
          }),
          progress = Utils.ce("div", {
            class: "ewck-sn-pb",
            style: `background:${data.progressBarColor}`,
          });
        badge.appendChild(badgeText),
          data.timestamp &&
            "" !== notifications[notiIndex].purchaseTimestamp &&
            extraInfo.appendChild(timestamp),
          data.verified && extraInfo.appendChild(badge),
          prodTitleLink.appendChild(prodTitle),
          infoWrap.append(notiTitle, prodTitleLink),
          (data.timestamp || data.verified) && infoWrap.appendChild(extraInfo),
          imgLink.appendChild(img),
          imgWrap.appendChild(imgLink),
          notiBody.append(imgWrap, infoWrap),
          data.closeButton && innerWrapper.appendChild(closeBtn),
          innerWrapper.appendChild(notiBody),
          data.progressBar && innerWrapper.appendChild(progress),
          wrapper.appendChild(innerWrapper),
          container.appendChild(wrapper),
          document.body.appendChild(container);
        let loopCount = 0,
          progressInterval;
        for (; !(notiIndex < 0); ) {
          0 === loopCount
            ? await new Promise((e) =>
                setTimeout(e, 1e3 * data.showFirstNotificationAfter)
              )
            : (setTimeout(() => {
                (imgLink.href = notifications[notiIndex].product.productUrl),
                  (img.src = notifications[notiIndex].product.imageUrl),
                  (notiTitle.innerText = data.title
                    .replace("{{name}}", notifications[notiIndex].customerName)
                    .replace(
                      "{{location}}",
                      notifications?.[notiIndex]?.customerLocation || ""
                    )),
                  (prodTitleLink.href =
                    notifications[notiIndex].product.productUrl),
                  (prodTitle.innerText =
                    notifications[notiIndex].product.title),
                  (timestamp.innerText =
                    notifications[notiIndex].purchaseTimestamp);
              }, (1e3 * data.delayBetweenNotifications) / 2),
              await new Promise((e) =>
                setTimeout(e, 1e3 * data.delayBetweenNotifications)
              ));
          let tempNotis = localStorage.getItem("ewck-sn-active");
          if (tempNotis) {
            let tempParsed = JSON.parse(tempNotis);
            notiIndex >= notifications.length - 1
              ? (tempParsed.nextIndex = 0)
              : (tempParsed.nextIndex = notiIndex + 1),
              localStorage.setItem(
                "ewck-sn-active",
                JSON.stringify(tempParsed)
              );
          }
          "Left" === data.position
            ? ("Slide in" === data.effect
                ? (wrapper.style.left = "0")
                : (wrapper.style.bottom = "0"),
              "true" === settings.saleNotificationTopDown &&
                ((wrapper.style.top = "0"), (wrapper.style.bottom = "unset")))
            : ("Slide in" === data.effect
                ? (wrapper.style.right = "0")
                : (wrapper.style.bottom = "0"),
              "true" === settings.saleNotificationTopDown &&
                ((wrapper.style.top = "0"), (wrapper.style.bottom = "unset")));
          let startTime = Date.now();
          progressInterval && clearInterval(progressInterval),
            (progressInterval = setInterval(() => {
              let e = Date.now() - startTime;
              progress.style.width =
                100 - e / (10 * data.showNotificationFor) + "%";
            }, (1e3 * data.showNotificationFor) / 200)),
            await new Promise((e) =>
              setTimeout(e, 1e3 * data.showNotificationFor)
            ),
            "Left" === data.position
              ? ("Slide in" === data.effect
                  ? (wrapper.style.left = "-500px")
                  : (wrapper.style.bottom = "-150px"),
                "true" === settings.saleNotificationTopDown &&
                  ((wrapper.style.top = "-250px"),
                  (wrapper.style.bottom = "unset"),
                  (wrapper.style.left = "0")))
              : ("Slide in" === data.effect
                  ? (wrapper.style.right = "-500px")
                  : (wrapper.style.bottom = "-150px"),
                "true" === settings.saleNotificationTopDown &&
                  ((wrapper.style.top = "-250px"),
                  (wrapper.style.bottom = "unset"),
                  (wrapper.style.right = "0"))),
            notiIndex >= notifications.length - 1
              ? (notiIndex = 0)
              : notiIndex++,
            loopCount++;
        }
      },
      handleHideDynamicCheckout(e) {
        if (
          e.hideOnPP &&
          (location.pathname.includes("/products/") || currentProduct)
        ) {
          let t = setInterval(() => {
            let e = document.querySelector(
              settings?.ppdcs || ".shopify-payment-button"
            );
            e && ((e.style.display = "none"), clearInterval(t));
          }, 500);
        }
        if (e.hideOnCP && location.pathname.includes("/cart")) {
          let i = setInterval(() => {
            let e = document.querySelector(
              settings?.cpdcs ||
                ".cart__dynamic-checkout-buttons,.additional-checkout-buttons"
            );
            e && ((e.style.display = "none"), clearInterval(i));
          }, 500);
        }
      },
      async handleAddons(e) {
        let t = Utils.sortUpsellProducts(e),
          i;
        for (let a of t) {
          let n = {
            resourceType: a.resourceType,
            selectionIds: a.selectionIds,
          };
          if (
            currentProduct &&
            Utils.checkVisibility(n) &&
            "Inactive" !== a.status
          ) {
            i = a;
            break;
          }
        }
        if (!i) return;
        i?.translations &&
          i.translations[Shopify.locale] &&
          ((i.subTitle = i.translations[Shopify.locale].subTitle),
          (i.minError = i.translations[Shopify.locale].minError),
          (i.maxError = i.translations[Shopify.locale].maxError),
          (i.totalPriceText = i.translations[Shopify.locale].totalPriceText));
        let o = document.getElementById("ewck-product-add-ons-block"),
          r = "";
        if (
          (o ||
            ((o =
              settings?.productAddOnsTargetSelector !== "" &&
              settings?.productAddOnsTargetSelector !== void 0
                ? document.querySelector(settings.productAddOnsTargetSelector)
                : Utils.findAtc()),
            (r =
              settings?.productAddOnsInsert !== "" &&
              settings?.productAddOnsInsert !== void 0
                ? settings.productAddOnsInsert
                : "before")),
          !o)
        )
          return;
        let l = document.querySelectorAll(".ewck-pao-c"),
          c = [];
        if (0 === l.length) return;
        l.forEach((e) => {
          "block" === e.style.display
            ? c.push(e)
            : EWCK.paoContainer ||
              ((EWCK.paoContainer = e.cloneNode(!0)), c.push(e));
        });
        let s = EWCK.paoContainer.cloneNode(!0);
        if (!s) return;
        Utils.addCustomCSS(s, settings?.css || "");
        let d = s.querySelector(".ewck-pao-w");
        d.style.marginBlock = i.marginY + "px";
        let p = d.querySelector(".ewck-pao-t-w").querySelector(".ewck-pao-t-t");
        (p.style = `font-size:${i.titleFontSize}px;color:${
          i.titleColor
        };margin:${"" === i.subTitle.trim() ? "0 0 10px 0" : "0 0 2px 0"}`),
          (p.innerHTML = i.title);
        let u = d
          .querySelector(".ewck-pao-s-t-w")
          .querySelector(".ewck-pao-s-t-t");
        (u.style = `font-size:${i.subTitleFontSize}px;color:${i.subTitleColor};margin:0 0 8px 0`),
          (u.innerHTML = i.subTitle.replace(
            "{{discountValue}}",
            "None" === i.discountType
              ? ""
              : "Percentage" === i.discountType
              ? i.discountPercentage + "%"
              : Utils.cf(100 * i.discountAmount, settings?.moneyFormat)
          ));
        let m = d.querySelector(".ewck-pao-addons"),
          y = m.querySelector(".ewck-pao-i-m"),
          f = (
            await Promise.allSettled(
              i.addOnProducts.map((e) => Apis.getProduct(e.handle))
            )
          ).map((e) => e.value);
        for (let [g, h] of (i.randomize && (f = Utils.shuffle(f)),
        f.entries())) {
          if (!h || h?.id === currentProduct.id) continue;
          let b = h.variants.find((e) => !0 === e.available);
          if (!b) continue;
          (EWCK.paoSelected[h.id] = h),
            (EWCK.paoSelected[h.id].selectedVariantId = b.id.toString()),
            (EWCK.paoSelected[h.id].selected = !!i.preSelectedAddOns.includes(
              h.title
            )),
            (EWCK.paoSelected[h.id].selectedVariantQty = "1");
          let w = y.cloneNode(!0);
          y.remove();
          w.querySelector(".ewck-pao-img-link").href = h.url;
          let k = w.querySelector(".ewck-pao-img");
          k.src = h?.featured_image || "";
          w.querySelector(".ewck-pao-pt-link").href = h.url;
          w.querySelector(".ewck-pao-pt").innerText = h.title;
          let v = h.variants.find((e) => !0 === e.available),
            $ = w.querySelector(".ewck-pao-d-p"),
            x = +Utils.getPAODisPrice(i, v.price);
          (EWCK.paoSelected[h.id].totalAfterDiscount = Math.floor(x / 100)),
            ($.innerHTML = Utils.cf(x, settings?.moneyFormat));
          let T = w.querySelector(".ewck-pao-a-p");
          (T.innerHTML = Utils.cf(v.price, settings?.moneyFormat)),
            "None" === i.discountType &&
              (v.compare_at_price
                ? (T.innerHTML = Utils.cf(
                    v.compare_at_price,
                    settings?.moneyFormat
                  ))
                : (T.style.display = "none"));
          let C = w.querySelector(".ewck-pao-vsqs-w");
          (EWCK.paoSelected?.[h.id] && h.variants.length > 1) ||
          !EWCK.paoSelected?.[h.id]
            ? (C.style.justifyContent = "space-between")
            : (C.style.justifyContent = "end");
          let S = w.querySelector(".ewck-pao-v-s");
          for (let _ of ((S.onchange = (e) => {
            let [t, a] = e.target.value.split("-");
            EWCK.paoSelected[t].selectedVariantId = a;
            let n = h.variants.find((e) => e.id.toString() === a);
            n?.featured_image
              ? (k.src = n.featured_image.src)
              : (k.src = h?.featured_image || "");
            let o = +Utils.getPAODisPrice(i, n.price);
            ($.innerHTML = Utils.cf(o, settings?.moneyFormat)),
              (T.innerHTML = Utils.cf(n.price, settings?.moneyFormat)),
              "None" === i.discountType &&
                (n.compare_at_price
                  ? ((T.style.display = "inline-block"),
                    (T.innerHTML = Utils.cf(
                      n.compare_at_price,
                      settings?.moneyFormat
                    )))
                  : (T.style.display = "none")),
              L();
          }),
          h.variants.length <= 1 && S.remove(),
          h.variants))
            if (_.available && h.variants.length > 1) {
              let I = Utils.ce("option", {
                value: h.id + "-" + _.id,
                innerText: _.title,
              });
              S.appendChild(I);
            }
          let P = w.querySelector(".ewck-pao-qty-s-w");
          P.style.display = i.preSelectedAddOns.includes(h.title)
            ? "flex"
            : "none";
          let q = w.querySelector(".ewck-pao-q-i");
          q.addEventListener("input", (e) => {
            EWCK.paoSelected[h.id].selectedVariantQty = e.target.value;
          }),
            q.addEventListener("keydown", (e) => {
              38 === e.keyCode
                ? ((q.value = +e.target.value + 1),
                  q.dispatchEvent(new InputEvent("input")))
                : 40 === e.keyCode
                ? +q.value > 1 &&
                  ((q.value = +q.value - 1),
                  q.dispatchEvent(new InputEvent("input")))
                : e.preventDefault(),
                L();
            });
          w.querySelector(".ewck-pao-q-m").onclick = () => {
            +q.value > 1 &&
              ((q.value = +q.value - 1),
              q.dispatchEvent(new InputEvent("input"))),
              L();
          };
          (w.querySelector(".ewck-pao-q-p").onclick = () => {
            (q.value = +q.value + 1),
              q.dispatchEvent(new InputEvent("input")),
              L();
          }),
            q.setAttribute("value", "1"),
            m.appendChild(w);
          let E = w.querySelector(".ewck-pao-c-b");
          (E.checked = !!i.preSelectedAddOns.includes(h.title)),
            E.setAttribute("value", h.id),
            (E.onchange = (e) => {
              e.target.checked
                ? ((EWCK.paoSelected[e.target.value].selected = !0),
                  h.variants.length > 1
                    ? (C.style.justifyContent = "space-between")
                    : (C.style.justifyContent = "end"),
                  (P.style.display = "flex"))
                : ((EWCK.paoSelected[e.target.value].selected = !1),
                  (P.style.display = "none")),
                L();
            });
        }
        c.length && c.forEach((e) => e.remove()),
          Object.keys(EWCK.paoSelected).length && Utils.insert(o, s, r);
        let L = (e = !1) => {
          if (!i?.showTotalPrice) return;
          let t = 0;
          for (let a in EWCK.paoSelected)
            if (!0 === EWCK.paoSelected[a].selected) {
              let n = EWCK.paoSelected[a].variants.find((t) =>
                  e
                    ? !0 === t.available
                    : t.id === +EWCK.paoSelected[a].selectedVariantId
                ),
                o = Number(n.price) * +EWCK.paoSelected[a].selectedVariantQty;
              "Percentage" === i.discountType
                ? (t += o - (o * i.discountPercentage) / 100)
                : "Amount off each" === i.discountType &&
                  (t +=
                    o -
                    i.discountAmount *
                      Shopify.currency.rate *
                      +EWCK.paoSelected[a].selectedVariantQty);
            }
          if (e) return t;
          {
            let r = document.querySelector(".ewck-pao-t-p-t");
            if (r) {
              if (t <= 0 && "on-select" === i.totalPriceVisibility) {
                r.style.display = "none";
                return;
              }
              (r.style.display = "block"),
                (r.innerHTML = i.totalPriceText.replace(
                  "{{totalPrice}}",
                  Utils.cf(t, settings?.moneyFormat)
                ));
            }
          }
        };
        if (i?.showTotalPrice) {
          let B = Utils.ce("div", {
            class: "ewck-pao-t-p-t",
            style: `display:${
              "always" === i.totalPriceVisibility ||
              i.preSelectedAddOns.length > 0
                ? "block"
                : "none"
            };margin-block:10px;text-align:end;`,
            innerHTML: i.totalPriceText.replace(
              "{{totalPrice}}",
              Utils.cf(L(!0), settings?.moneyFormat)
            ),
          });
          d.appendChild(B);
        }
        (s.style.display = "block"), EWCK.activeOnProd.push("product_add_ons");
        let F = Utils.findAtc();
        async function A(e = !1) {
          let t;
          t =
            EWCK.activeOnProd.includes("volume_discounts") && EWCK.volumeQty
              ? EWCK.volumeQty
              : document.querySelector(
                  settings?.quantitySelector === ""
                    ? "[name='quantity']"
                    : settings?.quantitySelector
                )?.value;
          let a = EWCK.activeOnProd.includes("volume_discounts")
              ? []
              : [{ id: selectedVariant.id.toString(), quantity: t || 1 }],
            n = [],
            o = 0;
          for (let r in EWCK.paoSelected)
            !0 === EWCK.paoSelected[r].selected &&
              (n.push(EWCK.paoSelected[r].id),
              (o += EWCK.paoSelected[r].variants.find(
                (e) => e.id.toString() === EWCK.paoSelected[r].selectedVariantId
              ).price),
              a.push({
                id: EWCK.paoSelected[r].selectedVariantId,
                quantity: EWCK.paoSelected[r].selectedVariantQty,
              }));
          if (n.length < +i.minimumAddOns) {
            let l = document.querySelector(".ewck-pao-min-adons-error"),
              c = document.querySelector(".ewck-pao-max-adons-error");
            return (
              c && c.remove(),
              l ||
                ((l = Utils.ce("span", {
                  class: "ewck-pao-min-adons-error",
                  innerText: i.minError,
                })),
                d.appendChild(l)),
              i.minError
            );
          }
          if (
            (document.querySelector(".ewck-pao-min-adons-error")?.remove(),
            "" !== i.maximumAddOns &&
              0 !== i.maximumAddOns &&
              n.length > +i.maximumAddOns)
          ) {
            let s = document.querySelector(".ewck-pao-max-adons-error");
            return (
              s ||
                ((s = Utils.ce("span", {
                  class: "ewck-pao-max-adons-error",
                  innerText: i.maxError,
                })),
                d.appendChild(s)),
              i.maxError
            );
          }
          if (0 === n.length && e) return;
          document.querySelector(".ewck-pao-max-adons-error")?.remove(),
            (F.style.position = "relative");
          let p;
          n.length && (p = Utils.createSpinner(F));
          let u = "",
            m = [];
          if ("None" !== i.discountType && n.length) {
            let y = await Apis.createDiscount("pao_discount_create", {
              offerId: i.id,
              addOnProductIds: n,
              mainProductId: currentProduct.id,
              quantity: 1 === a.length ? 2 : a.length,
              mainProductQuantity: t,
            });
            if (y?.discount) {
              let f = Object.keys(y.discount)[0];
              (i.discounts[f] = y.discount[f]),
                m.push(f),
                (window.name = JSON.stringify({
                  ...i.discounts[f],
                  discountCode: f,
                  offerId: i.id,
                }));
            } else
              (u = y?.message),
                console.log("Something went wrong while creating discount");
          }
          if (
            (setTimeout(() => {
              p?.remove();
            }, 2e3),
            "" === u)
          ) {
            if (EWCK.activeOnProd.includes("volume_discounts")) {
              await new Promise((e) => setTimeout(e, 200));
              let g = Utils.getVDTierItems(EWCK.volumeSelectedTier);
              (await Loaders.cartInitials(!0)).items.forEach((e) => {
                e.properties?._ewckGift ||
                  (a.push({ id: e.variant_id, quantity: e.quantity }),
                  (m = m.concat(e.discounts.map((e) => e.title))));
              }),
                (g = g.concat(a)),
                Apis.applyMultipleDiscounts(g, m);
              return;
            }
            if (0 === n.length)
              F.removeEventListener("click", EWCK.paoAtcLis, !0),
                setTimeout(() => {
                  F.click();
                }, 200);
            else {
              if (
                ((await Loaders.cartInitials(!0)).items.forEach((e) => {
                  e.properties?._ewckGift ||
                    (a.push({ id: e.variant_id, quantity: e.quantity }),
                    (m = m.concat(e.discounts.map((e) => e.title))));
                }),
                settings?.optionsEnabled === "true")
              ) {
                a.shift();
                let h = await Apis.applyMultipleDiscounts(a, m, !1);
                return (EWCK.paoSelected = {}), h;
              }
              Apis.applyMultipleDiscounts(a, m);
            }
          } else console.log("error", u);
        }
        if (settings?.optionsEnabled) {
          Utils.checkRequest(A, "product_add_ons");
          return;
        }
        F &&
          (null !== EWCK.paoAtcLis &&
            F.removeEventListener("click", EWCK.paoAtcLis, !0),
          F.addEventListener(
            "click",
            (EWCK.paoAtcLis = async (e) => {
              (tools.terms_conditions_checkbox?.status !== "Active" ||
                tools.terms_conditions_checkbox?.enableOnProductPage !== !0 ||
                !1 !== EWCK.tccProductCheck) &&
                (e.preventDefault(), e.stopPropagation(), A());
            }),
            !0
          ));
      },
      async handleTermsConditions(e) {
        function t(t, i, a, n, o, r) {
          document
            .querySelector(
              `${a ? ".ewck-tcc-product-page" : ""} ${
                t && !a ? ".ewck-tcc-cart-page" : ""
              } ${o ? ".ewck-tcc-cart-drawer" : ""}`
            )
            ?.remove();
          let l = Utils.ce("div", {
            class: `${a ? "ewck-tcc-product-page" : ""} ${
              t && !a ? "ewck-tcc-cart-page" : ""
            } ${o ? "ewck-tcc-cart-drawer" : ""} "ewck-tcc-c"`,
          });
          Utils.addCustomCSS(l, settings?.css || "");
          let c = Utils.ce("div", { class: "ewck-tcc-w" }),
            s = Utils.ce("div", { class: "ewck-tcc-content" }),
            d = Utils.ce("span", {
              class: "ewck-tcc-error",
              innerText: e.errorText,
            }),
            p = Utils.ce("input", {
              type: "checkbox",
              id: "ewck-tcc-checkbox",
              onchange(e) {
                (EWCK.tccProductCheck = e.target.check),
                  e.target.checked && (d.style.display = "none");
              },
            }),
            u = Utils.ce("label", {
              htmlfor: "ewck-tcc-checkbox",
              class: "ewck-tcc-label",
            }),
            m = Utils.ce("span", {
              innerHTML: e.checkboxText.replace(
                "{{link}}",
                "" !== e.linkText
                  ? `<a href='${e.linkUrl}' target='${e.openLink}'>${e.linkText}</a>`
                  : ""
              ),
            });
          u.append(p, m),
            s.appendChild(u),
            c.append(s, d),
            l.appendChild(c),
            t &&
              (null !== EWCK.tccCheckoutLis &&
                t.removeEventListener("click", EWCK.tccCheckoutLis, !0),
              t.addEventListener(
                "click",
                (EWCK.tccCheckoutLis = (e) => {
                  e.stopPropagation(),
                    e.preventDefault(),
                    p.checked
                      ? (t.removeEventListener(
                          "click",
                          EWCK.tccCheckoutLis,
                          !0
                        ),
                        t.click())
                      : (d.style.display = "block");
                }),
                !0
              ),
              i
                ? i.parentElement.insertBefore(l, i)
                : t.parentElement.parentElement.insertBefore(
                    l,
                    t.parentElement
                  )),
            a &&
              (a.addEventListener(
                "click",
                (EWCK.tccAtcLis = (e) => {
                  e.stopPropagation(),
                    e.preventDefault(),
                    p.checked
                      ? (a.removeEventListener("click", EWCK.tccAtcLis, !0),
                        a.click())
                      : (d.style.display = "block");
                }),
                !0
              ),
              n
                ? n.parentElement.insertBefore(l, n)
                : a.parentElement.parentElement.insertBefore(
                    l,
                    a.parentElement
                  )),
            o &&
              (null !== EWCK.tccCartDrawerCheckoutLis &&
                o.removeEventListener(
                  "click",
                  EWCK.tccCartDrawerCheckoutLis,
                  !0
                ),
              o.addEventListener(
                "click",
                (EWCK.tccCartDrawerCheckoutLis = (e) => {
                  if ((e.stopPropagation(), e.preventDefault(), p.checked)) {
                    let t = EWCK.tccCartDrawerCheckoutLis;
                    o.removeEventListener(
                      "click",
                      EWCK.tccCartDrawerCheckoutLis,
                      !0
                    ),
                      o.click(),
                      o.addEventListener("click", t, !0);
                  } else d.style.display = "block";
                }),
                !0
              ),
              r
                ? r.parentElement.insertBefore(l, r)
                : o.parentElement.parentElement.insertBefore(
                    l,
                    o.parentElement
                  ));
        }
        if (
          (document
            .querySelectorAll(
              ".ewck-tcc-product-page,.ewck-tcc-cart-page,.ewck-tcc-cart-drawer"
            )
            .forEach((e) => {
              e.className.includes("ewck-tcc-product-page")
                ? (EWCK.tccAtcBtn.removeEventListener(
                    "click",
                    EWCK.tccAtcLis,
                    !0
                  ),
                  EWCK.tccCheckoutBtn.removeEventListener(
                    "click",
                    EWCK.tccCheckoutLis,
                    !0
                  ))
                : e.className.includes("ewck-tcc-cart-page") &&
                  EWCK.tccCheckoutBtn.removeEventListener(
                    "click",
                    EWCK.tccCheckoutLis,
                    !0
                  ),
                EWCK.tccCartDrawerCheckoutBtn?.removeEventListener(
                  "click",
                  EWCK.tccCartDrawerCheckoutLis,
                  !0
                ),
                e.remove();
            }),
          e?.translations &&
            e.translations[Shopify.locale] &&
            ((e.checkboxText = e.translations[Shopify.locale].checkboxText),
            (e.linkText = e.translations[Shopify.locale].linkText),
            (e.errorText = e.translations[Shopify.locale].errorText)),
          e.enableOnProductPage)
        ) {
          if (!Utils.checkVisibility(e)) return;
          if (
            (settings?.tccProductPageDelay &&
              (await new Promise((e) =>
                setTimeout(e, +settings.tccProductPageDelay)
              )),
            currentProduct)
          ) {
            if (
              settings?.atcSelector !== "" &&
              settings?.atcSelector !== void 0 &&
              settings?.termsCheckoutSelectorProductPage !== "" &&
              settings?.termsCheckoutSelectorProductPage !== void 0
            ) {
              let i = document.querySelector(settings.atcSelector);
              if (i) {
                let a = document.querySelector(
                  settings.termsCheckoutSelectorProductPage
                );
                (EWCK.tccAtcBtn = i), (EWCK.tccCheckoutBtn = a), t(a, null, i);
              }
            } else {
              let n = Utils.findAtc(),
                o = document.querySelector(".shopify-payment-button__button");
              n &&
                ((EWCK.tccAtcBtn = n),
                (EWCK.tccCheckoutBtn = o),
                t(o, null, n));
            }
          }
        } else {
          let r = location.pathname.split("/"),
            l = await Loaders.cartInitials(!0),
            c = l.items.map((e) => e.id.toString());
          for (let s in cartItemsInCollection)
            c.includes(s) || delete cartItemsInCollection[s];
          let d = !0;
          if ("product" === e.resourceType)
            d = l.items.every(
              (t) => !e.selectionIds.includes(t.product_id.toString())
            );
          else if ("collection" === e.resourceType) {
            for (let p in cartItemsInCollection)
              for (let u of cartItemsInCollection[p])
                e.selectionIds.includes(u.toString()) && (d = !1);
            if (currentProduct) {
              for (let m of currentProductCollections)
                if (
                  e.selectionIds.includes(m.id.toString()) &&
                  l.items.find((e) => e.id === selectedVariant.id)
                ) {
                  d = !1;
                  break;
                }
            }
          } else d = !1;
          if (!d) {
            if ("cart" === r[r.length - 1]) {
              if (
                settings?.termsCheckoutSelectorCartPage !== "" &&
                settings?.termsCheckoutSelectorCartPage !== void 0
              ) {
                let y = document.querySelector(
                  settings.termsCheckoutSelectorCartPage
                );
                (EWCK.tccCheckoutBtn = y),
                  y &&
                    t(
                      y,
                      document.querySelector(
                        settings?.termsCheckoutParentSelectorCartPage
                      )
                    );
              } else {
                let f = document.querySelector("#checkout");
                f && ((EWCK.tccCheckoutBtn = f), t(f));
              }
            }
            if (
              settings?.termsCheckoutSelectorCartDrawer !== "" &&
              settings?.termsCheckoutSelectorCartDrawer !== void 0
            ) {
              let g = document.querySelector(
                settings.termsCheckoutSelectorCartDrawer
              );
              g &&
                ((EWCK.tccCartDrawerCheckoutBtn = g),
                t(
                  null,
                  null,
                  null,
                  null,
                  g,
                  document.querySelector(
                    settings.termsCheckoutParentSelectorCartDrawer
                  )
                ));
            } else {
              let h = document.querySelector("#CartDrawer-Checkout");
              h &&
                ((EWCK.tccCartDrawerCheckoutBtn = h),
                t(null, null, null, null, h));
            }
          }
        }
      },
      async handleLabelsStickers(e) {
        if (!(EWCK.stickerProductCards.length > 0)) {
          for (let [t, i] of e.entries())
            if ("Inactive" !== i.status) {
              if (
                (i?.translations &&
                  i.translations[Shopify.locale] &&
                  (i.badgeText = i.translations[Shopify.locale].badgeText),
                currentProduct &&
                  i.showOnProductPage &&
                  ("all" === i.resourceType ||
                    i.productHandles.includes(currentProduct.handle)))
              ) {
                settings?.labelsStickersProductPageDelay &&
                  (await new Promise((e) =>
                    setTimeout(e, +settings.labelsStickersProductPageDelay)
                  ));
                let a = document.querySelector(
                  settings?.labelsStickersProductImgSelector !== "" &&
                    settings?.labelsStickersProductImgSelector !== void 0
                    ? settings.labelsStickersProductImgSelector
                    : ".product__media-item,.product__primary .product__primary-left"
                );
                a &&
                  !a.querySelector(`.ewck-ls-c-${t}`) &&
                  (("" === a?.style.position ||
                    "unset" === a?.style.position) &&
                    (a.style.position = "relative"),
                  a.appendChild(n(i, t)));
              }
              EWCK.labelsStickersSI[t] &&
                clearInterval(EWCK.labelsStickersSI[t]),
                (EWCK.labelsStickersSI[t] = setInterval(
                  () => {
                    if (
                      ((EWCK.stickerProductCards = [
                        ...document.querySelectorAll(
                          settings?.productCardSelector !== "" &&
                            settings?.productCardSelector !== void 0
                            ? settings.productCardSelector
                            : Utils.productCardSelectors
                        ),
                      ]),
                      EWCK.stickerProductCards.length)
                    )
                      for (let e of EWCK.stickerProductCards) {
                        if (e.querySelector(`ewck-ls-c ewck-ls-c-${t}`))
                          continue;
                        let a;
                        if (
                          (a =
                            "A" === e.tagName
                              ? e
                              : e.querySelector("a[href*='/products/']")) &&
                          a.href.includes("/products/")
                        ) {
                          let o = a.href.split("/products/")[1].split("?")[0],
                            r = !1;
                          if (
                            ("all" === i.resourceType
                              ? (r = !0)
                              : i.productHandles.includes(o) && (r = !0),
                            r)
                          ) {
                            if (
                              (("" === e?.style.position ||
                                "unset" === e?.style.position) &&
                                (e.style.position = "relative"),
                              settings?.labelsStickersProductCardTarget !==
                                void 0 &&
                                settings?.labelsStickersProductCardTarget !==
                                  "")
                            ) {
                              let l = e.querySelector(
                                settings.labelsStickersProductCardTarget
                              );
                              l && l.appendChild(n(i, t));
                            } else e.appendChild(n(i, t));
                          }
                        }
                      }
                    EWCK.stickerProductCards.length > 0 &&
                      (!settings?.lazyLoadProductCarts ||
                        settings?.lazyLoadProductCarts === "false") &&
                      clearInterval(EWCK.labelsStickersSI[t]);
                  },
                  settings?.lazyLoadProductCarts === "true" ? 1e3 : 500
                ));
            }
        }
        function n(e, t) {
          let i = Utils.ce("div", {
            class: `ewck-ls-c ewck-ls-c-${t}`,
            style: "position:unset",
          });
          Utils.addCustomCSS(i, settings?.css || "");
          let a = () => {
              let t = "position:absolute;top:0;z-index:1;";
              return "Left" === e.position
                ? t.concat("left:0;")
                : "Middle" === e.position
                ? t.concat("left:50%;transform:translateX(-50%);")
                : t.concat("right:0;");
            },
            n = (e, t, i, a) =>
              `<div style='width:${t}px;height:${t}px;margin-block:${i}px;margin-inline:${a}px;'><img src='${e}' alt='sticker' style='width:100%;height:auto;object-fit:cover' /></div>`,
            o = Utils.ce("div", {
              class: "ewck-ls-w",
              style: a(),
              innerHTML:
                "Text" === e.badgeType
                  ? e.textEffectCode
                      .replaceAll("{{label}}", e.badgeText)
                      .replaceAll(
                        "{{background}}",
                        `${e.cssProperties.badgeBackgroundColor};${
                          e?.textMarginY
                            ? "margin-block:" + e.textMarginY + "px;"
                            : ""
                        }${
                          e?.textMarginX
                            ? "margin-inline:" + e.textMarginX + "px"
                            : ""
                        }`
                      )
                      .replaceAll("<h2", "<div")
                      .replaceAll("</h2>", "</div>")
                      .replaceAll("{{fontFamily}}", e.cssProperties.fontFamily)
                      .replaceAll(
                        "{{badgePaddingY}}",
                        e.cssProperties.badgePaddingY + "px"
                      )
                      .replaceAll(
                        "{{badgePaddingX}}",
                        e.cssProperties.badgePaddingX + "px"
                      )
                      .replaceAll("{{textColor}}", e.cssProperties.textColor)
                      .replaceAll(
                        "{{fontSize}}",
                        e.cssProperties.fontSize + "px"
                      )
                      .replaceAll(
                        "{{borderRadius}}",
                        e.cssProperties.borderRadius + "px"
                      )
                      .replaceAll("{{fontUrl}}", e.cssProperties.fontUrl)
                  : "Sticker" === e.badgeType
                  ? n(
                      e.sticker.includes("cloudinary.com")
                        ? `https://d2nt3atlyf8bm0.cloudfront.net/shopify/apps/upsell-kit/labels-stickers/${e.sticker.slice(
                            e.sticker.lastIndexOf("/") + 1
                          )}`
                        : e.sticker,
                      e.stickerSize,
                      e.stickerMarginY,
                      e.stickerMarginX
                    )
                  : n(e.imageUrl, e.imageSize, e.imageMarginY, e.imageMarginX),
            });
          return i.appendChild(o), i;
        }
      },
      handlePopUps(e) {
        if (EWCK.pop) return;
        let t = Utils.assemblePopComponents();
        function i(e) {
          let i = localStorage.getItem(`ewck-pop-closed-${e.id}`, Date.now());
          if (i && "never" === e.whenClosed) return;
          if (i && Date.now() - i < 36e5 * e.hideHours) return null;
          let a = Utils.cloneComp(t);
          a.main.classList.add(`ewck-pop-main-${e.id}`);
          let n =
              ("Small" === e.popupSize
                ? 220
                : "Medium" === e.popupSize
                ? 300
                : 380) +
              (e.showImage || window.innerWidth < 490 ? 0 : 50) +
              "px",
            o =
              ("Small" === e.popupSize
                ? 330
                : "Medium" === e.popupSize
                ? 450
                : 570) + "px";
          function r() {
            localStorage.setItem(`ewck-pop-closed-${e.id}`, Date.now());
          }
          (a.infoWrapper.style.width = n),
            (a.infoWrapper.style.maxWidth = n),
            (a.infoWrapper.style.maxHeight = o),
            e.showImage && "Background" === e.imagePosition
              ? ((a.infoWrapper.style.background = `url(${e.imageUrl})`),
                (a.infoWrapper.style.backgroundSize = "cover"),
                (a.infoWrapper.style.backgroundRepeat = "no-repeat"))
              : (a.infoWrapper.style.background = e.backgroundColor),
            (a.infoWrapper.style.borderRadius = e.showImage
              ? "Left" === e.imagePosition
                ? `0px ${e.popupBorderRadius}px ${e.popupBorderRadius}px 0px`
                : `${e.popupBorderRadius}px 0px 0px ${e.popupBorderRadius}px`
              : e.popupBorderRadius + "px"),
            e.showImage &&
            "Background" !== e.imagePosition &&
            window.innerWidth > 490
              ? ((a.imageWrapper.style.width = n),
                (a.imageWrapper.style.maxWidth = n),
                (a.imageWrapper.style.maxHeight = o),
                (a.imageWrapper.style.borderRadius =
                  "Left" === e.imagePosition
                    ? `${e.popupBorderRadius}px 0px 0px ${e.popupBorderRadius}px`
                    : `0px ${e.popupBorderRadius}px ${e.popupBorderRadius}px 0px`),
                (a.image.src = e.imageUrl),
                "Right" === e.imagePosition &&
                  a.wrapper.appendChild(a.imageWrapper))
              : a.imageWrapper.remove(),
            e.showDiscard
              ? ((a.infoDiscardBtn.innerText = e.discardText),
                (a.infoDiscardBtn.style.color = e.discardTextColor),
                (a.infoDiscardBtn.onclick = () => {
                  a.main.remove(), r();
                }))
              : a.infoDiscardBtnWrapper.remove(),
            (a.closeWrapper.style.top = +e.popupBorderRadius / 3 + 5 + "px"),
            (a.closeWrapper.style.right = +e.popupBorderRadius / 3 + 5 + "px"),
            (a.closeWrapper.onclick = () => {
              a.main.remove(), r();
            }),
            !e.showImage ||
            (e.showImage && "Left" === e.imagePosition) ||
            (e.showImage && "Background" === e.imagePosition) ||
            (e.showImage &&
              "Background" === e.imagePosition &&
              window.innerWidth < 490)
              ? a.infoWrapper.appendChild(a.closeWrapper)
              : a.imageWrapper.appendChild(a.closeWrapper);
          let l = "<style>h1,h2,h3,h4,h5,p{margin:0!important}</style>";
          switch (((a.initiateContent.innerHTML = l + e.content), e.type)) {
            case "Newsletter":
            case "Coupon":
              e.showNameField
                ? ((a.infoNameFieldInput.placeholder = e.nameFieldPlaceholder),
                  (a.infoNameFieldInput.style.border = `1px solid ${e.inputBorderColor}`),
                  (a.infoNameFieldInput.style.color = e.inputTextColor),
                  (a.infoNameFieldInput.style.background =
                    e.inputBackgroundColor),
                  (a.infoNameFieldInput.onchange = (e) => {
                    "2px solid red" === e.target.style.border &&
                      ((e.target.style.border = "1px solid #ccc"),
                      (e.target.style.margin = "0"));
                  }))
                : a.infoNameField.remove(),
                (a.infoEmailFieldInput.placeholder = e.emailPlaceholder),
                (a.infoEmailFieldInput.style.border = `1px solid ${e.inputBorderColor}`),
                (a.infoEmailFieldInput.style.color = e.inputTextColor),
                (a.infoEmailFieldInput.style.background =
                  e.inputBackgroundColor),
                (a.infoEmailFieldInput.onchange = (e) => {
                  "2px solid red" === e.target.style.border &&
                    ((e.target.style.border = "1px solid #ccc"),
                    (e.target.style.margin = "0"));
                }),
                e.showPhoneField
                  ? ((a.infoPhoneFieldInput.placeholder =
                      e.phoneFieldPlaceholder),
                    (a.infoPhoneFieldInput.style.border = `1px solid ${e.inputBorderColor}`),
                    (a.infoPhoneFieldInput.style.color = e.inputTextColor),
                    (a.infoPhoneFieldInput.style.background =
                      e.inputBackgroundColor),
                    (a.infoPhoneFieldInput.onchange = (e) => {
                      "2px solid red" === e.target.style.border &&
                        ((e.target.style.border = "1px solid #ccc"),
                        (e.target.style.margin = "0"));
                    }))
                  : a.infoPhoneField.remove(),
                (a.infoSubmitBtn.innerText = e.submitText),
                (a.infoSubmitBtn.style.background = e.submitButtonColor),
                (a.infoSubmitBtn.style.color = e.submitButtonTextColor),
                (a.infoSubmitBtn.style.borderRadius =
                  e.submitButtonBorderRadius + "px"),
                (a.infoSubmitBtn.onclick = async () => {
                  let t = a?.infoNameFieldInput?.value,
                    i = a.infoEmailFieldInput.value,
                    n = a?.infoPhoneFieldInput?.value;
                  if (e.showNameField && t.length < 3) {
                    (a.infoNameFieldInput.style.border = "2px solid red"),
                      (a.infoNameFieldInput.style.margin = "-1px");
                    return;
                  }
                  if (
                    !i.match(
                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                    )
                  ) {
                    (a.infoEmailFieldInput.style.border = "2px solid red"),
                      (a.infoEmailFieldInput.style.margin = "-1px");
                    return;
                  }
                  if (e.showPhoneField && n.length < 3) {
                    (a.infoPhoneFieldInput.style.border = "2px solid red"),
                      (a.infoPhoneFieldInput.style.margin = "-1px");
                    return;
                  }
                  a.infoSubmitBtn.style.height =
                    a.infoSubmitBtn.offsetHeight + "px";
                  let o = Utils.createSpinner(a.infoSubmitBtn);
                  a.infoSubmitBtn.style.color = "transparent";
                  let l = await Apis.createCustomer(i, t, n);
                  if (!0 === l) {
                    if (e?.afterSubmit === "redirect") {
                      r(), (location.href = e?.afterSubmitRedirectUrl || "");
                      return;
                    }
                    a.info.remove(),
                      (a.successWrapper.style.display = "flex"),
                      "Coupon" === e.type &&
                        ((a.successDisCode.innerText = e.discountCode),
                        (a.successDisCopy.onclick = () => {
                          navigator.clipboard.writeText(e.discountCode),
                            (a.successDisCopyBefore.style.display = "none"),
                            (a.successDisCopyAfter.style.display = "flex"),
                            setTimeout(() => {
                              (a.successDisCopyBefore.style.display = "flex"),
                                (a.successDisCopyAfter.style.display = "none");
                            }, 2e3);
                        })),
                      r();
                  } else
                    l.error.includes("name") &&
                      ((a.infoNameFieldInput.style.border = "2px solid red"),
                      (a.infoNameFieldInput.style.margin = "-1px")),
                      (l.error.includes("email") ||
                        l.error.includes("emailMarketingConsent")) &&
                        ((a.infoEmailFieldInput.style.border = "2px solid red"),
                        (a.infoEmailFieldInput.style.margin = "-1px")),
                      l.error.includes("phone") &&
                        ((a.infoPhoneFieldInput.style.border = "2px solid red"),
                        (a.infoPhoneFieldInput.style.margin = "-1px")),
                      o?.remove(),
                      (a.infoSubmitBtn.innerText = e.submitText),
                      (a.infoSubmitBtn.style.color = e.submitButtonTextColor);
                }),
                a.infoActionBtnWrapper.remove(),
                (a.successContent.innerHTML = l + e.successContent),
                "Newsletter" === e.type && a.successDisWrapper.remove();
              break;
            case "Announcement":
              a.infoNAndC.remove(),
                e.showAnnouncementActionBtn
                  ? ((a.infoActionBtn.innerText = e.announcementActionBtnText),
                    (a.infoActionBtn.style.background =
                      e.announcementActionBtnColor),
                    (a.infoActionBtn.style.color =
                      e.announcementActionBtnTextColor),
                    (a.infoActionBtn.style.borderRadius =
                      e.actionButtonBorderRadius + "px"),
                    (a.infoActionBtn.onclick = () => {
                      e.announcementActionBtnUrl.startsWith("www.")
                        ? window.open(
                            "https://" + e.announcementActionBtnUrl,
                            e.announcementActionTarget
                          )
                        : window.open(
                            e.announcementActionBtnUrl,
                            e.announcementActionTarget
                          ),
                        r();
                    }))
                  : ((a.initiateContent.style.marginBottom = "0"),
                    a.infoActionBtnWrapper.remove());
          }
          return a.main;
        }
        for (let [a, n] of (Utils.addCustomCSS(t, settings?.css || ""),
        Utils.loadRTEStyle(),
        e.entries())) {
          if ("Inactive" === n.status) continue;
          if (n?.translations) {
            let o = n.translations[Shopify.locale];
            if (o && o.type === n.type) for (let r in o) n[r] = o[r];
          }
          let l = i(n);
          if (!l) return;
          if (
            (document.body.insertBefore(l, document.body.firstChild),
            "delay" === n.displayWidget)
          )
            setTimeout(() => {
              l.style.display = "block";
            }, 1e3 * +n.delay);
          else if ("exit" === n.displayWidget) {
            let c = function e() {
              (l.style.display = "block"),
                document.removeEventListener("mouseout", c);
            };
            document.addEventListener("mouseout", function (e) {
              (e.relatedTarget && "HTML" !== e.relatedTarget.nodeName) || c();
            });
          } else {
            let s,
              d = function e(t) {
                clearTimeout(s),
                  (s = setTimeout(() => {
                    (window.scrollY || document.documentElement.scrollTop) >=
                      n.scroll &&
                      ((l.style.display = "block"),
                      window.removeEventListener("scroll", d));
                  }, 100));
              };
            d(), window.addEventListener("scroll", d);
          }
        }
      },
      async handleCartUpsell(e, t = !1) {
        if (settings?.disableCartUpsellRefresh === "true") {
          let i = document.querySelector(".ewck-cu-c");
          if (i) return;
        }
        let a = Utils.sortUpsellProducts(e),
          n = document.getElementById("ewck-cart-upsell-block"),
          o = location.pathname.split("/"),
          r = o.includes("cart") ? "cart" : "drawer",
          l =
            "cart" === r
              ? settings?.cartUpsellInsertPage || "before"
              : settings?.cartUpsellInsertDrawer || "after";
        if (!n) {
          if ("cart" === r) {
            if (
              !(n = document.querySelector(
                settings?.cartUpsellPageTargetSelector ||
                  "cart-items > div > div:not(.ewck-cu-c)"
              ))
            ) {
              let c = document.querySelector("h1");
              n = c?.parentElement || document.querySelector("main");
            }
          } else {
            let s = "#CartDrawer-Form,.cart__items",
              d = settings?.cartUpsellDrawerTargetSelector || s,
              p = settings?.cartUpsellDrawerDelay || settings?.cartDrawerDelay;
            if (
              (p && (await new Promise((e) => setTimeout(e, +p))),
              settings?.cartDrawerClickSelector && !1 === t)
            ) {
              let u = document.querySelector(settings.cartDrawerClickSelector);
              u &&
                u.addEventListener("click", () => {
                  document.querySelector(".ewck-cu-c") ||
                    EWCK.handleCartUpsell(e, !0);
                });
            }
            (n = document.querySelector(d)) ||
              (await new Promise((e) => setTimeout(e, 2e3)),
              (n = document.querySelector(d)));
          }
        }
        if (!n) return;
        let m = "cart" === r ? window?.CKCart : await Loaders.cartInitials(!0);
        m && setTimeout(() => delete window.CKCart, 2e3);
        let y = [];
        async function f(e) {
          switch ((m || (m = await Loaders.cartInitials(!0)), e.resourceType)) {
            case "product":
              if (
                !m.items.some((t) =>
                  e.selectionIds.includes(t.product_id.toString())
                )
              )
                return !1;
              break;
            case "collection":
              let t = !1;
              for (let i in cartItemsInCollection)
                if (m.items.find((e) => e.id.toString() === i.toString()))
                  for (let a of cartItemsInCollection[i])
                    e.selectionIds.includes(a.toString()) && (t = !0);
              if (currentProduct) {
                for (let n of currentProductCollections)
                  if (
                    e.selectionIds.includes(n.id.toString()) &&
                    m.items.find((e) => e.id === selectedVariant.id)
                  ) {
                    t = !0;
                    break;
                  }
              }
              if (!t) return !1;
          }
          return !0;
        }
        for (let [g, h] of a.entries()) {
          if ("Inactive" === h.status) continue;
          h?.translations &&
            h.translations[Shopify.locale] &&
            ((h.title = h.translations[Shopify.locale].title),
            (h.atcText = h.translations[Shopify.locale].atcText)),
            (y = h.upsellProducts);
          if (await f(h)) Utils.createUpsellMarkup(m, n, l, h, y, !0);
          else {
            g === a.length - 1 &&
              document.querySelector(".ewck-cu-c")?.remove();
            continue;
          }
          let b = [];
          m || b.push(Loaders.cartInitials(!0));
          let w = h.upsellProducts.map((e) => Apis.getProduct(e.handle));
          b = b.concat(w);
          try {
            let k = await Promise.allSettled(b);
            if (m)
              y = k
                .filter((e) => "fulfilled" === e.status && e.value?.available)
                .map((e) => e.value);
            else {
              let [v, ...$] = k;
              (m = "fulfilled" === v.status ? v.value : null),
                (y = $.filter(
                  (e) => "fulfilled" === e.status && e.value?.available
                ).map((e) => e.value));
            }
            h.randomize && (y = Utils.shuffle(y)),
              Utils.createUpsellMarkup(m, n, l, h, y, !1);
            break;
          } catch (x) {
            console.error("Error processing offers:", x);
          }
        }
      },
      async handleProductCrossSell(e) {
        let t = Utils.sortUpsellProducts(e),
          i = document.getElementById("ewck-product-cross-sell-block"),
          a = "";
        if (
          !i &&
          (location.pathname.includes("/products/") ||
            settings?.singleProductPage === "true")
        ) {
          let n = settings?.pcsTargetSelector || "";
          (a = settings?.pcsInsert || (n ? "after" : "")),
            (i = n ? document.querySelector(n) : Utils.findTarget());
        }
        if (!i) return;
        let o = window?.CKCart || (await Loaders.cartInitials(!0));
        window?.CKCart && setTimeout(() => delete window.CKCart, 2e3);
        let r = [];
        if (
          currentProduct ||
          (settings?.singleProductPage &&
            settings?.singleProductPage !== "false")
        )
          for (let [l, c] of t.entries()) {
            if (
              "Inactive" === c.status ||
              !Utils.checkVisibility({
                resourceType: c.resourceType,
                selectionIds: c.selectionIds,
              })
            )
              continue;
            if (
              (c?.translations &&
                c.translations[Shopify.locale] &&
                ((c.title = c.translations[Shopify.locale].title),
                (c.atcText = c.translations[Shopify.locale].atcText)),
              !0 === c.alwaysVisible && document.querySelector(".ewck-pcs-c"))
            )
              return;
            (r = c.crossSellProducts.filter(
              (e) => e.id !== currentProduct.id.toString()
            )),
              Utils.createUpsellMarkup(o, i, a, c, r, !0, "ewck-pcs-c");
            let s = [];
            o || s.push(Loaders.cartInitials(!0));
            let d = r.map((e) => Apis.getProduct(e.handle));
            s = s.concat(d);
            try {
              let p = await Promise.allSettled(s);
              if (o)
                r = p
                  .filter((e) => "fulfilled" === e.status && e.value?.available)
                  .map((e) => e.value);
              else {
                let [u, ...m] = p;
                (o = "fulfilled" === u.status ? u.value : null),
                  (r = m
                    .filter(
                      (e) => "fulfilled" === e.status && e.value?.available
                    )
                    .map((e) => e.value));
              }
              c.randomize && (r = Utils.shuffle(r)),
                Utils.createUpsellMarkup(o, i, a, c, r, !1, "ewck-pcs-c");
              break;
            } catch (y) {
              console.error("Error processing offers:", y);
            }
          }
      },
      async handleShippingProtection(e) {
        function t(t, i, a, n, o) {
          document
            .querySelector(
              `${i ? ".ewck-sp-cart-page" : ""}${
                n ? (i ? ", .ewck-sp-cart-drawer" : ".ewck-sp-cart-drawer") : ""
              }`
            )
            ?.remove(),
            (EWCK.spEnabled = "Yes" === e.defaultEnabled);
          let r = Utils.ce("div", {
            class: `${i ? "ewck-sp-cart-page " : ""}${
              n ? "ewck-sp-cart-drawer " : ""
            } ${
              EWCK.spEnabled ? "ewck-sp-c-enabled " : "ewck-sp-c-disabled "
            }ewck-sp-c`,
            style: `width:100%;margin-block:${e.marginY}px;`,
          });
          Utils.addCustomCSS(r, settings?.css || "");
          let l = Utils.ce("div", {
              class: "ewck-sp-w",
              style: `max-width:${
                i?.offsetWidth || n?.offsetWidth
              }px;margin-inline:auto;`,
            }),
            c = document.createElement("div");
          (c.className = `ewck-sp-img ${
            EWCK.spEnabled ? "ewck-sp-img-enabled" : "ewck-sp-img-disabled"
          }`),
            ("1" === e.disabledImageSelected && !EWCK.spEnabled) ||
            ("1" === e.enabledImageSelected && EWCK.spEnabled)
              ? (c.innerHTML = e.defaultLogo
                  .replace(
                    "{{fillColor}}",
                    EWCK.spEnabled ? e.fillColor : "transparent"
                  )
                  .replaceAll(
                    "{{outlineColor}}",
                    EWCK.spEnabled
                      ? e.enabledOutlineColor
                      : e.disabledOutlineColor
                  ))
              : (c.innerHTML = `<img src='${
                  EWCK.spEnabled ? e.enabledImage : e.disabledImage
                }' style='width:100%;height:100%;object-fit:contain;' alt='shipping protection image' />`);
          let s = document.createElement("div");
          s.className = "ewck-sp-title-desc-wrap";
          let d = document.createElement("div");
          (d.className = "ewck-sp-title"),
            (d.style.color = e.textColor),
            (d.innerHTML = `${
              e.title
            }<span style='margin-left:4px;font-weight:normal'>(${Utils.cf(
              t.rawPrice
            )})</span>`);
          let p = document.createElement("div");
          (p.className = `ewck-sp-desc ${
            EWCK.spEnabled ? "ewck-sp-desc-enabled" : "ewck-sp-desc-disabled"
          }`),
            (p.style.color = e.textColor),
            (p.innerHTML = EWCK.spEnabled
              ? "" === e.enabledDescription.trim()
                ? e.disabledDescription
                : e.enabledDescription
              : "" === e.disabledDescription.trim()
              ? e.enabledDescription
              : e.disabledDescription),
            s.appendChild(d),
            s.appendChild(p);
          let u = document.createElement("div");
          u.className = "ewck-sp-toggle-wrap";
          let m = document.createElement("label");
          m.className = "ewck-sp-toggle-label";
          let y = document.createElement("input");
          (y.className = "ewck-sp-toggle-checkbox"),
            (y.type = "checkbox"),
            (y.checked = EWCK.spEnabled),
            (y.style.display = "none"),
            y.addEventListener("change", () => {
              (EWCK.spEnabled = !EWCK.spEnabled),
                (r.className = `${i ? "ewck-sp-cart-page " : ""}${
                  n ? "ewck-sp-cart-drawer " : ""
                }${
                  EWCK.spEnabled ? "ewck-sp-c-enabled " : "ewck-sp-c-disabled "
                }ewck-sp-c`),
                (c.className = `ewck-sp-img ${
                  EWCK.spEnabled
                    ? "ewck-sp-img-enabled"
                    : "ewck-sp-img-disabled"
                }`),
                ("1" === e.disabledImageSelected && !EWCK.spEnabled) ||
                ("1" === e.enabledImageSelected && EWCK.spEnabled)
                  ? (c.innerHTML = e.defaultLogo
                      .replace(
                        "{{fillColor}}",
                        EWCK.spEnabled ? e.fillColor : "transparent"
                      )
                      .replaceAll(
                        "{{outlineColor}}",
                        EWCK.spEnabled
                          ? e.enabledOutlineColor
                          : e.disabledOutlineColor
                      ))
                  : (c.innerHTML = `<img src='${
                      EWCK.spEnabled ? e.enabledImage : e.disabledImage
                    }' style='width:100%;height:100%;object-fit:contain;' alt='shipping protection image' />`),
                (p.className = `ewck-sp-desc ${
                  EWCK.spEnabled
                    ? "ewck-sp-desc-enabled"
                    : "ewck-sp-desc-disabled"
                }`),
                (p.innerHTML = EWCK.spEnabled
                  ? "" === e.enabledDescription.trim()
                    ? e.disabledDescription
                    : e.enabledDescription
                  : "" === e.disabledDescription.trim()
                  ? e.enabledDescription
                  : e.disabledDescription),
                (f.style.backgroundColor = EWCK.spEnabled
                  ? e.fillColor
                  : "#ccc"),
                (f.className = `ewck-sp-toggle-bg ${
                  EWCK.spEnabled
                    ? "ewck-sp-toggle-bg-enabled"
                    : "ewck-sp-toggle-bg-disabled"
                }`),
                (g.className = `ewck-sp-toggle-circle ${
                  EWCK.spEnabled
                    ? "ewck-sp-toggle-circle-on"
                    : "ewck-sp-toggle-circle-off"
                }`),
                h();
            });
          let f = document.createElement("div");
          (f.className = `ewck-sp-toggle-bg ${
            EWCK.spEnabled
              ? "ewck-sp-toggle-bg-enabled"
              : "ewck-sp-toggle-bg-disabled"
          }`),
            (f.style.backgroundColor = EWCK.spEnabled ? e.fillColor : "#ccc");
          let g = document.createElement("div");
          (g.className = `ewck-sp-toggle-circle ${
            EWCK.spEnabled
              ? "ewck-sp-toggle-circle-on"
              : "ewck-sp-toggle-circle-off"
          }`),
            (g.style.display = "block"),
            f.appendChild(g),
            m.appendChild(y),
            m.appendChild(f),
            u.appendChild(m),
            l.appendChild(c),
            l.appendChild(s),
            l.appendChild(u),
            r.appendChild(l);
          let h = () => {
            (i || n).offsetWidth < 460 &&
              ((d.style.fontSize = "14px"),
              (p.style.fontSize = "12px"),
              (c.style.minWidth = "30px"),
              (c.style.maxWidth = "60px"),
              (c.style.minHeight = "30px"),
              (c.style.maxHeight = "60px"),
              (s.style.gap = "3px"),
              (f.style.width = "40px"),
              (f.style.height = "20px"),
              (g.style.width = "16px"),
              (g.style.height = "16px"),
              g.classList.contains("ewck-sp-toggle-circle-on")
                ? (g.style.left = "22px")
                : (g.style.left = "2px"));
          };
          async function b(e) {
            if (tools.terms_conditions_checkbox) {
              let i = document.getElementById("ewck-tcc-checkbox");
              if (i && !i.checked) return;
            }
            let a = Utils.createSpinner(e);
            if (
              (await Loaders.cartInitials(!0)).items.every(
                (e) =>
                  "Upsell Kit App (UKA)" !== e.vendor &&
                  !e.handle.includes("upsell-kit-shipping-protection")
              )
            ) {
              let n = await Apis.getShippingProtection(
                Number(t.actualPrice).toFixed(2)
              );
              n &&
                (await Utils.manualAtc([
                  {
                    id: n,
                    quantity: 1,
                    properties: {
                      _ewckShippingProtection: Number(t.actualPrice).toFixed(2),
                    },
                  },
                ])) &&
                (location.href =
                  (window?.Shopify?.routes?.root || "/") + "cart/checkout");
            } else
              location.href =
                (window?.Shopify?.routes?.root || "/") + "cart/checkout";
            a?.remove();
          }
          i &&
            (null !== EWCK.spCheckoutLis &&
              i.removeEventListener("click", EWCK.spCheckoutLis, !0),
            i.addEventListener(
              "click",
              (EWCK.spCheckoutLis = async (e) => {
                EWCK.spEnabled &&
                  (e.stopPropagation(), e.preventDefault(), b(i));
              }),
              !0
            ),
            a
              ? a.parentElement.insertBefore(r, a)
              : i.parentElement.parentElement.insertBefore(r, i.parentElement),
            h()),
            n &&
              (null !== EWCK.spCartDrawerCheckoutLis &&
                n.removeEventListener(
                  "click",
                  EWCK.spCartDrawerCheckoutLis,
                  !0
                ),
              n.addEventListener(
                "click",
                (EWCK.spCartDrawerCheckoutLis = (e) => {
                  EWCK.spEnabled &&
                    (e.stopPropagation(), e.preventDefault(), b(n));
                }),
                !0
              ),
              o
                ? o.parentElement.insertBefore(r, o)
                : n.parentElement.parentElement.insertBefore(
                    r,
                    n.parentElement
                  ),
              h());
        }
        e?.translations &&
          e.translations[Shopify.locale] &&
          ((e.title = e.translations[Shopify.locale].title),
          (e.disabledDescription =
            e.translations[Shopify.locale].disabledDescription),
          (e.enabledDescription =
            e.translations[Shopify.locale].enabledDescription));
        let i = location.pathname.split("/"),
          a;
        (a =
          null === EWCK.cart ? window.CKCart : await Loaders.cartInitials(!0)),
          (EWCK.cart = a);
        let n = [];
        if ("product" === e.resourceType)
          n = a.items.filter((t) =>
            e.selectionIds.includes(t.product_id.toString())
          );
        else if ("collection" === e.resourceType) {
          let o = a.items.map((e) => e.id.toString());
          for (let r in cartItemsInCollection)
            o.includes(r) || delete cartItemsInCollection[r];
          if (
            (a.items.forEach((t) => {
              if (cartItemsInCollection[t.id]) {
                for (let i of cartItemsInCollection[t.id])
                  if (e.selectionIds.includes(i.toString())) {
                    n.push(t);
                    break;
                  }
              }
            }),
            currentProduct)
          ) {
            for (let l of currentProductCollections)
              if (e.selectionIds.includes(l.id.toString())) {
                let c = a.items.find((e) => e.id === selectedVariant.id);
                if (c) {
                  n.find((e) => e.id === c.id) || n.push(c);
                  break;
                }
              }
          }
        } else n = a.items;
        if (
          (document
            .querySelectorAll(".ewck-sp-cart-page,.ewck-sp-cart-drawer")
            .forEach((e) => {
              e.className.includes("ewck-sp-cart-page") &&
                EWCK.spCheckoutBtn.removeEventListener(
                  "click",
                  EWCK.spCheckoutLis,
                  !0
                ),
                EWCK.spCartDrawerCheckoutBtn?.removeEventListener(
                  "click",
                  EWCK.spCartDrawerCheckoutLis,
                  !0
                ),
                e.remove();
            }),
          n.length)
        ) {
          let s, d;
          if ("Fixed" === e.pricingType)
            (s = e.fixedPriceValue * Shopify.currency.rate),
              (d = e.fixedPriceValue);
          else {
            let p = n.reduce((e, t) => e + t.line_price, 0) / 100;
            if ("Percentage" === e.pricingType)
              (d =
                (s = (p * e.percentagePriceValue) / 100) *
                Shopify.currency.rate),
                s < +e.minimumPriceValue
                  ? ((s = e.minimumPriceValue * Shopify.currency.rate),
                    (d = e.minimumPriceValue))
                  : s > +e.maximumPriceValue &&
                    ((s = e.maximumPriceValue * Shopify.currency.rate),
                    (d = e.maximumPriceValue));
            else
              for (let u of e.tieredPricing)
                p >= u.minimumAmount * Shopify.currency.rate &&
                  p <= u.maximumAmount * Shopify.currency.rate &&
                  ((s = u.priceValue * Shopify.currency.rate),
                  (d = u.priceValue));
          }
          if (!s) return;
          let m = Number(s).toFixed(settings?.toFixed || 2);
          if ("cart" === i[i.length - 1]) {
            if (settings?.spCheckoutSelectorCartPage) {
              let y = document.querySelector(
                settings.spCheckoutSelectorCartPage
              );
              (EWCK.spCheckoutBtn = y),
                y &&
                  t(
                    { rawPrice: m, actualPrice: d },
                    y,
                    settings?.spCheckoutParentSelectorCartPage
                      ? document.querySelector(
                          settings?.spCheckoutParentSelectorCartPage
                        )
                      : y
                  );
            } else {
              let f = document.querySelector("#checkout, [name='checkout']");
              f &&
                ((EWCK.spCheckoutBtn = f),
                t({ rawPrice: m, actualPrice: d }, f));
            }
          }
          function g() {
            if (settings?.spCheckoutSelectorCartDrawer) {
              let e = document.querySelector(
                settings.spCheckoutSelectorCartDrawer
              );
              e &&
                ((EWCK.spCartDrawerCheckoutBtn = e),
                t(
                  { rawPrice: m, actualPrice: d },
                  null,
                  null,
                  e,
                  document.querySelector(
                    settings.spCheckoutParentSelectorCartDrawer
                  )
                ));
            } else {
              let i = document.querySelector("#CartDrawer-Checkout");
              i &&
                ((EWCK.spCartDrawerCheckoutBtn = i),
                t({ rawPrice: m, actualPrice: d }, null, null, i));
            }
          }
          if (settings?.cartDrawerClickSelector) {
            let h = document.querySelector(settings.cartDrawerClickSelector);
            h &&
              (h.addEventListener("click", async () => {
                document.querySelector(".ewck-sp-cart-drawer") ||
                  (settings?.cartDrawerDelay &&
                    (await new Promise((e) =>
                      setTimeout(e, +settings.cartDrawerDelay)
                    )),
                  g());
              }),
              g());
          } else
            settings?.cartDrawerDelay &&
              (await new Promise((e) =>
                setTimeout(e, +settings.cartDrawerDelay)
              )),
              g();
        }
      },
      async handlePreorder(data, selectedProd) {
        let limitReached =
          data.preorderLimit &&
          variantsQuantities[selectedVariant.id] <=
            data.initialInventory[selectedVariant.id] - data.limitInventory;
        if (
          !selectedVariant.available ||
          !selectedProd.variants.includes(selectedVariant.id.toString()) ||
          ("continue-selling" === data.showPreorderWhen &&
            variantsQuantities[selectedVariant.id] > 0) ||
          ("in-stock" === data.showPreorderWhen &&
            variantsQuantities[selectedVariant.id] < 1) ||
          limitReached
        ) {
          limitReached &&
            selectedVariant.available &&
            Apis.updateContinueSelling(selectedVariant.id),
            document.querySelector(".ewck-preorder-p-p-ori")?.remove(),
            EWCK.themeAtc && (EWCK.themeAtc.style.display = "block"),
            EWCK.shopifyPaymentButton &&
              (EWCK.shopifyPaymentButton.style.display = "block");
          let classElem = document.querySelector(".ewck-preorder-p-p-dis");
          classElem && classElem.classList.remove("ewck-preorder-p-p-dis"),
            document.querySelector(".ewck-preorder-c")?.remove();
          return;
        }
        if (document.querySelector(".ewck-preorder-c")) {
          (EWCK.themeAtc = Utils.findAtc()),
            (EWCK.themeAtc.style.display = "none");
          return;
        }
        data?.translations &&
          data.translations[Shopify.locale] &&
          ((data.fullPaymentTitle =
            data.translations[Shopify.locale].fullPaymentTitle),
          (data.fullPaymentDescription =
            data.translations[Shopify.locale].fullPaymentDescription),
          (data.partialPaymentTitle =
            data.translations[Shopify.locale].partialPaymentTitle),
          (data.partialPaymentDescription =
            data.translations[Shopify.locale].partialPaymentDescription),
          (data.preorderButtonText =
            data.translations[Shopify.locale].preorderButtonText),
          (data.additionalText =
            data.translations[Shopify.locale].additionalText),
          (data.customPropertyKey =
            data.translations[Shopify.locale].customPropertyKey),
          (data.customPropertyValue =
            data.translations[Shopify.locale].customPropertyValue),
          (data.errorMessage1 =
            data.translations[Shopify.locale].errorMessage1),
          (data.errorMessage2 =
            data.translations[Shopify.locale].errorMessage2));
        let parentElement = document.getElementById("ewck-preorder-block"),
          insert = "";
        if (!parentElement) {
          let targetSelector = settings?.preorderTargetSelector || "";
          (insert = settings?.preorderInsert || "before"),
            (parentElement = targetSelector
              ? document.querySelector(targetSelector)
              : Utils.findAtc());
        }
        if (!parentElement) return;
        let container = Utils.ce("div", { class: "ewck-preorder-c" }),
          mainWrapper = Utils.ce("div", { class: "ewck-preorder-w" });
        function getFormatedDescription(e) {
          return e
            .replaceAll(
              "{{initialPayment}}",
              Utils.cf(
                "Percentage" === data.partialPaymentType
                  ? (
                      ((("None" === data.discountType
                        ? selectedVariant.price
                        : "Percentage" === data.discountType
                        ? selectedVariant.price -
                          (selectedVariant.price * data.discountPercentage) /
                            100
                        : selectedVariant.price - 100 * data.discountAmount) /
                        100) *
                        data.partialPaymentPercentage) /
                      100
                    ).toFixed(settings?.toFixed || 2)
                  : Number(data.partialPaymentFixed).toFixed(
                      settings?.toFixed || 2
                    )
              )
            )
            .replaceAll(
              "{{remainingPayment}}",
              Utils.cf(
                (
                  ("None" === data.discountType
                    ? selectedVariant.price
                    : "Percentage" === data.discountType
                    ? selectedVariant.price -
                      (selectedVariant.price * data.discountPercentage) / 100
                    : selectedVariant.price - 100 * data.discountAmount) /
                    100 -
                  ("Percentage" === data.partialPaymentType
                    ? ((("None" === data.discountType
                        ? selectedVariant.price
                        : "Percentage" === data.discountType
                        ? selectedVariant.price -
                          (selectedVariant.price * data.discountPercentage) /
                            100
                        : selectedVariant.price - 100 * data.discountAmount) /
                        100) *
                        data.partialPaymentPercentage) /
                      100
                    : data.partialPaymentFixed)
                ).toFixed(settings?.toFixed || 2)
              )
            )
            .replaceAll("{{remainingPaymentDate}}", () =>
              "Days after checkout" === data.partialPaymentCollectRemainingType
                ? EWCK.customDate.format(
                    new Date().setDate(
                      new Date().getDate() +
                        +data.partialPaymentCollectRemainingDays
                    )
                  )
                : EWCK.customDate.format(
                    new Date(data.partialPaymentCollectRemainingDate)
                  )
            );
        }
        if (
          (null === EWCK.poSelectedPayment &&
            (EWCK.poSelectedPayment =
              (data.fullPayment && "fullPayment" === data.default) ||
              (data.fullPayment && !data.partialPayment)
                ? "fullPayment"
                : "partialPayment"),
          !data.hidePaymentOptions)
        ) {
          let optionsWrapper = Utils.ce("div", {
            class: "ewck-preorder-o-w",
            style: `margin-top:${data.paymentOptionMarginTop}px;margin-bottom:${data.paymentOptionMarginBottom}px;gap:${data.paymentOptionGap}px`,
          });
          if (data.fullPayment) {
            let fullPaymentWrapper = Utils.ce("div", {
                class: `ewck-preorder-fp-w${
                  "fullPayment" === EWCK.poSelectedPayment
                    ? " ewck-po-po-selected"
                    : ""
                }`,
                style: `padding:${data.paymentOptionPadding}px;margin:${
                  "fullPayment" === EWCK.poSelectedPayment
                    ? `-${
                        data.paymentOptionSelectedBorderWidth -
                        data.paymentOptionNormalBorderWidth
                      }px`
                    : "0"
                };border-color:${
                  "fullPayment" === EWCK.poSelectedPayment
                    ? data.paymentOptionSelectedBorderColor
                    : data.paymentOptionNormalBorderColor
                };border-width:${
                  "fullPayment" === EWCK.poSelectedPayment
                    ? data.paymentOptionSelectedBorderWidth + "px"
                    : data.paymentOptionNormalBorderWidth + "px"
                };border-radius:${
                  data.paymentOptionBorderRadius
                }px;background-color:${data.paymentOptionBackgroundColor}`,
                onclick() {
                  (EWCK.poSelectedPayment = "fullPayment"), fpRadio.click();
                  let e = document.querySelector(".ewck-preorder-pp-radio");
                  if ((e && (e.checked = !1), data.descOnFullPaymentSelected)) {
                    let t = document.querySelector(".ewck-preorder-fp-desc");
                    t && (t.style.display = "block");
                  }
                  if (data.descOnPartialPaymentSelected) {
                    let i = document.querySelector(".ewck-preorder-pp-desc");
                    i && (i.style.display = "none");
                  }
                  fullPaymentWrapper.classList.add("ewck-po-po-selected"),
                    (fullPaymentWrapper.style.borderColor =
                      data.paymentOptionSelectedBorderColor),
                    (fullPaymentWrapper.style.borderWidth =
                      data.paymentOptionSelectedBorderWidth + "px"),
                    (fullPaymentWrapper.style.margin =
                      "-" +
                      (data.paymentOptionSelectedBorderWidth -
                        data.paymentOptionNormalBorderWidth) +
                      "px");
                  let a = document.querySelector(".ewck-preorder-pp-w");
                  a &&
                    ((a.style.borderColor =
                      data.paymentOptionNormalBorderColor),
                    (a.style.borderWidth =
                      +data.paymentOptionNormalBorderWidth + "px"),
                    (a.style.margin = "0"),
                    a.classList.remove("ewck-po-po-selected"));
                },
              }),
              topContent = Utils.ce("div", {
                class: "ewck-preorder-fp-top-content",
              }),
              fpRadio = Utils.ce("input", {
                class: "ewck-preorder-fp-radio",
                type: "radio",
                style: "width:15px;height:15px;",
                checked: "fullPayment" === EWCK.poSelectedPayment,
              }),
              fpTitle = Utils.ce("div", {
                class: "ewck-preorder-fp-title",
                style: `color:${data.paymentOptionTitleColor};font-family:${data.paymentOptionTitleFontFamily};font-size:${data.paymentOptionTitleFontSize}px;font-weight:${data.paymentOptionTitleFontWeight}`,
                innerHTML: data.fullPaymentTitle,
              });
            if (
              (topContent.append(fpRadio, fpTitle),
              fullPaymentWrapper.appendChild(topContent),
              "" !== data.fullPaymentDescription.trim())
            ) {
              let fpDescription = Utils.ce("div", {
                class: "ewck-preorder-fp-desc",
                style: `display:${
                  !data.descOnFullPaymentSelected ||
                  (data.descOnFullPaymentSelected &&
                    "fullPayment" === EWCK.poSelectedPayment)
                    ? "block"
                    : "none"
                };color:${data.paymentOptionDescriptionColor};font-family:${
                  data.paymentOptionDescriptionFontFamily
                };font-size:${
                  data.paymentOptionDescriptionFontSize
                }px;font-weight:${data.paymentOptionDescriptionFontWeight}`,
                innerHTML: data.fullPaymentDescription,
              });
              fullPaymentWrapper.appendChild(fpDescription);
            }
            optionsWrapper.appendChild(fullPaymentWrapper);
          }
          if (data.partialPayment) {
            let partialPaymentWrapper = Utils.ce("div", {
                class: `"ewck-preorder-pp-w${
                  "partialPayment" === EWCK.poSelectedPayment
                    ? " ewck-po-po-selected"
                    : ""
                }`,
                style: `padding:${data.paymentOptionPadding}px;margin:${
                  "partialPayment" === EWCK.poSelectedPayment
                    ? `-${
                        data.paymentOptionSelectedBorderWidth -
                        data.paymentOptionNormalBorderWidth
                      }px`
                    : "0"
                };border-color:${
                  "partialPayment" === EWCK.poSelectedPayment
                    ? data.paymentOptionSelectedBorderColor
                    : data.paymentOptionNormalBorderColor
                };border-width:${
                  "partialPayment" === EWCK.poSelectedPayment
                    ? data.paymentOptionSelectedBorderWidth + "px"
                    : data.paymentOptionNormalBorderWidth + "px"
                };border-radius:${
                  data.paymentOptionBorderRadius
                }px;background-color:${data.paymentOptionBackgroundColor}`,
                onclick() {
                  (EWCK.poSelectedPayment = "partialPayment"), ppRadio.click();
                  let e = document.querySelector(".ewck-preorder-fp-radio");
                  if (
                    (e && (e.checked = !1), data.descOnPartialPaymentSelected)
                  ) {
                    let t = document.querySelector(".ewck-preorder-pp-desc");
                    t && (t.style.display = "block");
                  }
                  if (data.descOnFullPaymentSelected) {
                    let i = document.querySelector(".ewck-preorder-fp-desc");
                    i && (i.style.display = "None");
                  }
                  partialPaymentWrapper.classList.add("ewck-po-po-selected"),
                    (partialPaymentWrapper.style.borderColor =
                      data.paymentOptionSelectedBorderColor),
                    (partialPaymentWrapper.style.borderWidth =
                      data.paymentOptionSelectedBorderWidth + "px"),
                    (partialPaymentWrapper.style.margin =
                      "-" +
                      (data.paymentOptionSelectedBorderWidth -
                        data.paymentOptionNormalBorderWidth) +
                      "px");
                  let a = document.querySelector(".ewck-preorder-fp-w");
                  a &&
                    ((a.style.borderColor =
                      data.paymentOptionNormalBorderColor),
                    (a.style.borderWidth =
                      +data.paymentOptionNormalBorderWidth + "px"),
                    (a.style.margin = "0"),
                    a.classList.remove("ewck-po-po-selected"));
                },
              }),
              topContent = Utils.ce("div", {
                class: "ewck-preorder-pp-top-content",
              }),
              ppRadio = Utils.ce("input", {
                class: "ewck-preorder-pp-radio",
                type: "radio",
                style: "width:15px;height:15px;",
                checked: "partialPayment" === EWCK.poSelectedPayment,
              }),
              ppTitle = Utils.ce("div", {
                class: "ewck-preorder-pp-title",
                style: `color:${data.paymentOptionTitleColor};font-family:${data.paymentOptionTitleFontFamily};font-size:${data.paymentOptionTitleFontSize}px;font-weight:${data.paymentOptionTitleFontWeight}`,
                innerHTML: data.partialPaymentTitle,
              });
            if (
              (topContent.append(ppRadio, ppTitle),
              partialPaymentWrapper.appendChild(topContent),
              "" !== data.partialPaymentDescription.trim())
            ) {
              let ppDescription = Utils.ce("div", {
                class: "ewck-preorder-pp-desc",
                style: `display:${
                  !data.descOnPartialPaymentSelected ||
                  (data.descOnPartialPaymentSelected &&
                    "partialPayment" === EWCK.poSelectedPayment)
                    ? "block"
                    : "none"
                };color:${data.paymentOptionDescriptionColor};font-family:${
                  data.paymentOptionDescriptionFontFamily
                };font-size:${
                  data.paymentOptionDescriptionFontSize
                }px;font-weight:${data.paymentOptionDescriptionFontWeight}`,
                innerHTML: getFormatedDescription(
                  data.partialPaymentDescription
                ),
              });
              partialPaymentWrapper.appendChild(ppDescription);
            }
            optionsWrapper.appendChild(partialPaymentWrapper);
          }
          mainWrapper.appendChild(optionsWrapper);
        }
        async function onPreorderBtnClick() {
          (poBtn.style.width = poBtn.offsetWidth + "px"),
            (poBtn.style.minWidth = poBtn.offsetWidth + "px"),
            (poBtn.style.height = poBtn.offsetHeight + "px"),
            (poBtn.style.minHeight = poBtn.offsetHeight + "px"),
            (poBtn.innerText = "");
          let e = Utils.createSpinner(poBtn);
          e.innerHTML =
            '<div class="ewck-tool-spinner" style="border-right:2px solid #fff;border-bottom:2px solid #fff;"></div>';
          let t =
            document.querySelector(
              settings?.quantitySelector === ""
                ? "[name='quantity']"
                : settings?.quantitySelector
            )?.value || 1;
          if (data.preorderLimit) {
            let i = await Loaders.cartInitials(!0),
              a = 0;
            i.items.forEach((e) => {
              e.variant_id === selectedVariant.id &&
                e.properties?._upsell_kit_preorder === data.id &&
                (a += e.quantity);
            });
            let n =
                data.initialInventory[selectedVariant.id] -
                data.limitInventory -
                variantsQuantities[selectedVariant.id],
              o =
                data.initialInventory[selectedVariant.id] -
                data.limitInventory -
                variantsQuantities[selectedVariant.id] +
                a,
              r = !1,
              l = "",
              c;
            if (
              (o >= 0
                ? ((c = Utils.preOrderError(
                    data,
                    data.errorMessage2,
                    "message-2",
                    settings?.preorderErrorInsertAbsolute === "true"
                      ? null
                      : mainWrapper
                  )),
                  (r = !0),
                  (l = "message-2"))
                : o < 0 && t > Math.abs(o)
                ? ((c = Utils.preOrderError(
                    data,
                    data.errorMessage1.replaceAll("{{quantity}}", Math.abs(o)),
                    "message-1",
                    settings?.preorderErrorInsertAbsolute === "true"
                      ? null
                      : mainWrapper
                  )),
                  (r = !0),
                  (l = "message-1"),
                  (t = Math.abs(o)))
                : t > Math.abs(n) &&
                  ((c = Utils.preOrderError(
                    data,
                    data.errorMessage1.replaceAll("{{quantity}}", Math.abs(n)),
                    "message-1",
                    settings?.preorderErrorInsertAbsolute === "true"
                      ? null
                      : mainWrapper
                  )),
                  (r = !0),
                  (l = "message-1"),
                  (t = o)),
              r &&
                (setTimeout(() => {
                  e?.remove(), (poBtn.innerText = data.preorderButtonText);
                }, 1e3),
                setTimeout(() => {
                  c?.remove();
                }, 5e3),
                "message-2" === l))
            )
              return;
          }
          let s = {
            id: selectedVariant.id.toString(),
            quantity: t,
            selling_plan:
              "fullPayment" === EWCK.poSelectedPayment
                ? data.fullPaymentId.replace("gid://shopify/SellingPlan/", "")
                : data.partialPaymentId.replace(
                    "gid://shopify/SellingPlan/",
                    ""
                  ),
            properties: {
              _upsell_kit_preorder: data.id,
              _preorder_campaign_name: data.name,
            },
          };
          "" !== data.customPropertyKey.trim() &&
            "" !== data.customPropertyValue.trim() &&
            (s.properties[data.customPropertyKey] = data.customPropertyValue),
            Utils.atc([s], "preorder", data.id, data.name),
            setTimeout(() => {
              e?.remove(), (poBtn.innerText = data.preorderButtonText);
            }, 2e3);
        }
        let poBtnWrap = Utils.ce("div", { class: "ewck-preorder-btn-wrap" }),
          poBtn;
        (EWCK.themeAtc = Utils.findAtc()),
          data.useThemeAtc &&
            EWCK.themeAtc &&
            ((poBtn = EWCK.themeAtc.cloneNode()),
            null !== EWCK.poThemeAtcLis &&
              EWCK.poThemeAtcLis.removeEventListener(
                "click",
                onPreorderBtnClick,
                !0
              ),
            poBtn.addEventListener("click", onPreorderBtnClick, !0),
            (poBtn.type = "button"),
            poBtn.classList.add("ewck-po-action-btn-selected"),
            (poBtn.innerText = data.preorderButtonText)),
          poBtn ||
            (poBtn = Utils.ce("div", {
              class: "ewck-preorder-btn",
              innerText: data.preorderButtonText,
              style: `display:block;width:100%;position:relative;margin-top:${data.buttonMarginTop}px;margin-bottom:${data.buttonMarginBottom}px;padding-block:${data.buttonPadding}px;font-family:${data.buttonFontFamily};font-size:${data.buttonFontSize}px;background-color:${data.buttonBackgroundColor};color:${data.buttonTextColor};border-color:${data.buttonBorderColor};border-width:${data.buttonBorderWidth}px;border-radius:${data.buttonBorderRadius}px;font-weight:${data.buttonFontWeight};text-align:center;cursor:pointer;`,
              onclick: onPreorderBtnClick,
            }));
        let poATWrap = Utils.ce("div", {
            class: "ewck-preorder-at-wrap",
            style: "margin-bottom:15px;",
          }),
          poAT = Utils.ce("div", {
            class: "ewck-preorder-at",
            style: `text-align:center;font-family:${data.additionalTextFontFamily};color:${data.additionalTextColor};font-size:${data.additionalTextFontSize}px;font-weight:${data.additionalTextFontWeight}`,
            innerHTML: getFormatedDescription(data.additionalText),
          });
        if (
          (EWCK.themeAtc && (EWCK.themeAtc.style.display = "none"),
          !EWCK.shopifyPaymentButton)
        ) {
          let spb = document.querySelector(".shopify-payment-button");
          !spb &&
            settings?.shopifyPaymentButton &&
            (spb = document.querySelector(settings?.shopifyPaymentButton)),
            spb &&
              "none" !== spb.style.display &&
              (EWCK.shopifyPaymentButton = spb);
        }
        if (
          (EWCK.shopifyPaymentButton &&
            (EWCK.shopifyPaymentButton.style.display = "none"),
          "None" !== data.discountType)
        ) {
          let priceElement,
            tempPriceElms = document.querySelectorAll(
              settings?.priceSelector ||
                "product-info .price__regular .price-item, product-info .price__sale .price-item.price-item--sale"
            );
          if (tempPriceElms.length) {
            for (let el of tempPriceElms)
              if (Utils.isElementVisible(el)) {
                priceElement = el;
                break;
              }
            let foundDPE = document.querySelector(".ewck-preorder-p-p-ori");
            foundDPE && foundDPE.remove();
            let classElem = document.querySelector(".ewck-preorder-p-p-dis");
            if (
              (classElem && classElem.classList.remove("ewck-preorder-p-p-dis"),
              priceElement)
            ) {
              let disPriceElement = priceElement.cloneNode(!0);
              disPriceElement.classList.add("ewck-preorder-p-p-ori"),
                (disPriceElement.innerHTML = Utils.cf(
                  "Percentage" === data.discountType
                    ? (
                        selectedVariant.price / 100 -
                        ((selectedVariant.price / 100) *
                          data.discountPercentage) /
                          100
                      ).toFixed(settings?.toFixed || 2)
                    : (
                        selectedVariant.price / 100 -
                        data.discountAmount
                      ).toFixed(settings?.toFixed || 2)
                )),
                priceElement.parentElement.appendChild(disPriceElement),
                priceElement.classList.add("ewck-preorder-p-p-dis"),
                EWCK.poCFS ||
                  (EWCK.poCFS = window
                    .getComputedStyle(priceElement)
                    .fontSize.replace("px", "")),
                document.documentElement.style.setProperty(
                  "--ewck-po-p-o-p",
                  EWCK.poCFS - 0.1 * EWCK.poCFS + "px"
                );
            }
          }
        }
        poATWrap.appendChild(poAT),
          poBtnWrap.appendChild(poBtn),
          mainWrapper.append(poBtnWrap, poATWrap),
          container.appendChild(mainWrapper),
          Utils.insert(parentElement, container, insert),
          settings?.afterPreorderJS && eval(settings.afterPreorderJS);
      },
      async handleMixMatchBundle(e) {
        let t = settings?.mixMatchProductsFetchCount || 4,
          i = mixMatchBundlePageSettings?.translations?.[Shopify.locale];
        if (i)
          for (let a in i)
            "content" === a
              ? (mixMatchBundlePageSettings.richText = i[a])
              : (mixMatchBundlePageSettings[a] = i[a]);
        let n = Shopify.currency.rate,
          o = {
            initialFetchProgress: {},
            async handleProductFetch(e, i, a, n) {
              let r = JSON.parse(JSON.stringify(i.selectedProducts)),
                l = [];
              for (; l.length < t; ) {
                let c = t - l.length;
                if (
                  ((l = l.concat(
                    await Apis.getProductsFromStorefrontApi(
                      r.splice(0, c).map((e) => e.id)
                    )
                  )),
                  0 === r.length)
                )
                  break;
              }
              EWCK.mmbInfo.productFetchDetails[e.id]
                ? (EWCK.mmbInfo.productFetchDetails[e.id] = {
                    ...EWCK.mmbInfo.productFetchDetails[e.id],
                    [i.sectionId]: {
                      resourceType: i.resourceType,
                      loadedProducts: l,
                      toBeLoadedProducts: r,
                      initialProducts: i.selectedProducts,
                    },
                  })
                : (EWCK.mmbInfo.productFetchDetails[e.id] = {
                    [i.sectionId]: {
                      resourceType: i.resourceType,
                      loadedProducts: l,
                      toBeLoadedProducts: r,
                      initialProducts: i.selectedProducts,
                    },
                  }),
                delete o.initialFetchProgress[e.id][i.sectionId],
                0 === Object.keys(o.initialFetchProgress[e.id]).length &&
                  (delete o.initialFetchProgress[e.id],
                  o.startWidgetCreation(e, a, n));
            },
            async handleCollectionProductFetch(e, i, a, n) {
              let r = JSON.parse(JSON.stringify(i.selectedCollections)),
                l = {
                  products: [],
                  hasNextPage: !0,
                  cursor: null,
                  currentlyLoadedCollectionId: null,
                },
                c = t;
              for (; l.products.length < t; ) {
                l.currentlyLoadedCollectionId = r.splice(0, 1)[0];
                let s = await Apis.getCollectionproductsFromStorefrontApi(
                  l.currentlyLoadedCollectionId,
                  c,
                  l.cursor,
                  l.hasNextPage
                );
                if (
                  ((l.products = l.products.concat(s.products)),
                  s.hasNextPage &&
                    ((l.hasNextPage = s.hasNextPage), (l.cursor = s.cursor)),
                  (c -= l.products.length),
                  0 === r.length)
                )
                  break;
              }
              l?.products.length &&
                (EWCK.mmbInfo.productFetchDetails[e.id]
                  ? (EWCK.mmbInfo.productFetchDetails[e.id] = {
                      ...EWCK.mmbInfo.productFetchDetails[e.id],
                      [i.sectionId]: {
                        resourceType: i.resourceType,
                        loadedProducts: l.products,
                        cursor: l.cursor,
                        hasNextPage: l.hasNextPage,
                        currentlyLoadedCollectionId:
                          l.currentlyLoadedCollectionId,
                        toBeLoadedCollections: r,
                        initialCollections: i.selectedCollections,
                      },
                    })
                  : (EWCK.mmbInfo.productFetchDetails[e.id] = {
                      [i.sectionId]: {
                        resourceType: i.resourceType,
                        loadedProducts: l.products,
                        cursor: l.cursor,
                        hasNextPage: l.hasNextPage,
                        currentlyLoadedCollectionId:
                          l.currentlyLoadedCollectionId,
                        toBeLoadedCollections: r,
                        initialCollections: i.selectedCollections,
                      },
                    }),
                delete o.initialFetchProgress[e.id][i.sectionId],
                0 === Object.keys(o.initialFetchProgress[e.id]).length &&
                  (delete o.initialFetchProgress[e.id],
                  o.startWidgetCreation(e, a, n)));
            },
            startWidgetCreation(e, t, i) {
              "bundle-builder" === t || "bundle-builder-featured" === t
                ? o.createBundleBuilder(e, i, t)
                : "bundle-builder-overlay" === t
                ? ((i.overlay.style.display = "flex"),
                  i.overlayBody.setAttribute("campaign-id", e.id),
                  i.overlayBody.setAttribute(
                    "color",
                    e.styles.mainActionButtonTextColor
                  ),
                  o.createBundleBuilder(e, i.overlayBody, t),
                  i?.spinner?.remove())
                : o.widgetInit(e);
            },
            async widgetInit(e) {
              o.handleTranslations(e);
              let i = document.getElementById("ewck-mix-match-bundle-block"),
                a = "";
              if (!i) {
                let r = settings?.mixMatchTargetSelector || "";
                (a = settings?.mixMatchInsert || (r ? "after" : "")),
                  (i = r ? document.querySelector(r) : Utils.findTarget());
              }
              if (!i) return;
              let l = Utils.ce("div", {
                class: "ewck-mm-c",
                id: `ewck-mm-c-${e.id}`,
              });
              if ("Popup bundle builder" === e.widgetType) {
                let c = o.createOverlay(),
                  s = await o.createTypeBasedBundleWidget(e, "product-page", c);
                (s.style.marginBlock = e.styles.widgetVerticalMargin + "px"),
                  l.appendChild(s),
                  document.getElementById(`ewck-mm-c-${e.id}`)?.remove(),
                  "" === a ? i.appendChild(l) : Utils.insert(i, l, a);
              } else {
                Utils.addCustomCSS(l, settings?.css || "");
                let d = Utils.ce("div", {
                    class: "ewck-mm-w",
                    style: `position:relative;width:100%;max-width:490px;background:${e.styles.widgetBackgroundColor};margin-block:${e.styles.widgetVerticalMargin}px;padding:${e.styles.widgetPadding}px;border-radius:8px;font-family:${e.styles.fontFamily}`,
                  }),
                  p = Utils.ce("div", {
                    class: "ewck-mm-tdtw",
                    style: `margin: 0 0 ${+e.styles
                      .widgetTitleMarginBottom}px 0;`,
                  }),
                  u = Utils.ce("div", {
                    class: "ewck-mm-wt",
                    style: `font-family:inherit;font-size:${e.styles.widgetTitleFontSize}px;font-weight:${e.styles.primaryFontWeight};color:${e.styles.widgetTitleColor};line-height:1.3`,
                    innerHTML: e.widgetTitle,
                  });
                if ((p.append(u), "No discount" !== e.discountType)) {
                  let m =
                      "Percentage" === e.discountType
                        ? e.discountPercentage + "%"
                        : "Amount off each" === e.discountType ||
                          "Fixed amount" === e.discountType
                        ? Utils.cf(
                            e.discountAmount * n * 100,
                            settings?.moneyFormat
                          )
                        : "Bundle price" === e.discountType
                        ? Utils.cf(
                            e.bundlePrice * n * 100,
                            settings?.moneyFormat
                          )
                        : "Tiered percentage" === e.discountType
                        ? e.discountTiers[e.discountTiers.length - 1].discount +
                          "%"
                        : Utils.cf(
                            e.discountTiers[e.discountTiers.length - 1]
                              .discount *
                              n *
                              100,
                            settings?.moneyFormat
                          ),
                    y = Utils.ce("div", {
                      id: `ewck-mm-dt-${e.id}`,
                      class: "ewck-mm-dt",
                      innerHTML:
                        "<span class='ewck-mm-dr'>" +
                        e.discountSaveText.replace("{{discount}}", m) +
                        "</span>",
                    });
                  p.appendChild(y);
                }
                let f = Utils.ce("div", {
                    class: "ewck-mm-ws",
                    style:
                      "Expanded" === e.layoutType
                        ? `max-height:${e.expandedMaxHeight}px`
                        : "unset",
                  }),
                  g = Utils.ce("div", {
                    class: "ewck-mm-divider",
                    style: "display:block;border-top:1px solid #ebebeb",
                  });
                for (let [h, b] of e.sections.entries()) {
                  let w = Utils.ce("div", {
                      class: `ewck-mm-s ewck-mm-s${h}`,
                      style: `padding:12px;background-color:${e.styles.sectionBackgroundColor}`,
                    }),
                    k = Utils.ce("div", { class: "ewck-mm-s-hs" }),
                    v = Utils.ce("div", {
                      class: "ewck-mm-s-hiw",
                      style: b?.imageUrl
                        ? `width:${e.styles.imageSizeInWidget}px;height:${e.styles.imageSizeInWidget}px;min-width:${e.styles.imageSizeInWidget}px;min-height:${e.styles.imageSizeInWidget}px;`
                        : "display:none",
                    }),
                    $ = Utils.ce("img", {
                      class: "ewck-mm-s-h-img",
                      src: b.imageUrl,
                      alt: "section image",
                      style: `min-width:${e.styles.imageSizeInWidget}px`,
                    }),
                    x = Utils.ce("div", { class: "ewck-mm-s-hcw" }),
                    T = Utils.ce("div", { class: "ewck-mm-s-hc" }),
                    C = Utils.ce("div", {
                      class: "ewck-mm-s-h-tdw",
                      style: `${
                        "" === b.title.trim() && "" === b.description.trim()
                          ? "display:none;"
                          : ""
                      }gap:${
                        b.title.trim() && b.description.trim() ? "2px" : "0"
                      }`,
                    }),
                    S = Utils.ce("div", {
                      style: `font-size:${e.styles.sectionTitleFontSize}px;line-height:1.3;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                      innerHTML: b.title,
                    }),
                    _ = Utils.ce("div", {
                      style: `font-size:${e.styles.sectionDescriptionFontSize}px;line-height:1.3;color:${e.styles.sectionSecondaryTextColor}`,
                      innerHTML: b.description,
                    }),
                    I = Utils.ce("div", { class: "ewck-mm-s-h-apw" }),
                    P = Utils.ce("div", { class: "ewck-mm-s-h-ab" }),
                    q = Utils.ce("span", {
                      id: `ewck-mm-s-hs-abt-${e.id}-${b.sectionId}`,
                      style: `margin-left:3px;color:${e.styles.sectionPrimaryTextColor};font-size:${e.styles.addedBadgeFontSize}px;line-height:1;padding:5px;`,
                      innerHTML: e.addedBadgeText.replace("{{quantity}}", "0"),
                    });
                  if (
                    (P.appendChild(q),
                    I.appendChild(P),
                    "Expanded" === e.layoutType)
                  ) {
                    let E = Utils.ce("div", {
                      id: `ewck-mm-s-hs-vab-${e.id}-${b.sectionId}`,
                      style: `display:none;color:#2c6ecb;cursor:pointer;font-size:${e.styles.viewAllButtonFontSize}px`,
                      innerHTML: e.viewAllText,
                      onclick() {
                        o.showAddedProductsModal(e, b, n);
                      },
                    });
                    I.appendChild(E);
                  }
                  if (
                    (C.append(S, _),
                    T.append(C, I),
                    x.appendChild(T),
                    "Compact" === e.layoutType)
                  ) {
                    let L = Utils.ce("div", {
                      class: "ewck-mm-s-h-pab",
                      style: `background-color:${e.styles.productPickerButtonColor}`,
                      innerHTML: mixMatchBundlePageSettings.icons.plusSVG,
                      onclick() {
                        o.showAddedProductsModal(e, b, n);
                      },
                    });
                    x.appendChild(L);
                  }
                  let B = Utils.ce("div", {
                    class: "ewck-mm-s-bs",
                    id: `ewck-mm-s-bs-${e.id}-${b.sectionId}`,
                  });
                  if ("Expanded" === e.layoutType) {
                    let F = Utils.ce("div", {
                      class: `ewck-mm-s-bsi ${
                        "Collapsed" === e.collapsible ? "" : "ewck-mm-s-eb-open"
                      }`,
                    });
                    if ("Horizontal" === e.productListing) {
                      let A = g.cloneNode();
                      (A.style.marginBlock = "12px"), F.appendChild(A);
                    }
                    let M = Utils.ce("div", {
                      class: "ewck-mm-bb-s-cw",
                      innerHTML:
                        "Collapsed" === e.collapsible
                          ? mixMatchBundlePageSettings.icons.collapsibleDownSVG
                          : mixMatchBundlePageSettings.icons.collapsibleUpSVG,
                      onclick() {
                        F.classList.contains("ewck-mm-s-eb-open")
                          ? (F.classList.remove("ewck-mm-s-eb-open"),
                            (M.innerHTML =
                              mixMatchBundlePageSettings.icons.collapsibleDownSVG))
                          : (F.classList.add("ewck-mm-s-eb-open"),
                            (M.innerHTML =
                              mixMatchBundlePageSettings.icons.collapsibleUpSVG));
                      },
                    });
                    x.appendChild(M);
                    let D = Utils.ce("div", {
                      class: "ewck-mm-s-bs-mw",
                      style:
                        "Horizontal" === e.productListing
                          ? `display:flex;gap:12px;overflow-x:scroll;${
                              EWCK.mmbInfo.productFetchDetails[e.id][
                                b.sectionId
                              ].loadedProducts.length +
                                ("product" === b.resourceType
                                  ? EWCK.mmbInfo.productFetchDetails[e.id][
                                      b.sectionId
                                    ].toBeLoadedProducts.length
                                  : EWCK.mmbInfo.productFetchDetails[e.id][
                                      b.sectionId
                                    ].toBeLoadedCollections.length ||
                                    (EWCK.mmbInfo.productFetchDetails[e.id][
                                      b.sectionId
                                    ].hasNextPage &&
                                      EWCK.mmbInfo.productFetchDetails[e.id][
                                        b.sectionId
                                      ].cursor)
                                  ? 3
                                  : 0) >
                              2
                                ? "padding-bottom:8px;scrollbar-width:thin;"
                                : "scrollbar-width:none;justify-content:center;"
                            }`
                          : "",
                    });
                    function H(t, i, a, r = !1) {
                      let l = Utils.ce("div", {
                          class: "ewck-mm-s-bs-pw",
                          style: `position:relative;min-width:${
                            "Vertical" === e.productListing ? "100%" : "47.5%"
                          };flex-direction:${
                            "Vertical" === e.productListing ? "row" : "column"
                          };align-items:${
                            "Vertical" === e.productListing ? "unset" : "center"
                          };`,
                        }),
                        c = Utils.ce("div", {
                          class: "ewck-mm-s-bs-pimg-w",
                          style: `width:${e.styles.imageSizeInWidget}px;height:${e.styles.imageSizeInWidget}px;min-width:${e.styles.imageSizeInWidget}px;min-height:${e.styles.imageSizeInWidget}px;`,
                        }),
                        s = t.variants.find((e) => e.availableForSale),
                        d = s?.image?.ur || t.featuredImage,
                        p = Utils.ce("a", {
                          href: `/products/${t.handle}`,
                          target: "_blank",
                        }),
                        u = Utils.ce("img", {
                          src: d,
                          style: `width:100%;height:100%;object-fit:contain;min-width:${e.styles.imageSizeInWidget}px;`,
                        }),
                        m = Utils.ce("div", { class: "ewck-mm-s-bs-piaw" }),
                        y = Utils.ce("div", {
                          class: "ewck-mm-s-bs-piw",
                          style: `align-items:${
                            "Vertical" === e.productListing ? "start" : "center"
                          }`,
                        }),
                        f = Utils.ce("a", {
                          href: `/products/${t.handle}`,
                          target: "_blank",
                          style: "text-decoration:none",
                        }),
                        h = Utils.ce("div", {
                          class: "ewck-mm-s-bs-pt",
                          style: `font-size:${
                            e.styles.productTitleFontSize
                          }px;color:${
                            e.styles.sectionPrimaryTextColor
                          };font-weight:${
                            e.styles.secondaryFontWeight
                          };text-align:${
                            "Vertical" === e.productListing ? "start" : "center"
                          };`,
                          innerText: t.title,
                        }),
                        w = Utils.ce("div", {
                          class: "ewck-mm-s-bs-vpw",
                          style:
                            "Horizontal" === e.productListing
                              ? "align-items:center"
                              : "",
                        }),
                        k = Utils.ce("div", {
                          id: `ewck-mm-s-bs-pp-${e.id}-${b.sectionId}-${t.id}`,
                          class: "ewck-mm-s-bs-pp",
                          style: `color:${e.styles.sectionSecondaryTextColor};line-height:1.3;font-size:${e.styles.productPriceFontSize}px`,
                          innerHTML: Utils.cf(
                            100 * s.price.amount,
                            settings?.moneyFormat
                          ),
                        });
                      w.appendChild(k);
                      let v;
                      if (t.variants.length > 1) {
                        let $ = Utils.ce("div", { style: "line-height:1" });
                        (v = Utils.ce("select", {
                          id: `ewck-mm-s-bs-ap-${e.id}-${b.sectionId}-${t.id}`,
                          class: "ewck-mm-s-bs-pvs",
                          style: `margin-left:-4px;border:none;outline:none;padding:0 4px 0 0;width:fit-content;max-width:50%;cursor:pointer;font-size:${e.styles.productVariantTitleFontSize}px;background-color:transparent;font-family:inherit;color:${e.styles.sectionSecondaryTextColor}`,
                          onchange(i) {
                            let a = document.getElementById(
                                `ewck-mm-s-bs-pp-${e.id}-${b.sectionId}-${t.id}`
                              ),
                              n = t.variants.find(
                                (e) => e.id === i.target.value
                              );
                            a.innerHTML = Utils.cf(100 * n.price.amount);
                            let o = document.getElementById(
                              `ewck-mm-s-bs-pab-${e.id}-${b.sectionId}-${t.id}`
                            );
                            o.setAttribute("data-product-id", t.id),
                              o.setAttribute("data-variant-id", n.id);
                            let r = 0;
                            switch (
                              (Object.values(
                                EWCK.mmbInfo.addedProducts[e.id][b.sectionId]
                              ).forEach((e) => {
                                Object.values(e.variants).forEach((e) => {
                                  r += e.quantity;
                                });
                              }),
                              b.requirementType)
                            ) {
                              case "Exact quantity":
                                if (r === +b.exactQuantity) return;
                                break;
                              case "Maximum quantity":
                              case "Range quantity":
                                if (r >= +b.maximumQuantity) return;
                            }
                            let l =
                              EWCK.mmbInfo.addedProducts[e.id]?.[b.sectionId]?.[
                                t.id
                              ]?.variants?.[n.id];
                            !l || l?.quantity < n.quantityAvailable
                              ? ((o.style.backgroundColor =
                                  e.styles.sectionActionButtonColor),
                                (o.style.pointerEvents = "all"))
                              : (l?.quantity >= n.quantityAvailable &&
                                  (o.style.backgroundColor = "#ccc"),
                                (o.style.pointerEvents = "none"));
                          },
                        })),
                          t.variants.forEach((t) => {
                            if (t.availableForSale) {
                              let i = Utils.ce("option", {
                                value: t.id,
                                style: `color:${e.styles.sectionPrimaryTextColor}`,
                                innerText: t.title,
                              });
                              v.appendChild(i);
                            }
                          }),
                          $.appendChild(v),
                          w.appendChild($);
                      }
                      function x() {
                        let t = 0;
                        return (
                          EWCK.mmbInfo.addedProducts[e.id]?.[b.sectionId] &&
                            Object.values(
                              EWCK.mmbInfo.addedProducts[e.id][b.sectionId]
                            ).forEach((e) => {
                              Object.values(e.variants).forEach((e) => {
                                t += e.quantity;
                              });
                            }),
                          t
                        );
                      }
                      let T = x(!1),
                        C = !0;
                      switch (b.requirementType) {
                        case "Exact quantity":
                          T < +b.exactQuantity && (C = !1);
                          break;
                        case "Minimum quantity":
                        case "No requirement":
                          C = !1;
                          break;
                        case "Maximum quantity":
                        case "Range quantity":
                          T < +b.maximumQuantity && (C = !1);
                      }
                      let S = Utils.ce("div", {
                        id: `ewck-mm-s-bs-pab-${e.id}-${b.sectionId}-${t.id}`,
                        class: `ewck-mm-s-bs-pab ewck-mm-s-bs-pab-${e.id}-${b.sectionId}`,
                        style: `font-size:${
                          e.styles.productAddButtonFontSize
                        }px;background-color:${
                          e.styles.sectionActionButtonColor
                        };color:${
                          e.styles.sectionActionButtonTextColor
                        };position:${
                          "Vertical" === e.productListing
                            ? "absolute"
                            : "static"
                        };${
                          C && r
                            ? "background-color:#ccc;pointer-events:none;"
                            : ""
                        }`,
                        innerText: e.addButtonText,
                        onclick() {
                          if ("✓" === S.innerText) return;
                          (S.style.width = S.offsetWidth + "px"),
                            (S.style.height = S.offsetHeight + "px"),
                            (S.innerText = "✓"),
                            setTimeout(() => {
                              S.innerText = e.addButtonText;
                            }, 1e3);
                          let i;
                          (i =
                            t.variants.length > 1
                              ? t.variants.find((e) => e.id === v.value)
                              : s),
                            o.addProductToSection(e, b, t, i, n);
                        },
                      });
                      if (
                        (S.setAttribute("data-product-id", t.id),
                        S.setAttribute("data-variant-id", s.id),
                        f.appendChild(h),
                        y.append(f, w),
                        m.append(y, S),
                        p.appendChild(u),
                        c.appendChild(p),
                        l.append(c, m),
                        "Vertical" === e.productListing)
                      ) {
                        let _ = g.cloneNode();
                        (_.style.marginBlock = "12px"), D.appendChild(_);
                      }
                      D.appendChild(l),
                        i === a - 1 &&
                          Utils.onElementVisible(l, () => {
                            N();
                          });
                    }
                    for (let [z, W] of EWCK.mmbInfo.productFetchDetails[e.id][
                      b.sectionId
                    ].loadedProducts.entries())
                      H(
                        W,
                        z,
                        EWCK.mmbInfo.productFetchDetails[e.id][b.sectionId]
                          .loadedProducts.length
                      );
                    async function N() {
                      let i = Utils.createSpinner(D);
                      i.style =
                        "position:static;transform:none;margin-block:10px;";
                      let a =
                        EWCK.mmbInfo.productFetchDetails[e.id][b.sectionId];
                      if ("product" === a.resourceType) {
                        if (a.toBeLoadedProducts.length) {
                          let n = JSON.parse(
                              JSON.stringify(a.toBeLoadedProducts)
                            ),
                            o = [];
                          for (; o.length < t; ) {
                            let r = t - o.length;
                            if (
                              ((o = o.concat(
                                await Apis.getProductsFromStorefrontApi(
                                  n.splice(0, r).map((e) => e.id)
                                )
                              )),
                              0 === n.length)
                            )
                              break;
                          }
                          let l =
                            EWCK.mmbInfo.productFetchDetails[e.id][b.sectionId]
                              .loadedProducts;
                          for (let [c, s] of ((l = l.concat(o)),
                          (EWCK.mmbInfo.productFetchDetails[e.id][
                            b.sectionId
                          ].loadedProducts = l),
                          (EWCK.mmbInfo.productFetchDetails[e.id][
                            b.sectionId
                          ].toBeLoadedProducts = n),
                          i.remove(),
                          o.entries()))
                            H(s, c, o.length, !0);
                        } else i.remove();
                      } else if (
                        a.toBeLoadedCollections.length ||
                        (a.hasNextPage && a.cursor)
                      ) {
                        let d = JSON.parse(
                            JSON.stringify(a.toBeLoadedCollections)
                          ),
                          p = {
                            products: [],
                            hasNextPage: a.hasNextPage,
                            cursor: a.hasNextPage ? a.cursor : null,
                            currentlyLoadedCollectionId:
                              a.currentlyLoadedCollectionId,
                          },
                          u = t;
                        for (; p.products.length < t; ) {
                          a.hasNextPage ||
                            (p.currentlyLoadedCollectionId = d.splice(0, 1)[0]);
                          let m =
                            await Apis.getCollectionproductsFromStorefrontApi(
                              p.currentlyLoadedCollectionId,
                              u,
                              p.cursor,
                              p.hasNextPage
                            );
                          if (
                            ((p.products = p.products.concat(m.products)),
                            (p.hasNextPage = m.hasNextPage),
                            (p.cursor = m.hasNextPage ? m.cursor : null),
                            (u -= p.products.length),
                            0 === d.length && !m.hasNextPage)
                          )
                            break;
                        }
                        let y =
                          EWCK.mmbInfo.productFetchDetails[e.id][b.sectionId]
                            .loadedProducts;
                        for (let [f, g] of ((y = y.concat(p.products)),
                        (EWCK.mmbInfo.productFetchDetails[e.id][
                          b.sectionId
                        ].loadedProducts = y),
                        (EWCK.mmbInfo.productFetchDetails[e.id][
                          b.sectionId
                        ].currentlyLoadedCollectionId =
                          p.currentlyLoadedCollectionId),
                        (EWCK.mmbInfo.productFetchDetails[e.id][
                          b.sectionId
                        ].cursor = p.cursor),
                        (EWCK.mmbInfo.productFetchDetails[e.id][
                          b.sectionId
                        ].hasNextPage = p.hasNextPage),
                        (EWCK.mmbInfo.productFetchDetails[e.id][
                          b.sectionId
                        ].toBeLoadedCollections = d),
                        i.remove(),
                        p.products.entries()))
                          H(g, f, p.products.length, !0);
                      } else i.remove();
                    }
                    F.appendChild(D), B.appendChild(F);
                  }
                  if (
                    (v.appendChild($),
                    k.append(v, x),
                    w.append(k, B),
                    f.appendChild(w),
                    h < e.sections.length - 1)
                  ) {
                    let O = g.cloneNode();
                    f.appendChild(O);
                  }
                }
                let V = Utils.ce("div", {
                    id: `ewck-mm-tpw-${e.id}`,
                    class: "ewck-mm-tpw",
                    style: `display:none;margin-top:${e.styles.gapBetweenElements}px`,
                  }),
                  R = Utils.ce("div", {
                    class: "ewck-mm-tpt",
                    style: `font-size:${e.styles.priceTextFontSize}px;color:#121212;font-weight:${e.styles.primaryFontWeight};line-height:1`,
                    innerHTML: e.totalPriceText,
                  }),
                  j = Utils.ce("div", { class: "ewck-mm-tpaw" }),
                  G = Utils.ce("div", {
                    id: `ewck-mm-se-${e.id}`,
                    class: "ewck-mm-se",
                    style: `display:none;font-size:${e.styles.priceTextFontSize}px;`,
                  }),
                  Q = Utils.ce("div", {
                    id: `ewck-mm-fpe-${e.id}`,
                    class: "ewck-mm-fpe",
                    style: `font-size:${e.styles.priceTextFontSize}px;color:#121212;font-weight:500;`,
                  }),
                  U = Utils.ce("div", {
                    class: "ewck-mm-tdiw",
                    style: `margin-top:${e.styles.gapBetweenElements}px;`,
                  });
                if (
                  "Tiered percentage" === e.discountType ||
                  "Tiered amount off each" === e.discountType ||
                  "Tiered fixed amount" === e.discountType
                ) {
                  let Y = Utils.ce("div", {
                    id: `ewck-mm-tdpt-${e.id}`,
                    class: "ewck-mm-tdpt",
                    style: `background-color:#ddca3e;font-weight:${e.styles.primaryFontWeight};`,
                    innerHTML: e.tieredInitialText
                      .replaceAll("{{quantity}}", e.discountTiers[0].quantity)
                      .replaceAll(
                        "{{discount}}",
                        "Tiered percentage" === e.discountType
                          ? e.discountTiers[0].discount + "%"
                          : Utils.cf(
                              n * e.discountTiers[0].discount * 100,
                              settings?.moneyFormat
                            )
                      ),
                  });
                  U.appendChild(Y);
                } else U.style.display = "none";
                let X = Utils.ce("div", {
                    id: `ewck-mm-atc-w-${e.id}`,
                    class: "ewck-mm-atc-w",
                    style: `margin-top:${e.styles.gapBetweenElements}px`,
                  }),
                  J = Utils.ce("div", {
                    id: `ewck-mm-atc-btn-${e.id}`,
                    class: "ewck-mm-atc-btn",
                    style: `font-size:${e.styles.atcButtonFontSize}px;position:relative;background-color:#ccc;color:${e.styles.mainActionButtonTextColor};font-weight:${e.styles.primaryFontWeight};cursor:not-allowed;`,
                    async onclick() {
                      if ("transparent" === J.style.color) return;
                      let t = EWCK.mmbInfo.eligibleBundle[e.id];
                      if (t) {
                        J.style.color = "transparent";
                        let i = Utils.createSpinner(J);
                        i.firstChild.style =
                          "border-right:2px solid #ffffff;border-bottom:2px solid #ffffff;";
                        let a = !0;
                        "No discount" !== e.discountType &&
                          (a = !!(
                            await Apis.createDiscount("mmb_discount_create", {
                              campaignId: e.id,
                              addedProducts: t.addedProducts,
                            })
                          )?.success),
                          a
                            ? Utils.atc(
                                t.items.map((i) => ({
                                  ...i,
                                  properties: {
                                    _upsell_kit_mmb:
                                      e.id + "-" + t.items.length,
                                  },
                                })),
                                "mix_match_bundle",
                                e.id,
                                e.name
                              )
                            : console.error("Something went wrong"),
                          setTimeout(() => {
                            i &&
                              (i.remove(),
                              (J.style.color =
                                e.styles.mainActionButtonTextColor));
                          }, 2e3);
                      }
                    },
                  }),
                  K = Utils.ce("span", { innerHTML: e.mainActionButtonText });
                J.appendChild(K),
                  X.appendChild(J),
                  j.append(G, Q),
                  V.append(R, j),
                  d.append(p, f, V),
                  ("Tiered percentage" === e.discountType ||
                    "Tiered amount off each" === e.discountType ||
                    "Tiered fixed amount" === e.discountType) &&
                    d.appendChild(U),
                  d.appendChild(X),
                  l.appendChild(d),
                  document.getElementById(`ewck-mm-c-${e.id}`)?.remove(),
                  "" === a ? i.appendChild(l) : Utils.insert(i, l, a);
              }
            },
            addProductToSection(e, t, i, a, n, r) {
              let l = JSON.parse(JSON.stringify(EWCK.mmbInfo.addedProducts)),
                c = {
                  variantId: a.id,
                  variantTitle: a.title,
                  image: a?.image?.url || i.featuredImage,
                  price: a.price.amount,
                  quantity: 1,
                  quantityAvailable: a.quantityAvailable,
                },
                s = {
                  [i.id]: {
                    productId: i.id,
                    productTitle: i.title,
                    productHandle: i.handle,
                    featuredImage: i.featuredImage,
                    variants: { [a.id]: c },
                  },
                };
              l[e.id]
                ? l[e.id][t.sectionId]
                  ? l[e.id][t.sectionId][i.id]
                    ? l[e.id][t.sectionId][i.id].variants[a.id]
                      ? (l[e.id][t.sectionId][i.id].variants[a.id].quantity =
                          l[e.id][t.sectionId][i.id].variants[a.id].quantity +
                          1)
                      : (l[e.id][t.sectionId][i.id].variants[a.id] = c)
                    : (l[e.id][t.sectionId] = { ...l[e.id][t.sectionId], ...s })
                  : (l[e.id] = { ...l[e.id], [t.sectionId]: s })
                : (l[e.id] = { [t.sectionId]: s }),
                (EWCK.mmbInfo.addedProducts = l);
              let d = 0,
                p = 0;
              Object.values(l[e.id][t.sectionId]).forEach((e) => {
                Object.values(e.variants).forEach((e) => {
                  (d += e.quantity), e.variantId === a.id && (p = e.quantity);
                });
              });
              let u = document.getElementById(
                `ewck-mm-s-hs-abt-${e.id}-${t.sectionId}`
              );
              if (
                ((u.innerHTML = e.addedBadgeText.replace("{{quantity}}", d)),
                "Expanded" === e.layoutType || "bundle-builder" === r)
              ) {
                if (null == r) {
                  let m = document.getElementById(
                    `ewck-mm-s-hs-vab-${e.id}-${t.sectionId}`
                  );
                  d > 0
                    ? (m.style.display = "block")
                    : (m.style.display = "none");
                } else {
                  let y = document.getElementById(
                      `ewck-mm-bb-s-h-apw-${e.id}-${t.sectionId}`
                    ),
                    f = document.getElementById(
                      `ewck-mm-bb-aps-elt-${e.id}-${t.sectionId}`
                    );
                  if (d > 0) {
                    y.innerHTML = "";
                    let g = Utils.ce("div", {
                      class: "ewck-mm-bb-s-aib",
                      style: "gap:12px;width:100%;",
                    });
                    Object.values(l[e.id][t.sectionId]).forEach((i) => {
                      Object.values(i.variants).forEach((a) => {
                        Array(a.quantity)
                          .fill()
                          .forEach(() => {
                            let l = Utils.ce("div", {
                                class: "ewck-mm-bb-s-cb-pw",
                              }),
                              c = Utils.ce("div", {
                                class: "ewck-mm-s-cb-piw",
                              }),
                              s = Utils.ce("div", {
                                class: "ewck-mm-s-cb-img-w",
                              }),
                              d = Utils.ce("img", {
                                src: a?.image || i.featuredImage,
                                style:
                                  "width:100%;height:100%;object-fit:contain;",
                              }),
                              p = Utils.ce("div", { class: "ewck-mm-s-cb-cw" }),
                              u = Utils.ce("div", {
                                class: "ewck-mm-s-cb-tp-w",
                              }),
                              m = Utils.ce("div", {
                                class: "ewck-mm-s-cb-pt",
                                style: `font-size:${e.styles.productTitleFontSize}px;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                                innerText: i.productTitle,
                              }),
                              y = Utils.ce("div", {
                                class: "ewck-mm-s-cb-pp",
                                style: `font-size:${e.styles.productPriceFontSize}px;color:${e.styles.sectionSecondaryTextColor}`,
                                innerHTML: a.variantTitle,
                              }),
                              h = Utils.ce("div", {
                                class: "ewck-mm-s-cb-db",
                                onclick() {
                                  function c() {
                                    let i = 0;
                                    return (
                                      EWCK.mmbInfo.addedProducts[e.id]?.[
                                        t.sectionId
                                      ] &&
                                        Object.values(
                                          EWCK.mmbInfo.addedProducts[e.id][
                                            t.sectionId
                                          ]
                                        ).forEach((e) => {
                                          Object.values(e.variants).forEach(
                                            (e) => {
                                              i += e.quantity;
                                            }
                                          );
                                        }),
                                      i
                                    );
                                  }
                                  EWCK.mmbInfo.addedProducts[e.id][t.sectionId][
                                    i.productId
                                  ].variants[a.variantId].quantity > 1
                                    ? (EWCK.mmbInfo.addedProducts[e.id][
                                        t.sectionId
                                      ][i.productId].variants[
                                        a.variantId
                                      ].quantity =
                                        EWCK.mmbInfo.addedProducts[e.id][
                                          t.sectionId
                                        ][i.productId].variants[a.variantId]
                                          .quantity - 1)
                                    : delete EWCK.mmbInfo.addedProducts[e.id][
                                        t.sectionId
                                      ][i.productId].variants[a.variantId],
                                    l.remove(),
                                    0 ===
                                      Object.keys(
                                        EWCK.mmbInfo.addedProducts[e.id][
                                          t.sectionId
                                        ][i.productId].variants
                                      ).length &&
                                      delete EWCK.mmbInfo.addedProducts[e.id][
                                        t.sectionId
                                      ][i.productId],
                                    0 ===
                                      Object.keys(
                                        EWCK.mmbInfo.addedProducts[e.id][
                                          t.sectionId
                                        ]
                                      ).length &&
                                      (delete EWCK.mmbInfo.addedProducts[e.id][
                                        t.sectionId
                                      ],
                                      g.remove()),
                                    0 ===
                                      Object.keys(
                                        EWCK.mmbInfo.addedProducts[e.id]
                                      ).length &&
                                      delete EWCK.mmbInfo.addedProducts[e.id];
                                  let s = c(!1);
                                  function d() {
                                    return document.querySelectorAll(
                                      `.ewck-mm-s-bs-pab-${e.id}-${t.sectionId}`
                                    );
                                  }
                                  function p() {
                                    let i = d();
                                    i.forEach((i) => {
                                      let a = i.getAttribute("data-product-id"),
                                        n = i.getAttribute("data-variant-id"),
                                        o =
                                          EWCK.mmbInfo.addedProducts[e.id]?.[
                                            t.sectionId
                                          ]?.[a]?.variants[n],
                                        r = !0;
                                      o &&
                                        o.quantity >= o.quantityAvailable &&
                                        (r = !1),
                                        r &&
                                          ((i.style.backgroundColor =
                                            e.styles.sectionActionButtonColor),
                                          (i.style.pointerEvents = "all"));
                                    });
                                  }
                                  switch (
                                    (0 === s && (f.style.display = "block"),
                                    t.requirementType)
                                  ) {
                                    case "Exact quantity":
                                      s < +t.exactQuantity && p();
                                      break;
                                    case "Maximum quantity":
                                    case "Range quantity":
                                      s < +t.maximumQuantity && p();
                                      break;
                                    case "No requirement":
                                      p();
                                  }
                                  let u = document.getElementById(
                                    `ewck-mm-s-hs-abt-${e.id}-${t.sectionId}`
                                  );
                                  (u.innerHTML = e.addedBadgeText.replace(
                                    "{{quantity}}",
                                    s
                                  )),
                                    o.updateTotalPrice(e, n, r);
                                },
                                innerHTML:
                                  mixMatchBundlePageSettings.icons.deleteSVG,
                              });
                            u.appendChild(m),
                              "Default Title" !== a.variantTitle &&
                                "" !== a.variantTitle &&
                                u.appendChild(y),
                              s.appendChild(d),
                              p.append(u, h),
                              c.append(s, p),
                              l.appendChild(c),
                              g.appendChild(l);
                          });
                      });
                    }),
                      (f.style.display = "none"),
                      Object.values(l[e.id][t.sectionId]).length &&
                        y.appendChild(g);
                  } else (y.innerHTML = ""), (f.style.display = "block");
                }
                function h() {
                  let i = document.querySelectorAll(
                    `.ewck-mm-s-bs-pab-${e.id}-${t.sectionId}`
                  );
                  i.forEach((e) => {
                    (e.style.backgroundColor = "#ccc"),
                      (e.style.pointerEvents = "none");
                  });
                }
                switch (t.requirementType) {
                  case "Exact quantity":
                    d === +t.exactQuantity && h();
                    break;
                  case "Maximum quantity":
                  case "Range quantity":
                    d >= +t.maximumQuantity && h();
                }
                if (p >= a.quantityAvailable) {
                  let b = document.getElementById(
                    `ewck-mm-s-bs-pab-${e.id}-${t.sectionId}-${i.id}`
                  );
                  (b.style.backgroundColor = "#ccc"),
                    (b.style.pointerEvents = "none");
                }
              }
              o.updateTotalPrice(e, n, r);
            },
            showAddedProductsModal(e, i, a) {
              let n = {},
                r = EWCK.mmbInfo.addedProducts?.[e.id]?.[i.sectionId];
              function l(t) {
                let a = t,
                  n = {};
                for (let o of a) {
                  let r = {};
                  o.variants.forEach((t) => {
                    r[t.id] = {
                      variantId: t.id,
                      variantTitle:
                        t?.title && "Default Title" !== t.title ? t.title : "",
                      image: t?.image?.url || "",
                      price: t.price.amount,
                      quantity:
                        EWCK.mmbInfo.addedProducts?.[e.id]?.[i.sectionId]?.[
                          o.id
                        ]?.variants?.[t.id]?.quantity || 0,
                      quantityAvailable: t.quantityAvailable,
                    };
                  }),
                    (n[o.id] = {
                      productId: o.id,
                      productTitle: o.title,
                      productHandle: o.handle,
                      featuredImage: o?.featuredImage || "",
                      variants: r,
                    });
                }
                return n;
              }
              function c() {
                let t = document.querySelectorAll(
                    `.ewck-mm-s-amp-bc-select-${e.id}-${i.sectionId}`
                  ),
                  a = document.querySelectorAll(
                    `.ewck-mm-s-apm-bc-qpb-${e.id}-${i.sectionId}`
                  ),
                  n = document.querySelectorAll(
                    `.ewck-mm-s-bs-pab-${e.id}-${i.sectionId}`
                  );
                return [t, a, n];
              }
              function s(t = !0, a = null) {
                let o = 0;
                if (
                  (Object.values(a || n).forEach((e) => {
                    Object.values(e.variants).forEach((e) => {
                      o += e.quantity;
                    });
                  }),
                  t)
                ) {
                  let r = document.getElementById(
                    `ewck-mm-s-apm-f-cb-${e.id}-${i.sectionId}`
                  );
                  (r.style.backgroundColor = e.styles.sectionActionButtonColor),
                    (r.style.cursor = "pointer"),
                    (r.style.pointerEvents = "all");
                }
                function l() {
                  let [e, t, i] = c();
                  e.forEach((e) => {
                    (e.disabled = "true"),
                      (e.style.pointerEvents = "none"),
                      (e.style.color = "#ccc");
                  }),
                    t.forEach((e) => {
                      e.style.pointerEvents = "none";
                    }),
                    i.forEach((e) => {
                      (e.style.backgroundColor = "#ccc"),
                        (e.style.pointerEvents = "none");
                    });
                }
                function s() {
                  let [t, i, a] = c();
                  t.forEach((t) => {
                    t.removeAttribute("disabled"),
                      (t.style.pointerEvents = "all"),
                      (t.style.color = e.styles.sectionPrimaryTextColor);
                  }),
                    i.forEach((e) => {
                      e.style.pointerEvents = "all";
                    }),
                    a.forEach((t) => {
                      (t.style.backgroundColor =
                        e.styles.sectionActionButtonColor),
                        (t.style.pointerEvents = "all");
                    });
                }
                switch (i.requirementType) {
                  case "Exact quantity":
                    o === +i.exactQuantity ? l() : o < +i.exactQuantity && s();
                    break;
                  case "Maximum quantity":
                  case "Range quantity":
                    o >= +i.maximumQuantity
                      ? l()
                      : o < +i.maximumQuantity && s();
                }
                function d(t, a) {
                  let n = document.getElementById(
                    `ewck-mm-s-amp-bc-select-${e.id}-${i.sectionId}-${a}`
                  );
                  n &&
                    ((n.disabled = "true"),
                    (n.style.pointerEvents = "none"),
                    (n.style.color = "#ccc"));
                  let o = document.getElementById(
                    `ewck-mm-s-apm-bc-qpb-${e.id}-${i.sectionId}-${a}`
                  );
                  o && (o.style.pointerEvents = "none");
                  let r = document.getElementById(
                    `ewck-mm-s-bs-pab-${e.id}-${i.sectionId}-${t}`
                  );
                  r &&
                    r.getAttribute("data-variant-id") === a &&
                    ((r.style.backgroundColor = "#ccc"),
                    (r.style.pointerEvents = "none"));
                }
                return (
                  Object.values(n).forEach((e) => {
                    Object.values(e.variants).forEach((t) => {
                      t.quantity >= t.quantityAvailable &&
                        d(e.productId, t.variantId);
                    });
                  }),
                  o
                );
              }
              r && (n = JSON.parse(JSON.stringify(r))),
                "Compact" === e.layoutType &&
                  (n = l(
                    EWCK.mmbInfo.productFetchDetails[e.id][i.sectionId]
                      .loadedProducts
                  ));
              let d = Utils.ce("div", {
                  class: "ewck-mm-s-apm-overlay",
                  onclick() {
                    s(!0, EWCK.mmbInfo.addedProducts?.[e.id]?.[i.sectionId]),
                      d.remove();
                  },
                }),
                p = Utils.ce("div", {
                  class: "ewck-mm-s-apm",
                  style: `font-family:${e.styles.fontFamily}`,
                  onclick(e) {
                    e.stopPropagation();
                  },
                }),
                u = Utils.ce("div", { class: "ewck-mm-s-apm-h" }),
                m = Utils.ce("div", { class: "ewck-mm-s-apm-h-cw" }),
                y = Utils.ce("div", {
                  style: `margin:0;font-size:${e.styles.sectionTitleFontSize}px;line-height:1;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                  innerHTML: i.title,
                }),
                f = Utils.ce("div", { class: "ewck-mm-s-apm-h-b" }),
                g = Utils.ce("span", {
                  style: `margen-left:3px;color:${e.styles.sectionPrimaryTextColor};font-size:${e.styles.addedBadgeFontSize}px;line-height:1;padding:5px;`,
                  innerHTML: e.addedBadgeText.replace(
                    "{{quantity}}",
                    s(!1, EWCK.mmbInfo.addedProducts?.[e.id]?.[i.sectionId])
                  ),
                }),
                h = Utils.ce("div", {
                  class: "ewck-mm-s-apm-cb",
                  onclick() {
                    s(!0, EWCK.mmbInfo.addedProducts?.[e.id]?.[i.sectionId]),
                      d.remove();
                  },
                  innerHTML: "&times;",
                }),
                b = Utils.ce("div", { class: "ewck-mm-s-apm-b" }),
                w = Utils.ce("div", { class: "ewck-mm-s-apm-bc" }),
                k = [];
              function v(t, a, n) {
                function o() {
                  let t = 0;
                  return (
                    EWCK.mmbInfo.addedProducts[e.id]?.[i.sectionId] &&
                      Object.values(
                        EWCK.mmbInfo.addedProducts[e.id][i.sectionId]
                      ).forEach((e) => {
                        Object.values(e.variants).forEach((e) => {
                          t += e.quantity;
                        });
                      }),
                    t
                  );
                }
                let r = o(!1),
                  l = !0;
                switch (i.requirementType) {
                  case "Exact quantity":
                    r < +i.exactQuantity && (l = !1);
                    break;
                  case "Minimum quantity":
                  case "No requirement":
                    l = !1;
                    break;
                  case "Maximum quantity":
                  case "Range quantity":
                    r < +i.maximumQuantity && (l = !1);
                }
                let d = Object.keys(t.variants).length,
                  p = `ewck-mm-s-apm-bc-c-i-${e.id}-${i.sectionId}-${t.productId}`,
                  u = Utils.ce("div", {
                    class: "ewck-mm-s-apm-bc-pmw",
                    style: 1 === d ? "auto" : "pointer",
                    onclick() {
                      if (1 === d) return;
                      let a = document.getElementById(p),
                        n = document.getElementById(
                          `ewck-mm-s-apm-bc-vmw-${e.id}-${i.sectionId}-${t.productId}`
                        );
                      k.includes(p)
                        ? ((a.innerHTML =
                            mixMatchBundlePageSettings.icons.collapsibleDownSVG),
                          (k = k.filter((e) => e !== p)),
                          (n.style.display = "none"))
                        : ((a.innerHTML =
                            mixMatchBundlePageSettings.icons.collapsibleUpSVG),
                          k.push(p),
                          (n.style.display = "flex"));
                    },
                  }),
                  m = Utils.ce("div", {
                    class: "ewck-mm-s-apm-bc-piw",
                    style: d > 1 ? "cursor:pointer;" : "",
                  });
                u.appendChild(m);
                let y = Utils.ce("div", {
                    class: "ewck-mm-s-apm-bc-img-w",
                    style: `width:${e.styles.imageSizeInPopup}px;height:${e.styles.imageSizeInPopup}px;min-width:${e.styles.imageSizeInPopup}px;min-height:${e.styles.imageSizeInPopup}px;`,
                  }),
                  f = Utils.ce("a", {
                    href: `/products/${t.productHandle}`,
                    target: "_blank",
                  }),
                  h = Utils.ce("img", {
                    src:
                      1 === d
                        ? Object.values(t.variants)[0].image
                        : t.featuredImage,
                    style: `width:100%;height:100%;object-fit:contain;min-width:${e.styles.imageSizeInPopup}px;`,
                    alt: t.title,
                  }),
                  b = Utils.ce("div", {
                    class: "ewck-mm-s-apm-bc-pcw",
                    style: `${
                      window.innerWidth < 490
                        ? "flex-direction:column;align-items:start;"
                        : "flex-direction:row;align-items:center;"
                    }`,
                  }),
                  v = Utils.ce("div", { class: "ewck-mm-s-apm-bc-ptpw" });
                b.appendChild(v);
                let $ = Utils.ce("a", {
                    style: "text-decoration:none",
                    href: `/products/${t.productHandle}`,
                    target: "_blank",
                  }),
                  x = Utils.ce("div", {
                    class: "ewck-mm-s-apm-bc-pt",
                    style: `font-size:${e.styles.productTitleFontSize}px;line-height:1.3;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                    innerText:
                      t.productTitle +
                      (1 === d &&
                      Object.values(t.variants)[0]?.variantTitle &&
                      "Default Title" !==
                        Object.values(t.variants)[0].variantTitle
                        ? " - " + Object.values(t.variants)[0].variantTitle
                        : ""),
                  });
                if (($.appendChild(x), v.appendChild($), 1 === d)) {
                  let T = Object.keys(t.variants)[0],
                    S = Utils.ce("div", {
                      class: "ewck-mm-s-apm-bc-pp",
                      style: `font-size:${e.styles.productPriceFontSize}px;line-height:1.3;color:${e.styles.sectionSecondaryTextColor}`,
                      innerHTML: Utils.cf(
                        100 * Object.values(t.variants)[0].price,
                        settings?.moneyFormat
                      ),
                    });
                  function _(t, a, n, o) {
                    let r = s(
                      !1,
                      EWCK.mmbInfo.addedProducts?.[e.id]?.[i.sectionId]
                    );
                    switch (i.requirementType) {
                      case "Exact quantity":
                      case "Maximum quantity":
                      case "Range quantity":
                        if (
                          r - +a.variants[n].quantity + t >
                          +i[
                            "Exact quantity" === i.requirementType
                              ? "exactQuantity"
                              : "maximumQuantity"
                          ]
                        ) {
                          let l = Math.abs(
                            +i[
                              "Exact quantity" === i.requirementType
                                ? "exactQuantity"
                                : "maximumQuantity"
                            ] -
                              (+r - +a.variants[n].quantity)
                          );
                          (o.value = l), (a.variants[n].quantity = l);
                          let [d, p, u] = c();
                          return (
                            d.forEach((e) => {
                              (e.disabled = "true"),
                                (e.style.pointerEvents = "none"),
                                (e.style.color = "#ccc");
                            }),
                            p.forEach((e) => {
                              e.style.pointerEvents = "none";
                            }),
                            u.forEach((e) => {
                              (e.style.backgroundColor = "#ccc"),
                                (e.style.pointerEvents = "none");
                            }),
                            !1
                          );
                        }
                    }
                    return !0;
                  }
                  v.appendChild(S);
                  let I = Utils.ce("div", { class: "ewck-mm-s-apm-bc-qw" }),
                    P = Utils.ce("input", {
                      id: `ewck-mm-s-amp-bc-select-${e.id}-${i.sectionId}-${
                        Object.values(t.variants)[0].variantId
                      }`,
                      class: `ewck-mm-s-amp-bc-select ewck-mm-s-amp-bc-select-${e.id}-${i.sectionId}`,
                      style: `padding:0;margin:0;width:100%;text-align:center;border:none;color:${
                        e.styles.sectionPrimaryTextColor
                      };font-size:14px;${
                        l ? "disabled:true;pointer-events:none;color:#ccc;" : ""
                      }`,
                      value:
                        t.variants[Object.values(t.variants)[0].variantId]
                          .quantity,
                      type: "number",
                      name: "quantity input",
                      min: "0",
                      onchange(i) {
                        let a = Number(i.target.value),
                          n = _(+i.target.value, t, T, P);
                        a >= 0 &&
                          n &&
                          ((t.variants[T].quantity = a), (P.value = a)),
                          (g.innerHTML = e.addedBadgeText.replace(
                            "{{quantity}}",
                            s()
                          ));
                      },
                    }),
                    q = Utils.ce("div", {
                      class: "ewck-mm-s-apm-bc-qmb",
                      onclick() {
                        let i = Object.values(t.variants)[0].quantity - 1;
                        i >= 0 &&
                          ((t.variants[T].quantity = i),
                          (P.value = i),
                          (g.innerHTML = e.addedBadgeText.replace(
                            "{{quantity}}",
                            s()
                          )));
                      },
                      innerHTML: mixMatchBundlePageSettings.icons.qtyMinusSVG,
                    }),
                    E = Utils.ce("div", {
                      id: `ewck-mm-s-apm-bc-qpb-${e.id}-${i.sectionId}-${
                        Object.values(t.variants)[0].variantId
                      }`,
                      class: `ewck-mm-s-apm-bc-qpb ewck-mm-s-apm-bc-qpb-${e.id}-${i.sectionId}`,
                      style: `${l ? "pointer-events:none" : ""}`,
                      onclick() {
                        let i = Object.values(t.variants)[0].quantity + 1;
                        (t.variants[T].quantity = i),
                          (P.value = i),
                          (g.innerHTML = e.addedBadgeText.replace(
                            "{{quantity}}",
                            s()
                          ));
                      },
                      innerHTML: mixMatchBundlePageSettings.icons.qtyPlusSVG,
                    });
                  I.append(q, P, E), b.appendChild(I);
                } else {
                  let L = Utils.ce("div", {
                    id: p,
                    class: "ewck-mm-bb-s-cw",
                    innerHTML:
                      mixMatchBundlePageSettings.icons.collapsibleDownSVG,
                  });
                  b.appendChild(L);
                  let B = Utils.ce("div", {
                    class: "ewck-mm-s-apm-bc-vmw",
                    id: `ewck-mm-s-apm-bc-vmw-${e.id}-${i.sectionId}-${t.productId}`,
                    style: "display:none",
                    onclick(e) {
                      e.stopPropagation();
                    },
                  });
                  Object.values(t.variants).map((a, n) => {
                    let o = Utils.ce("div", {
                        style: "display:block;border-top:1px solid #ebebeb",
                      }),
                      r = Utils.ce("div", { class: "ewck-mm-s-apm-bc-vcw" }),
                      c = Utils.ce("div", { class: "ewck-mm-s-apm-bc-itpw" }),
                      d = Utils.ce("div", {
                        class: "ewck-mm-s-apm-bc-viw",
                        style: `width:${e.styles.imageSizeInPopup}px;height:${e.styles.imageSizeInPopup}px;min-width:${e.styles.imageSizeInPopup}px;min-height:${e.styles.imageSizeInPopup}px;`,
                      }),
                      p = Utils.ce("img", {
                        src: a.image,
                        style: `width:100%;height:100%;object-fit:contain;min-width:${e.styles.imageSizeInPopup}px;`,
                      }),
                      u = Utils.ce("div", { class: "ewck-mm-s-apm-bc-tpw" }),
                      m = Utils.ce("div", {
                        class: "ewck-mm-s-apm-bc-vt",
                        style: `color:${e.styles.sectionPrimaryTextColor};font-size:${e.styles.productTitleFontSize}px;font-weight:400;line-height:1.3;`,
                        innerText: a.variantTitle,
                      }),
                      y = Utils.ce("div", {
                        class: "ewck-mm-s-apm-bc-vp",
                        style: `color:${e.styles.sectionSecondaryTextColor};font-size:${e.styles.productPriceFontSize}px;line-height:1;`,
                        innerHTML: Utils.cf(
                          100 * a.price,
                          settings?.moneyFormat
                        ),
                      }),
                      f = Utils.ce("div", { class: "ewck-mm-s-apm-bc-qw" }),
                      h = Utils.ce("input", {
                        id: `ewck-mm-s-amp-bc-select-${e.id}-${i.sectionId}-${a.variantId}`,
                        class: `ewck-mm-s-amp-bc-select ewck-mm-s-amp-bc-select-${e.id}-${i.sectionId}`,
                        style: `padding:0;margin:0;width:100%;text-align:center;border:none;color:${
                          e.styles.sectionPrimaryTextColor
                        };font-size:14px;${
                          l
                            ? "disabled:true;pointer-events:none;color:#ccc"
                            : ""
                        }`,
                        value: a.quantity,
                        type: "number",
                        name: "quantity input",
                        min: "0",
                        onchange(i) {
                          let n = Number(i.target.value),
                            o = _(+i.target.value, t, a.variantId, h);
                          n >= 0 && o && ((a.quantity = n), (h.value = n)),
                            (g.innerHTML = e.addedBadgeText.replace(
                              "{{quantity}}",
                              s()
                            ));
                        },
                      }),
                      b = Utils.ce("div", {
                        class: "ewck-mm-s-apm-bc-qmb",
                        onclick() {
                          let t = a.quantity - 1;
                          t >= 0 &&
                            ((a.quantity = t),
                            (h.value = t),
                            (g.innerHTML = e.addedBadgeText.replace(
                              "{{quantity}}",
                              s()
                            )));
                        },
                        innerHTML: mixMatchBundlePageSettings.icons.qtyMinusSVG,
                      }),
                      w = Utils.ce("div", {
                        id: `ewck-mm-s-apm-bc-qpb-${e.id}-${i.sectionId}-${a.variantId}`,
                        class: `ewck-mm-s-apm-bc-qpb ewck-mm-s-apm-bc-qpb-${e.id}-${i.sectionId}`,
                        style: `${l ? "pointer-events:none;" : ""}`,
                        onclick() {
                          let t = a.quantity + 1;
                          (a.quantity = t),
                            (h.value = t),
                            (g.innerHTML = e.addedBadgeText.replace(
                              "{{quantity}}",
                              s()
                            ));
                        },
                        innerHTML: mixMatchBundlePageSettings.icons.qtyPlusSVG,
                      });
                    f.append(b, h, w),
                      u.append(m, y),
                      d.appendChild(p),
                      c.append(d, u),
                      r.append(c, f),
                      B.append(o, r);
                  }),
                    u.appendChild(B);
                }
                if (
                  (f.appendChild(h),
                  y.appendChild(f),
                  m.append(y, b),
                  w.appendChild(u),
                  a < n - 1)
                ) {
                  let F = Utils.ce("div", {
                    style:
                      "margin-inline:-16px;display:block;border-top:1px solid #ebebeb",
                  });
                  w.appendChild(F);
                }
                a === n - 1 &&
                  "Compact" === e.layoutType &&
                  Utils.onElementVisible(u, () => {
                    C();
                  });
              }
              for (let [$, x] of Object.values(n).entries())
                v(x, $, Object.keys(n).length);
              let T = JSON.parse(
                JSON.stringify(
                  EWCK.mmbInfo.productFetchDetails[e.id][i.sectionId]
                )
              );
              async function C() {
                let e = Utils.createSpinner(w);
                if (
                  ((e.style =
                    "position:static;transform:none;margin-block:10px;"),
                  "product" === T.resourceType)
                ) {
                  if (T.toBeLoadedProducts.length) {
                    let i = JSON.parse(JSON.stringify(T.toBeLoadedProducts)),
                      a = [];
                    for (; a.length < t; ) {
                      let o = t - a.length;
                      if (
                        ((a = a.concat(
                          await Apis.getProductsFromStorefrontApi(
                            i.splice(0, o).map((e) => e.id)
                          )
                        )),
                        0 === i.length)
                      )
                        break;
                    }
                    (T.toBeLoadedProducts = i), e.remove();
                    let r = l(a);
                    for (let [c, s] of ((n = { ...n, ...r }),
                    Object.values(r).entries())) {
                      if (0 === c) {
                        let d = Utils.ce("div", {
                          class: "ewck-mm-divider",
                          style:
                            "display:block;border-top:1px solid #ebebeb;margin-inline:-16px;",
                        });
                        w.appendChild(d);
                      }
                      v(s, c, Object.keys(r).length);
                    }
                  } else e.remove();
                } else if (
                  T.toBeLoadedCollections.length ||
                  (T.hasNextPage && T.cursor)
                ) {
                  let p = JSON.parse(JSON.stringify(T.toBeLoadedCollections)),
                    u = {
                      products: [],
                      hasNextPage: T.hasNextPage,
                      cursor: T.hasNextPage ? T.cursor : null,
                      currentlyLoadedCollectionId:
                        T.currentlyLoadedCollectionId,
                    },
                    m = t;
                  for (; u.products.length < t; ) {
                    T.hasNextPage ||
                      (u.currentlyLoadedCollectionId = p.splice(0, 1)[0]);
                    let y = await Apis.getCollectionproductsFromStorefrontApi(
                      u.currentlyLoadedCollectionId,
                      m,
                      u.cursor,
                      u.hasNextPage
                    );
                    if (
                      ((u.products = u.products.concat(y.products)),
                      (u.hasNextPage = y.hasNextPage),
                      (u.cursor = y.hasNextPage ? y.cursor : null),
                      (m -= u.products.length),
                      0 === p.length && !y.hasNextPage)
                    )
                      break;
                  }
                  (T.currentlyLoadedCollectionId =
                    u.currentlyLoadedCollectionId),
                    (T.cursor = u.cursor),
                    (T.hasNextPage = u.hasNextPage),
                    (T.toBeLoadedCollections = p),
                    e.remove();
                  let f = l(u.products);
                  for (let [g, h] of ((n = { ...n, ...f }),
                  Object.values(f).entries())) {
                    if (0 === g) {
                      let b = Utils.ce("div", {
                        class: "ewck-mm-divider",
                        style:
                          "display:block;border-top:1px solid #ebebeb;margin-inline:-16px;",
                      });
                      w.appendChild(b);
                    }
                    v(h, g, Object.keys(f).length);
                  }
                } else e.remove();
              }
              let S = Utils.ce("div", { class: "ewck-mm-s-apm-f" }),
                _ = Utils.ce("div", {
                  class: "ewck-mm-s-apm-f-cb",
                  id: `ewck-mm-s-apm-f-cb-${e.id}-${i.sectionId}`,
                  style: `color:${e.styles.sectionActionButtonTextColor}`,
                  innerText: e.confirmButtonText,
                  onclick() {
                    for (let t in n) {
                      for (let r in n[t].variants)
                        n[t].variants[r].quantity <= 0 &&
                          delete n[t].variants[r];
                      0 === Object.keys(n[t].variants).length && delete n[t];
                    }
                    EWCK.mmbInfo.addedProducts[e.id]
                      ? (EWCK.mmbInfo.addedProducts[e.id][i.sectionId] = n)
                      : (EWCK.mmbInfo.addedProducts[e.id] = {
                          [i.sectionId]: n,
                        });
                    let l = s(),
                      c = document.getElementById(
                        `ewck-mm-s-hs-abt-${e.id}-${i.sectionId}`
                      );
                    if (
                      ((c.innerHTML = e.addedBadgeText.replace(
                        "{{quantity}}",
                        l
                      )),
                      "Expanded" === e.layoutType && 0 === l)
                    ) {
                      let p = document.getElementById(
                        `ewck-mm-s-hs-vab-${e.id}-${i.sectionId}`
                      );
                      p.style.display = "none";
                    }
                    if ("Compact" === e.layoutType) {
                      let u = document.getElementById(
                        `ewck-mm-s-bs-${e.id}-${i.sectionId}`
                      );
                      if (l > 0) {
                        u.innerHTML = "";
                        let m = Utils.ce("div", { class: "ewck-mm-s-cb" });
                        Object.values(n).forEach((t) => {
                          Object.values(t.variants).forEach((n) => {
                            Array(n.quantity)
                              .fill()
                              .forEach(() => {
                                let r = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-pw",
                                  }),
                                  l = Utils.ce("div", {
                                    class: "ewck-mm-divider",
                                    style:
                                      "display:block;border-top:1px solid #ebebeb;",
                                  }),
                                  d = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-piw",
                                  }),
                                  p = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-img-w",
                                  }),
                                  u = Utils.ce("img", {
                                    src: n?.image || t.featuredImage,
                                    style:
                                      "width:100%;height:100%;object-fit:contain;",
                                  }),
                                  y = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-cw",
                                  }),
                                  f = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-tp-w",
                                  }),
                                  g = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-pt",
                                    style: `font-size:${e.styles.productTitleFontSize}px;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                                    innerText: t.productTitle,
                                  }),
                                  h = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-pp",
                                    style: `font-size:${e.styles.productPriceFontSize}px;color:${e.styles.sectionSecondaryTextColor}`,
                                    innerHTML: Utils.cf(
                                      100 * n.price,
                                      settings?.moneyFormat
                                    ),
                                  }),
                                  b = Utils.ce("div", {
                                    class: "ewck-mm-s-cb-db",
                                    onclick() {
                                      EWCK.mmbInfo.addedProducts[e.id][
                                        i.sectionId
                                      ][t.productId].variants[n.variantId]
                                        .quantity > 1
                                        ? (EWCK.mmbInfo.addedProducts[e.id][
                                            i.sectionId
                                          ][t.productId].variants[
                                            n.variantId
                                          ].quantity =
                                            EWCK.mmbInfo.addedProducts[e.id][
                                              i.sectionId
                                            ][t.productId].variants[n.variantId]
                                              .quantity - 1)
                                        : delete EWCK.mmbInfo.addedProducts[
                                            e.id
                                          ][i.sectionId][t.productId].variants[
                                            n.variantId
                                          ],
                                        r.remove(),
                                        0 ===
                                          Object.keys(
                                            EWCK.mmbInfo.addedProducts[e.id][
                                              i.sectionId
                                            ][t.productId].variants
                                          ).length &&
                                          delete EWCK.mmbInfo.addedProducts[
                                            e.id
                                          ][i.sectionId][t.productId],
                                        0 ===
                                          Object.keys(
                                            EWCK.mmbInfo.addedProducts[e.id][
                                              i.sectionId
                                            ]
                                          ).length &&
                                          (delete EWCK.mmbInfo.addedProducts[
                                            e.id
                                          ][i.sectionId],
                                          m.remove()),
                                        0 ===
                                          Object.keys(
                                            EWCK.mmbInfo.addedProducts[e.id]
                                          ).length &&
                                          delete EWCK.mmbInfo.addedProducts[
                                            e.id
                                          ];
                                      let l = s(!1);
                                      (c.innerHTML = e.addedBadgeText.replace(
                                        "{{quantity}}",
                                        l
                                      )),
                                        o.updateTotalPrice(e, a);
                                    },
                                    innerHTML:
                                      mixMatchBundlePageSettings.icons
                                        .deleteSVG,
                                  });
                                f.append(g, h),
                                  p.appendChild(u),
                                  y.append(f, b),
                                  d.append(p, y),
                                  r.append(l, d),
                                  m.appendChild(r);
                              });
                          });
                        }),
                          Object.values(n).length && u.appendChild(m);
                      } else u.innerHTML = "";
                    }
                    d.remove(), o.updateTotalPrice(e, a);
                  },
                });
              f.appendChild(g),
                m.append(y, f),
                u.append(m, h),
                b.appendChild(w),
                S.appendChild(_),
                p.append(u, b, S),
                d.appendChild(p),
                document.body.insertBefore(d, document.body.firstChild),
                s(!1, EWCK.mmbInfo.addedProducts?.[e.id]?.[i.sectionId]);
            },
            calculateDiscount(e, t, i, a, n) {
              let o = i;
              switch (e.discountType) {
                case "Percentage":
                  o = i - (i * e.discountPercentage) / 100;
                  break;
                case "Amount off each":
                  o = Object.values(t).reduce((t, i) => {
                    let a =
                      i.price * i.quantity -
                      i.quantity * (100 * e.discountAmount * n);
                    return t + (a > 0 ? a : 0);
                  }, 0);
                  break;
                case "Fixed amount":
                  o = i - n * e.discountAmount * 100;
                  break;
                case "Bundle price":
                  o = +e.bundlePrice > i ? i : 100 * +e.bundlePrice * n;
                  break;
                case "Tiered percentage":
                case "Tiered amount off each":
                case "Tiered fixed amount":
                  let r;
                  e.discountTiers.forEach((e) => {
                    a >= +e.quantity && (r = e);
                  }),
                    r &&
                      (o =
                        "Tiered amount off each" === e.discountType
                          ? Object.values(t).reduce((e, t) => {
                              let i =
                                t.price * t.quantity -
                                t.quantity * (r.discount * n * 100);
                              return e + (i > 0 ? i : 0);
                            }, 0)
                          : i -
                            ("Tiered percentage" === e.discountType
                              ? (i * r.discount) / 100
                              : r.discount * n * 100));
                  let l = e.discountTiers.find((e) => a < e.quantity);
                  if (
                    (l || (l = e.discountTiers[e.discountTiers.length - 1]), l)
                  ) {
                    let c = document.getElementById(`ewck-mm-tdpt-${e.id}`);
                    0 === a
                      ? (c.innerHTML = e.tieredInitialText
                          .replaceAll(
                            "{{quantity}}",
                            e.discountTiers[0].quantity
                          )
                          .replaceAll(
                            "{{discount}}",
                            "Tiered percentage" === e.discountType
                              ? e.discountTiers[0].discount + "%"
                              : Utils.cf(
                                  n * e.discountTiers[0].discount * 100,
                                  settings?.moneyFormat
                                )
                          ))
                      : a >=
                        +e.discountTiers[e.discountTiers.length - 1].quantity
                      ? (c.innerHTML = e.tieredMaxText.replaceAll(
                          "{{discount}}",
                          "Tiered percentage" === e.discountType
                            ? l.discount + "%"
                            : Utils.cf(
                                n * l.discount * 100,
                                settings?.moneyFormat
                              )
                        ))
                      : (c.innerHTML = e.tieredProgressText
                          .replaceAll("{{quantity}}", l.quantity - a)
                          .replaceAll(
                            "{{discount}}",
                            "Tiered percentage" === e.discountType
                              ? l.discount + "%"
                              : Utils.cf(
                                  n * l.discount * 100,
                                  settings?.moneyFormat
                                )
                          ));
                  }
              }
              return Math.round(o);
            },
            updateTotalPrice(e, t, i) {
              let a = document.getElementById(`ewck-mm-tpw-${e.id}`);
              if (a) {
                let n = document.getElementById(`ewck-mm-se-${e.id}`),
                  r = document.getElementById(`ewck-mm-fpe-${e.id}`);
                if (n && r) {
                  let l = EWCK.mmbInfo.addedProducts[e.id],
                    c = 0,
                    s = {},
                    d = 0,
                    p = {};
                  for (let u in l) {
                    let m = l[u],
                      y = e.sections.find((e) => e.sectionId.toString() === u),
                      f = 0;
                    for (let g in m)
                      for (let h in m[g].variants) {
                        let b = m[g].variants[h].quantity,
                          w = +m[g].variants[h].price;
                        (f += b),
                          (d += b),
                          (c += 100 * w * b),
                          s[h]
                            ? (s[h] = {
                                price: 100 * w,
                                quantity: b + s[h].quantity,
                              })
                            : (s[h] = { price: 100 * w, quantity: b });
                      }
                    switch (((p[u] = !1), y.requirementType)) {
                      case "Exact quantity":
                        f === +y.exactQuantity && (p[u] = !0);
                        break;
                      case "Minimum quantity":
                        f >= +y.minimumQuantity && (p[u] = !0);
                        break;
                      case "Maximum quantity":
                        f <= +y.maximumQuantity && (p[u] = !0);
                        break;
                      case "Range quantity":
                        f >= +y.minimumQuantity &&
                          f <= +y.maximumQuantity &&
                          (p[u] = !0);
                        break;
                      case "No requirement":
                        p[u] = !0;
                    }
                  }
                  let k = o.calculateDiscount(e, s, c, d, t);
                  c > k
                    ? ((n.innerHTML = Utils.cf(c, settings?.moneyFormat)),
                      (n.style.display = "block"))
                    : ((n.innerHTML = ""), (n.style.display = "none")),
                    (r.innerHTML = Utils.cf(k, settings?.moneyFormat)),
                    "bundle-builder" !== i &&
                      (a.style.display = d > 0 ? "flex" : "none");
                  let v = document.getElementById(`ewck-mm-atc-btn-${e.id}`),
                    $ = [];
                  e.sections.forEach((e) => {
                    ("Exact quantity" === e.requirementType ||
                      "Minimum quantity" === e.requirementType ||
                      ("Range quantity" === e.requirementType &&
                        +e.minimumQuantity > 0)) &&
                      $.push(e.sectionId.toString());
                  });
                  let x = Object.keys(p);
                  if (
                    d > 0 &&
                    $.every((e) => x.includes(e)) &&
                    x.every((e) => !0 === p[e])
                  ) {
                    (v.style.backgroundColor = e.styles.mainActionButtonColor),
                      (v.style.cursor = "pointer");
                    let T = [];
                    for (let C of Object.values(
                      EWCK.mmbInfo.addedProducts[e.id]
                    ))
                      for (let S of Object.values(C))
                        for (let _ of Object.values(S.variants))
                          T.push({ id: _.variantId, quantity: _.quantity });
                    (EWCK.mmbInfo.eligibleBundle[e.id] = {
                      campaignId: e.id,
                      addedProducts: EWCK.mmbInfo.addedProducts[e.id],
                      items: T,
                    }),
                      console.log("EWCK", EWCK.mmbInfo);
                  } else
                    EWCK.mmbInfo.eligibleBundle?.[e.id] &&
                      delete EWCK.mmbInfo.eligibleBundle[e.id],
                      (v.style.backgroundColor = "#ccc"),
                      (v.style.cursor = "not-allowed");
                }
              }
            },
            async createBundleBuilder(e, i, a) {
              o.handleTranslations(e);
              let r = new ResizeObserver((e) => {
                for (let t of e) l(t.contentRect.width);
              });
              function l(e) {
                let t = document.querySelectorAll(".ewck-mm-bb-b"),
                  i = document.querySelectorAll(".ewck-mm-bb-s-plw"),
                  a = document.querySelectorAll(".ewck-mm-bb-fdw"),
                  n = document.querySelectorAll(".ewck-mm-bb-s-bs-pimg-w");
                +e >= 1e3
                  ? (t.forEach((e) => {
                      e.style.flexWrap = "nowrap";
                    }),
                    i.forEach((e) => {
                      e.style.gridTemplateColumns = "1fr 1fr 1fr";
                    }),
                    a.forEach((e) => {
                      e.style.maxWidth = "400px";
                    }),
                    n.forEach((e) => {
                      (e.style.maxHeight = "200px"),
                        (e.style.minHeight = "200px");
                    }))
                  : 1e3 > +e && +e >= 650
                  ? (t.forEach((e) => {
                      e.style.flexWrap = "nowrap";
                    }),
                    i.forEach((e) => {
                      e.style.gridTemplateColumns = "1fr 1fr";
                    }),
                    a.forEach((e) => {
                      e.style.maxWidth = "400px";
                    }),
                    n.forEach((e) => {
                      (e.style.maxHeight = "180px"),
                        (e.style.minHeight = "180px");
                    }))
                  : 650 > +e && +e >= 490
                  ? (t.forEach((e) => {
                      e.style.flexWrap = "nowrap";
                    }),
                    i.forEach((e) => {
                      e.style.gridTemplateColumns = "1fr";
                    }),
                    a.forEach((e) => {
                      e.style.maxWidth = "400px";
                    }),
                    n.forEach((e) => {
                      (e.style.maxHeight = "160px"),
                        (e.style.minHeight = "160px");
                    }))
                  : (t.forEach((e) => {
                      e.style.flexWrap = "wrap";
                    }),
                    i.forEach((e) => {
                      e.style.gridTemplateColumns = "1fr 1fr";
                    }),
                    a.forEach((e) => {
                      e.style.maxWidth = "unset";
                    }),
                    n.forEach((e) => {
                      (e.style.maxHeight = "140px"),
                        (e.style.minHeight = "140px");
                    }));
              }
              r.observe(i);
              let c = Utils.ce("div", { class: "ewck-mm-bb-c" });
              Utils.addCustomCSS(c, settings?.css || "");
              let s = Utils.ce("div", {
                class: "ewck-mm-bbw",
                style: `padding:${e.styles.widgetPadding}px;font-family:${
                  e.styles.fontFamily
                };${
                  "bundle-builder-overlay" === a
                    ? "max-height:90vh;overflow-y:auto;scrollbar-width:none;"
                    : ""
                }`,
              });
              if (e.richText.trim()) {
                let d = Utils.ce("div", {
                  class: "ewck-mm-bb-pd sun-editor-editable",
                  style:
                    "width:100%;padding:0;background-color:transparent;margin-bottom:34px;",
                  innerHTML: e.richText,
                });
                s.appendChild(d), Utils.loadRTEStyle();
              }
              if ("bundle-builder-overlay" === a) {
                let p = Utils.ce("div", {
                  class: "ewck-mm-bb-close-btn",
                  innerHTML: "&times;",
                  onclick() {
                    let e = document.querySelector(".ewck-mm-bb-overlay-body"),
                      t = e.parentElement;
                    t.style.display = "none";
                    let i = e.getAttribute("campaign-id"),
                      a = e.getAttribute("color");
                    e.innerHTML = "";
                    let n = document.getElementById(`ewck-mm-bp-ab-${i}`);
                    n.style.color = a;
                  },
                });
                s.appendChild(p);
              }
              let u = Utils.ce("div", {
                  class: "ewck-mm-bb-wt",
                  style: `margin-bottom:${
                    +e.styles.widgetTitleMarginBottom + 8
                  }px;font-family:inherit;font-size:${
                    +e.styles.widgetTitleFontSize + 2
                  }px;font-weight:${e.styles.primaryFontWeight};color:${
                    e.styles.widgetTitleColor
                  };line-height:1.3`,
                  innerHTML: e.widgetTitle,
                }),
                m = Utils.ce("div", { class: "ewck-mm-bb-b" }),
                y = Utils.ce("div", {
                  class: "ewck-mm-bb-sw",
                  style: `max-height:${e.expandedMaxHeight}px;scrollbar-width:auto;`,
                }),
                f = Utils.ce("div", {
                  class: "ewck-mm-divider",
                  style:
                    "display:block;border-top:1px solid #ebebeb;margin-block:12px;",
                });
              for (let [g, h] of e.sections.entries()) {
                let b = Utils.ce("div", {
                    class: `ewck-mm-bb-s ewck-mm-s${g}`,
                  }),
                  w = Utils.ce("div", {
                    class: "ewck-mm-s-hs",
                    style: "align-items:center;cursor:pointer;",
                    onclick() {
                      _.classList.contains("ewck-mm-bb-s-eb-open")
                        ? (_.classList.remove("ewck-mm-bb-s-eb-open"),
                          (S.innerHTML =
                            mixMatchBundlePageSettings.icons.collapsibleDownSVG))
                        : (_.classList.add("ewck-mm-bb-s-eb-open"),
                          (S.innerHTML =
                            mixMatchBundlePageSettings.icons.collapsibleUpSVG));
                    },
                  }),
                  k = Utils.ce("div", {
                    class: "ewck-mm-s-hiw",
                    style: h?.imageUrl
                      ? "width:60px;height:60px;min-width:60px;min-height:60px;"
                      : "display:none",
                  }),
                  v = Utils.ce("img", {
                    class: "ewck-mm-s-h-img",
                    src: h.imageUrl,
                    alt: "section image",
                    style: "min-width:60px;height:100%",
                  }),
                  $ = Utils.ce("div", {
                    class: "ewck-mm-s-hc",
                    style:
                      "flex-direction:row;flex-wrap:nowrap;justify-content:space-between;align-items:center;",
                  }),
                  x = Utils.ce("div", {
                    class: "ewck-mm-s-h-tdw",
                    style: `${
                      "" === h.title.trim() && "" === h.description.trim()
                        ? "display:none;"
                        : ""
                    }gap:${
                      h.title.trim() && h.description.trim() ? "6px" : "0"
                    }`,
                  }),
                  T = Utils.ce("div", {
                    style: `font-size:${e.styles.sectionTitleFontSize}px;line-height:1.3;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                    innerHTML: h.title,
                  }),
                  C = Utils.ce("div", {
                    style: `font-size:${e.styles.sectionDescriptionFontSize}px;line-height:1.3;color:${e.styles.sectionSecondaryTextColor}`,
                    innerHTML: h.description,
                  });
                x.append(T, C);
                let S = Utils.ce("div", {
                  class: "ewck-mm-bb-s-cw",
                  innerHTML:
                    "Collapsed" === mixMatchBundlePageSettings.collapsible
                      ? mixMatchBundlePageSettings.icons.collapsibleDownSVG
                      : mixMatchBundlePageSettings.icons.collapsibleUpSVG,
                });
                $.append(x, S);
                let _ = Utils.ce("div", {
                    id: `ewck-mm-bb-s-eb-${e.id}-${h.sectionId}`,
                    class: `ewck-mm-bb-s-eb ${
                      "Collapsed" === mixMatchBundlePageSettings.collapsible
                        ? ""
                        : "ewck-mm-bb-s-eb-open"
                    }`,
                  }),
                  I = Utils.ce("div", { class: "ewck-mm-bb-s-plw" }),
                  P = f.cloneNode();
                function q(t, i, a, r = !1) {
                  let l = Utils.ce("div", { class: "ewck-mm-bb-s-bs-pw" }),
                    c = Utils.ce("div", { class: "ewck-mm-bb-s-bs-pimg-w" }),
                    s = t.variants.find((e) => e.availableForSale),
                    d = s?.image?.ur || t.featuredImage,
                    p = Utils.ce("a", {
                      href: `/products/${t.handle}`,
                      target: "_blank",
                    }),
                    u = Utils.ce("img", {
                      src: d,
                      style:
                        "width:100%;height:100%;object-fit:contain;min-width:100%;border:none;",
                    }),
                    m = Utils.ce("div", { class: "ewck-mm-bb-s-piaw" }),
                    y = Utils.ce("div", {
                      class: "ewck-mm-bb-s-bs-piw",
                      style: "height:100%;align-items:center;",
                    }),
                    f = Utils.ce("a", {
                      href: `/products/${t.handle}`,
                      target: "_blank",
                      style: "text-decoration:none",
                    }),
                    g = Utils.ce("div", {
                      class: "ewck-mm-bb-s-bs-pt",
                      style: `font-size:${e.styles.productTitleFontSize}px;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight};text-align:center;`,
                      innerText: t.title,
                    }),
                    b = Utils.ce("div", {
                      class: "ewck-mm-bb-s-bs-vpw",
                      style: "align-items:center",
                    }),
                    w = Utils.ce("div", {
                      id: `ewck-mm-bb-s-bs-pp-${e.id}-${h.sectionId}-${t.id}`,
                      class: "ewck-mm-bb-s-bs-pp",
                      style: `color:${e.styles.sectionSecondaryTextColor};line-height:1.3;font-size:${e.styles.productPriceFontSize}px`,
                      innerHTML: Utils.cf(
                        100 * s.price.amount,
                        settings?.moneyFormat
                      ),
                    });
                  b.appendChild(w);
                  let k;
                  if (t.variants.length > 1) {
                    let v = Utils.ce("div", { style: "line-height:1" });
                    (k = Utils.ce("select", {
                      id: `ewck-mm-bb-s-bs-ap-${e.id}-${h.sectionId}-${t.id}`,
                      class: "ewck-mm-bb-s-bs-pvs",
                      style: `margin-left:-4px;border:none;outline:none;padding:0 4px 0 0;max-width:154px;cursor:pointer;font-size:${e.styles.productVariantTitleFontSize}px;background-color:transparent;font-family:inherit;color:${e.styles.sectionSecondaryTextColor}`,
                      onchange(i) {
                        let a = document.getElementById(
                            `ewck-mm-bb-s-bs-pp-${e.id}-${h.sectionId}-${t.id}`
                          ),
                          n = t.variants.find((e) => e.id === i.target.value);
                        a.innerHTML = Utils.cf(100 * n.price.amount);
                        let o = document.getElementById(
                          `ewck-mm-s-bs-pab-${e.id}-${h.sectionId}-${t.id}`
                        );
                        o.setAttribute("data-product-id", t.id),
                          o.setAttribute("data-variant-id", n.id);
                        let r = 0;
                        switch (
                          (Object.values(
                            EWCK.mmbInfo.addedProducts[e.id][h.sectionId]
                          ).forEach((e) => {
                            Object.values(e.variants).forEach((e) => {
                              r += e.quantity;
                            });
                          }),
                          h.requirementType)
                        ) {
                          case "Exact quantity":
                            if (r === +h.exactQuantity) return;
                            break;
                          case "Maximum quantity":
                          case "Range quantity":
                            if (r >= +h.maximumQuantity) return;
                        }
                        let l =
                          EWCK.mmbInfo.addedProducts[e.id]?.[h.sectionId]?.[
                            t.id
                          ]?.variants?.[n.id];
                        !l || l?.quantity < n.quantityAvailable
                          ? ((o.style.backgroundColor =
                              e.styles.sectionActionButtonColor),
                            (o.style.pointerEvents = "all"))
                          : (l?.quantity >= n.quantityAvailable &&
                              (o.style.backgroundColor = "#ccc"),
                            (o.style.pointerEvents = "none"));
                      },
                    })),
                      t.variants.forEach((t) => {
                        if (t.availableForSale) {
                          let i = Utils.ce("option", {
                            value: t.id,
                            style: `color:${e.styles.sectionPrimaryTextColor}`,
                            innerText: t.title,
                          });
                          k.appendChild(i);
                        }
                      }),
                      v.appendChild(k),
                      b.appendChild(v);
                  }
                  function $() {
                    let t = 0;
                    return (
                      EWCK.mmbInfo.addedProducts[e.id]?.[h.sectionId] &&
                        Object.values(
                          EWCK.mmbInfo.addedProducts[e.id][h.sectionId]
                        ).forEach((e) => {
                          Object.values(e.variants).forEach((e) => {
                            t += e.quantity;
                          });
                        }),
                      t
                    );
                  }
                  let x = $(!1),
                    T = !0;
                  switch (h.requirementType) {
                    case "Exact quantity":
                      x < +h.exactQuantity && (T = !1);
                      break;
                    case "Minimum quantity":
                    case "No requirement":
                      T = !1;
                      break;
                    case "Maximum quantity":
                    case "Range quantity":
                      x < +h.maximumQuantity && (T = !1);
                  }
                  let C = Utils.ce("div", {
                    id: `ewck-mm-s-bs-pab-${e.id}-${h.sectionId}-${t.id}`,
                    class: `ewck-mm-s-bs-pab ewck-mm-s-bs-pab-${e.id}-${h.sectionId}`,
                    style: `font-size:${
                      e.styles.productAddButtonFontSize
                    }px;background-color:${
                      e.styles.sectionActionButtonColor
                    };color:${e.styles.sectionActionButtonTextColor};${
                      T && r ? "background-color:#ccc;pointer-events:none" : ""
                    }`,
                    innerText: e.addButtonText,
                    onclick() {
                      if ("✓" === C.innerText) return;
                      (C.style.width = C.offsetWidth + "px"),
                        (C.style.height = C.offsetHeight + "px"),
                        (C.innerText = "✓"),
                        setTimeout(() => {
                          C.innerText = e.addButtonText;
                        }, 1e3);
                      let i;
                      (i =
                        t.variants.length > 1
                          ? t.variants.find((e) => e.id === k.value)
                          : s),
                        o.addProductToSection(e, h, t, i, n, "bundle-builder");
                    },
                  });
                  C.setAttribute("data-product-id", t.id),
                    C.setAttribute("data-variant-id", s.id),
                    f.appendChild(g),
                    y.append(f, b),
                    m.append(y, C),
                    p.appendChild(u),
                    c.appendChild(p),
                    l.append(c, m),
                    I.append(l),
                    i === a - 1 &&
                      Utils.onElementVisible(l, () => {
                        B();
                      });
                }
                for (let [E, L] of (_.append(P, I),
                EWCK.mmbInfo.productFetchDetails[e.id][
                  h.sectionId
                ].loadedProducts.entries()))
                  q(
                    L,
                    E,
                    EWCK.mmbInfo.productFetchDetails[e.id][h.sectionId]
                      .loadedProducts.length
                  );
                async function B() {
                  let a = Utils.createSpinner(_);
                  a.style = "position:static;transform:none;margin-block:10px;";
                  let n = EWCK.mmbInfo.productFetchDetails[e.id][h.sectionId];
                  if ("product" === n.resourceType) {
                    if (n.toBeLoadedProducts.length) {
                      let o = JSON.parse(JSON.stringify(n.toBeLoadedProducts)),
                        r = [];
                      for (; r.length < t; ) {
                        let c = t - r.length;
                        if (
                          ((r = r.concat(
                            await Apis.getProductsFromStorefrontApi(
                              o.splice(0, c).map((e) => e.id)
                            )
                          )),
                          0 === o.length)
                        )
                          break;
                      }
                      let s =
                        EWCK.mmbInfo.productFetchDetails[e.id][h.sectionId]
                          .loadedProducts;
                      for (let [d, p] of ((s = s.concat(r)),
                      (EWCK.mmbInfo.productFetchDetails[e.id][
                        h.sectionId
                      ].loadedProducts = s),
                      (EWCK.mmbInfo.productFetchDetails[e.id][
                        h.sectionId
                      ].toBeLoadedProducts = o),
                      a.remove(),
                      r.entries()))
                        q(p, d, r.length, !0);
                    } else a.remove();
                  } else if (
                    n.toBeLoadedCollections.length ||
                    (n.hasNextPage && n.cursor)
                  ) {
                    let u = JSON.parse(JSON.stringify(n.toBeLoadedCollections)),
                      m = {
                        products: [],
                        hasNextPage: n.hasNextPage,
                        cursor: n.hasNextPage ? n.cursor : null,
                        currentlyLoadedCollectionId:
                          n.currentlyLoadedCollectionId,
                      },
                      y = t;
                    for (; m.products.length < t; ) {
                      n.hasNextPage ||
                        (m.currentlyLoadedCollectionId = u.splice(0, 1)[0]);
                      let f = await Apis.getCollectionproductsFromStorefrontApi(
                        m.currentlyLoadedCollectionId,
                        y,
                        m.cursor,
                        m.hasNextPage
                      );
                      if (
                        ((m.products = m.products.concat(f.products)),
                        (m.hasNextPage = f.hasNextPage),
                        (m.cursor = f.hasNextPage ? f.cursor : null),
                        (y -= m.products.length),
                        0 === u.length && !f.hasNextPage)
                      )
                        break;
                    }
                    let g =
                      EWCK.mmbInfo.productFetchDetails[e.id][h.sectionId]
                        .loadedProducts;
                    for (let [b, w] of ((g = g.concat(m.products)),
                    (EWCK.mmbInfo.productFetchDetails[e.id][
                      h.sectionId
                    ].loadedProducts = g),
                    (EWCK.mmbInfo.productFetchDetails[e.id][
                      h.sectionId
                    ].currentlyLoadedCollectionId =
                      m.currentlyLoadedCollectionId),
                    (EWCK.mmbInfo.productFetchDetails[e.id][
                      h.sectionId
                    ].cursor = m.cursor),
                    (EWCK.mmbInfo.productFetchDetails[e.id][
                      h.sectionId
                    ].hasNextPage = m.hasNextPage),
                    (EWCK.mmbInfo.productFetchDetails[e.id][
                      h.sectionId
                    ].toBeLoadedCollections = u),
                    a.remove(),
                    m.products.entries()))
                      q(w, b, m.products.length, !0);
                  } else a.remove();
                  l(i.offsetWidth);
                }
                k.appendChild(v),
                  w.append(k, $),
                  b.append(w, _),
                  y.appendChild(b),
                  m.appendChild(y);
              }
              let F = Utils.ce("div", { class: "ewck-mm-bb-fdw" });
              if ("No discount" !== e.discountType) {
                let A =
                    "Percentage" === e.discountType
                      ? e.discountPercentage + "%"
                      : "Amount off each" === e.discountType ||
                        "Fixed amount" === e.discountType
                      ? Utils.cf(
                          e.discountAmount * n * 100,
                          settings?.moneyFormat
                        )
                      : "Bundle price" === e.discountType
                      ? Utils.cf(e.bundlePrice * n * 100, settings?.moneyFormat)
                      : "Tiered percentage" === e.discountType
                      ? e.discountTiers[e.discountTiers.length - 1].discount +
                        "%"
                      : Utils.cf(
                          e.discountTiers[e.discountTiers.length - 1].discount *
                            n *
                            100,
                          settings?.moneyFormat
                        ),
                  M = Utils.ce("div", {
                    id: `ewck-mm-dt-${e.id}`,
                    class: "ewck-mm-bb-dt",
                    innerHTML:
                      "<span class='ewck-mm-bb-dr'>" +
                      e.discountSaveText.replace("{{discount}}", A) +
                      "</span>",
                  });
                F.appendChild(M);
              }
              let D = Utils.ce("div", { class: "ewck-mm-bb-apb" }),
                H = Utils.ce("div", {
                  class: "ewck-mm-bb-apbt",
                  style: `color:${e.styles.sectionPrimaryTextColor}`,
                  innerText: mixMatchBundlePageSettings.addedItemsText,
                }),
                z = Utils.ce("div", { class: "ewck-mm-bb-apb-sl" });
              for (let [W, N] of e.sections.entries()) {
                let O = Utils.ce("div", { class: "ewck-mm-bb-apsw" }),
                  V = Utils.ce("div", { class: "ewck-mm-bb-aps-tc" }),
                  R = Utils.ce("div", { class: "ewck-mm-bb-aps-tbw" }),
                  j = Utils.ce("div", {
                    style: `font-size:${e.styles.sectionTitleFontSize}px;line-height:1.3;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                    innerHTML: N.title,
                  }),
                  G = Utils.ce("div", { class: "ewck-mm-bb-s-h-ab" }),
                  Q = Utils.ce("span", {
                    id: `ewck-mm-s-hs-abt-${e.id}-${N.sectionId}`,
                    style: `margin-left:3px;color:${e.styles.sectionPrimaryTextColor};font-size:${e.styles.addedBadgeFontSize}px;line-height:1;padding:5px;`,
                    innerHTML: e.addedBadgeText.replace("{{quantity}}", "0"),
                  }),
                  U = Utils.ce("div", {
                    id: `ewck-mm-bb-fd-${e.id}-${N.sectionId}`,
                    class: "ewck-mm-bb-s-cw",
                    innerHTML:
                      mixMatchBundlePageSettings.icons.collapsibleUpSVG,
                    onclick() {
                      Y.classList.contains("ewck-mm-bb-s-eb-open")
                        ? (Y.classList.remove("ewck-mm-bb-s-eb-open"),
                          (U.innerHTML =
                            mixMatchBundlePageSettings.icons.collapsibleDownSVG))
                        : (Y.classList.add("ewck-mm-bb-s-eb-open"),
                          (U.innerHTML =
                            mixMatchBundlePageSettings.icons.collapsibleUpSVG));
                    },
                  }),
                  Y = Utils.ce("div", {
                    class: "ewck-mm-bb-aps-bc ewck-mm-bb-s-eb-open",
                  }),
                  X = Utils.ce("div", {
                    id: `ewck-mm-bb-aps-elt-${e.id}-${N.sectionId}`,
                    class: "ewck-mm-bb-aps-elt",
                    style: `color:${e.styles.sectionSecondaryTextColor}`,
                    innerText: mixMatchBundlePageSettings.emptyAddedText,
                  }),
                  J = Utils.ce("div", {
                    id: `ewck-mm-bb-s-h-apw-${e.id}-${N.sectionId}`,
                    class: "ewck-mm-bb-s-h-apw",
                    style: "padding-left:24px;margin-top:12px;",
                  });
                if (
                  (G.appendChild(Q),
                  R.append(j, G),
                  V.append(R, U),
                  Y.append(X, J),
                  O.append(V, Y),
                  z.appendChild(O),
                  W < e.sections.length - 1)
                ) {
                  let K = f.cloneNode();
                  (K.style.marginBlock = "0"), z.appendChild(K);
                }
              }
              D.append(H, z);
              let Z = Utils.ce("div", { class: "ewck-mm-bb-pab" }),
                ee = Utils.ce("div", {
                  id: `ewck-mm-tpw-${e.id}`,
                  class: "ewck-mm-tpw",
                  style: `margin-top:${e.styles.gapBetweenElements}px`,
                }),
                et = Utils.ce("div", {
                  class: "ewck-mm-tpt",
                  style: `font-size:${e.styles.priceTextFontSize}px;color:#121212;font-weight:${e.styles.primaryFontWeight};line-height:1`,
                  innerHTML: e.totalPriceText,
                }),
                ei = Utils.ce("div", { class: "ewck-mm-tpaw" }),
                ea = Utils.ce("div", {
                  id: `ewck-mm-se-${e.id}`,
                  class: "ewck-mm-se",
                  style: `display:none;font-size:${e.styles.priceTextFontSize}px;`,
                }),
                en = Utils.ce("div", {
                  id: `ewck-mm-fpe-${e.id}`,
                  class: "ewck-mm-fpe",
                  style: `font-size:${e.styles.priceTextFontSize}px;color:#121212;font-weight:500;`,
                  innerHTML: Utils.cf(0, settings?.moneyFormat),
                }),
                eo = Utils.ce("div", {
                  class: "ewck-mm-tdiw",
                  style: `margin-top:${e.styles.gapBetweenElements}px;`,
                });
              if (
                "Tiered percentage" === e.discountType ||
                "Tiered amount off each" === e.discountType ||
                "Tiered fixed amount" === e.discountType
              ) {
                let er = Utils.ce("div", {
                  id: `ewck-mm-tdpt-${e.id}`,
                  class: "ewck-mm-tdpt",
                  style: `background-color:#ddca3e;font-weight:${e.styles.primaryFontWeight};`,
                  innerHTML: e.tieredInitialText
                    .replaceAll("{{quantity}}", e.discountTiers[0].quantity)
                    .replaceAll(
                      "{{discount}}",
                      "Tiered percentage" === e.discountType
                        ? e.discountTiers[0].discount + "%"
                        : Utils.cf(
                            n * e.discountTiers[0].discount * 100,
                            settings?.moneyFormat
                          )
                    ),
                });
                eo.appendChild(er);
              } else eo.style.display = "none";
              let el = Utils.ce("div", {
                  id: `ewck-mm-atc-w-${e.id}`,
                  class: "ewck-mm-atc-w",
                  style: `margin-top:${e.styles.gapBetweenElements}px`,
                }),
                ec = Utils.ce("div", {
                  id: `ewck-mm-atc-btn-${e.id}`,
                  class: "ewck-mm-atc-btn",
                  style: `font-size:${e.styles.atcButtonFontSize}px;position:relative;background-color:#ccc;color:${e.styles.mainActionButtonTextColor};font-weight:${e.styles.primaryFontWeight};cursor:not-allowed;`,
                  async onclick() {
                    if ("transparent" === ec.style.color) return;
                    let t = EWCK.mmbInfo.eligibleBundle[e.id];
                    if (t) {
                      ec.style.color = "transparent";
                      let i = Utils.createSpinner(ec);
                      i.firstChild.style =
                        "border-right:2px solid #ffffff;border-bottom:2px solid #ffffff;";
                      let a = !0;
                      "No discount" !== e.discountType &&
                        (a = !!(
                          await Apis.createDiscount("mmb_discount_create", {
                            campaignId: e.id,
                            addedProducts: t.addedProducts,
                          })
                        )?.success),
                        a
                          ? Utils.atc(
                              t.items.map((i) => ({
                                ...i,
                                properties: {
                                  _upsell_kit_mmb: e.id + "-" + t.items.length,
                                },
                              })),
                              "mix_match_bundle",
                              e.id,
                              e.name
                            )
                          : console.error("Something went wrong"),
                        setTimeout(() => {
                          i &&
                            (i.remove(),
                            (ec.style.color =
                              e.styles.mainActionButtonTextColor));
                        }, 2e3);
                    }
                  },
                }),
                es = Utils.ce("span", { innerHTML: e.mainActionButtonText });
              if (
                (ec.appendChild(es),
                el.appendChild(ec),
                ei.append(ea, en),
                ee.append(et, ei),
                Z.appendChild(ee),
                ("Tiered percentage" === e.discountType ||
                  "Tiered amount off each" === e.discountType ||
                  "Tiered fixed amount" === e.discountType) &&
                  Z.appendChild(eo),
                Z.appendChild(el),
                F.append(D, Z),
                m.appendChild(F),
                s.append(u, m),
                e?.bottomContent?.trim())
              ) {
                let ed = Utils.ce("div", {
                  class: "ewck-mm-bb-pbc sun-editor-editable",
                  style:
                    "width:100%;padding:0;background-color:transparent;margin-block:34px;",
                  innerHTML: e.bottomContent,
                });
                s.appendChild(ed), Utils.loadRTEStyle();
              }
              c.appendChild(s),
                "bundle-builder-featured" === a
                  ? ((c.style = "max-width:1200px;margin-inline:auto;"),
                    i.parentElement.insertBefore(c, i))
                  : ((i.innerHTML = ""), i.appendChild(c)),
                l(i.offsetWidth),
                window.history.replaceState({}, "", window.location.href);
            },
            handleInitialProductsFetch(e, t, i) {
              for (let a of e.sections)
                o.initialFetchProgress[e.id]
                  ? (o.initialFetchProgress[e.id] = {
                      ...o.initialFetchProgress[e.id],
                      [a.sectionId]: !0,
                    })
                  : (o.initialFetchProgress[e.id] = { [a.sectionId]: !0 }),
                  "product" === a.resourceType
                    ? o.handleProductFetch(e, a, t, i)
                    : o.handleCollectionProductFetch(e, a, t, i);
            },
            async createAllBundlesMarkup(e, t) {
              document.querySelector(".ewck-mm-bp-c")?.remove(),
                (t.innerHTML = "");
              let i = Utils.ce("div", { class: "ewck-mm-bp-c" });
              Utils.addCustomCSS(i, settings?.css || "");
              let a = Utils.ce("div", { class: "ewck-mm-bp-mw" });
              if (mixMatchBundlePageSettings.pageTitle.trim()) {
                let n = Utils.ce("div", {
                  class: "ewck-mm-bp-pt",
                  innerHTML: mixMatchBundlePageSettings.pageTitle,
                });
                (document.title = mixMatchBundlePageSettings.pageTitle),
                  a.append(n);
              }
              if (mixMatchBundlePageSettings.richText.trim()) {
                let r = Utils.ce("div", {
                  class: "ewck-mm-bp-pc sun-editor-editable",
                  innerHTML: mixMatchBundlePageSettings.richText,
                  style: "width:100%;padding:0;background-color:transparent;",
                });
                Utils.loadRTEStyle(), a.appendChild(r);
              }
              let l = Utils.ce("div", {
                  style: "width:100%;height:100px;position:relative;",
                }),
                c = Utils.createSpinner(l);
              if (
                ((c.firstChild.style = "width:30px;height:30px;"),
                a.appendChild(l),
                i.appendChild(a),
                t.appendChild(i),
                e && e?.length > 0)
              ) {
                let s = await Apis.getTools("mix_match_bundle", e);
                if (s?.length) {
                  s.sort((t, i) => e.indexOf(t.id) - e.indexOf(i.id));
                  let d = o.createOverlay(),
                    p = Utils.ce("div", { class: "ewck-mm-bp-w" });
                  for (let u of s)
                    if (u.separateBundlePage) {
                      let m = await o.createTypeBasedBundleWidget(
                        u,
                        "bundle-page",
                        d
                      );
                      p.appendChild(m);
                    }
                  i.appendChild(p);
                }
              }
              l.remove();
            },
            createOverlay() {
              let e = Utils.ce("div", {
                  class: "ewck-mm-bb-overlay",
                  style: "display:none",
                  onclick() {
                    e.style.display = "none";
                    let i = t.getAttribute("campaign-id"),
                      a = t.getAttribute("color");
                    t.innerHTML = "";
                    let n = document.getElementById(`ewck-mm-bp-ab-${i}`);
                    (n.style.color = a), delete EWCK.mmbInfo.addedProducts[i];
                  },
                }),
                t = Utils.ce("div", {
                  class: "ewck-mm-bb-overlay-body",
                  onclick(e) {
                    e.stopPropagation();
                  },
                });
              return e.appendChild(t), { overlay: e, overlayBody: t };
            },
            async createTypeBasedBundleWidget(e, t, i) {
              let a = Utils.ce("div", {
                  class: "ewck-mm-bp-wb",
                  style: `background:${e.styles.widgetBackgroundColor};padding:${e.styles.widgetPadding}px;font-family:${e.styles.fontFamily};margin-bottom:${e.styles.gapBetweenElements}px`,
                }),
                r = Utils.ce("div", {
                  class: "ewck-mm-bp-tdt",
                  style: `margin: 0 0 ${+e.styles
                    .widgetTitleMarginBottom}px 0;`,
                }),
                l = Utils.ce("div", {
                  class: "ewck-mm-wt",
                  style: `font-family:inherit;font-size:${e.styles.widgetTitleFontSize}px;font-weight:${e.styles.primaryFontWeight};color:${e.styles.widgetTitleColor};line-height:1.3`,
                  innerHTML: e.widgetTitle,
                });
              if ((r.append(l), "No discount" !== e.discountType)) {
                let c =
                    "Percentage" === e.discountType
                      ? e.discountPercentage + "%"
                      : "Amount off each" === e.discountType ||
                        "Fixed amount" === e.discountType
                      ? Utils.cf(
                          e.discountAmount * n * 100,
                          settings?.moneyFormat
                        )
                      : "Bundle price" === e.discountType
                      ? Utils.cf(e.bundlePrice * n * 100, settings?.moneyFormat)
                      : "Tiered percentage" === e.discountType
                      ? e.discountTiers[e.discountTiers.length - 1].discount +
                        "%"
                      : Utils.cf(
                          e.discountTiers[e.discountTiers.length - 1].discount *
                            n *
                            100,
                          settings?.moneyFormat
                        ),
                  s = Utils.ce("div", {
                    class: "ewck-mm-bp-dt",
                    innerHTML:
                      "<span class='ewck-mm-bp-dr'>" +
                      e.discountSaveText.replace("{{discount}}", c) +
                      "</span>",
                  });
                r.appendChild(s);
              }
              let d = Utils.ce("div", { class: "ewck-mm-bp-sb" });
              for (let [p, u] of e.sections.entries()) {
                let m = Utils.ce("div", {
                    class: "ewck-mm-bp-sw",
                    style: "padding:12px;background-color:#fff",
                  }),
                  y = Utils.ce("div", {
                    class: "ewck-mm-bp-tdw",
                    style: `${
                      "" === u.title.trim() && "" === u.description.trim()
                        ? "display:none;"
                        : ""
                    }gap:${
                      u.title.trim() && u.description.trim() ? "4px" : "0"
                    }`,
                  }),
                  f = Utils.ce("div", {
                    style: `font-size:${e.styles.sectionTitleFontSize}px;line-height:1.3;color:${e.styles.sectionPrimaryTextColor};font-weight:${e.styles.secondaryFontWeight}`,
                    innerHTML: u.title,
                  }),
                  g = Utils.ce("div", {
                    style: `font-size:${e.styles.sectionDescriptionFontSize}px;line-height:1.3;color:${e.styles.sectionSecondaryTextColor}`,
                    innerHTML: u.description,
                  }),
                  h = Utils.ce("div", { class: "ewck-mm-bp-prw" }),
                  b,
                  w,
                  k;
                async function v() {
                  let e = [];
                  if ("product" === u.resourceType) {
                    let t = JSON.parse(JSON.stringify(u.selectedProducts));
                    e = await Apis.getProductsFromStorefrontApi(
                      t.splice(0, 3).map((e) => e.id)
                    );
                  } else {
                    let i = 0;
                    for (; e.length < 3 && i < u.selectedCollections.length; ) {
                      let a = await Apis.getCollectionproductsFromStorefrontApi(
                        u.selectedCollections[i],
                        3 - e.length,
                        null,
                        !0
                      );
                      a.products.length && (e = e.concat(a.products)), (i += 1);
                    }
                  }
                  0 === e.length || 1 === e.length
                    ? (w.remove(), k.remove())
                    : 2 === e.length && k.remove(),
                    e.forEach((e, t) => {
                      0 === t
                        ? (b.style.backgroundImage = `url(${e.featuredImage})`)
                        : 1 === t
                        ? (w.style.backgroundImage = `url(${e.featuredImage})`)
                        : (k.style.backgroundImage = `url(${e.featuredImage})`);
                    });
                }
                if (
                  (Array.from({ length: 3 }, (e, t) => {
                    let i = Utils.ce("div", {
                      class: "ewck-mm-bp-pimg",
                      style: `display:block;${
                        t > 0 ? "margin-left:-10px;" : ""
                      }background-image:`,
                    });
                    0 === t ? (b = i) : 1 === t ? (w = i) : (k = i),
                      h.appendChild(i);
                  }),
                  v(),
                  y.append(f, g),
                  m.append(y, h),
                  d.appendChild(m),
                  p < e.sections.length - 1)
                ) {
                  let $ = Utils.ce("div", {
                    class: "ewck-mm-divider",
                    style: "display:block;border-top:1px solid #ebebeb",
                  });
                  d.appendChild($);
                }
              }
              let x = Utils.ce("div", {
                id: `ewck-mm-bp-ab-${e.id}`,
                class: "ewck-mm-bp-ab",
                style: `position:relative;margin-top:${e.styles.gapBetweenElements}px;background-color:${e.styles.mainActionButtonColor};color:${e.styles.mainActionButtonTextColor};`,
              });
              return (
                "bundle-page" === t &&
                "page" === mixMatchBundlePageSettings.actionType
                  ? ((x.innerHTML =
                      mixMatchBundlePageSettings.pageActionButtonText),
                    (x.onclick = () => {
                      let t = Utils.createSpinner(x);
                      (t.firstChild.style =
                        "border-right:2px solid #ffffff;border-bottom:2px solid #ffffff;"),
                        window.history.pushState(
                          { bundlesPageRedirected: !0 },
                          "",
                          location.pathname + "/" + e.id
                        ),
                        (x.style.color = "transparent"),
                        EWCK.handleMixMatchBundle();
                    }))
                  : ((x.innerHTML =
                      mixMatchBundlePageSettings.popupActionButtonText),
                    document.body.insertBefore(
                      i.overlay,
                      document.body.firstChild
                    ),
                    (x.onclick = () => {
                      let t = Utils.createSpinner(x);
                      (t.firstChild.style =
                        "border-right:2px solid #ffffff;border-bottom:2px solid #ffffff;"),
                        (x.style.color = "transparent"),
                        o.handleInitialProductsFetch(
                          e,
                          "bundle-builder-overlay",
                          { ...i, spinner: t }
                        );
                    })),
                a.append(r, d, x),
                a
              );
            },
            handleTranslations(e) {
              let t = e,
                i = t?.translations && t.translations[Shopify.locale];
              if (i)
                for (let a in i)
                  if ("sections" === a)
                    for (let [n, o] of i[a].entries())
                      (t.sections[n].title = o.title),
                        (t.sections[n].description = o.description);
                  else t[a] = i[a];
            },
          };
        if (!e && currentPage?.id) {
          if (
            currentPage?.id &&
            settings?.mixMatchBundlePageId &&
            settings.mixMatchBundlePageId.includes(currentPage.id)
          ) {
            async function r() {
              let e = location.pathname
                .replace(Shopify.routes.root, "/")
                .split("/")
                .filter(Boolean);
              if (e.length >= 2 && e.length <= 3 && "pages" === e[0]) {
                let t = document.getElementById("ewck-mm-bp");
                if (!t) return;
                if (
                  (Utils.addCustomCSS(t, settings?.css || ""), 3 === e.length)
                ) {
                  let i;
                  history.state?.bundlesPageRedirected ||
                    ((i = Utils.createSpinner(t)).firstChild.style =
                      "width:30px;height:30px;"),
                    (t.style.minHeight = "400px");
                  let a = e[2],
                    n = await Apis.getTools("mix_match_bundle", [a]);
                  if (n[0] && n[0].separateBundlePage)
                    o.handleInitialProductsFetch(n[0], "bundle-builder", t);
                  else {
                    i?.remove();
                    let r = Utils.ce("div", {
                      class: "ewck-mm-bp-et",
                      innerHTML: mixMatchBundlePageSettings.notFound,
                    });
                    t.appendChild(r),
                      (t.style =
                        "display:flex;justify-content:center;align-items:center;");
                  }
                } else if (2 === e.length) {
                  let l = currentPage?.metafield
                    ? JSON.parse(currentPage.metafield)
                    : null;
                  o.createAllBundlesMarkup(l, t);
                }
              }
            }
            window.addEventListener("popstate", () => {
              r();
            }),
              r();
          }
        } else if (
          settings?.featuredMixMatchBundleId &&
          !location.pathname.includes("/products/") &&
          settings?.featuredMixMatchBundleType === "bundle-builder"
        ) {
          let l = document.querySelector(".rich-text__wrapper"),
            c = await Apis.getTools("mix_match_bundle", [
              settings.featuredMixMatchBundleId,
            ]);
          c[0].separateBundlePage &&
            o.handleInitialProductsFetch(c[0], "bundle-builder-featured", l);
        } else {
          let s = await Apis.getTools("mix_match_bundle", [
            settings?.featuredMixMatchBundleId &&
            !location.pathname.includes("/products/")
              ? settings.featuredMixMatchBundleId
              : e,
          ]);
          if (!s) return;
          for (let d of s)
            if (d.showOnProductPage && currentProduct) {
              let p = !1;
              if ("bundle" === d.resourceType) {
                for (sec of d.sections)
                  if ("product" === sec.resourceType) {
                    for (let u of sec.selectedProducts)
                      if (u.variants.includes(selectedVariant.id.toString())) {
                        p = !0;
                        break;
                      }
                  } else if ("collection" === sec.resourceType)
                    for (let m of sec.selectedCollections)
                      currentProductCollections.forEach((e) => {
                        m === e.id.toString() && (p = !0);
                      });
              } else if ("all" === d.resourceType) p = !0;
              else if ("product" === d.resourceType) {
                for (let y of d.selectionIds)
                  if (y.variants.includes(selectedVariant.id.toString())) {
                    p = !0;
                    break;
                  }
              } else if ("collection" === d.resourceType)
                for (let f of d.selectionIds)
                  currentProductCollections.forEach((e) => {
                    f === e.id.toString() && (p = !0);
                  });
              if (!p) {
                document.getElementById(`ewck-mm-c-${d.id}`)?.remove();
                continue;
              }
              o.handleInitialProductsFetch(d, null, null);
            }
        }
      },
    },
    Loaders = {
      async pre() {
        if (tools.shipping_protection) {
          for (let e of CKCart.items)
            if (e.properties._ewckShippingProtection) {
              if ("false" === settings.shippingProtectionRemove) return;
              (await Utils.removeCartItem([e.variant_id])) && location.reload();
            }
        }
      },
      sttLoader(e, t) {
        let i = () => {
          let i = document.querySelector(".ewck-s-atc-c"),
            a = document.querySelectorAll("[class*='ewck-ab-c-main']");
          if (window.scrollY >= 200) {
            if (((t.style.bottom = "0"), a.length)) {
              let n = !1;
              a.forEach((e) => {
                if ("0px" === e.style.bottom) {
                  n = e;
                  return;
                }
              }),
                n && (t.style.bottom = n.offsetHeight + "px");
            }
            if (
              i &&
              ("block" === i.style.display ||
                tools?.sticky_add_to_cart?.condition === "1")
            ) {
              let o = document.querySelector(".ewck-s-atc-w");
              t.style.bottom = o.offsetHeight + "px";
            }
            e.style.display = "block";
          } else e.style.display = "none";
        };
        i(),
          window.addEventListener("scroll", () => {
            i();
          });
      },
      async cartInitials(e = !1) {
        let t = window?.Shopify?.routes?.root || "/",
          i = await (
            await fetch(
              "/" === t
                ? "/cart.js"
                : t + ("/" === t.charAt(t.length - 1) ? "cart.js" : "/cart.js")
            )
          ).json(),
          a = i.items;
        if (e) return i;
        let n = EWCK.cartItemsElms;
        return (
          (null !== n &&
            document.body.contains(n[0]) &&
            document.body.contains(n[n.length - 1])) ||
            ((n = [
              ...document.querySelectorAll(
                settings?.cartItemSelector !== "" &&
                  settings?.cartItemSelector !== void 0
                  ? settings.cartItemSelector
                  : ".cart-item__details,.cart__item-title"
              ),
            ]),
            (EWCK.cartItemsElms = n)),
          n.length > a.length && (n = n.slice(a.length, n.length)),
          [a, n]
        );
      },
      async bogoCartLoader(e) {
        let [t, i] = await Loaders.cartInitials();
        if (!t || 0 === i.length) {
          await new Promise((e) => setTimeout(e, 2e3));
          let [a, n] = await Loaders.cartInitials();
          if (!a || 0 === n.length) return;
          (t = a), (i = n);
        }
        let o = settings?.bogoCartLoaderDelay || settings?.cartDrawerDelay;
        o && (await new Promise((e) => setTimeout(e, +o))),
          e?.translations &&
            e.translations[Shopify.locale] &&
            ((e.bogoCartText = e.translations[Shopify.locale].bogoCartText),
            (e.atcText = e.translations[Shopify.locale].atcText));
        let r = {},
          l = 0,
          c = [],
          s = 0;
        if (e.buySelectionProductIds.length > 0) {
          for (let d of e.buySelectionProductIds)
            for (let [p, u] of t.entries())
              if (+d.id === u.product_id)
                for (let m of ((r[p] = u),
                (l += u.quantity),
                e.getSelectionProductIds)) {
                  let y = t.find((e) => e.product_id === +m.id);
                  y &&
                    (c.some((e) => e.id === y.id) ||
                      ((s += y.quantity), c.push(y)));
                }
        } else
          t.forEach((e, t) => {
            (r[t] = e), (l += e.quantity);
          });
        for (let f in r)
          r[f].discounts.some((t) => t.title === e.cartDiscountLabel) &&
            (l -= r[f].quantity);
        if (
          (l >= e.buyQuantity && l % e.getQuantity == 0) ||
          (l >= e.buyQuantity && 0 === s) ||
          (settings?.alwaysShowBOGOCartWidget === "true" && l > 0)
        ) {
          let g = await Apis.getProduct(
            e.getSelectionProductIds[
              Math.floor(Math.random() * e.getSelectionProductIds.length)
            ].handle
          );
          for (let h in r)
            if (!r[h].discounts.some((t) => t.title === e.cartDiscountLabel)) {
              let b = EWCK.handleBOGOCart(e, r[h].id, g);
              i[h].appendChild(b);
            }
        }
      },
      async bogoHCLoader(e) {
        let t = [];
        EWCK.bogoHCSI[e.id] && clearInterval(EWCK.bogoHCSI[e.id]),
          e?.translations &&
            e.translations[Shopify.locale] &&
            (e.bogoHCText = e.translations[Shopify.locale].bogoHCText),
          (EWCK.bogoHCSI[e.id] = setInterval(
            () => {
              if (
                (t = [
                  ...document.querySelectorAll(
                    settings?.productCardSelector !== "" &&
                      settings?.productCardSelector !== void 0
                      ? settings.productCardSelector
                      : Utils.productCardSelectors
                  ),
                ]).length
              )
                for (let i of t) {
                  if (i.querySelector(".ewck-bogo-hc-c")) continue;
                  let a = i.querySelector("a[href*='/products/']");
                  if (a) {
                    let n = a.href
                        .split("/products/")[1]
                        .split("?")[0]
                        .replace("products/", ""),
                      o = !1;
                    if (
                      (o =
                        "all" === e.buyResourceType ||
                        e.buySelectionProductIds.some((e) => e.handle === n))
                    ) {
                      let r = Utils.ce("div", { class: "ewck-bogo-hc-c" });
                      Utils.addCustomCSS(r, e.css),
                        Utils.addCustomCSS(r, settings?.css || "");
                      let l = Utils.ce("div", { class: "ewck-bogo-hc-w" }),
                        c = Utils.ce("span", {
                          class: "ewck-bogo-hc-p-t",
                          style: `background:${e.badgeBackgroundColor};color:${e.badgeTextColor}`,
                          innerText: e.bogoHCText,
                        });
                      l.appendChild(c),
                        r.appendChild(l),
                        (i.style.position = "relative"),
                        i.appendChild(r);
                    }
                  }
                }
              t.length > 0 &&
                (!settings?.lazyLoadProductCarts ||
                  settings?.lazyLoadProductCarts === "false") &&
                clearInterval(EWCK.bogoHCSI[e.id]);
            },
            settings?.lazyLoadProductCarts === "true" ? 1e3 : 500
          ));
      },
      async vdCartLoader(e) {
        settings?.cartDrawerDelay &&
          (await new Promise((e) => setTimeout(e, +settings.cartDrawerDelay)));
        let [t, i] = await Loaders.cartInitials();
        if (!t || 0 === i.length) {
          await new Promise((e) => setTimeout(e, 2e3));
          let [a, n] = await Loaders.cartInitials();
          if (!a || 0 === n.length) return;
          (t = a), (i = n);
        }
        e?.translations &&
          e.translations[Shopify.locale] &&
          (e.cartText = e.translations[Shopify.locale].cartText);
        let o = {},
          r = 0;
        for (let l in (t.forEach((t, i) => {
          let a = !1;
          "all" !== e.buyResourceType
            ? e.buySelectionProductIds.find(
                (e) => e.id === t.product_id.toString()
              ) &&
              ((e?.excludedProducts &&
                e.excludedProducts.includes(t.product_id.toString())) ||
                (a = !0))
            : (e?.excludedProducts &&
                e.excludedProducts.includes(t.product_id.toString())) ||
              (a = !0),
            a &&
              ((r += t.quantity),
              o[t.product_id]
                ? (o[t.product_id] = {
                    quantity: o[t.product_id].quantity + t.quantity,
                    lineIndexes: [...o[t.product_id].lineIndexes, i],
                  })
                : (o[t.product_id] = {
                    quantity: t.quantity,
                    lineIndexes: [i],
                  }));
        }),
        o)) {
          e?.mergeQuantity === !0 && (o[l].quantity = r);
          let c;
          for (let s of e.discountTiers)
            if (o[l].quantity < +s.quantity) {
              (c = s), (o[l].eligibleTier = s);
              break;
            }
          c || delete o[l];
        }
        if (Object.keys(o).length)
          for (let d in o)
            o[d].lineIndexes.forEach((t) => {
              document.querySelector(`.ewck-vd-cart-c-${t}`)?.remove();
              let a = Utils.ce("div", {
                  class: `ewck-vd-cart-c ewck-vd-cart-c-${t}`,
                }),
                n = Utils.ce("div", {
                  class: "ewck-vd-cart-w",
                  style: `background-color:${e.cartPageWidgetBackgroundColor};color:${e.cartPageWidgetTextColor}`,
                }),
                r = Utils.ce("div", {
                  style: "font-size:12px",
                  innerHTML: `<span>${e.cartText
                    .replace(
                      "{{quantity}}",
                      `<span style='font-weight:bold'>${
                        o[d].eligibleTier.quantity - o[d].quantity
                      }</span>`
                    )
                    .replace(
                      "{{discountValue}}",
                      `<span style='font-weight:bold'>${
                        "Percentage" === e.discountType
                          ? o[d].eligibleTier.discountValue + "%"
                          : Utils.cf(
                              100 * o[d].eligibleTier.discountValue,
                              settings?.moneyFormat
                            )
                      }</span>`
                    )}</span>`,
                });
              n.appendChild(r), a.appendChild(n), i[t].appendChild(a);
            });
      },
      async paoLoader(e, t, i, a, n) {
        let o = "" !== window.name ? JSON.parse(window.name) : null;
        if (EWCK.checkoutBtnsLis.length > 0 && !n && !t) return;
        if (0 === EWCK.checkoutBtnsLis.length || n) {
          let r = document.querySelectorAll(
            settings?.checkoutSelector || "#checkout, [name='checkout']"
          );
          !r.length ||
            t ||
            i ||
            a ||
            ((EWCK.checkoutBtns = r),
            EWCK.checkoutBtnsLis?.[0] &&
              r.forEach((e, t) => {
                e.removeEventListener("click", EWCK.checkoutBtnsLis[t], !0);
              }),
            r.forEach((t, i) => {
              settings?.removeTypeFromCheckoutButton === "true" &&
                t.removeAttribute("type"),
                t.addEventListener(
                  "click",
                  (EWCK.checkoutBtnsLis[i] = (a) => {
                    a.preventDefault(),
                      a.stopPropagation(),
                      Loaders.paoLoader(e, !0, t, i);
                  }),
                  !0
                );
              let a = new MutationObserver((i) => {
                  i.forEach((i) => {
                    i.removedNodes.forEach((i) => {
                      i.contains(t) &&
                        (a.disconnect(),
                        Loaders.paoLoader(e, !1, null, null, !0));
                    });
                  });
                }),
                n = document.body;
              a.observe(n, { childList: !0, subtree: !0 });
            }));
        }
        let l;
        (l =
          null === EWCK.cart ? window.CKCart : await Loaders.cartInitials(!0)),
          (EWCK.cart = l);
        let c = {},
          s = [];
        for (let d in (l.items.forEach((t, i) => {
          t.discounts.length &&
            t.discounts.forEach((a) => {
              let n = e.find(
                (e) =>
                  !!e.discounts[a.title] && ((o = e.discounts[a.title]), !0)
              );
              !n &&
                o &&
                o?.discountCode === a.title &&
                (n = e.find((e) => e.id === o?.offerId)),
                n &&
                  (s.push(i),
                  c[o.discountId]
                    ? c[o.discountId].items.push(t)
                    : (c[o.discountId] = {
                        items: [t],
                        mainProductId: o.mainProductId,
                        mainProductQuantity: o.mainProductQuantity,
                      }));
            });
        }),
        l.items.forEach((t, i) => {
          s.includes(i) ||
            e.forEach((e) => {
              for (let i in e.discounts)
                e.discounts[i].mainProductId === t.product_id &&
                  c[e.discounts[i].discountId] &&
                  c[e.discounts[i].discountId].items.push(t);
              o &&
                o.mainProductId === t.product_id &&
                c[o.discountId] &&
                c[o.discountId].items.push(t);
            });
        }),
        c)) {
          let p = c[d].items.find(
            (e) => e.product_id === c[d].mainProductId
          )?.quantity;
          (c[d].items.length < c[d].mainProductQuantity ||
            !p ||
            p < +c[d].mainProductQuantity) &&
            (await Apis.removeDiscount({ discountId: d }),
            await new Promise((e) => setTimeout(e, 2e3)));
        }
        !0 !== t ||
          (settings?.removeTypeFromCheckoutButton === "true" &&
            (i.type = "submit"),
          i.removeEventListener("click", EWCK.checkoutBtnsLis[a], !0),
          (EWCK.checkoutBtns = []),
          (EWCK.checkoutBtnsLis = []),
          tools.shipping_protection || i.click());
      },
    },
    Utils = {
      insert(e, t, i) {
        switch (i) {
          case "":
            e.appendChild(t);
            break;
          case "after":
            e.parentNode.insertBefore(t, e.nextSibling);
            break;
          case "before":
            e.parentElement.insertBefore(t, e);
        }
      },
      ce(e, t) {
        let i = document.createElement(e);
        return t && Utils.assignAtt(i, t), i;
      },
      checkVisibility: (e) =>
        !!e?.resourceType &&
        ("product" === e.resourceType
          ? !!e?.selectionIds &&
            e.selectionIds.includes(currentProduct?.id?.toString())
          : "collection" !== e.resourceType ||
            (!!(currentProductCollections && e?.selectionIds) &&
              e.selectionIds.some((e) =>
                currentProductCollections.some((t) => e === t.id.toString())
              ))),
      isMobile: () =>
        !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ),
      checkScreenSize: () =>
        window.innerWidth >= 1090
          ? 4
          : window.innerWidth < 1090 && window.innerWidth >= 892
          ? 3
          : window.innerWidth < 892 && window.innerWidth >= 500
          ? 2
          : window.innerWidth < 500
          ? 1
          : void 0,
      calSize(e, t = "medium") {
        switch (EWCK.screenSize) {
          case 4:
            return e;
          case 3:
            return (
              e -
              (e / 100) *
                ("small" === t
                  ? 10
                  : "medium" === t
                  ? 15
                  : "large" === t
                  ? 20
                  : 40)
            );
          case 2:
            return (
              e -
              (e / 100) *
                ("small" === t
                  ? 15
                  : "medium" === t
                  ? 22.5
                  : "large" === t
                  ? 20
                  : 55)
            );
          case 1:
            return (
              e -
              (e / 100) *
                ("small" === t
                  ? 20
                  : "medium" === t
                  ? 30
                  : "large" === t
                  ? 20
                  : 70)
            );
        }
      },
      assignAtt(e, t) {
        for (let i of Object.keys(t))
          if ("class" === i) {
            if ("" !== t[i])
              for (let a of t[i].split(" "))
                "" !== a &&
                  e.classList.add(a.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, ""));
          } else e[i] = t[i];
        return e;
      },
      createGiftClaim(
        cart,
        cartTP,
        cartTA,
        data,
        eligibleTier,
        progressPercent,
        zeroPriceProducts
      ) {
        let gifts = [];
        if (
          (data.tier1.enabled &&
            "Free gift" === data.tier1.discountType &&
            gifts.push({ tier: "tier1", props: data.tier1 }),
          data.tier2.enabled &&
            "Free gift" === data.tier2.discountType &&
            gifts.push({ tier: "tier2", props: data.tier2 }),
          data.tier3.enabled &&
            "Free gift" === data.tier3.discountType &&
            gifts.push({ tier: "tier3", props: data.tier3 }),
          gifts.length)
        ) {
          let container = Utils.ce("div", { class: "ewck-or-gift-c" });
          Utils.addCustomCSS(container, settings?.css || "");
          let wrapper = Utils.ce("div", { class: "ewck-or-gift-w" }),
            popOuterWrap = Utils.ce("div", { style: "display:none" }),
            popWrap = Utils.ce("div", { class: "ewck-or-gift-p-w" }),
            iconOuterWrap = Utils.ce("div", { class: "ewck-or-gift-i-o-w" }),
            noti = Utils.ce("div", { class: "ewck-or-gift-noti" });
          iconOuterWrap.appendChild(noti);
          let iconWrap = Utils.ce("div", { class: "ewck-or-gift-i-w" });
          (iconWrap.innerHTML = data.giftIcon),
            (iconOuterWrap.onclick = () => {
              popOuterWrap.style.display =
                "none" === popOuterWrap.style.display ? "block" : "none";
            }),
            setTimeout(async () => {
              let closeBtn = Utils.ce("div", {
                innerHTML: "&#10005;",
                class: "ewck-or-gift-p-w-c",
                onclick: () =>
                  (popOuterWrap.style.display =
                    "none" === popOuterWrap.style.display ? "block" : "none"),
              });
              popWrap.appendChild(closeBtn);
              let allClaimed = !0;
              for (let [index, item] of gifts.entries()) {
                let giftItems = await Utils.confirmGiftAdd(
                    cart,
                    item.props,
                    item.tier,
                    !0
                  ),
                  eligibleForGift =
                    100 === progressPercent ||
                    Number(item.tier.charAt(item.tier.length - 1)) <
                      Number(
                        eligibleTier.tier.charAt(eligibleTier.tier.length - 1)
                      ),
                  alreadyClaimed;
                if (eligibleForGift) {
                  if (
                    !(alreadyClaimed = item.props.gifts.some((e) =>
                      cart.items.find(
                        (t) =>
                          t.variant_id.toString() === e.variantId &&
                          t.properties?._ewckGift
                      )
                    ))
                  ) {
                    let num =
                      (noti?.firstChild
                        ? Number(noti.firstChild.innerText)
                        : 0) + giftItems.length;
                    noti > 0 &&
                      ((noti.innerHTML = `<span>${num}</span>`),
                      noti.classList.contains("ewck-or-gift-noti-unclaimed") ||
                        noti.classList.add("ewck-or-gift-noti-unclaimed")),
                      settings?.showGiftClaimable === "true" &&
                        (window?.ewckGiftIconClick &&
                          clearTimeout(window.ewckGiftIconClick),
                        (window.ewckGiftIconClick = setTimeout(() => {
                          document
                            .querySelector(".ewck-or-gift-i-o-w")
                            ?.click();
                        }, 2e3)));
                  }
                } else
                  for (let zeroP of ((allClaimed = !1), zeroPriceProducts)) {
                    let splitted = zeroP.properties._ewckGift.split(" ");
                    if (splitted[splitted.length - 1] === item.tier) {
                      let success;
                      (await Utils.removeCartItem([zeroP.variant_id])) &&
                        (settings?.afterGiftRemoveJS
                          ? eval(settings.afterGiftRemoveJS)
                          : location.reload());
                    }
                  }
                let section = Utils.ce("div", {
                    class: "ewck-or-gift-pop-section",
                  }),
                  soldOutItem = localStorage.getItem(
                    "ewck-or-gift-item-add-error-" + item.tier
                  ),
                  soldOutItemCopy = soldOutItem;
                for (let gift of item.props.gifts) {
                  let isSoldOut = !1;
                  soldOutItemCopy &&
                    (0 === (soldOutItem = JSON.parse(soldOutItemCopy)).length &&
                    "all" !== item.props.giftOption
                      ? (isSoldOut = !0)
                      : soldOutItem.forEach((e) => {
                          gift.variantId === e.id && (isSoldOut = !0);
                        }));
                  if (
                    !giftItems.includes(gift.variantId) &&
                    giftItems.length > 0
                  )
                    continue;
                  let pContent = Utils.ce("div", {
                      class: "ewck-or-gift-pop-p-c",
                    }),
                    pImgWrap = Utils.ce("div", {
                      class: "ewck-or-gift-pop-p-img-w",
                    }),
                    giftProduct = await Apis.getProduct(gift.productHandle),
                    giftProductVariant = giftProduct?.variants.find(
                      (e) => e.id.toString() === gift.variantId
                    ),
                    pImgLink = Utils.ce("a", {
                      href: `/products/${gift.productHandle}?variant=${gift.variantId}`,
                      target: "_blank",
                      style: "text-decoration:none",
                    }),
                    pImg = Utils.ce("img", {
                      class: "ewck-or-gift-pop-p-img",
                      src: gift?.variantImage || gift.featuredImage,
                    }),
                    tnpWrap = Utils.ce("div", { class: "ewck-or-gift-tnp-w" }),
                    pTitleLink = Utils.ce("a", {
                      href: `/products/${gift.productHandle}?variant=${gift.variantId}`,
                      target: "_blank",
                      style: "text-decoration:none",
                    }),
                    pTitle = Utils.ce("div", {
                      class: "ewck-or-gift-pop-p-t",
                      innerText:
                        (giftProduct?.title || gift.productTitle) +
                        ("Default title" !==
                          (giftProductVariant?.title || gift.variantTitle) &&
                        "Default Title" !==
                          (giftProductVariant?.title || gift.variantTitle)
                          ? " - " +
                            (giftProductVariant?.title || gift.variantTitle)
                          : ""),
                    }),
                    pPrice = Utils.ce("div", {
                      class: "ewck-or-gift-pop-p-p",
                      style: "white-space:nowrap;",
                      innerHTML:
                        isSoldOut && eligibleForGift
                          ? data?.soldOutText ||
                            settings?.translateSoldOut ||
                            "Sold Out"
                          : settings?.translateFree || item.props.giftFreeText,
                    });
                  pImgLink.appendChild(pImg),
                    pImgWrap.appendChild(pImgLink),
                    pTitleLink.appendChild(pTitle),
                    tnpWrap.append(pTitleLink, pPrice),
                    pContent.append(pImgWrap, tnpWrap),
                    section.appendChild(pContent);
                }
                let cBtn = Utils.ce("div", {
                    class: `ewck-or-gift-pop-p-claim ${
                      alreadyClaimed ? "ewck-or-gift-pop-p-claimed" : ""
                    }`,
                    style: eligibleForGift
                      ? alreadyClaimed
                        ? "background-color:#2c7f8012;color:green;font-weight:500;"
                        : ""
                      : "opacity:0.6;cursor:not-allowed",
                    innerHTML: alreadyClaimed
                      ? `<div style="display:flex;align-items:center;justify-content:center;gap:4px;">${data.checkSvg}<span>${item.props.giftClaimedText}</span></div>`
                      : eligibleForGift
                      ? item.props.giftClaimText
                      : data?.triggerType === "quantity"
                      ? item.props.giftPopQuantityProgressText.replace(
                          "{{quantity}}",
                          `<span style="font-weight:bold;color:${
                            data.specialTextColor
                          }">${item.props.minimumQuantity - cartTA}</span>`
                        )
                      : item.props.giftPopAmountProgressText.replace(
                          "{{amount}}",
                          `<span style="font-weight:bold;color:${
                            data.specialTextColor
                          }">${Utils.cf(
                            (
                              item.props.minimumTotal * +Shopify.currency.rate -
                              cartTP
                            ).toFixed(settings?.toFixed || 2),
                            settings?.moneyFormat
                          )}</span>`
                        ),
                    onclick(e) {
                      if (!eligibleForGift || alreadyClaimed) return;
                      (e.currentTarget.style.width = cBtn.offsetWidth + "px"),
                        (e.currentTarget.style.minWidth =
                          cBtn.offsetWidth + "px"),
                        (e.currentTarget.style.height =
                          cBtn.offsetHeight + "px"),
                        (e.currentTarget.style.maxHeight =
                          cBtn.offsetHeight + "px"),
                        (e.currentTarget.innerHTML = "");
                      let t = Utils.createSpinner(e.currentTarget);
                      (t.firstChild.style.border = "2px solid #ffffff"),
                        (t.firstChild.style.borderTop = "2px solid #000000"),
                        setTimeout(() => {
                          t?.remove(),
                            (cBtn.innerHTML = item.props.giftClaimedText);
                        }, 2e3),
                        Utils.confirmGiftAdd(cart, item.props, item.tier);
                    },
                  }),
                  giftBase = Utils.ce("div", {
                    class: "ewck-or-gift-pop-base",
                  });
                giftBase.append(section, cBtn), popWrap.append(giftBase);
              }
              "" === noti.innerHTML &&
                allClaimed &&
                ((noti.innerHTML = data.checkSvg),
                noti.classList.add("ewck-or-gift-noti-claimed"),
                (noti.style.backgroundColor = "transparent"));
            }, 10),
            iconOuterWrap.appendChild(iconWrap),
            popOuterWrap.appendChild(popWrap),
            wrapper.append(popOuterWrap, iconOuterWrap),
            container.appendChild(wrapper);
          let body = document.getElementsByTagName("body")[0];
          document.querySelector(".ewck-or-gift-c")?.remove(),
            body.append(container);
        }
      },
      async addFreeGifts(e, t, i) {
        "automatic" === t.giftAddType && Utils.confirmGiftAdd(e, t, i);
      },
      async confirmGiftAdd(e, t, i, a = !1) {
        let n = [],
          o = [];
        switch (t.giftOption) {
          case "all":
            for (let r of t.gifts) {
              o.push(r.variantId);
              !e.items.find(
                (e) =>
                  e.variant_id.toString() === r.variantId &&
                  e.properties._ewckGift === t.discountTitle + " " + i
              ) &&
                n.push({
                  id: r.variantId,
                  quantity: r.quantity,
                  properties: { _ewckGift: t.discountTitle + " " + i },
                });
            }
            break;
          case "available":
            for (let l of t.gifts) {
              let c = await Apis.getProduct(l.productHandle),
                s = c.variants.find((e) => e.id.toString() === l.variantId);
              if (s.available) {
                o.push(l.variantId),
                  e.items.some(
                    (e) =>
                      e.variant_id.toString() === l.variantId &&
                      e.properties._ewckGift === t.discountTitle + " " + i
                  ) ||
                    n.push({
                      id: l.variantId,
                      quantity: l.quantity,
                      properties: { _ewckGift: t.discountTitle + " " + i },
                    });
                break;
              }
            }
            break;
          case "cheapest":
            let d = t.gifts.map((e) => Apis.getProduct(e.productHandle)),
              p = (await Promise.allSettled(d))
                .filter((e) => "fulfilled" === e.status)
                .map((e) => e.value);
            if (p.length) {
              let u = null;
              if (
                (p.forEach((e) => {
                  let i = e.variants.filter(
                    (e) =>
                      e.available &&
                      t.gifts.some((t) => t.variantId === e.id.toString())
                  );
                  if (i?.length) {
                    let a = i.reduce(
                      (e, t) => (t.price < e.price ? t : e),
                      i[0]
                    );
                    (!u || a.price < u.price) && (u = a);
                  }
                }),
                u)
              ) {
                o.push(u.id.toString());
                let m = t.gifts.find((e) => e.variantId === u.id.toString());
                m &&
                  !e.items.some(
                    (e) =>
                      e.variant_id.toString() === m.variantId &&
                      e.properties._ewckGift === t.discountTitle + " " + i
                  ) &&
                  n.push({
                    id: m.variantId,
                    quantity: m.quantity,
                    properties: { _ewckGift: t.discountTitle + " " + i },
                  });
              }
            }
        }
        if (!0 === a) return o;
        let y = localStorage.getItem("ewck-or-gift-item-add-error-" + i);
        if (y && JSON.stringify(n) === y) {
          let f = [];
          for (let g of t.gifts) {
            let h = await (
              await fetch("/products/" + g.productHandle + ".js")
            ).json();
            if (h?.available) {
              let b = h.variants.find((e) => e.id.toString() === g.variantId);
              b.available && f.push(b.id.toString());
            }
          }
          let w = JSON.parse(y);
          (w = w.filter((e) => !f.includes(e.id))),
            localStorage.setItem(
              "ewck-or-gift-item-add-error-" + i,
              JSON.stringify(w)
            );
          return;
        }
        if (n.length) {
          if (settings?.atcAction === "ajax" && settings?.themeName)
            await Utils.atc(
              n,
              "gift",
              "order_rewards",
              "Order Rewards (+Gift)"
            );
          else {
            let k = await Utils.manualAtc(n);
            if ("error" === k) {
              localStorage.setItem(
                "ewck-or-gift-item-add-error-" + i,
                JSON.stringify(n)
              ),
                alert("The gift is not available.");
              return;
            }
            !0 === k &&
              (localStorage.removeItem("ewck-or-gift-item-add-error-" + i),
              location.reload());
          }
        }
      },
      async manualAtc(e) {
        let t = window?.Shopify?.routes?.root || "/";
        try {
          let i = await (
            await fetch(
              "/" === t
                ? "/cart/add.js"
                : t +
                    ("/" === t.charAt(t.length - 1)
                      ? "cart/add.js"
                      : "/cart/add.js"),
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: e }),
              }
            )
          ).json();
          if (i?.status && 200 !== i.status) return "error";
          if (i?.items) return !0;
        } catch (a) {
          console.log(a);
        }
        return !1;
      },
      atc: async function (e, t, i, a) {
        if (settings?.atcAction === "ajax" && settings?.themeName) {
          Utils.ajaxCart(e);
          return;
        }
        try {
          let n = window?.Shopify?.routes?.root || "/";
          return (
            (
              await (
                await fetch(
                  "/" === n
                    ? "/cart/add.js"
                    : n +
                        ("/" === n.charAt(n.length - 1)
                          ? "cart/add.js"
                          : "/cart/add.js"),
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ items: e }),
                  }
                )
              ).json()
            )?.items
              ? (await Apis.addToCart(e, t, i, a),
                settings?.redirectToCheckout === "true"
                  ? (location.href =
                      "/" === n
                        ? "/cart/checkout"
                        : n +
                          ("/" === n.charAt(n.length - 1)
                            ? "cart/checkout"
                            : "/cart/checkout"))
                  : (location.href =
                      "/" === n
                        ? "/cart"
                        : n +
                          ("/" === n.charAt(n.length - 1) ? "cart" : "/cart")))
              : alert(
                  "Something went wrong! This might be because some products are out of stock."
                ),
            !0
          );
        } catch (o) {
          console.log(o);
        }
      },
      async ajaxCart(items, intent) {
        let themeName = settings.themeName;
        if ("Shopify" === themeName) {
          let shopifyCart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer"),
            formData = {
              sections: shopifyCart.getSectionsToRender().map((e) => e.id),
            };
          intent ? (formData.updates = {}) : (formData.items = items),
            shopifyCart.setActiveElement(document.activeElement);
          let config = fetchConfig("json");
          (config.headers["X-Requested-With"] = "XMLHttpRequest"),
            (config.body = JSON.stringify(formData)),
            fetch(
              `${intent ? routes.cart_update_url : routes.cart_add_url}`,
              config
            )
              .then((e) => e.json())
              .then((e) => {
                if (e.errors)
                  console.log("Ajax add to cart error on shopify theme."),
                    console.log(e.errors);
                else {
                  let t = location.pathname.split("/");
                  if ("cart" === t[t.length - 1]) location.reload();
                  else {
                    let i = {};
                    Object.assign(i, e.items[0]),
                      Object.assign(i, { sections: e.sections }),
                      shopifyCart.renderContents(i),
                      shopifyCart.classList.remove("is-empty"),
                      trapFocus(
                        document.getElementById("CartDrawer"),
                        document.getElementById("CartDrawer")
                      );
                  }
                }
              });
        } else {
          let result;
          if (!intent) {
            let origin = window?.Shopify?.routes?.root || "/";
            result = await (
              await fetch(
                "/" === origin
                  ? "/cart/add.js"
                  : origin +
                      ("/" === origin.charAt(origin.length - 1)
                        ? "cart/add.js"
                        : "/cart/add.js"),
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ items: items }),
                }
              )
            ).json();
          }
          if (result?.items || intent) {
            let paths = location.pathname.split("/");
            if ("cart" === paths[paths.length - 1]) location.reload();
            else {
              if (settings?.cartDrawerHook) {
                eval(settings.cartDrawerHook);
                return;
              }
              switch (themeName) {
                case "Impulse":
                  let impCart = new theme.CartDrawer();
                  impCart.init(), impCart.open();
                  break;
                case "Prestige":
                case "Impact":
                case "Focal":
                case "Warehouse":
                case "Reformation":
                  document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", { bubbles: !0 })
                  );
                  let cdb1 = document.querySelector(
                    settings?.themeCartDrawerButtonSelector ||
                      ".header__secondary-nav a[href='/cart'], .header__linklist-item a[href='/cart'], .header__action-item a[href='/cart'], .thb-secondary-area a[href='/cart']"
                  );
                  cdb1 && cdb1.click();
                  break;
                case "Concept":
                case "Be Yours":
                  document.dispatchEvent(
                    new CustomEvent("cart:refresh", {
                      bubbles: !0,
                      detail: { open: !0 },
                    })
                  );
                  break;
                case "Symmetry":
                case "Enterprise":
                  document.dispatchEvent(
                    new CustomEvent("dispatch:cart-drawer:refresh", {
                      bubbles: !0,
                    })
                  ),
                    document.dispatchEvent(
                      new CustomEvent("dispatch:cart-drawer:open")
                    );
                  break;
                case "Motion":
                  document.dispatchEvent(new CustomEvent("cart:build"));
                  let cdb2 = document.querySelector(
                    ".site-nav__icons a[href='/cart']"
                  );
                  cdb2 && cdb2.click();
                  break;
                case "Shapes":
                  document.dispatchEvent(new CustomEvent("theme:update:cart"));
                  let cdb3 = document.getElementById("CartButton");
                  cdb3 && cdb3.click();
                  break;
                case "Stiletto":
                  document.dispatchEvent(
                    new CustomEvent("apps:product-added-to-cart")
                  );
                  let cdb4 = document.querySelector(
                    ".header__row-segment a[href='/cart']"
                  );
                  cdb4 && cdb4.click();
                  break;
                case "Mono":
                  let cdb5 = document.querySelector(
                    ".header__icons a[href='/cart']"
                  );
                  cdb5 && cdb5.click();
              }
            }
          } else
            alert(
              "Something went wrong! This might be because some products are out of stock."
            );
        }
      },
      async removeCartItem(e) {
        try {
          let t = {};
          e.forEach((e) => {
            t[e] = 0;
          });
          let i = window?.Shopify?.routes?.root || "/",
            a = await fetch(
              "/" === i
                ? "/cart/update.js"
                : i +
                    ("/" === i.charAt(i.length - 1)
                      ? "cart/update.js"
                      : "/cart/update.js"),
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: t }),
              }
            );
          if (a.ok) return await a.json(), !0;
          console.error("Failed to update the cart:", a.statusText);
        } catch (n) {
          console.error("Error removing cart lines:", n);
        }
        return !1;
      },
      addCustomCSS: function (e, t) {
        if ("" === t) return;
        let i = document.createElement("style");
        (i.innerHTML = t), e.appendChild(i);
      },
      variantChangeTracker: function () {
        let e = function (e) {
            let t;
            if (currentProduct) {
              for (let i = 0; i < currentProduct.variants.length; i++)
                if (currentProduct.variants[i].id === e) {
                  selectedVariant = t = currentProduct.variants[i];
                  break;
                }
              EWCK.init();
            }
          },
          t = window.location.href;
        EWCK.variantChangeTracker = new MutationObserver(function (i) {
          window.location.href !== t &&
            ((t = window.location.href),
            e(
              parseInt(
                new URLSearchParams(window.location.search)?.get("variant")
              )
            ));
        });
        let i = { subtree: !0, childList: !0 };
        if (
          (EWCK.variantChangeTracker.observe(document, i),
          settings?.varinatInputSelector)
        ) {
          let a = document.querySelector(settings.varinatInputSelector);
          a &&
            a.addEventListener("change", (e) => {
              let t = e.target.value;
              t &&
                ((selectedVariant = currentProduct.variants.find(
                  (e) => e.id.toString() === t
                )),
                EWCK.init(t));
            });
        }
      },
      productsFilterTracker: function () {
        EWCK.productsFilterObserver && EWCK.productsFilterObserver.disconnect();
        let e = window.location.href;
        EWCK.productsFilterObserver = new MutationObserver(function (t) {
          window.location.href !== e &&
            ((e = window.location.href),
            (EWCK.stickerProductCards = []),
            setTimeout(() => {
              EWCK.init();
            }, 1e3));
        });
        let t = { subtree: !0, childList: !0 };
        EWCK.productsFilterObserver.observe(document, t);
      },
      checkVisible(e) {
        let t = e.getBoundingClientRect(),
          i = Math.max(
            document.documentElement.clientHeight,
            window.innerHeight
          );
        return !(t.bottom < 0 || t.top - i >= 0);
      },
      createSpinner(e) {
        let t = Utils.ce("div", { class: "ewck-tool-spinner-container" });
        return (
          (t.innerHTML = "<div class='ewck-tool-spinner'></div></div>"),
          e.appendChild(t),
          t
        );
      },
      cf: function (e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        let i = "",
          a = /{{\s*(\w+)\s*}}/,
          n = t || Shopify.money_format;
        function o(e, t) {
          return void 0 === e ? t : e;
        }
        function r(e, t, i, a) {
          if (
            ((t = o(t, 2)),
            (i = o(i, ",")),
            (a = o(a, ".")),
            isNaN(e) || null == e)
          )
            return 0;
          let n = (e = (e / 100).toFixed(t)).split("."),
            r;
          return (
            n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
            (n[1] ? a + n[1] : "")
          );
        }
        switch (n.match(a)[1]) {
          case "amount":
            i = r(e, settings?.toFixed || 2);
            break;
          case "amount_no_decimals":
            i = r(e, 0);
            break;
          case "amount_with_comma_separator":
            i = r(e, settings?.toFixed || 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            i = r(e, 0, ".", ",");
        }
        return n.replace(a, i);
      },
      getRandomInt(e, t) {
        let i = Math.ceil(e),
          a = Math.floor(t);
        return Math.floor(Math.random() * (a - i + 1) + i);
      },
      getDHMS(e) {
        let t = Math.floor(e / 1e3),
          i = Math.floor(t / 60),
          a = Math.floor(i / 60),
          n;
        return [Math.floor(a / 24), (a %= 24), (i %= 60), (t %= 60)];
      },
      loadRTEStyle() {
        let e = document.createElement("link");
        (e.href =
          "https://cdn.jsdelivr.net/npm/suneditor@latest/dist/css/suneditor.min.css"),
          (e.type = "text/css"),
          (e.rel = "stylesheet");
        document.getElementsByTagName("head")[0].append(e);
      },
      cartChangeWatch: class CartWatch {
        init() {
          this.emitCartChanges().then(() => {
            this.observeCartChanges();
          });
        }
        async fetchCart() {
          let e = window?.Shopify?.routes?.root || "/",
            t = await fetch(
              "/" === e
                ? "/cart.js"
                : e + ("/" === e.charAt(e.length - 1) ? "cart.js" : "/cart.js")
            );
          return t.json();
        }
        storeCart(e) {
          localStorage.setItem("ewck-cart-items", JSON.stringify(e));
        }
        storedCart() {
          return (
            JSON.parse(localStorage.getItem("ewck-cart-items")) || { items: [] }
          );
        }
        findCartChanges(e, t) {
          let i = (e, t) => e.filter((e) => !t.some((t) => e.key == t.key)),
            a = { added: i(t.items, e.items), removed: i(e.items, t.items) };
          return (
            e.items.forEach((e) => {
              let i = t.items.find(
                (t) => t.key == e.key && t.quantity != e.quantity
              );
              if (!i) return;
              let n = i.quantity - e.quantity,
                o = { ...i };
              (o.quantity = Math.abs(n)),
                n > 0 ? a.added.push(o) : a.removed.push(o);
            }),
            a
          );
        }
        async emitCartChanges() {
          let e = await this.fetchCart(),
            t = this.storedCart(),
            i = this.findCartChanges(t, e),
            a = new CustomEvent("cart_changed", { detail: i });
          window.dispatchEvent(a), this.storeCart(e);
        }
        observeCartChanges() {
          let e = new PerformanceObserver((e) => {
            e.getEntries().forEach((e) => {
              let t = ["xmlhttprequest", "fetch"].includes(e.initiatorType),
                i = /\/cart\//.test(e.name);
              t && i && this.emitCartChanges();
            });
          });
          e.observe({ entryTypes: ["resource"] });
        }
      },
      getBOGODisPrice(e, t) {
        let i = +t;
        return ("Percentage" === e.discountType
          ? (i -= (i * e.discountValue) / 100)
          : "Amount off each" === e.discountType
          ? (i -= 100 * e.discountValue)
          : (i = 0),
        i <= 0)
          ? "0.00"
          : i.toFixed(settings?.toFixed || 2);
      },
      getPAODisPrice(e, t) {
        let i = +t;
        return ("Percentage" === e.discountType
          ? (i -= (i * e.discountPercentage) / 100)
          : "Amount off each" === e.discountType &&
            (i -= 100 * e.discountAmount),
        i <= 0)
          ? "0.00"
          : i.toFixed(settings?.toFixed || 2);
      },
      getVDDisPrice(e, t, i) {
        let a = +e;
        return (
          "Percentage" === t ? (a -= (a * i) / 100) : (a -= 100 * i),
          a.toFixed(settings?.toFixed || 2)
        );
      },
      getVDTierItems(e) {
        let t = [];
        for (let i of e.variants) {
          let a;
          t.find((e, t) => e.id === Object.keys(i)[0] && ((a = t), !0))
            ? (t[a].quantity = +t[a].quantity + 1)
            : t.push({ id: Object.keys(i)[0], quantity: 1 });
        }
        return t;
      },
      findTarget() {
        let e = !(
            settings?.shopifyPaymentButton !== "" &&
            settings?.shopifyPaymentButton !== void 0
          ),
          t = document.querySelector(
            e ? ".shopify-payment-button" : settings.shopifyPaymentButton
          );
        return e ? (t ? t.closest("form") : Utils.findAtc()) : t;
      },
      findAtc() {
        if (settings?.atcSelector !== "" && settings?.atcSelector !== void 0)
          return document.querySelector(settings.atcSelector);
        let e = document.querySelector(
            "[id^=shopify-section-template i][id*=__main i], [class^=shopify-section-template i][id*=__main i]"
          ),
          t = [];
        if (e) {
          let i = e.querySelectorAll(
            ".shopify-product-form, .product_form, .product-form__buttons, .product-form, product-form, .product-single__form, .buy-buttons, [class*=button i][class*=buy i]"
          );
          i.length && (t = [...i]);
        } else {
          let a = document.querySelectorAll(
            ".shopify-product-form, .product_form, .product-form__buttons, .product-form, product-form, .product-single__form, .buy-buttons, [class*=button i][class*=buy i]"
          );
          a && (t = [...a]);
        }
        let n = null;
        if (t.length > 0) {
          for (let o of t)
            if ((n = o.querySelector("[name=add], [type=submit]"))) break;
          n || (n = e?.querySelector("[name=add], [type=submit]"));
        } else e && (n = e.querySelector("[name=add], [type=submit]"));
        return (
          n ||
            (n = document.querySelector(
              `${Utils.defAtcSelectors},[name=add],[type=submit],button,[type=button]`
            )),
          n
        );
      },
      getSNContainerStyle(e) {
        let t = `border-radius:${e.widgetBorderRadius}px;`;
        return (
          e.progressBar &&
            (t = t.concat(
              window.innerWidth <= 490
                ? "padding-bottom:9px;"
                : "padding-bottom:13px;"
            )),
          (t =
            "Solid color" === e.backgroundType
              ? t.concat(`background:${e.backgroundColor}`)
              : "Gradient" === e.backgroundType
              ? t.concat(
                  `background-image:linear-gradient(to right, ${e.gradientStartColor} , ${e.gradientEndColor})`
                )
              : t.concat(
                  `background-image:url(${e.imageUrl});background-size:cover;background-position:center`
                ))
        );
      },
      df(e, t) {
        let i = Math.floor((new Date() - new Date(t)) / 1e3),
          a = i / 604800;
        if (a >= 1)
          return new Date(t).toLocaleDateString("en-us", {
            month: "short",
            day: "numeric",
          });
        if ((a = i / 86400) >= 1) {
          let n = Math.floor(a);
          return (
            n +
            " " +
            (n > 1
              ? e?.translateDays || settings?.translateDays
              : e?.translateDay || settings?.translateDay) +
            " " +
            (e?.translateAgo || settings?.translateAgo || e?.ago)
          );
        }
        if ((a = i / 3600) >= 1) {
          let o = Math.floor(a);
          return (
            o +
            " " +
            (o > 1
              ? e?.translateHours || settings?.translateHours
              : e?.translateHour || settings?.translateHour) +
            " " +
            (e?.translateAgo || settings?.translateAgo || e?.ago)
          );
        }
        if ((a = i / 60) >= 1) {
          let r = Math.floor(a);
          return (
            r +
            " " +
            (r > 1
              ? e?.translateMinutes || settings?.translateMinutes
              : e?.translateMinute || settings?.translateMinute) +
            " " +
            (e?.translateAgo || settings?.translateAgo || e?.ago)
          );
        }
        return e?.translateJustNow || settings?.translateJustNow || "just now";
      },
      shuffle(e) {
        let t, i, a;
        for (a = e.length - 1; a > 0; a--)
          (t = Math.floor(Math.random() * (a + 1))),
            (i = e[a]),
            (e[a] = e[t]),
            (e[t] = i);
        return e;
      },
      assemblePopComponents() {
        let e = document.querySelector(".ewck-pop-main"),
          t = e.cloneNode(!0);
        return e.remove(), (EWCK.pop = !0), t;
      },
      cloneComp(e) {
        let t = e.cloneNode(!0),
          i = {};
        return (
          (i.main = t),
          (i.container = t.querySelector(".ewck-pop-c")),
          (i.bgShadow = t.querySelector(".ewck-pop-bg-shadow")),
          (i.wrapper = t.querySelector(".ewck-pop-w")),
          (i.imageWrapper = t.querySelector(".ewck-pop-img-w")),
          (i.image = t.querySelector(".ewck-pop-img")),
          (i.infoWrapper = t.querySelector(".ewck-pop-info-w")),
          (i.closeWrapper = t.querySelector(".ewck-pop-close-w")),
          (i.info = t.querySelector(".ewck-pop-info")),
          (i.initiateContent = t.querySelector(".ewck-pop-info-content")),
          (i.infoNAndC = t.querySelector(".ewck-pop-info-n-c")),
          (i.infoNameField = t.querySelector(".ewck-pop-info-name-field")),
          (i.infoNameFieldInput = t.querySelector(
            ".ewck-pop-info-name-field-i"
          )),
          (i.infoEmailField = t.querySelector(".ewck-pop-info-email-field")),
          (i.infoEmailFieldInput = t.querySelector(
            ".ewck-pop-info-email-field-i"
          )),
          (i.infoPhoneField = t.querySelector(".ewck-pop-info-phone-field")),
          (i.infoPhoneFieldInput = t.querySelector(
            ".ewck-pop-info-phone-field-i"
          )),
          (i.infoSubmitBtnWrapper = t.querySelector(
            ".ewck-pop-info-submit-btn-w"
          )),
          (i.infoSubmitBtn = t.querySelector(".ewck-pop-info-submit-btn")),
          (i.infoSubmitBtn = t.querySelector(".ewck-pop-info-submit-btn")),
          (i.infoAnn = t.querySelector(".ewck-pop-info-ann")),
          (i.infoActionBtnWrapper = t.querySelector(
            ".ewck-pop-info-action-btn-w"
          )),
          (i.infoActionBtn = t.querySelector(".ewck-pop-info-action-btn")),
          (i.infoDiscardBtnWrapper = t.querySelector(".ewck-pop-info-dis-w")),
          (i.infoDiscardBtn = t.querySelector(".ewck-pop-info-dis")),
          (i.successWrapper = t.querySelector(".ewck-pop-info-success-w")),
          (i.successContent = t.querySelector(".ewck-pop-info-success-con")),
          (i.successDisWrapper = t.querySelector(".ewck-pop-info-success-d-w")),
          (i.successDisCode = t.querySelector(".ewck-pop-info-success-d-c")),
          (i.successDisCopy = t.querySelector(
            ".ewck-pop-info-success-dis-cop"
          )),
          (i.successDisCopyBefore = t.querySelector(
            ".ewck-pop-info-success-dis-cop-before"
          )),
          (i.successDisCopyAfter = t.querySelector(
            ".ewck-pop-info-success-dis-cop-after"
          )),
          i
        );
      },
      createUpsellMarkup(e, t, i, a, n, o, r) {
        document.querySelector(r ? `.${r}` : ".ewck-cu-c")?.remove();
        let l = t;
        if (0 === t.offsetWidth) {
          let c = t.parentElement.querySelector("div:nth-child(2)");
          l = c || t.parentElement;
        }
        let s = Utils.ce("div", {
          class: `${
            r ? r + " ewck-cu-c-" + a.id : "ewck-cu-c ewck-cu-c-" + a.id
          }`,
          style: "width:100%",
        });
        Utils.addCustomCSS(s, settings?.css || "");
        let d = Utils.ce("div", {
            class: r ? "ewck-pcs-w" : "ewck-cu-w",
            style: `${a.marginY ? "margin-block:" + a.marginY + "px;" : ""}`,
          }),
          p = Utils.ce("div", {
            class: r ? "ewck-pcs-he" : "ewck-cu-he",
            style: `margin-bottom:8px;display:flex;align-items:center;justify-content:${
              "" === a.title.trim() ? "end" : "space-between"
            }`,
          }),
          u,
          m;
        function y() {
          let t = 0;
          return (
            n.forEach((i) => {
              e.items.some(
                (e) => e.product_id.toString() === i.id.toString()
              ) && t++;
            }),
            (!(l.offsetWidth < 550) ||
              (!(n.length <= 1) &&
                !(n.length - (a.alwaysVisible ? 0 : t) <= 1))) &&
              (!(l.offsetWidth > 549) ||
                !(n.length < 1080) ||
                (!(n.length <= 2) &&
                  !(n.length - (a.alwaysVisible ? 0 : t) <= 2))) &&
              (!(l.offsetWidth > 1079) ||
                (!(n.length <= 3) &&
                  !(n.length - (a.alwaysVisible ? 0 : t) <= 3)))
          );
        }
        if (
          ("" !== a.title.trim() &&
            ((u = Utils.ce("div", {
              class: r ? "ewck-pcs-he-t-w" : "ewck-cu-he-t-w",
            })),
            (m = Utils.ce("div", {
              class: r ? "ewck-pcs-he-t" : "ewck-cu-he-t",
              style: r
                ? `font-size:${a.titleFontSize}px;color:${a.titleColor};`
                : `font-size:${
                    l.offsetWidth > 1080
                      ? a.titleFontSize
                      : l.offsetWidth > 549 && l.offsetWidth < 1080
                      ? a.titleFontSize - (15 * a.titleFontSize) / 100
                      : a.titleFontSize - (8 * a.titleFontSize) / 100
                  }px;color:${a.titleColor};`,
              innerHTML: a.title,
            })),
            u.appendChild(m),
            p.appendChild(u)),
          "Carousel" === a.layout)
        ) {
          let f = y(),
            g = Utils.ce("div", { class: "ewck-cu-he-pa" }),
            h = Utils.ce("button", {
              class: `ewck-cu-carousel-button ewck-cu-carousel-button-prev ${
                f
                  ? "ewck-cu-carousel-button-enabled"
                  : "ewck-cu-carousel-button-disabled"
              }`,
              disabled: !f,
              onclick(e) {
                e.preventDefault(),
                  e.stopPropagation(),
                  Utils.scrollCarousel(
                    -1,
                    r
                      ? ".ewck-pcs-product-container"
                      : ".ewck-cu-product-container"
                  );
              },
              innerHTML: "&#8249;",
            }),
            b = Utils.ce("button", {
              class: `ewck-cu-carousel-button ewck-cu-carousel-button-next ${
                f
                  ? "ewck-cu-carousel-button-enabled"
                  : "ewck-cu-carousel-button-disabled"
              }`,
              disabled: !f,
              onclick(e) {
                e.preventDefault(),
                  e.stopPropagation(),
                  Utils.scrollCarousel(
                    1,
                    r
                      ? ".ewck-pcs-product-container"
                      : ".ewck-cu-product-container"
                  );
              },
              innerHTML: "&#8250;",
            });
          g.append(h, b), p.appendChild(g);
        }
        let w = Utils.ce("div", {
          class: `${
            r ? "ewck-pcs-product-container" : "ewck-cu-product-container"
          } ewck-cu-carousel-layout`,
        });
        "Carousel" !== a.layout && (w.style.flexWrap = "wrap");
        let k = [];
        for (let [v, $] of n.entries()) {
          if (
            $?.available === !1 ||
            (a?.alwaysVisible !== !0 &&
              e.items.some((e) => e.product_id.toString() === $.id.toString()))
          )
            continue;
          let x = $.variants.find((e) => !0 === e.available),
            T = Utils.ce("div", {
              class: "ewck-upsell-product-item",
              style:
                "flex:" +
                (l.offsetWidth < 550
                  ? "0 0 calc(100% - 6px)"
                  : l.offsetWidth > 549 && l.offsetWidth < 1080
                  ? "0 0 calc(50% - 6px)"
                  : "0 0 calc(33.33% - 6px)"),
            }),
            C = Utils.ce("div", { class: "ewck-cu-img-wrap" }),
            S = Utils.ce("a", { href: $.url, target: "_blank" }),
            _ = Utils.ce("img", {
              class: "ewck-cu-img",
              alt: "",
              src: x?.featured_image?.src || $?.featured_image || "",
            }),
            I = Utils.ce("div", {
              style:
                "display:block;width:80px;height:80px;min-width:80px;background-color:#E3E3E3;border-radius:6px;",
            }),
            P = Utils.ce("div", {
              class: "ewck-cu-info-wrap",
              style: o
                ? ""
                : `padding-bottom:${$.variants.length > 1 ? "0px" : "15px"}`,
            }),
            q = Utils.ce("a", {
              href: $.url,
              target: "_blank",
              class: "ewck-cu-info-prod-link",
            }),
            E = Utils.ce("span", {
              class: "ewck-cu-info-pt",
              innerText: $.title,
            }),
            L = Utils.ce("div", {
              style:
                "display:block;width:70%;height:16px;background-color:#E3E3E3;border-radius:10px",
            }),
            B = Utils.ce("div", { class: "ewck-cu-info-p-b" }),
            F = Utils.ce("div", {
              style:
                "display:block;width:60px;height:14px;background-color:#E3E3E3;border-radius:10px",
            }),
            A = Utils.ce("span", {
              class: "ewck-cu-info-dis-p",
              innerHTML: Utils.cf(
                +Utils.getPAODisPrice(a, x?.price) || 0,
                settings?.moneyFormat
              ),
            });
          B.appendChild(A);
          let M;
          ("None" !== a.discountType || x?.compare_at_price) &&
            ((M = Utils.ce("span", {
              class: "ewck-cu-info-ori-p",
              innerHTML: Utils.cf(
                "None" !== a.discountType
                  ? x?.price || 0
                  : x?.compare_at_price || 0,
                settings?.moneyFormat
              ),
            })),
            B.appendChild(M));
          let D = Utils.ce("div", {
              class: "ewck-cu-info-action",
              style: `display:${$.variants.length > 1 ? "flex" : "none"}`,
            }),
            H = Utils.ce("select", {
              class: "ewck-default-select ewck-cu-info-action-select",
              style: `display:${$.variants.length > 1 ? "block" : "none"}`,
              onchange(e) {
                e.preventDefault(),
                  e.stopPropagation(),
                  (x = $.variants.find(
                    (t) => t.id.toString() === e.target.value
                  )) &&
                    ((_.src = x?.featured_image?.src || $?.featured_image),
                    (A.innerHTML = Utils.cf(
                      +Utils.getPAODisPrice(a, x?.price) || 0,
                      settings?.moneyFormat
                    )),
                    M &&
                      ("None" !== a.discountType || x?.compare_at_price
                        ? ((M.style.display = "inline-block"),
                          (M.innerHTML = Utils.cf(
                            "None" !== a.discountType
                              ? x?.price || 0
                              : x?.compare_at_price || 0,
                            settings?.moneyFormat
                          )))
                        : (M.style.display = "none")));
              },
            });
          $.variants.length > 1 &&
            $.variants.forEach((e) => {
              if (e.available) {
                let t = Utils.ce("option", { value: e.id, innerText: e.title });
                H.appendChild(t);
              }
            });
          let z = `<span style='white-space:nowrap;color:${a.atcTextColor}'>${a.atcText}</span>`,
            W = Utils.ce("div", {
              class: "ewck-cu-info-action-atc",
              style: `background-color:${a.atcBackgroundColor}`,
              innerHTML: z,
              async onclick(e) {
                e.preventDefault(),
                  e.stopPropagation(),
                  (W.style.height = W.offsetHeight + "px"),
                  (W.style.width = W.offsetWidth + "px"),
                  (W.style.minWidth = W.offsetWidth + "px"),
                  (W.style.maxWidth = W.offsetWidth + "px"),
                  (W.innerHTML =
                    "<div class='ewck-tool-spinner-container'><div class='ewck-tool-spinner' style='border: 2px solid #fff; border-top: 2px solid #000;'></div></div>");
                let t = "",
                  i = null;
                if ("None" !== a.discountType) {
                  let n = await Apis.createDiscount(
                    r
                      ? "product_cross_sell_discount_create"
                      : "cart_upsell_discount_create",
                    { offerId: a.id, upsellProductId: $.id, quantity: 1 }
                  );
                  n?.discountCode
                    ? (i = n.discountCode)
                    : ((t = n?.message),
                      console.log(
                        "Something went wrong while creating discount"
                      ));
                }
                if (
                  (setTimeout(() => {
                    W.innerHTML = z;
                  }, 2e3),
                  "" === t)
                ) {
                  let o = [{ id: x.id, quantity: 1 }],
                    l = i ? [i] : [];
                  (await Loaders.cartInitials(!0)).items.forEach((e) => {
                    e.properties?._ewckGift ||
                      (o.push({ id: e.variant_id, quantity: e.quantity }),
                      (l = l.concat(e.discounts.map((e) => e.title))));
                  }),
                    Apis.applyMultipleDiscounts(o, l);
                } else console.log("error", t);
              },
            });
          W.cloneNode(!0).style.opacity = "0";
          let N = Utils.ce("div", {
              style:
                "display:block;width:30%;height:15px;background-color:#E3E3E3;border-radius:10px",
            }),
            O = Utils.ce("div", {
              style:
                "display:block;width:60px;height:33px;background-color:#E3E3E3;border-radius:10px",
            }),
            V = Utils.ce("div", {
              style: "width:100%;display:flex;justify-content:space-between;",
            });
          V.append(N, O),
            S.appendChild(_),
            C.appendChild(S),
            q.appendChild(o ? L : E),
            D.append(H),
            W.classList.add("ewck-cu-atc-actio-main"),
            P.append(q, o ? F : B, o ? V : D),
            o || P.appendChild(W),
            T.append(o ? I : C, P),
            w.appendChild(T),
            k.push(T);
        }
        0 !== k.length &&
          (d.append(p, w),
          s.appendChild(d),
          Utils.insert(t, s, i),
          null !== EWCK.cuResizeLis &&
            window.removeEventListener("resize", EWCK.cuResizeLis, !0),
          window.addEventListener(
            "resize",
            (EWCK.cuResizeLis = function () {
              if (
                (y()
                  ? document
                      .querySelectorAll(".ewck-cu-carousel-button")
                      .forEach((e) => {
                        e.classList.add("ewck-cu-carousel-button-enabled"),
                          e.classList.remove(
                            "ewck-cu-carousel-button-disabled"
                          ),
                          (e.disabled = !1);
                      })
                  : document
                      .querySelectorAll(".ewck-cu-carousel-button")
                      .forEach((e) => {
                        e.classList.add("ewck-cu-carousel-button-disabled"),
                          e.classList.remove("ewck-cu-carousel-button-enabled"),
                          (e.disabled = !0);
                      }),
                k.length)
              ) {
                let e = "";
                l.offsetWidth < 550
                  ? ((e = "0 0 calc(100% - 6px)"),
                    m &&
                      (m.style.fontSize =
                        a.titleFontSize - (15 * a.titleFontSize) / 100 + "px"))
                  : l.offsetWidth > 549 && l.offsetWidth < 1080
                  ? ((e = "0 0 calc(50% - 6px)"),
                    m &&
                      (m.style.fontSize =
                        a.titleFontSize - (8 * a.titleFontSize) / 100 + "px"))
                  : ((e = "0 0 calc(33.33% - 6px)"),
                    m && (m.style.fontSize = a.titleFontSize + "px")),
                  k.forEach((t) => {
                    t.style.flex = e;
                  });
              }
            }),
            !0
          ));
      },
      scrollCarousel(e, t) {
        let i = document.querySelector(t),
          a = i.offsetWidth;
        1 === e
          ? window.innerWidth < 550
            ? i.scrollLeft + a >= i.scrollWidth - i.offsetWidth + 5
              ? i.scrollTo({ left: 0, behavior: "smooth" })
              : i.scrollBy({ left: a, behavior: "smooth" })
            : window.innerWidth > 550 && window.innerWidth < 1080
            ? i.scrollLeft + a >= i.scrollWidth - i.offsetWidth / 2 + 5
              ? i.scrollTo({ left: 0, behavior: "smooth" })
              : i.scrollBy({ left: a, behavior: "smooth" })
            : i.scrollLeft + a >= i.scrollWidth - i.offsetWidth / 3 + 10
            ? i.scrollTo({ left: 0, behavior: "smooth" })
            : i.scrollBy({ left: a, behavior: "smooth" })
          : i.scrollLeft <= 0
          ? i.scrollTo({ left: i.scrollWidth, behavior: "smooth" })
          : i.scrollBy({ left: -a, behavior: "smooth" });
      },
      sortUpsellProducts(e) {
        let t = { product: 1, collection: 2, all: 3 };
        return e.sort((e, i) => {
          let a = t[e.resourceType] || 1 / 0,
            n = t[i.resourceType] || 1 / 0;
          return a - n;
        });
      },
      checkRequest(e, t) {
        !(function () {
          null === EWCK.originalFetch && (EWCK.originalFetch = window.fetch),
            (window.fetch = async function (...i) {
              if (i[0].includes("/cart/add")) {
                let a = i[1];
                if (a && a.body) {
                  let n;
                  if (
                    a.headers &&
                    "application/json" === a.headers["Content-Type"]
                  ) {
                    let o = JSON.parse(a.body);
                    n = o.id || (o.items && o.items[0]?.id);
                  } else {
                    let r = new URLSearchParams(a.body);
                    n = r.get("id") || r.get("items[][id]");
                  }
                  if (
                    currentProduct.variants.find((e) => e.id.toString() === n)
                  ) {
                    if ("product_add_ons" === t) {
                      let l = await e(!0);
                      if ("string" == typeof l)
                        throw Error("Add ons error: " + l);
                    }
                    "volume_discounts" === t && (await e(!0));
                  }
                }
              }
              return EWCK.originalFetch.apply(this, i);
            });
          let i = window.XMLHttpRequest,
            a = i.prototype.open,
            n = i.prototype.send;
          (i.prototype.open = function (e, t, ...i) {
            return (this._url = t), a.apply(this, [e, t, ...i]);
          }),
            (i.prototype.send = async function (i) {
              if (this._url && this._url.includes("/cart/add")) {
                let a;
                if (i) {
                  let o = new URLSearchParams(i);
                  a = o.get("id") || o.get("items[][id]");
                }
                if (
                  currentProduct.variants.find((e) => e.id.toString() === a) &&
                  "product_add_ons" === t
                ) {
                  let r = await e(!0);
                  if ("string" == typeof r) throw Error("Add ons error: " + r);
                }
              }
              return n.apply(this, [i]);
            });
        })();
      },
      isElementVisible(e) {
        if (!e || null === e.offsetParent) return !1;
        let t = window.getComputedStyle(e);
        return (
          "none" !== t.display && "hidden" !== t.visibility && "0" !== t.opacity
        );
      },
      preOrderError(e, t, i, a) {
        let n = Utils.ce("div", {
            class: `ewck-po-error-${i}`,
            style: `${
              a ? "" : "position:fixed;bottom:10px;right:10px;"
            }background-color:${
              e.errorBackgroundColor
            };padding:5px 10px;line-height:1.3;z-index:999`,
          }),
          o = Utils.ce("span", {
            innerHTML: t,
            style: `color:${e.errorTextColor};font-family:${e.errorTextFontFamily};font-size:${e.errorTextFontSize}px;font-weight:${e.errorTextFontWeight};`,
          });
        return (
          n.appendChild(o),
          a ? a.appendChild(n) : document.body.appendChild(n),
          n
        );
      },
      onElementVisible(e, t, i = {}) {
        let a = new IntersectionObserver((e, i) => {
          e.forEach((e) => {
            e.isIntersecting && (t(e.target), i.unobserve(e.target));
          });
        }, i);
        a.observe(e);
      },
      defAtcSelectors: [
        "button[name='add'][type='submit'],button.shopify-payment-button__button,.buy-buttons button[is='custom-button']",
      ],
      productCardSelectors:
        ".grid.product-grid li.grid__item,Product-recommendations ul li.grid__item,.collection__main .product-list .product-card,.collection-grid__wrapper .grid .grid__item,.collection__results .product-list .product-card,.collection-listing .product-list .product-block,.grid .grid-item.product-item,.productgrid--items .productgrid--item,.grid .card.card--product,.collection .product-grid .grid__item,.collection__products product-grid-item,.grid .grid__item.grid-product,.product-list.product-list--collection .product-item,.collection__products .product-item,.product-list .product-list__inner .product-item,.product-grid .grid-item.grid-product,#product-grid .product-card,#CollectionProductGrid .product-item,.grid .product-grid-item.grid__item,.products.collection .product-card,[data-collection-products] [data-product-grid],.collection-main-body .grid__item,.product-list-container .product-list .product-block,.cc-filters-results .grid-flex .product-block,.collection-products .collection__cards .product-card,.collection.grid .product-item__wrapper,product-card",
    },
    Apis = {
      async updateViews(e, t) {
        await (
          await fetch(`${Shopify.routes.root}apps/api/tools`, {
            method: "POST",
            body: JSON.stringify({ type: e, intent: "stats_update", prop: t }),
          })
        ).json();
      },
      addToCart: async (e, t, i, a) => !0,
      async createCustomer(e, t, i) {
        let a = await (
          await fetch(`${Shopify.routes.root}apps/api/tools`, {
            method: "POST",
            body: JSON.stringify({
              intent: "create_customer",
              email: e,
              name: t,
              phone: i,
            }),
          })
        ).json();
        return a?.success || a;
      },
      async getProduct(e) {
        let t = `${
          settings?.disableLocaleBasedRoute === "true"
            ? "/"
            : location.origin + Shopify.routes.root
        }products/${e}.js`;
        try {
          let i = await fetch(t),
            a = await i.json();
          return a;
        } catch (n) {
          return null;
        }
      },
      createDiscount: async (e, t) =>
        await (
          await fetch(`${Shopify.routes.root}apps/api/tools`, {
            method: "POST",
            body: JSON.stringify({ intent: e, prop: t }),
          })
        ).json(),
      async applyMultipleDiscounts(e, t, i) {
        let a = window?.Shopify?.routes?.root || "/";
        if (
          (await fetch(
            `${a + ("/" === a.charAt(a.length - 1) ? "cart" : "/cart")}/${e
              .map((e) => e.id + ":" + e.quantity)
              .toString()}?discount=${t
              .toString()
              .replaceAll("%", "")}&storefront=true`
          ),
          !1 === i)
        )
          return !0;
        if (location.href.split("/").includes("cart"))
          location.href =
            "/" === a
              ? "/cart"
              : a + ("/" === a.charAt(a.length - 1) ? "cart" : "/cart");
        else {
          if (settings?.atcAction === "ajax" && settings?.themeName) {
            Utils.ajaxCart(e, "update");
            return;
          }
          settings?.redirectUpsellToCheckout ||
          settings?.redirectAddOnsToCheckout
            ? (location.href =
                "/" === a
                  ? "/cart/checkout"
                  : a +
                    ("/" === a.charAt(a.length - 1)
                      ? "cart/checkout"
                      : "/cart/checkout"))
            : (location.href =
                "/" === a
                  ? "/cart"
                  : a + ("/" === a.charAt(a.length - 1) ? "cart" : "/cart"));
        }
      },
      removeDiscount: async (e) =>
        (
          await (
            await fetch(`${Shopify.routes.root}apps/api/tools`, {
              method: "POST",
              body: JSON.stringify({ intent: "pao_discount_remove", prop: e }),
            })
          ).json()
        )?.success,
      getShippingProtection: async (e) =>
        (
          await (
            await fetch(`${Shopify.routes.root}apps/api/tools`, {
              method: "POST",
              body: JSON.stringify({ intent: "shipping_protection", price: e }),
            })
          ).json()
        ).variantId,
      async updateContinueSelling(e) {
        await (
          await fetch(`${Shopify.routes.root}apps/api/tools`, {
            method: "POST",
            body: JSON.stringify({
              intent: "update-continue-selling",
              variantId: e,
            }),
          })
        ).json();
      },
      getTools: async (e, t) =>
        (
          await (
            await fetch(`${Shopify.routes.root}apps/api/tools`, {
              method: "POST",
              body: JSON.stringify({ intent: "get-tools", type: e, ids: t }),
            })
          ).json()
        )?.campaigns.map((e) => e.data),
      async getProductsFromStorefrontApi(e) {
        let t = e.map((e) => `gid://shopify/Product/${e}`),
          i = `
        query GetProductsByIds @inContext(country: ${Shopify.country}${
            settings?.disableLocaleBasedRoute === "true"
              ? ""
              : `, language: ${Shopify.locale.toUpperCase()}`
          }) {
          nodes(ids: [${t.map((e) => `"${e}"`).join(",")}]) {
            ... on Product {
              availableForSale
              id
              title
              handle
              images(first: 1) {
                edges {
                  node {
                    url
                  }
                }
              }
              variants(first: 250) {
                edges {
                  node {
                    availableForSale
                    id
                    title
                    price {
                      amount
                    }
                    image{
                      url
                    }
                    quantityAvailable  
                  }
                }
              }
            }
          }
        }
      `,
          a = await fetch(EWCK.gqlEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": CKSettings.SAT.tokens.at(-1),
            },
            body: JSON.stringify({ query: i }),
          }),
          n = await a.json();
        if (n?.data)
          return n.data.nodes
            .filter((e) => e?.availableForSale)
            .map((e) => ({
              ...e,
              id: e.id.replace("gid://shopify/Product/", ""),
              featuredImage: e?.images?.edges?.[0]?.node?.url || "",
              variants: e.variants.edges.map((e) => ({
                ...e.node,
                id: e.node.id.replace("gid://shopify/ProductVariant/", ""),
              })),
            }));
        n?.errors && console.log("Error fetching products!", n.errors);
      },
      async getCollectionproductsFromStorefrontApi(
        e,
        t = 25,
        i = null,
        a = !0
      ) {
        let n = i;
        if (a) {
          let o = `
            query GetCollectionProducts($collectionId: ID!, $cursor: String) @inContext(country: ${
              Shopify.country
            }${
              settings?.disableLocaleBasedRoute === "true"
                ? ""
                : `, language: ${Shopify.locale.toUpperCase()}`
            }) {
              node(id: $collectionId) {
                ... on Collection {
                  id
                  title
                  products(first: ${t}, after: $cursor) {
                    pageInfo {
                      hasNextPage
                      endCursor
                    }
                    edges {
                      node {
                        availableForSale
                        id
                        title
                        handle
                        images(first: 1) {
                          edges {
                            node {
                              url
                            }
                          }
                        }
                        variants(first: 250) {
                          edges {
                            node {
                              availableForSale
                              id
                              title
                              price {
                                amount
                              }
                              image{
                                url
                              }
                              quantityAvailable  
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
            r = await fetch(EWCK.gqlEndpoint, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token":
                  CKSettings.SAT.tokens.at(-1),
              },
              body: JSON.stringify({
                query: o,
                variables: {
                  collectionId: `gid://shopify/Collection/${e}`,
                  cursor: n,
                },
              }),
            }),
            l = await r.json(),
            c = l.data.node;
          if (c && c.products) {
            let s = c.products.edges
              .filter((e) => e.node.availableForSale)
              .map((e) => ({
                ...e.node,
                id: e.node.id.replace("gid://shopify/Product/", ""),
                featuredImage: e?.node?.images?.edges?.[0]?.node?.url || "",
                variants: e.node.variants.edges.map((e) => ({
                  ...e.node,
                  id: e.node.id.replace("gid://shopify/ProductVariant/", ""),
                })),
              }));
            return {
              products: s,
              hasNextPage: c.products.pageInfo.hasNextPage,
              cursor: c.products.pageInfo.endCursor,
            };
          }
        }
        return null;
      },
    };
  for (let key in (Loaders.pre(), tools))
    ("buy_x_get_y" === key || "labels_stickers" === key) &&
      Utils.productsFilterTracker(),
      ("announcement_bars" !== key &&
        "buy_x_get_y" !== key &&
        "order_rewards" !== key &&
        "volume_discounts" !== key &&
        "favicon_cart_count" !== key &&
        "product_add_ons" !== key &&
        "terms_conditions_checkbox" !== key &&
        "cart_upsell" !== key &&
        "product_cross_sell" !== key &&
        "shipping_protection" !== key) ||
        EWCK.cartChangeWatch ||
        ((EWCK.cartChangeWatch = new Utils.cartChangeWatch()),
        EWCK.cartChangeWatch.init(),
        window.addEventListener("cart_changed", (e) => {
          !0 === EWCK.cartChangeWatchActive &&
            (location.href.includes("/cart")
              ? EWCK.init()
              : setTimeout(() => {
                  EWCK.init();
                }, 1e3)),
            (EWCK.cartChangeWatchActive = !0);
        }));
  EWCK.variantChangeTracker || Utils.variantChangeTracker(),
    settings?.beforeJS !== "" &&
      settings?.beforeJS !== void 0 &&
      setTimeout(() => {
        eval(settings.beforeJS);
      }, 0),
    EWCK.init(),
    settings?.afterJS !== "" &&
      settings?.afterJS !== void 0 &&
      setTimeout(() => {
        eval(settings.afterJS);
      }, 1e3);
})();